import Vue from 'vue';

const colourOptions = {
  BlackWhite: 1,
  ColourOutline: 2,
  FullColour: 3
};
const defaults = {
  colourOption: colourOptions.BlackWhite,
  strokeColour: '#787770',
  textColour: '#787770',
  autoHints: false,
  size: null,
  dpi: 180,
  blockLanguage: 1,
  editorLanguage: 1
};
const effectDirections = {
  SouthEast: 1,
  SouthWest: 2,
  NorthWest: 3,
  NorthEast: 4
};

function isInt(value) {
  if (/^[-+]?(\d+|Infinity)$/.test(value)) {
    return true;
  } else {
    return false;
  }
}
function addHashPrefix(colour) {
  if (colour[0] == "#") return colour;
  return `#${colour}`;
}
function getFillColour(properties, options) {
  if (properties && options.colour === colourOptions.FullColour) {
    const colour = options.high_contrast ? properties.hc_colour : properties.colour;
    return addHashPrefix(colour);
  }
  return "#FFFFFF";
}
function getStrokeColour(properties, options) {
  if (options.colour === colourOptions.FullColour) {
    const colour = options.high_contrast ? properties.hc_stroke_colour : properties.stroke_colour;
    return addHashPrefix(colour);
  } else if (options.colour === colourOptions.ColourOutline) {
    return addHashPrefix(properties.colour);
  } else {
    return addHashPrefix(convertToHex(options.stroke_colour));
  }
}
function getStrokeWeight(options, is_command = false) {
  if (options.colour === colourOptions.FullColour) {
    return 1;
  } else {
    if (is_command) return Math.ceil(options.stroke_weight / 2);else return options.stroke_weight;
  }
}
function convertToHex(value) {
  const hexChars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F"];
  if (value < 256) {
    const firstChar = hexChars[Math.floor(value / 16)];
    const secondChar = hexChars[value % 16];
    const number = `${firstChar}${secondChar}`;
    return number.repeat(3);
  }
}
function lighten(value, percent) {
  let diff = 255 - value;
  if (value > 0) {
    diff *= percent / 100;
    return value + Math.floor(diff);
  }
  return value;
}
function lightenHEX(hex, percent) {
  const colour = hex[0] == "#" ? hex.substring(1) : hex;
  const r = colour.substring(0, 2);
  const g = colour.substring(2, 4);
  const b = colour.substring(4);
  let new_r = Math.ceil(parseInt(r, 16) * (1 + percent / 100));
  new_r = new_r > 255 ? 255 : new_r;
  let new_g = Math.ceil(parseInt(g, 16) * (1 + percent / 100));
  new_g = new_g > 255 ? 255 : new_g;
  let new_b = Math.ceil(parseInt(b, 16) * (1 + percent / 100));
  new_b = new_b > 255 ? 255 : new_b;
  return `#${new_r.toString(16)}${new_g.toString(16)}${new_b.toString(16)}`;
}
function round(num, decimals) {
  const factor = 10 ** decimals;
  return Math.round((num + Number.EPSILON) * factor) / factor;
}
function addClass(element, newClass) {
  let classes = element.className.split(" ");
  if (classes.indexOf(newClass) == -1) {
    element.className += " " + newClass;
  }
}
function removeClass(element, oldClass) {
  element.className = element.className.replace(oldClass, "").trim();
}

// The below was taken from Emacs keymap distributed with CodeMirror

var killRing = [];
var lastKill = null;
function posEq(a, b) {
  return a.line == b.line && a.ch == b.ch;
}
function getPrefix(cm, precise) {
  var digits = cm.state.emacsPrefix;
  if (!digits) return precise ? null : 1;
  clearPrefix(cm);
  return digits == "-" ? -1 : Number(digits);
}
function clearPrefix(cm) {
  cm.state.emacsPrefix = null;
  cm.off("keyHandled", maybeClearPrefix);
  cm.off("inputRead", maybeDuplicateInput);
}
function addToRing(str) {
  killRing.push(str);
  if (killRing.length > 50) killRing.shift();
}
function growRingTop(str) {
  if (!killRing.length) return addToRing(str);
  killRing[killRing.length - 1] += str;
}
function byChar(cm, pos, dir) {
  return cm.findPosH(pos, dir, "char", true);
}
function _kill(cm, from, to, ring, text) {
  if (text == null) text = cm.getRange(from, to);
  if (ring == "grow" && lastKill && lastKill.cm == cm && posEq(from, lastKill.pos) && cm.isClean(lastKill.gen)) growRingTop(text);else if (ring !== false) addToRing(text);
  cm.replaceRange("", from, to, "+delete");
  if (ring == "grow") lastKill = {
    cm: cm,
    pos: from,
    gen: cm.changeGeneration()
  };else lastKill = null;
}
function _killRegion(cm, ring) {
  if (cm.somethingSelected()) {
    var selections = cm.listSelections(),
      selection;
    var i = selections.length;
    while (i--) {
      selection = selections[i];
      _kill(cm, selection.anchor, selection.head, ring);
    }
    return true;
  }
}
function findEnd(cm, pos, by, dir) {
  var prefix = getPrefix(cm);
  if (prefix < 0) {
    dir = -dir;
    prefix = -prefix;
  }
  for (var i = 0; i < prefix; ++i) {
    var newPos = by(cm, pos, dir);
    if (posEq(newPos, pos)) break;
    pos = newPos;
  }
  return pos;
}
function killTo(cm, by, dir, ring) {
  var selections = cm.listSelections(),
    cursor;
  var i = selections.length;
  while (i--) {
    cursor = selections[i].head;
    _kill(cm, cursor, findEnd(cm, cursor, by, dir), ring);
  }
}
function deleteBackwardChar(cm, amount = -1) {
  _killRegion(cm, false) || killTo(cm, byChar, amount, false);
}

// End of code taken from CodeMirror's Emacs keymap

var script$A = {
  name: "ps-content-text",
  props: ["content", "transforms", "options"],
  data() {
    return {
      context: document.createElement("canvas").getContext("2d"),
      fontSize: 12,
      fontFamily: "Helvetica, sans-serif",
      fontWeight: 500
    };
  },
  computed: {
    type: function () {
      return this.content.command;
    },
    value: function () {
      return this.content.value.trim();
    },
    isGreaterOrLessThan: function () {
      if (this.value == ">" || this.value == "<") return true;
      return false;
    },
    contents: function () {
      return this.content.contents | [];
    },
    isHighlight: function () {
      return this.content.isHighlight || this.options.colour === colourOptions.BlackWhite && this.$parent.isHighlight;
    },
    isMystery: function () {
      return this.content.isMystery || false;
    },
    isDim: function () {
      if (this.options.colour === colourOptions.BlackWhite && !this.isHighlight && this.options.containsHighlight) {
        return true;
      }
      return this.content.isDim || this.$parent.isDim;
      //return this.content.isDim || 
    },
    isMyVar: function () {
      return this.content.isMyVar || false;
    },
    isMyList: function () {
      return this.content.isMyList || false;
    },
    transform: function () {
      if (this.transforms) {
        return `translate(${this.transforms.x}, ${this.transforms.y})`;
      } else {
        return "translate(0, 0)";
      }
    },
    fillColour: function () {
      if (this.isHighlight && this.options.colour === colourOptions.BlackWhite) return "#000";
      let colour = this.options.text_colour;
      if (this.isDim) {
        colour = lighten(colour, 50);
      }
      if (this.$parent.fillColour === "#FFFFFF") {
        return addHashPrefix(convertToHex(colour));
      } else {
        return this.options.high_contrast ? "#000000" : "#FFFFFF";
      }
    },
    textStyle: function () {
      if (this.isHighlight && this.options.colour === colourOptions.BlackWhite) return "#000";
      return `color: ${this.textColour}`;
    }
    // colourOption: function() {
    //     return this.instructions.colour || this.options.colour
    // }
  },
  watch: {
    value: function (newValue, oldValue) {
      if (newValue !== oldValue) {
        // console.log(`newValue: ${newValue}, oldValue: ${oldValue}`)
        this.$emit("changed");
      }
    }
  },
  methods: {
    width: function () {
      this.context.font = `${this.fontWeight} ${this.fontSize}pt ${this.fontFamily}`;
      return this.context.measureText(this.value).width; //* 169.17/152 * 1.054232269360478
      //return this.$el.clientWidth
    },
    height: function () {
      return 0; //this.fontSize
    },
    pointFontSize: function () {
      return `${this.fontSize}pt`;
    },
    getDimOptions: function () {
      let colour = this.options.colour - 1;
      let strokeColour = lighten(this.options.stroke_colour, 50);
      if (colour === 0) {
        colour = 1;
      }
      return {
        colour: colour,
        stroke_colour: strokeColour
      };
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$A = script$A;

/* template */
var __vue_render__$A = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.isGreaterOrLessThan ? _c('text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isMystery,
      expression: "!isMystery"
    }],
    staticClass: "scratch-font",
    attrs: {
      "fill": _vm.fillColour,
      "y": "2",
      "text-anchor": "start",
      "dominant-baseline": "middle",
      "dy": "0",
      "transform": _vm.transform,
      "stroke": _vm.fillColour,
      "stroke-weight": "1"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.value) + "\n")]) : _c('text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isMystery,
      expression: "!isMystery"
    }],
    staticClass: "scratch-font",
    attrs: {
      "fill": _vm.fillColour,
      "y": "2",
      "text-anchor": "start",
      "dominant-baseline": "middle",
      "dy": "0",
      "transform": _vm.transform
    }
  }, [_vm._v("\n  " + _vm._s(_vm.value) + "\n")]);
};
var __vue_staticRenderFns__$A = [];

/* style */
const __vue_inject_styles__$A = function (inject) {
  if (!inject) return;
  inject("data-v-6cdabd76_0", {
    source: ".scratch-font[data-v-6cdabd76]{font-family:\"Helvetica Neue\",Helvetica,sans-serif;font-size:12pt;font-weight:500}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$A = "data-v-6cdabd76";
/* module identifier */
const __vue_module_identifier__$A = undefined;
/* functional template */
const __vue_is_functional_template__$A = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$C = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$A,
  staticRenderFns: __vue_staticRenderFns__$A
}, __vue_inject_styles__$A, __vue_script__$A, __vue_scope_id__$A, __vue_is_functional_template__$A, __vue_module_identifier__$A, false, createInjector, undefined, undefined);
var PsContentText = __vue_component__$C;

var script$z = {
  name: 'ps-content-flag',
  props: ['content', 'transforms', 'options'],
  data() {
    return {
      imageSize: 24
    };
  },
  inject: ['appConfig'],
  computed: {
    isHighlight: function () {
      return this.$parent.isHighlight;
    },
    isDim: function () {
      if (this.options.colour === colourOptions.BlackWhite && !this.isHighlight && this.options.containsHighlight) {
        return true;
      }
      return this.content.isDim || false;
    },
    // colourOption: function() {
    //     return this.instructions.colour || this.options.colour
    // },
    imageSource: function () {
      if (!this.isDim && this.options.colour === colourOptions.FullColour) {
        return `${this.appConfig.IMAGE_DIR}/images/colour/green-flag.svg`;
      } else {
        return `${this.appConfig.IMAGE_DIR}/images/bw/green-flag.svg`;
      }
    },
    transform: function () {
      return `translate(${this.transforms.x}, ${this.transforms.y})`;
    }
  },
  methods: {
    width: function () {
      return this.imageSize;
    },
    height: function () {
      return this.imageSize;
    },
    pixelSize: function (size) {
      return `${size}px`;
    }
  }
};

/* script */
const __vue_script__$z = script$z;

/* template */
var __vue_render__$z = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('g', {
    attrs: {
      "transform": _vm.transform
    }
  }, [_c('image', {
    attrs: {
      "height": _vm.pixelSize(_vm.imageSize),
      "width": _vm.pixelSize(_vm.imageSize),
      "xlink:href": _vm.imageSource
    }
  })]);
};
var __vue_staticRenderFns__$z = [];

/* style */
const __vue_inject_styles__$z = undefined;
/* scoped */
const __vue_scope_id__$z = "data-v-a09b5ac0";
/* module identifier */
const __vue_module_identifier__$z = undefined;
/* functional template */
const __vue_is_functional_template__$z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$B = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$z,
  staticRenderFns: __vue_staticRenderFns__$z
}, __vue_inject_styles__$z, __vue_script__$z, __vue_scope_id__$z, __vue_is_functional_template__$z, __vue_module_identifier__$z, false, undefined, undefined, undefined);
var PsContentFlag = __vue_component__$B;

var script$y = {
  name: "ps-content-turnright",
  props: ["content", "transforms", "options"],
  data() {
    return {
      imageSize: 24
    };
  },
  inject: ["appConfig"],
  computed: {
    isHighlight: function () {
      return this.$parent.isHighlight;
    },
    isDim: function () {
      if (this.options.colour === colourOptions.BlackWhite && !this.isHighlight && this.options.containsHighlight) {
        return true;
      }
      return this.content.isDim || false;
    },
    // colourOption: function() {
    //     return this.instructions.colour || this.options.colour
    // },
    imageSource: function () {
      if (!this.isDim && this.options.colour === colourOptions.FullColour) {
        if (this.options.high_contrast) return `${this.appConfig.IMAGE_DIR}/images/bw/rotate-right-black.svg`;
        return `${this.appConfig.IMAGE_DIR}/images/colour/rotate-right.svg`;
      } else {
        return `${this.appConfig.IMAGE_DIR}/images/bw/rotate-right.svg`;
      }
    },
    transform: function () {
      return `translate(${this.transforms.x}, ${this.transforms.y})`;
    }
  },
  methods: {
    width: function () {
      return this.imageSize;
    },
    height: function () {
      return this.imageSize;
    },
    pixelSize: function (size) {
      return `${size}px`;
    }
  }
};

/* script */
const __vue_script__$y = script$y;

/* template */
var __vue_render__$y = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('g', {
    attrs: {
      "transform": _vm.transform
    }
  }, [_c('image', {
    attrs: {
      "height": _vm.pixelSize(_vm.imageSize),
      "width": _vm.pixelSize(_vm.imageSize),
      "xlink:href": _vm.imageSource
    }
  })]);
};
var __vue_staticRenderFns__$y = [];

/* style */
const __vue_inject_styles__$y = undefined;
/* scoped */
const __vue_scope_id__$y = "data-v-44307458";
/* module identifier */
const __vue_module_identifier__$y = undefined;
/* functional template */
const __vue_is_functional_template__$y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$A = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$y,
  staticRenderFns: __vue_staticRenderFns__$y
}, __vue_inject_styles__$y, __vue_script__$y, __vue_scope_id__$y, __vue_is_functional_template__$y, __vue_module_identifier__$y, false, undefined, undefined, undefined);
var PsContentTurnright = __vue_component__$A;

var script$x = {
  name: "ps-content-turnleft",
  props: ["content", "transforms", "options"],
  data() {
    return {
      imageSize: 24
    };
  },
  inject: ["appConfig"],
  computed: {
    isHighlight: function () {
      return this.$parent.isHighlight;
    },
    isDim: function () {
      if (this.options.colour === colourOptions.BlackWhite && !this.isHighlight && this.options.containsHighlight) {
        return true;
      }
      return this.content.isDim || false;
    },
    // colourOption: function() {
    //     return this.instructions.colour || this.options.colour
    // },
    imageSource: function () {
      if (!this.isDim && this.options.colour === colourOptions.FullColour) {
        if (this.options.high_contrast) return `${this.appConfig.IMAGE_DIR}/images/bw/rotate-left-black.svg`;
        return `${this.appConfig.IMAGE_DIR}/images/colour/rotate-left.svg`;
      } else {
        return `${this.appConfig.IMAGE_DIR}/images/bw/rotate-left.svg`;
      }
    },
    transform: function () {
      return `translate(${this.transforms.x}, ${this.transforms.y})`;
    }
  },
  methods: {
    width: function () {
      return this.imageSize;
    },
    height: function () {
      return this.imageSize;
    },
    pixelSize: function (size) {
      return `${size}px`;
    }
  }
};

/* script */
const __vue_script__$x = script$x;

/* template */
var __vue_render__$x = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('g', {
    attrs: {
      "transform": _vm.transform
    }
  }, [_c('image', {
    attrs: {
      "height": _vm.pixelSize(_vm.imageSize),
      "width": _vm.pixelSize(_vm.imageSize),
      "xlink:href": _vm.imageSource
    }
  })]);
};
var __vue_staticRenderFns__$x = [];

/* style */
const __vue_inject_styles__$x = undefined;
/* scoped */
const __vue_scope_id__$x = "data-v-f99e0dc6";
/* module identifier */
const __vue_module_identifier__$x = undefined;
/* functional template */
const __vue_is_functional_template__$x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$z = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$x,
  staticRenderFns: __vue_staticRenderFns__$x
}, __vue_inject_styles__$x, __vue_script__$x, __vue_scope_id__$x, __vue_is_functional_template__$x, __vue_module_identifier__$x, false, undefined, undefined, undefined);
var PsContentTurnleft = __vue_component__$z;

var script$w = {
  name: "ps-content-value",
  components: {
    PsContentText
  },
  props: ["content", "transforms", "options"],
  data() {
    return {
      innerTransforms: [],
      // offset: 16,
      separator: 10,
      minHeight: 32,
      radius: 16,
      minRadius: 16,
      innerWidth: 24,
      extensionOffset: 48,
      extensionImageHeight: 32
    };
  },
  inject: ["appConfig"],
  computed: {
    type: function () {
      return this.content.command;
    },
    contents: function () {
      return this.content.contents || [];
    },
    properties: function () {
      return this.content.properties;
    },
    isChildTextHighlighted: function () {
      if (this.contents.length === 1 && this.contents[0].command && this.contents[0].command.toLowerCase() === "text") {
        return this.contents[0].isHighlight;
      }
      return false;
    },
    isHighlight: function () {
      return this.content.isHighlight || this.isChildTextHighlighted || this.options.colour === colourOptions.BlackWhite && this.$parent.isHighlight;
    },
    isMystery: function () {
      return this.content.isMystery || false;
    },
    isDim: function () {
      if (this.options.colour === colourOptions.BlackWhite && !this.isHighlight && this.options.containsHighlight) {
        return true;
      }
      return this.content.isDim || false;
      //return this.content.isDim || this.$parent.isDim;
    },
    transform: function () {
      if (this.transforms) {
        return `translate(${this.transforms.x}, ${this.transforms.y})`;
      } else {
        return "translate(0, 0)";
      }
    },
    points: function () {
      return `m ${this.radius},0 h ${this.innerWidth} a ${this.radius} ${this.radius} 0 0 1 0 ${this.diameter} H ${this.radius} a ${this.radius} ${this.radius} 0 0 1 0 -${this.diameter} z`;
    },
    containsSingleValue: function () {
      return this.contents.length === 1 && this.contents[0].command && this.contents[0].command.toLowerCase() === "value";
    },
    containsSingleValueOrText: function () {
      return this.contents.length === 1 && this.contents[0].command && (this.contents[0].command.toLowerCase() === "value" || this.contents[0].command.toLowerCase() === "text");
    },
    singleValueType: function () {
      if (this.contents.length === 1) return this.contents[0].command;
    },
    diameter: function () {
      return this.radius * 2;
    },
    // colourOption: function() {
    //     return this.instructions.colour || this.options.colour
    // },
    fillColour: function () {
      // if (!this.isDim && this.properties && this.options.colour === drawing.colourOptions.FullColour) {
      //     return utilities.addHashPrefix(this.properties.colour)
      // }
      // return '#FFFFFF'
      const options = this.isDim ? this.getDimOptions() : this.options;
      return getFillColour(this.properties, options);
    },
    strokeColour: function () {
      if (this.isHighlight && this.options.colour === colourOptions.BlackWhite) return "#000";
      const options = this.isDim ? this.getDimOptions() : this.options;
      if (options.colour !== colourOptions.BlackWhite) {
        if (this.properties) {
          if (this.$parent.$options.name === "ps-drawing") {
            //ContentValue has ps-drawing as the parent
            return addHashPrefix(this.properties.colour);
          } else {
            return addHashPrefix(this.properties.stroke_colour);
          }
        }
        if (options.colour === colourOptions.FullColour) {
          if (options.high_contrast) return addHashPrefix(this.$parent.properties.hc_stroke_colour);
          return addHashPrefix(this.$parent.properties.stroke_colour);
        }
      }
      return addHashPrefix(convertToHex(options.stroke_colour));
    },
    strokeWidth: function () {
      let strokeWidth = getStrokeWeight(this.options, true);
      if (this.isHighlight && this.options.colour === colourOptions.BlackWhite) return strokeWidth;
      return strokeWidth;
    },
    showHighlightPath: function () {
      if (this.isHighlight && this.options.colour === colourOptions.FullColour) {
        return true;
      }
      return false;
    },
    mainPathDash: function () {
      // if (
      //   this.isHighlight &&
      //   (this.options.colour === drawing.colourOptions.BlackWhite ||
      //     this.options.colour === drawing.colourOptions.ColourOutline)
      // ) {
      //   return "4";
      // }
      return "";
    },
    highlightPathStrokeWidth: function () {
      if (this.options.colour === colourOptions.FullColour) {
        return 3;
      }
      return this.strokeWidth;
    },
    isExtension: function () {
      return this.content.properties && this.content.properties.is_extension;
    },
    extensionName: function () {
      return this.content.properties ? this.content.properties.short_name : "";
    },
    extensionImage: function () {
      if (!this.isDim && this.options.colour === colourOptions.FullColour) {
        return `${this.appConfig.IMAGE_DIR}/images/colour/${this.extensionName}.svg`;
      } else {
        return `${this.appConfig.IMAGE_DIR}/images/bw/${this.extensionName}.svg`;
      }
    },
    extensionImageSizePixels: function () {
      const extensionHeight = this.radius * 2 - 8;
      return `${extensionHeight}px`;
    },
    offset: function () {
      if (this.isExtension) {
        {
          return this.radius + this.extensionOffset;
        }
      }
      return this.radius;
    },
    lineStroke: function () {
      if (this.options.colour === colourOptions.FullColour) {
        return "#0DA57A";
      } else {
        return addHashPrefix(convertToHex(this.options.stroke_colour));
      }
    },
    transformExtensionImage: function () {
      //translate(8, 12)
      const x = 16,
        y = 4;
      return `translate(${x}, ${y})`;
    },
    extensionLineHeight: function () {
      return this.radius * 2 - 8;
    },
    containsTextOnlyCommand: function () {
      if (this.containsSingleValue && this.$refs) {
        if (this.$refs.items[0].content.textOnlyCommand) {
          return true;
        }
      }
      return false;
    }
  },
  watch: {
    innerWidth: function () {
      this.$nextTick(() => {
        this.positionElements();
        this.$emit("changed");
      });
    },
    containsSingleValue: function () {
      this.$nextTick(() => {
        this.positionElements();
        this.$emit("changed");
      });
    },
    containsSingleValueOrText: function () {
      this.$nextTick(() => {
        this.positionElements();
        this.$emit("changed");
      });
    },
    singleValueType: function () {
      this.$nextTick(() => {
        this.positionElements();
        this.$emit("changed");
      });
    },
    contents: function () {
      this.$nextTick(() => {
        this.positionElements();
        this.$emit("changed");
      });
    },
    "options.colour": function () {
      this.positionElements();
      this.$emit("changed");
    }
  },
  methods: {
    width: function () {
      let width = this.innerWidth + this.diameter;
      if (this.containsSingleValue) {
        if (this.options.colour === colourOptions.FullColour) {
          width = this.refItem(0).width();
        } else {
          width = this.refItem(0).width() + 4 * 2;
        }
      }
      return width;
    },
    height: function () {
      return this.radius * 2;
    },
    getInnerWidth: function () {
      let width = this.getContentsWidth();
      if (this.isExtension) {
        width += this.extensionOffset;
      }
      if (this.containsSingleValue) {
        if (this.options.colour === colourOptions.FullColour || !this.containsTextOnlyCommand) {
          width -= this.diameter;
        } else {
          width -= this.diameter - 2 * 4;
        }
      }
      return width === 0 ? 24 : width;
    },
    getContentsHeight: function () {
      // Need to change that so that height increases if it contains a command
      let height = 0;
      if (this.$refs.items) {
        let heights = this.$refs.items.map(item => item.height());
        height = Math.max(...heights);
      }
      return height;
    },
    getContentsWidth: function () {
      let width = 0;
      if (this.$refs.items) {
        width = this.$refs.items.map(item => item.width()).reduce((a, b) => a + b, 0);
        if (!this.containsSingleValueOrText) {
          width += this.separator * (this.$refs.items.length - 1);
        }
      }
      return width;
    },
    getTransforms: function (index) {
      if (this.innerTransforms.length > 0) {
        return this.innerTransforms[index];
      }
    },
    contentType: function (type) {
      return `ps-content-${type.toLowerCase()}`;
    },
    refItem(index) {
      return this.$refs.items.find(refItem => {
        return refItem.$vnode.key === index;
      });
    },
    itemOffset: function (index) {
      if (index > this.contents.length - 1) return undefined;
      if (index === 0 && this.containsSingleValue) {
        if (this.options.colour === colourOptions.FullColour || !this.containsTextOnlyCommand) {
          return 0;
        } else {
          return 4;
        }
      }
      let offset = this.containsSingleValue ? 0 : this.offset;
      for (let i = 0; i < index; i++) {
        const item = this.refItem(i);
        offset += item.width() + this.separator;
      }
      return offset;
    },
    positionElements: function () {
      let contentsRadius = this.getContentsHeight() / 2;
      let newRadius = contentsRadius > this.minRadius ? contentsRadius : this.minRadius;
      if (!this.containsSingleValueOrText || this.containsTextOnlyCommand && this.options.colour !== colourOptions.FullColour) {
        newRadius += 4;
      }
      this.radius = newRadius;
      this.innerTransforms = [];
      for (let i = 0; i < this.contents.length; i++) {
        const x = this.itemOffset(i);
        let y = 0;
        if (this.$refs.items) {
          const item = this.getRefsItem(i);
          if (item) {
            y = (this.height() - item.height()) / 2;
          }
        }
        this.innerTransforms.push({
          x: x,
          y: y
        });
      }
      this.innerWidth = this.getInnerWidth();
    },
    getRefsItem: function (i) {
      if (this.$refs.items) {
        // first check if the item at position i has the correct key
        // if so return it
        if (this.$refs.items[i].$vnode && this.$refs.items[i].$vnode.key === i) return this.$refs.items[i];
        // otherwise find the $ref items where the $vnode.key === i
        return this.$refs.items.find(item => item.$vnode.key === i);
      }
    },
    getDimOptions: function () {
      let colour = this.options.colour - 1;
      let strokeColour = lighten(this.options.stroke_colour, 50);
      if (colour === 0) {
        colour = 1;
      }
      return {
        colour: colour,
        stroke_colour: strokeColour
      };
    },
    onChanged: function () {
      this.positionElements();
      this.$emit("changed");
    }
  },
  updated: function () {
    // this.positionElements()
  },
  created: function () {
    for (let i = 0; i < this.contents.length; i++) {
      this.$set(this.innerTransforms, i, {
        x: 0,
        y: 0
      });
    }
  },
  mounted: function () {
    this.positionElements();
  }
};

/* script */
const __vue_script__$w = script$w;

/* template */
var __vue_render__$w = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('g', {
    attrs: {
      "transform": _vm.transform
    }
  }, [_c('path', {
    attrs: {
      "stroke": _vm.strokeColour,
      "stroke-width": _vm.strokeWidth,
      "fill": _vm.fillColour,
      "stroke-dasharray": _vm.mainPathDash,
      "fill-opacity": "1",
      "d": _vm.points
    }
  }), _vm._v(" "), _vm.showHighlightPath ? _c('path', {
    attrs: {
      "d": _vm.points,
      "stroke": "#000",
      "stroke-width": _vm.highlightPathStrokeWidth,
      "fill": "none",
      "stroke-dasharray": "4",
      "fill-opacity": "1"
    }
  }) : _vm._e(), _vm._v(" "), _vm.isExtension ? _c('g', {
    attrs: {
      "transform": _vm.transformExtensionImage
    }
  }, [_c('image', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isMystery,
      expression: "!isMystery"
    }],
    attrs: {
      "height": _vm.extensionImageSizePixels,
      "width": _vm.extensionImageSizePixels,
      "xlink:href": _vm.extensionImage
    }
  })]) : _vm._e(), _vm._v(" "), _vm.isExtension ? _c('g', {
    attrs: {
      "transform": "translate(56, 4) "
    }
  }, [_c('line', {
    attrs: {
      "stroke": _vm.lineStroke,
      "stroke-linecap": "round",
      "x1": "0",
      "y1": "0",
      "x2": "0",
      "y2": _vm.extensionLineHeight
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l(_vm.contents, function (content, index) {
    return _c(_vm.contentType(content.command), {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.isMystery,
        expression: "!isMystery"
      }],
      key: index,
      ref: "items",
      refInFor: true,
      tag: "component",
      attrs: {
        "content": content,
        "transforms": _vm.getTransforms(index),
        "options": _vm.options
      },
      on: {
        "changed": _vm.onChanged
      }
    });
  })], 2);
};
var __vue_staticRenderFns__$w = [];

/* style */
const __vue_inject_styles__$w = undefined;
/* scoped */
const __vue_scope_id__$w = "data-v-0596d4a6";
/* module identifier */
const __vue_module_identifier__$w = undefined;
/* functional template */
const __vue_is_functional_template__$w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$y = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$w,
  staticRenderFns: __vue_staticRenderFns__$w
}, __vue_inject_styles__$w, __vue_script__$w, __vue_scope_id__$w, __vue_is_functional_template__$w, __vue_module_identifier__$w, false, undefined, undefined, undefined);
var PsContentValue = __vue_component__$y;

var script$v = {
  name: 'ps-content-matrix',
  components: {
    PsContentText
  },
  props: ['content', 'transforms', 'options'],
  inject: ['blockProperties'],
  data() {
    return {};
  },
  computed: {
    type: function () {
      return this.content.command;
    },
    value: function () {
      return this.content.value;
    },
    isHighlight: function () {
      return this.$parent.isHighlight;
    },
    isDim: function () {
      if (this.options.colour === colourOptions.BlackWhite && !this.isHighlight && this.options.containsHighlight) {
        return true;
      }
      return this.content.isDim || false;
      //return this.content.isDim || this.$parent.isDim
    },
    transform: function () {
      return `translate(${this.transforms.x}, ${this.transforms.y})`;
    }
    // colourOption: function() {
    //     return this.instructions.colour || this.options.colour
    // }
  },
  methods: {
    width: function () {
      return this.getInnerWidth();
    },
    height: function () {
      return this.getInnerWidth();
    },
    getInnerWidth: function () {
      return 24;
    },
    row: function (index) {
      const values = [1, 6, 11, 16, 21];
      return values[index % 5];
    },
    col: function (index) {
      const values = [1, 6, 11, 16, 21];
      return values[Math.floor(index / 5)];
    },
    fill: function (index) {
      if (this.value[index]) {
        if (['x', '1'].includes(this.value[index])) {
          if (!this.isDim && this.options.colour === colourOptions.FullColour) {
            return '#FFFFFF';
          }
          return "#808080";
        } else {
          if (!this.isDim && this.options.colour === colourOptions.FullColour) {
            return addHashPrefix(this.blockProperties.colour);
          } else {
            // return utilities.addHashPrefix(utilities.convertToHex(this.options.stroke_colour))
            return "#FFFFFF";
          }
        }
      }
    },
    stroke: function (index) {
      if (this.value[index]) {
        if (['x', '1'].includes(this.value[index])) {
          if (!this.isDim && this.options.colour === colourOptions.FullColour) {
            //return utilities.addHashPrefix(utilities.convertToHex(this.options.stroke_colour))
            return '#FFFFFF';
          }
          return "#808080";
        } else {
          if (!this.isDim && this.options.colour === colourOptions.FullColour) {
            return addHashPrefix(this.blockProperties.colour);
          } else {
            //return utilities.addHashPrefix(utilities.convertToHex(this.options.stroke_colour))
            return "#808080";
          }
        }
      }
    }
  },
  created: function () {},
  mounted: function () {}
};

/* script */
const __vue_script__$v = script$v;

/* template */
var __vue_render__$v = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('g', {
    staticStyle: {
      "cursor": "default"
    },
    attrs: {
      "transform": _vm.transform,
      "pointer-events": "bounding-box",
      "cursor": "pointer"
    }
  }, _vm._l(_vm.value, function (bit, index) {
    return _c('rect', {
      key: index,
      ref: "items",
      refInFor: true,
      attrs: {
        "x": _vm.row(index),
        "y": _vm.col(index),
        "width": "4",
        "height": "4",
        "rx": "1",
        "ry": "1",
        "fill": _vm.fill(index),
        "stroke": _vm.stroke(index)
      }
    });
  }), 0);
};
var __vue_staticRenderFns__$v = [];

/* style */
const __vue_inject_styles__$v = undefined;
/* scoped */
const __vue_scope_id__$v = "data-v-2c45e099";
/* module identifier */
const __vue_module_identifier__$v = undefined;
/* functional template */
const __vue_is_functional_template__$v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$x = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$v,
  staticRenderFns: __vue_staticRenderFns__$v
}, __vue_inject_styles__$v, __vue_script__$v, __vue_scope_id__$v, __vue_is_functional_template__$v, __vue_module_identifier__$v, false, undefined, undefined, undefined);
var PsContentMatrix = __vue_component__$x;

var script$u = {
  name: "ps-content-dropdown",
  components: {
    PsContentText,
    PsContentValue,
    PsContentMatrix
  },
  props: ["content", "transforms", "options"],
  data() {
    return {
      innerTransforms: [],
      separator: 10,
      innerWidth: 24,
      minHeight: 32,
      minWidth: 24,
      radius: 16,
      minRadius: 16,
      arrowXPosition: 0
    };
  },
  inject: ["appConfig"],
  computed: {
    type: function () {
      return this.content.command;
    },
    contents: function () {
      return this.content.contents || [];
    },
    isChildTextHighlighted: function () {
      if (this.contents.length === 1 && this.contents[0].command.toLowerCase() === "text") {
        return this.contents[0].isHighlight;
      }
      return false;
    },
    isHighlight: function () {
      return this.content.isHighlight || this.isChildTextHighlighted || this.options.colour === colourOptions.BlackWhite && this.$parent.isHighlight;
    },
    isMystery: function () {
      return this.content.isMystery || false;
    },
    isDim: function () {
      if (this.options.colour === colourOptions.BlackWhite && !this.isHighlight && this.options.containsHighlight) {
        return true;
      }
      return this.content.isDim || false;
      //return this.content.isDim || this.$parent.isDim;
    },
    isSquare: function () {
      return this.content.isSquare;
    },
    offset: function () {
      if (this.isSquare) {
        return 8;
      } else {
        return this.radius;
      }
    },
    transform: function () {
      if (this.transforms) {
        return `translate(${this.transforms.x}, ${this.transforms.y})`;
      } else {
        return "translate(0, 0)";
      }
    },
    translateArrow: function () {
      return `translate(${this.arrowXPosition}, ${(this.height() - 12) / 2})`;
    },
    points: function () {
      return `m ${this.radius},0 h ${this.innerWidth} a ${this.radius} ${this.radius} 0 0 1 0 ${this.diameter} H ${this.radius} a ${this.radius} ${this.radius} 0 0 1 0 -${this.diameter} z`;
    },
    showArrow: function () {
      return this.contents[0].command.toLowerCase() === "text" || this.contents[0].command.toLowerCase() === "matrix";
    },
    containsSingleValue: function () {
      return this.contents.length === 1 && this.contents[0].command.toLowerCase() === "value";
    },
    diameter: function () {
      return this.radius * 2;
    },
    fillColour: function () {
      if (!this.isDim && this.options.colour === colourOptions.FullColour) {
        if (this.isSquare) {
          return this.$parent.fillColour;
        } else {
          if (this.$parent.properties) {
            if (this.options.colour === colourOptions.FullColour && this.options.high_contrast) {
              return lightenHEX(this.$parent.fillColour, 20);
            }
            return addHashPrefix(this.$parent.properties.stroke_colour);
          } else {
            this.$parent.strokeColour;
          }
        }
      }
      return "#FFFFFF";
    },
    strokeColour: function () {
      if (this.isHighlight && this.options.colour === colourOptions.BlackWhite) return "#000";
      const options = this.isDim ? this.getDimOptions() : this.options;
      if (options.colour === colourOptions.FullColour) {
        return this.$parent.strokeColour;
      }
      return addHashPrefix(convertToHex(options.stroke_colour));
    },
    strokeWidth: function () {
      let strokeWidth = getStrokeWeight(this.options, true);
      if (this.isHighlight && this.options.colour === colourOptions.BlackWhite) return strokeWidth;
      return strokeWidth;
    },
    imageLink: function () {
      if (!this.isDim && this.options.colour === colourOptions.FullColour) {
        if (this.options.high_contrast) return `${this.appConfig.IMAGE_DIR}/images/bw/dropdown-arrow-black.svg`;
        return `${this.appConfig.IMAGE_DIR}/images/colour/dropdown-arrow.svg`;
      } else {
        return `${this.appConfig.IMAGE_DIR}/images/bw/dropdown-arrow.svg`;
      }
    },
    showHighlightPath: function () {
      if (this.isHighlight && this.options.colour === colourOptions.FullColour) {
        return true;
      }
      return false;
    },
    mainPathDash: function () {
      // if (
      //   this.isHighlight &&
      //   (this.options.colour === drawing.colourOptions.BlackWhite ||
      //     this.options.colour === drawing.colourOptions.ColourOutline)
      // ) {
      //   return "4";
      // }
      return "";
    },
    highlightPathStrokeWidth: function () {
      if (this.options.colour === colourOptions.FullColour) {
        return 3;
      }
      return this.strokeWidth;
    }
  },
  watch: {
    innerWidth: function () {
      this.$emit("changed");
    },
    contents: function () {
      this.$nextTick(() => {
        this.positionElements();
      });
    }
  },
  methods: {
    width: function () {
      if (this.isSquare) {
        return this.getInnerWidth() + 8; //for the arc of the rectangle
      } else {
        let width = this.innerWidth + this.diameter;
        if (this.containsSingleValue) {
          width = this.refItem(0).width();
        }
        return width;
      }
    },
    height: function () {
      if (this.isSquare) {
        const height = this.getContentsHeight();
        return height < this.minHeight ? this.minHeight : height;
      } else {
        return this.radius * 2;
      }
    },
    getInnerWidth: function () {
      if (this.isSquare) {
        return this.getContentsWidth() + this.separator + this.offset + (this.showArrow ? 12 : 0);
      } else {
        return this.getContentsWidth() + (this.showArrow ? 12 : 0); //width of arrow
      }
    },
    getContentsHeight: function () {
      if (this.$refs.items) {
        let heights = this.$refs.items.map(item => item.height());
        return Math.max(...heights);
      } else {
        return this.minHeight;
      }
    },
    getContentsWidth: function () {
      let width = 0;
      if (this.$refs.items) {
        width = this.$refs.items.map(item => item.width()).reduce((a, b) => a + b, 0);
        if (this.containsSingleValue) {
          width -= this.offset * 2;
        } else {
          width += this.separator * (this.$refs.items.length - 1);
        }
      }
      return width === 0 ? this.minWidth : width;
    },
    getTransforms: function (index) {
      if (this.innerTransforms.length > 0) {
        return this.innerTransforms[index];
      }
    },
    contentType: function (type) {
      return `ps-content-${type.toLowerCase()}`;
    },
    refItem(index) {
      return this.$refs.items.find(refItem => {
        return refItem.$vnode.key === index;
      });
    },
    itemOffset: function (index) {
      if (index > this.contents.length - 1) return undefined;
      if (index === 0) return this.containsSingleValue ? 0 : this.offset;
      let offset = this.containsSingleValue ? 0 : this.offset;
      for (let i = 0; i < index; i++) {
        const item = this.refItem(i);
        offset += item.width() + this.separator;
      }
      return offset;
    },
    positionElements: function () {
      let contentsRadius = this.getContentsHeight() / 2;
      let newRadius = contentsRadius > this.minRadius ? contentsRadius : this.minRadius;
      if (!this.containsSingleValue && this.$refs.items.length > 1) {
        newRadius += 4;
      }
      this.radius = newRadius;
      for (let i = 0; i < this.innerTransforms.length; i++) {
        this.innerTransforms[i].x = this.itemOffset(i);
        if (this.$refs.items) {
          const item = this.getRefsItem(i);
          if (item) {
            this.innerTransforms[i].y = (this.height() - item.height()) / 2;
          }
        }
      }
      this.innerWidth = this.getInnerWidth();
      if (this.isSquare) {
        this.arrowXPosition = this.getContentsWidth() + this.separator + this.offset;
      } else {
        this.arrowXPosition = this.getContentsWidth() + this.separator / 2 + this.radius;
      }
    },
    getRefsItem: function (i) {
      if (this.$refs.items) {
        // first check if the item at position i has the correct key
        // if so return it
        if (this.$refs.items[i].$vnode.key === i) return this.$refs.items[i];
        // otherwise find the $ref items where the $vnode.key === i
        return this.$refs.items.find(item => item.$vnode.key === i);
      }
    },
    getDimOptions: function () {
      let dimColour = this.options.colour - 1;
      let strokeColour = lighten(this.options.stroke_colour, 50);
      if (dimColour === 0) {
        dimColour = 1;
      }
      return {
        colour: dimColour,
        stroke_colour: strokeColour
      };
    },
    onChanged: function () {
      this.positionElements();
      this.$emit("changed");
    }
  },
  created: function () {
    for (let i = 0; i < this.contents.length; i++) {
      this.$set(this.innerTransforms, i, {
        x: 0,
        y: 0
      });
    }
  },
  mounted: function () {
    this.positionElements();
  }
};

/* script */
const __vue_script__$u = script$u;

/* template */
var __vue_render__$u = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('g', {
    attrs: {
      "transform": _vm.transform
    }
  }, [_vm.isSquare ? [_c('rect', {
    attrs: {
      "rx": "4",
      "ry": "4",
      "x": "0",
      "y": "0",
      "width": _vm.width(),
      "height": "32",
      "stroke": _vm.strokeColour,
      "stroke-width": _vm.strokeWidth,
      "fill": _vm.fillColour,
      "stroke-dasharray": _vm.mainPathDash,
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _vm.showHighlightPath ? _c('rect', {
    attrs: {
      "rx": "4",
      "ry": "4",
      "x": "0",
      "y": "0",
      "width": _vm.width(),
      "height": "32",
      "stroke": "#000",
      "stroke-width": _vm.highlightPathStrokeWidth,
      "fill": "none",
      "stroke-dasharray": 4,
      "fill-opacity": "1"
    }
  }) : _vm._e()] : [_c('path', {
    attrs: {
      "stroke": _vm.strokeColour,
      "stroke-width": _vm.strokeWidth,
      "fill": _vm.fillColour,
      "stroke-dasharray": _vm.mainPathDash,
      "fill-opacity": "1",
      "d": _vm.points
    }
  }), _vm._v(" "), _vm.showHighlightPath ? _c('path', {
    attrs: {
      "d": _vm.points,
      "stroke": "#000",
      "stroke-width": _vm.highlightPathStrokeWidth,
      "fill": "none",
      "stroke-dasharray": "4",
      "fill-opacity": "1"
    }
  }) : _vm._e()], _vm._v(" "), [_vm.showArrow ? _c('image', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isMystery,
      expression: "!isMystery"
    }],
    attrs: {
      "height": "12px",
      "width": "12px",
      "xlink:href": _vm.imageLink,
      "transform": _vm.translateArrow
    }
  }) : _vm._e(), _vm._v(" "), _vm._l(_vm.contents, function (content, index) {
    return _c(_vm.contentType(content.command), {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.isMystery,
        expression: "!isMystery"
      }],
      key: index,
      ref: "items",
      refInFor: true,
      tag: "component",
      attrs: {
        "content": content,
        "transforms": _vm.getTransforms(index),
        "options": _vm.options
      },
      on: {
        "changed": _vm.onChanged
      }
    });
  })]], 2);
};
var __vue_staticRenderFns__$u = [];

/* style */
const __vue_inject_styles__$u = undefined;
/* scoped */
const __vue_scope_id__$u = "data-v-705c6d8c";
/* module identifier */
const __vue_module_identifier__$u = undefined;
/* functional template */
const __vue_is_functional_template__$u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$w = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$u,
  staticRenderFns: __vue_staticRenderFns__$u
}, __vue_inject_styles__$u, __vue_script__$u, __vue_scope_id__$u, __vue_is_functional_template__$u, __vue_module_identifier__$u, false, undefined, undefined, undefined);
var PsContentDropdown = __vue_component__$w;

var script$t = {
  name: "ps-content-condition",
  components: {
    PsContentText,
    PsContentValue,
    PsContentDropdown
  },
  props: ["content", "transforms", "options"],
  // inject: ['blockProperties'],
  data() {
    return {
      innerTransforms: [],
      offset: 20,
      separator: 10,
      minHeight: 40,
      radius: 20,
      minRadius: 20,
      innerWidth: 24
    };
  },
  computed: {
    type: function () {
      return this.content.command;
    },
    contents: function () {
      return this.content.contents || [];
    },
    properties: function () {
      return this.content.properties;
    },
    isHighlight: function () {
      return this.content.isHighlight || this.options.colour === colourOptions.BlackWhite && this.$parent.isHighlight;
    },
    isMystery: function () {
      return this.content.isMystery || false;
    },
    isDim: function () {
      if (this.options.colour === colourOptions.BlackWhite && !this.isHighlight && this.options.containsHighlight) {
        return true;
      }
      return this.content.isDim || false;
      //return this.content.isDim || this.$parent.isDim;
    },
    transform: function () {
      if (this.transforms) {
        return `translate(${this.transforms.x}, ${this.transforms.y})`;
      } else {
        return "translate(0, 0)";
      }
    },
    points: function () {
      return `m 0,0 m ${this.radius},0 h ${this.innerWidth} l ${this.radius} ${this.radius} l -${this.radius} ${this.radius} H ${this.radius} l -${this.radius} -${this.radius} l ${this.radius} -${this.radius} z`;
    },
    containsSingleCondition: function () {
      return this.contents.length === 1 && this.contents[0].command.toLowerCase() === "condition";
    },
    diameter: function () {
      return this.radius * 2;
    },
    numContents: function () {
      return this.content.contents.length;
    },
    fillColour: function () {
      // if (!this.isDim && this.properties && this.options.colour === drawing.colourOptions.FullColour) {
      //     return utilities.addHashPrefix(this.properties.colour)
      // }
      // return '#FFFFFF'
      const options = this.isDim ? this.getDimOptions() : this.options;
      return getFillColour(this.properties, options);
    },
    strokeColour: function () {
      if (this.isHighlight && this.options.colour === colourOptions.BlackWhite) return "#000";
      const options = this.isDim ? this.getDimOptions() : this.options;
      if (options.colour === colourOptions.FullColour) {
        if (this.properties) {
          if (this.$parent.$options.name === "ps-drawing") {
            //ContentValue has ps-drawing as the parent
            return addHashPrefix(this.properties.colour);
          } else {
            return addHashPrefix(this.properties.stroke_colour);
          }
        }
        return addHashPrefix(this.$parent.properties.stroke_colour);
      } else if (options.colour === colourOptions.ColourOutline) {
        if (this.properties) return addHashPrefix(this.properties.stroke_colour);
      }
      return addHashPrefix(convertToHex(options.stroke_colour));
    },
    strokeWidth: function () {
      let strokeWidth = getStrokeWeight(this.options, true);
      if (this.isHighlight && this.options.colour === colourOptions.BlackWhite) return strokeWidth;
      return strokeWidth;
    },
    showHighlightPath: function () {
      if (this.isHighlight && this.options.colour === colourOptions.FullColour) {
        return true;
      }
      return false;
    },
    mainPathDash: function () {
      // if (
      //   this.isHighlight &&
      //   (this.options.colour === drawing.colourOptions.BlackWhite ||
      //     this.options.colour === drawing.colourOptions.ColourOutline)
      // ) {
      //   return "4";
      // }
      return "";
    },
    highlightPathStrokeWidth: function () {
      if (this.options.colour === colourOptions.FullColour) {
        return 3;
      }
      return this.strokeWidth;
    }
  },
  watch: {
    innerWidth: function () {
      this.$emit("changed");
    },
    numContents: function () {
      //console.log('numContents has changed')
      this.positionElements();
      this.$emit("changed");
    }
  },
  methods: {
    width: function () {
      let width = this.innerWidth + this.diameter;
      if (this.containsSingleCondition) {
        width = this.refItem(0).width();
      }
      return width;
    },
    height: function () {
      return this.radius * 2;
    },
    getInnerWidth: function () {
      let width = this.getContentsWidth();
      if (this.containsSingleCondition) {
        width -= this.diameter;
      }
      if (this.$refs.items[0].$vnode.tag.indexOf("content-condition") > 0) {
        width -= this.diameter - 12;
      }
      return width < 24 ? 24 : width;
    },
    getContentsHeight: function () {
      // Need to change that so that height increases if it contains a command
      let height = 0;
      if (this.$refs.items) {
        let heights = this.$refs.items.map(item => item.height());
        height = Math.max(...heights);
      }
      return height;
    },
    getContentsWidth: function () {
      let width = 0;
      if (this.$refs.items) {
        width = this.$refs.items.map(item => item.width()).reduce((a, b) => a + b, 0);
        if (!this.containsSingleCondition) {
          width += this.separator * (this.$refs.items.length - 1);
        }
      }
      return width === 0 ? 24 : width;
    },
    getTransforms: function (index) {
      if (this.innerTransforms.length > 0) {
        return this.innerTransforms[index];
      }
    },
    contentType: function (type) {
      return `ps-content-${type.toLowerCase()}`;
    },
    refItem(index) {
      return this.$refs.items.find(refItem => {
        return refItem.$vnode.key === index;
      });
    },
    itemOffset: function (index) {
      if (index > this.contents.length - 1) return undefined;
      // if (index === 0) return this.containsSingleCondition ? 0 : this.radius
      if (index == 0) {
        if (this.containsSingleCondition) return 0;
        if (this.$refs.items && this.$refs.items[0].$vnode.tag.indexOf("content-condition") > 0) {
          return 6;
        } else {
          return this.radius;
        }
      } else {
        let offset = this.itemOffset(0);
        for (let i = 0; i < index; i++) {
          const item = this.refItem(i);
          offset += item.width() + this.separator;
          // }
        }
        return offset;
      }
    },
    positionElements: function () {
      let contentsRadius = this.getContentsHeight() / 2;
      let newRadius = contentsRadius > this.minRadius ? contentsRadius : this.minRadius;
      if (!this.containsSingleCondition && this.$refs.items.length > 1) {
        newRadius += 4;
      }
      this.radius = newRadius;
      this.innerTransforms = [];
      for (let i = 0; i < this.contents.length; i++) {
        const x = this.itemOffset(i);
        let y = 0;
        if (this.$refs.items) {
          const item = this.getRefsItem(i);
          if (item) {
            y = (this.height() - item.height()) / 2;
          }
        }
        this.innerTransforms.push({
          x: x,
          y: y
        });
      }
      this.innerWidth = this.getInnerWidth();
    },
    getRefsItem: function (i) {
      if (this.$refs.items) {
        // first check if the item at position i has the correct key
        // if so return it
        if (this.$refs.items[i].$vnode.key === i) return this.$refs.items[i];
        // otherwise find the $ref items where the $vnode.key === i
        return this.$refs.items.find(item => item.$vnode.key === i);
      }
    },
    getDimOptions: function () {
      let dimColour = this.options.colour - 1;
      let strokeColour = lighten(this.options.stroke_colour, 50);
      if (dimColour === 0) {
        dimColour = 1;
      }
      return {
        colour: dimColour,
        stroke_colour: strokeColour
      };
    },
    onChanged: function () {
      this.positionElements();
      this.$emit("changed");
    }
  },
  updated: function () {
    // this.positionElements()
  },
  created: function () {
    for (let i = 0; i < this.contents.length; i++) {
      this.$set(this.innerTransforms, i, {
        x: 0,
        y: 0
      });
    }
  },
  mounted: function () {
    this.positionElements();
  }
};

/* script */
const __vue_script__$t = script$t;

/* template */
var __vue_render__$t = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('g', {
    attrs: {
      "transform": _vm.transform
    }
  }, [_c('path', {
    attrs: {
      "stroke": _vm.strokeColour,
      "stroke-width": _vm.strokeWidth,
      "fill": _vm.fillColour,
      "stroke-dasharray": _vm.mainPathDash,
      "fill-opacity": "1",
      "d": _vm.points
    }
  }), _vm._v(" "), _vm.showHighlightPath ? _c('path', {
    attrs: {
      "d": _vm.points,
      "stroke": "#000",
      "stroke-width": _vm.highlightPathStrokeWidth,
      "fill": "none",
      "stroke-dasharray": "4",
      "fill-opacity": "1"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l(_vm.contents, function (content, index) {
    return _c(_vm.contentType(content.command), {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !_vm.isMystery,
        expression: "!isMystery"
      }],
      key: index,
      ref: "items",
      refInFor: true,
      tag: "component",
      attrs: {
        "content": content,
        "transforms": _vm.getTransforms(index),
        "options": _vm.options
      },
      on: {
        "changed": _vm.onChanged
      }
    });
  })], 2);
};
var __vue_staticRenderFns__$t = [];

/* style */
const __vue_inject_styles__$t = undefined;
/* scoped */
const __vue_scope_id__$t = "data-v-e3034fda";
/* module identifier */
const __vue_module_identifier__$t = undefined;
/* functional template */
const __vue_is_functional_template__$t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$v = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$t,
  staticRenderFns: __vue_staticRenderFns__$t
}, __vue_inject_styles__$t, __vue_script__$t, __vue_scope_id__$t, __vue_is_functional_template__$t, __vue_module_identifier__$t, false, undefined, undefined, undefined);
var PsContentCondition = __vue_component__$v;

var script$s = {
  name: "ps-content",
  components: {
    PsContentText,
    PsContentFlag,
    PsContentTurnright,
    PsContentTurnleft,
    PsContentValue,
    PsContentCondition,
    PsContentDropdown,
    PsContentMatrix
  },
  props: ["contents", "transforms", "options"],
  data() {
    return {
      innerTransforms: [],
      offset: 8,
      separator: 10
    };
  },
  computed: {
    transform: function () {
      return `translate(${this.transforms.x}, ${this.transforms.y})`;
    },
    fillColour: function () {
      return this.$parent.fillColour;
    },
    strokeColour: function () {
      return this.$parent.strokeColour;
    },
    properties: function () {
      return this.$parent.properties;
    },
    isDim: function () {
      return this.$parent.isDim;
    },
    isHighlight: function () {
      return this.$parent.isHighlight;
    }
  },
  watch: {
    "contents.length": function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$nextTick(() => {
          this.onChanged();
        });
      }
    }
  },
  methods: {
    width: function () {
      // return this.$refs.items
      // .map(item => item.width())
      // .reduce((a, b) => a + b, 0) + this.offset * 2 + this.separator * (this.$refs.items.length - 1)
      const lastItem = this.$refs.items.length - 1;
      return this.itemOffset(lastItem) + this.refItem(lastItem).width() + this.offset;
    },
    height: function () {
      let heights = this.$refs.items.map(item => item.height());
      return Math.max(...heights);
    },
    contentType: function (type) {
      return `ps-content-${type.toLowerCase()}`;
    },
    getTransforms: function (index) {
      if (this.innerTransforms.length > 0) {
        return this.innerTransforms[index];
      }
    },
    refItem(index) {
      return this.$refs.items.find(refItem => {
        return refItem.$vnode.key === index;
      });
    },
    itemOffset: function (index) {
      if (index === 0) return this.offset;
      let offset = this.offset;
      for (let i = 0; i < index; i++) {
        const ref = this.refItem(i);
        if (ref) {
          offset += ref.width() + this.separator;
        }
      }
      return offset;
    },
    getContent: function (content) {
      //This function can be used to eliminate a value inside a value however
      //I don't like the approach
      if (content.command === "Value" && content.contents.length === 1 && content.contents[0].command === "Value") {
        return content.contents[0];
      }
      return content;
    },
    setInnerTransforms: function () {
      this.innerTransforms = [];
      for (let i = 0; i < this.contents.length; i++) {
        const x = this.itemOffset(i);
        let y = 0;
        if (this.$refs.items) {
          const item = this.getRefsItem(i);
          if (item) {
            const itemHeight = item.height();
            y = (this.height() - itemHeight) / 2;
          }
        }
        this.innerTransforms.push({
          x: x,
          y: y
        });
      }
    },
    getRefsItem: function (i) {
      if (this.$refs.items) {
        // first check if the item at position i has the correct key
        // if so return it
        if (this.$refs.items[i].$vnode.key === i) return this.$refs.items[i];
        // otherwise find the $ref items where the $vnode.key === i
        return this.$refs.items.find(item => item.$vnode.key === i);
      }
    },
    onChanged: function () {
      this.setInnerTransforms();
      this.$emit("changed");
    }
  },
  created: function () {
    for (let i = 0; i < this.contents.length; i++) {
      this.$set(this.innerTransforms, i, {
        x: 0,
        y: 0
      });
    }
  },
  mounted: function () {
    this.setInnerTransforms();
  }
};

/* script */
const __vue_script__$s = script$s;

/* template */
var __vue_render__$s = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('g', {
    attrs: {
      "transform": _vm.transform
    }
  }, _vm._l(_vm.contents, function (content, index) {
    return _c(_vm.contentType(content.command), {
      key: index,
      ref: "items",
      refInFor: true,
      tag: "component",
      attrs: {
        "content": content,
        "transforms": _vm.getTransforms(index),
        "options": _vm.options
      },
      on: {
        "changed": _vm.onChanged
      }
    });
  }), 1);
};
var __vue_staticRenderFns__$s = [];

/* style */
const __vue_inject_styles__$s = undefined;
/* scoped */
const __vue_scope_id__$s = "data-v-1c7bcc68";
/* module identifier */
const __vue_module_identifier__$s = undefined;
/* functional template */
const __vue_is_functional_template__$s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$u = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$s,
  staticRenderFns: __vue_staticRenderFns__$s
}, __vue_inject_styles__$s, __vue_script__$s, __vue_scope_id__$s, __vue_is_functional_template__$s, __vue_module_identifier__$s, false, undefined, undefined, undefined);
var PsContent = __vue_component__$u;

var script$r = {
  name: 'ps-hint-line',
  props: ['line', 'x', 'dy', 'fontSize'],
  data() {
    return {
      context: document.createElement("canvas").getContext("2d"),
      fontFamily: "helvetica neue",
      fontWeight: 500
    };
  },
  methods: {
    width: function () {
      this.context.font = `${this.fontWeight} ${this.fontSize}pt ${this.fontFamily}`;
      return this.context.measureText(this.line).width * 169.17 / 152;
    },
    height: function () {
      return this.fontSize;
    }
  }
};

/* script */
const __vue_script__$r = script$r;

/* template */
var __vue_render__$r = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('tspan', {
    attrs: {
      "x": _vm.x,
      "dy": _vm.dy
    }
  }, [_vm._v(_vm._s(_vm.line))]);
};
var __vue_staticRenderFns__$r = [];

/* style */
const __vue_inject_styles__$r = undefined;
/* scoped */
const __vue_scope_id__$r = "data-v-72297abb";
/* module identifier */
const __vue_module_identifier__$r = undefined;
/* functional template */
const __vue_is_functional_template__$r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$t = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$r,
  staticRenderFns: __vue_staticRenderFns__$r
}, __vue_inject_styles__$r, __vue_script__$r, __vue_scope_id__$r, __vue_is_functional_template__$r, __vue_module_identifier__$r, false, undefined, undefined, undefined);
var PsHintLine = __vue_component__$t;

var script$q = {
  name: 'ps-hint',
  props: ['hint', 'transform', 'options', 'parentHeight'],
  components: {
    PsHintLine
  },
  data() {
    return {
      context: document.createElement("canvas").getContext("2d"),
      fontSize: 12,
      fontFamily: "helvetica neue",
      fontWeight: 500,
      spaceChar: ' ',
      slashChar: '/',
      optimalLineLength: 90,
      separator: 10
    };
  },
  computed: {
    fillColour: function () {
      return addHashPrefix(convertToHex(this.options.text_colour));
    },
    lines: function () {
      return this.getLines();
    },
    numWords: function () {
      return this.hint.split(this.spaceChar).length;
    },
    numSlashes: function () {
      return this.hint.split(this.slashChar).length;
    },
    getX: function (index) {
      return this.transform.x + this.separator;
    }
  },
  watch: {
    parentHeight: function () {
      if (this.lines.length === 1) {
        this.transform.y = this.parentHeight / 2;
      } else {
        this.transform.y = (this.parentHeight - this.height()) / 2;
      }
    }
  },
  methods: {
    textWidth: function (text) {
      this.context.font = `${this.fontWeight} ${this.fontSize}pt ${this.fontFamily}`;
      return this.context.measureText(text).width * 169.17 / 152;
    },
    width: function () {
      if (this.$refs.items) {
        const widths = this.$refs.items.map(item => item.width());
        return Math.max(...widths) + this.separator;
      }
      return 0;
    },
    height: function () {
      // This does not account for the separator of 5 used in getDYTransforms
      if (this.$refs.items) {
        return this.$refs.items.map(item => item.height()).reduce((a, b) => a + b, 0);
      }
      return 0;
    },
    getDYTransforms: function (index) {
      if (index === 0) return 0;else return this.fontSize + 5;
    },
    getLines: function () {
      let lines = [];
      if (this.numWords > 1) {
        const lineWidth = this.textWidth(this.hint);
        if (lineWidth > this.optimalLineLength) {
          //split lines
          const newTargetLength = Math.floor(lineWidth / 2);
          lines = this.splitLines(this.hint, this.spaceChar, newTargetLength);
        } else {
          lines.push(this.hint);
        }
      } else if (this.numSlashes > 0) {
        const lineWidth = this.textWidth(this.hint);
        if (lineWidth > this.optimalLineLength) {
          //split lines
          const newTargetLength = Math.floor(lineWidth / 2);
          lines = this.splitLines(this.hint, this.slashChar, newTargetLength);
        } else {
          lines.push(this.hint);
        }
      } else {
        lines.push(this.hint);
      }
      if (lines.length === 1) {
        this.transform.y = this.parentHeight / 2;
      } else {
        this.transform.y = (this.parentHeight - this.height()) / 2;
      }
      return lines;
    },
    // recalculateTransformY: function() {
    //     if (this.lines.length === 1) {
    //         this.transform.y = this.parentHeight / 2
    //     } else {
    //         this.transform.y = (this.parentHeight - this.height()) / 2
    //     }
    // },
    splitLines: function (lineToSplit, char, targetLength) {
      let lines = [];
      const words = lineToSplit.split(char);
      let line = '';
      for (let word of words) {
        line = line === '' ? word : `${line}${char}${word}`;
        if (this.textWidth(line) > targetLength) break;
      }
      lines.push(line);
      const remaining = lineToSplit.replace(line, '');
      if (remaining.length > 0) lines.push(remaining.trim());
      return lines;
    }
  }
};

/* script */
const __vue_script__$q = script$q;

/* template */
var __vue_render__$q = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('text', {
    staticClass: "scratch-font",
    attrs: {
      "x": _vm.transform.x,
      "y": _vm.transform.y,
      "fill": _vm.fillColour,
      "text-anchor": "start",
      "dominant-baseline": "middle",
      "dy": "0"
    }
  }, _vm._l(_vm.lines, function (line, index) {
    return _c('PsHintLine', {
      key: index,
      ref: "items",
      refInFor: true,
      attrs: {
        "line": line,
        "x": _vm.getX,
        "dy": _vm.getDYTransforms(index),
        "fontSize": _vm.fontSize
      }
    });
  }), 1);
};
var __vue_staticRenderFns__$q = [];

/* style */
const __vue_inject_styles__$q = function (inject) {
  if (!inject) return;
  inject("data-v-32d63662_0", {
    source: ".scratch-font[data-v-32d63662]{font-family:\"Helvetica Neue\",Helvetica,sans-serif;font-size:12pt;font-weight:500}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$q = "data-v-32d63662";
/* module identifier */
const __vue_module_identifier__$q = undefined;
/* functional template */
const __vue_is_functional_template__$q = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$s = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$q,
  staticRenderFns: __vue_staticRenderFns__$q
}, __vue_inject_styles__$q, __vue_script__$q, __vue_scope_id__$q, __vue_is_functional_template__$q, __vue_module_identifier__$q, false, createInjector, undefined, undefined);
var PsHint = __vue_component__$s;

var script$p = {
  name: "ps-content-myblock",
  props: ["content", "transforms", "options"],
  components: {
    PsContent,
    PsHint
  },
  data() {
    return {
      cornerArc: 4,
      padding: 10,
      innerWidth: 139,
      innerHeight: 48,
      minInnerWidth: 56,
      extensionOffset: 56,
      extensionImageHeight: 40,
      innerTransforms: {
        x: 0,
        y: 0
      }
    };
  },
  computed: {
    type: function () {
      return this.content.block;
    },
    contents: function () {
      let contents = [];
      if (this.content.contents) {
        contents = this.content.contents;
        for (let content of contents) {
          if (content.command === "Value" || content.command === "Condition") {
            content.properties = this.properties;
          }
        }
      }
      return contents;
    },
    properties: function () {
      return this.content.properties;
    },
    isHighlight: function () {
      return this.content.isHighlight || false;
    },
    isMystery: function () {
      return this.content.isMystery || false;
    },
    isDim: function () {
      if (this.options.colour === colourOptions.BlackWhite && !this.content.isHighlight && this.options.containsHighlight) {
        return true;
      }
      return this.content.isDim || false;
      //return this.content.isDim || this.$parent.isDim;
    },
    isMyVar: function () {
      return this.content.isMyVar || false;
    },
    isMyList: function () {
      return this.content.isMyList || false;
    },
    isEnd: function () {
      return this.content.isEnd || false;
    },
    width: function () {
      let width = this.innerWidth + 2 * this.cornerArc;
      if (this.hint !== "" && this.$refs.hint) {
        width += this.$refs.hint.width();
      }
      return width;
    },
    widthSansHint: function () {
      return this.innerWidth + 2 * this.cornerArc;
    },
    height: function () {
      return this.innerHeight + 2 * this.cornerArc + Math.floor(this.strokeWidth / 2) * 2;
    },
    minHeight: function () {
      if (this.isExtension) {
        return 48;
      } else {
        return 40;
      }
    },
    isExtension: function () {
      return this.content.properties.is_extension;
    },
    extensionName: function () {
      return this.content.properties.short_name;
    },
    // colourOption: function() {
    //     return this.instructions.colour || this.options.colour
    // },
    extensionImage: function () {
      if (this.options.colour === colourOptions.FullColour) {
        return `/static/src/images/colour/${this.extensionName}.svg`;
      } else {
        return `/static/src/images/bw/${this.extensionName}.svg`;
      }
    },
    extensionImageSizePixels: function () {
      return `${this.extensionImageHeight}px`;
    },
    points: function () {
      //"M100 10 L300 10 L300 100 L100 100 Z"
      // path = "m 0,0"
      return `m 0,4 A 4,4 0 0,1 4,0 H 12 c 2,0 3,1 4,2 l 4,4 c 1,1 2,2 4,2 h 12 c 2,0 3,-1 4,-2 l 4,-4 c 1,-1 2,-2 4,-2 H ${this.innerWidth} a 4,4 0 0,1 4,4 v ${this.innerHeight}  a 4,4 0 0,1 -4,4 H 48   c -2,0 -3,1 -4,2 l -4,4 c -1,1 -2,2 -4,2 h -12 c -2,0 -3,-1 -4,-2 l -4,-4 c -1,-1 -2,-2 -4,-2 H 4 a 4,4 0 0,1 -4,-4 z`;
    },
    transform: function () {
      if (this.transforms) {
        return `translate(${this.transforms.x}, ${this.transforms.y})`;
      } else {
        return "translate(0, 0)";
      }
    },
    transformExtensionImage: function () {
      //translate(8, 12)
      const x = 8,
        y = 12;
      return `translate(${x}, ${y})`;
    },
    fillColour: function () {
      const options = this.isDim ? this.getDimOptions() : this.options;
      let properties = JSON.parse(JSON.stringify(this.properties));
      properties.colour = properties.stroke_colour;
      if (options.high_contrast) {
        properties.hc_colour = lightenHEX(properties.hc_colour, 20);
      }
      return getFillColour(properties, options);
    },
    strokeColour: function () {
      if (this.isHighlight && this.options.colour === colourOptions.BlackWhite) return "#000";
      const options = this.isDim ? this.getDimOptions() : this.options;
      return getStrokeColour(this.properties, options);
    },
    strokeWidth: function () {
      let strokeWidth = getStrokeWeight(this.options);
      if (this.isHighlight && this.options.colour === colourOptions.BlackWhite) return strokeWidth + 1;
      return strokeWidth;
    },
    lineStroke: function () {
      if (this.options.colour === colourOptions.FullColour) {
        return "#0DA57A";
      } else {
        return addHashPrefix(convertToHex(this.options.stroke_colour));
      }
    },
    hint: function () {
      if (this.content.manualHint) return this.content.manualHint;
      if (this.options.auto_hints || this.content.isAutoHint) {
        return this.content.autoHint;
      }
      return "";
    },
    hintTransform: function () {
      return {
        x: this.widthSansHint,
        y: 0
      };
    },
    showHighlightPath: function () {
      if (this.isHighlight && (this.options.colour === colourOptions.ColourOutline || this.options.colour === colourOptions.FullColour)) {
        return true;
      }
      return false;
    },
    mainPathDash: function () {
      // if (
      //   this.isHighlight &&
      //   this.options.colour === drawing.colourOptions.BlackWhite
      // ) {
      //   return "4";
      // }
      return "";
    },
    highlightPathStrokeWidth: function () {
      if (this.options.colour === colourOptions.FullColour) {
        return 3;
      }
      return this.strokeWidth;
    }
  },
  provide() {
    return {
      blockProperties: this.properties
    };
  },
  methods: {
    getContentsWidth: function () {
      if (this.$refs.item) {
        let innerWidth = this.$refs.item.width();
        if (this.isExtension) {
          innerWidth += this.extensionOffset;
        }
        return innerWidth < this.minInnerWidth ? this.minInnerWidth : innerWidth;
      }
      return 0;
    },
    getContentsHeight: function () {
      if (this.$refs.item) {
        return this.$refs.item.height();
      }
      return this.minHeight;
    },
    getTransforms: function (index) {
      return this.innerTransforms[index];
    },
    positionElements: function () {
      this.innerWidth = this.getContentsWidth();
      let innerHeight = this.minHeight + this.getContentsHeight() - 32;
      this.innerHeight = innerHeight < this.minHeight ? this.minHeight : innerHeight;
      this.setInnerTransformations();
    },
    setInnerTransformations: function () {
      if (this.isExtension) {
        {
          this.innerTransforms.x = this.extensionOffset;
        }
      }
      if (this.$refs.item) {
        this.innerTransforms.y = (this.height - this.$refs.item.height()) / 2;
      }
    },
    getDimOptions: function () {
      let colour = this.options.colour - 1;
      let strokeColour = lighten(this.options.stroke_colour, 50);
      if (colour === 0) {
        colour = 1;
      }
      return {
        colour: colour,
        stroke_colour: strokeColour
      };
    },
    onChanged: function () {
      this.positionElements();
      this.$emit("changed");
    }
  },
  created: function () {},
  mounted: function () {
    this.positionElements();
  }
};

/* script */
const __vue_script__$p = script$p;

/* template */
var __vue_render__$p = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('g', {
    attrs: {
      "transform": _vm.transform
    }
  }, [_c('path', {
    attrs: {
      "d": _vm.points,
      "stroke": _vm.strokeColour,
      "stroke-width": _vm.strokeWidth,
      "fill": _vm.fillColour,
      "stroke-dasharray": _vm.mainPathDash,
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _vm.showHighlightPath ? _c('path', {
    attrs: {
      "d": _vm.points,
      "stroke": "#000",
      "stroke-width": _vm.highlightPathStrokeWidth,
      "fill": "none",
      "stroke-dasharray": "4",
      "fill-opacity": "1"
    }
  }) : _vm._e(), _vm._v(" "), _vm.isExtension ? _c('g', {
    attrs: {
      "transform": _vm.transformExtensionImage
    }
  }, [_c('image', {
    attrs: {
      "height": _vm.extensionImageSizePixels,
      "width": _vm.extensionImageSizePixels,
      "xlink:href": _vm.extensionImage
    }
  })]) : _vm._e(), _vm._v(" "), _vm.isExtension ? _c('g', {
    attrs: {
      "transform": "translate(56, 8) "
    }
  }, [_c('line', {
    attrs: {
      "stroke": _vm.lineStroke,
      "stroke-linecap": "round",
      "x1": "0",
      "y1": "0",
      "x2": "0",
      "y2": "40"
    }
  })]) : _vm._e(), _vm._v(" "), _c('PsContent', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isMystery,
      expression: "!isMystery"
    }],
    ref: "item",
    attrs: {
      "contents": _vm.contents,
      "transforms": _vm.innerTransforms,
      "options": _vm.options
    },
    on: {
      "changed": _vm.onChanged
    }
  })], 1);
};
var __vue_staticRenderFns__$p = [];

/* style */
const __vue_inject_styles__$p = undefined;
/* scoped */
const __vue_scope_id__$p = "data-v-2ba05315";
/* module identifier */
const __vue_module_identifier__$p = undefined;
/* functional template */
const __vue_is_functional_template__$p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$r = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$p,
  staticRenderFns: __vue_staticRenderFns__$p
}, __vue_inject_styles__$p, __vue_script__$p, __vue_scope_id__$p, __vue_is_functional_template__$p, __vue_module_identifier__$p, false, undefined, undefined, undefined);
var PsContentMyBlock = __vue_component__$r;

var script$o = {
  name: "ps-block-basic",
  props: ["content", "transforms", "options"],
  components: {
    PsContent,
    PsHint
  },
  data() {
    return {
      cornerArc: 4,
      padding: 10,
      innerWidth: 139,
      innerHeight: 48,
      minInnerWidth: 56,
      extensionOffset: 56,
      extensionImageHeight: 40,
      innerTransforms: {
        x: 0,
        y: 0
      },
      flatBottom: "a 4,4 0 0,1 -4,4 H 4 a 4,4 0 0,1 -4,-4 z",
      connectorBottom: "a 4,4 0 0,1 -4,4 H 48 c -2,0 -3,1 -4,2 l -4,4 c -1,1 -2,2 -4,2 h -12 c -2,0 -3,-1 -4,-2 l -4,-4 c -1,-1 -2,-2 -4,-2 H 4 a 4,4 0 0,1 -4,-4 z"
    };
  },
  inject: ["appConfig"],
  computed: {
    type: function () {
      return this.content.block;
    },
    contents: function () {
      return this.content.contents || [];
    },
    properties: function () {
      return this.content.properties;
    },
    isHighlight: function () {
      return this.content.isHighlight || false;
    },
    isMystery: function () {
      return this.content.isMystery || false;
    },
    isDim: function () {
      if (this.options.colour === colourOptions.BlackWhite && !this.content.isHighlight && this.options.containsHighlight) {
        return true;
      }
      return this.content.isDim || false;
    },
    isMyVar: function () {
      return this.content.isMyVar || false;
    },
    isMyList: function () {
      return this.content.isMyList || false;
    },
    isEnd: function () {
      return this.content.isEnd || false;
    },
    width: function () {
      let width = this.innerWidth + 2 * this.cornerArc;
      if (this.options.auto_hints || this.hint !== "" && this.$refs.hint) {
        width += this.$refs.hint.width();
      }
      return width;
    },
    widthSansHint: function () {
      return this.innerWidth + 2 * this.cornerArc;
    },
    printWidth: function () {
      return this.width;
    },
    height: function () {
      return this.innerHeight + 2 * this.cornerArc + this.strokeWidth - 1;
    },
    minHeight: function () {
      if (this.isExtension) {
        return 48;
      } else {
        return 40;
      }
    },
    isExtension: function () {
      return this.content.properties.is_extension;
    },
    extensionName: function () {
      return this.content.properties.short_name;
    },
    extensionImage: function () {
      if (!this.isDim && this.options.colour === colourOptions.FullColour) {
        return `${this.appConfig.IMAGE_DIR}/images/colour/${this.extensionName}.svg`;
      } else {
        return `${this.appConfig.IMAGE_DIR}/images/bw/${this.extensionName}.svg`;
      }
    },
    extensionImageSizePixels: function () {
      const extensionImageHeight = this.innerHeight - 8;
      return `${extensionImageHeight}px`;
    },
    points: function () {
      //"M100 10 L300 10 L300 100 L100 100 Z"
      // path = "m 0,0"
      let path = `m 0,4 A 4,4 0 0,1 4,0 H 12 c 2,0 3,1 4,2 l 4,4 c 1,1 2,2 4,2 h 12 c 2,0 3,-1 4,-2 l 4,-4 c 1,-1 2,-2 4,-2 H ${this.innerWidth} a 4,4 0 0,1 4,4 v ${this.innerHeight} `;
      if (this.isEnd) {
        path += " " + this.flatBottom;
      } else {
        path += " " + this.connectorBottom;
      }
      return path;
    },
    transform: function () {
      if (this.transforms) {
        return `translate(${this.transforms.x}, ${this.transforms.y})`;
      } else {
        return "translate(0, 0)";
      }
    },
    transformExtensionImage: function () {
      //translate(8, 12)
      const x = 8,
        y = 12;
      return `translate(${x}, ${y})`;
    },
    // colourOption: function() {
    //     return this.instructions.colour || this.options.colour
    // },
    fillColour: function () {
      const options = this.isDim ? this.getDimOptions() : this.options;
      return getFillColour(this.properties, options);
    },
    strokeColour: function () {
      if (this.isHighlight && this.options.colour === colourOptions.BlackWhite) return "#000";
      const options = this.isDim ? this.getDimOptions() : this.options;
      return getStrokeColour(this.properties, options);
    },
    strokeWidth: function () {
      let strokeWidth = getStrokeWeight(this.options);
      if (this.isHighlight && this.options.colour === colourOptions.BlackWhite) return strokeWidth + 1;
      return strokeWidth;
    },
    lineStroke: function () {
      if (this.options.colour === colourOptions.FullColour) {
        return "#0DA57A";
      } else {
        return addHashPrefix(convertToHex(this.options.stroke_colour));
      }
    },
    hint: function () {
      if (this.content.manualHint) return this.content.manualHint;
      if (this.options.auto_hints || this.content.isAutoHint) {
        return this.content.autoHint;
      }
      return "";
    },
    hintTransform: function () {
      return {
        x: this.widthSansHint,
        y: this.height / 2
      };
    },
    showHighlightPath: function () {
      if (this.isHighlight && this.options.colour !== colourOptions.BlackWhite) {
        return true;
      }
      return false;
    },
    mainPathDash: function () {
      // if (
      //   this.isHighlight &&
      //   this.options.colour === drawing.colourOptions.BlackWhite
      // ) {
      //   return "4";
      // }
      return "";
    },
    highlightPathStrokeWidth: function () {
      if (this.options.colour === colourOptions.FullColour) {
        return 3;
      }
      return this.strokeWidth;
    },
    extensionLineHeight: function () {
      return this.innerHeight - 8;
    }
  },
  watch: {
    isHighlight: function (newVal, oldVal) {
      if (newVal != oldVal) {
        // if colour is FullColour emit an event with the path and the transformation
        // to the parent. Repeat, IfThen blocks have to listen for the event, add
        // their transformation and re-emit. The drawing blocks has to listen and maintain
        // a data array for highlights and add the highlights to the end of the SVG
        if (this.options.colour === colourOptions.FullColour) {
          this.emitAddHighlight({
            add: newVal
          });
        }
      }
    },
    "options.colour": function (newVal) {
      if (this.isHighlight) {
        this.emitAddHighlight({
          add: newVal === colourOptions.FullColour
        });
      }
    },
    transforms: function (newVal, oldVal) {
      if (this.isHighlight && newVal && oldVal && (newVal.x !== oldVal.x || newVal.y !== oldVal.y)) {
        this.emitAddHighlight({
          add: true
        });
      }
    }
  },
  provide() {
    return {
      blockProperties: this.properties
    };
  },
  methods: {
    getContentsWidth: function () {
      if (this.$refs.item) {
        let innerWidth = this.$refs.item.width();
        if (this.isExtension) {
          innerWidth += this.extensionOffset;
        }
        return innerWidth < this.minInnerWidth ? this.minInnerWidth : innerWidth;
      }
      return 0;
    },
    getContentsHeight: function () {
      if (this.$refs.item) {
        return this.$refs.item.height();
      }
      return this.minHeight;
    },
    getTransforms: function (index) {
      return this.innerTransforms[index];
    },
    positionElements: function () {
      this.innerWidth = this.getContentsWidth();
      let innerHeight = this.minHeight + this.getContentsHeight() - 32;
      this.innerHeight = innerHeight < this.minHeight ? this.minHeight : innerHeight;
      this.setInnerTransformations();
    },
    setInnerTransformations: function () {
      this.innerTransforms = {
        x: 0,
        y: 0
      };
      if (this.isExtension) {
        {
          this.innerTransforms.x = this.extensionOffset;
        }
      }
      if (this.$refs.item) {
        this.innerTransforms.y = (this.height - this.$refs.item.height()) / 2;
      }
    },
    getDimOptions: function () {
      let dimColour = this.options.colour - 1;
      let strokeColour = lighten(this.options.stroke_colour, 50);
      if (dimColour === 0) {
        dimColour = 1;
      }
      return {
        colour: dimColour,
        stroke_colour: strokeColour
      };
    },
    onChanged: function () {
      this.positionElements();
      this.$emit("changed");
    },
    emitAddHighlight: function (options) {
      this.$nextTick(() => {
        this.$emit("add-highlight", {
          path: options.path || this.points,
          transforms: options.transforms || this.transforms,
          add: options.add,
          key: options.key || this.$vnode.key
        });
      });
    }
  },
  created: function () {},
  mounted: function () {
    this.positionElements();
    this.$nextTick(() => {
      if (this.isHighlight && this.options.colour === colourOptions.FullColour) {
        this.emitAddHighlight({
          add: true
        });
      }
    });
  }
};

/* script */
const __vue_script__$o = script$o;

/* template */
var __vue_render__$o = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('g', {
    attrs: {
      "transform": _vm.transform
    }
  }, [_c('path', {
    attrs: {
      "d": _vm.points,
      "stroke": _vm.strokeColour,
      "stroke-width": _vm.strokeWidth,
      "fill": _vm.fillColour,
      "stroke-dasharray": _vm.mainPathDash,
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _vm.showHighlightPath ? _c('path', {
    attrs: {
      "d": _vm.points,
      "stroke": "#000",
      "stroke-width": _vm.highlightPathStrokeWidth,
      "fill": "none",
      "stroke-dasharray": "4",
      "fill-opacity": "1"
    }
  }) : _vm._e(), _vm._v(" "), _vm.isExtension ? _c('g', {
    attrs: {
      "transform": _vm.transformExtensionImage
    }
  }, [_c('image', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isMystery,
      expression: "!isMystery"
    }],
    attrs: {
      "height": _vm.extensionImageSizePixels,
      "width": _vm.extensionImageSizePixels,
      "xlink:href": _vm.extensionImage
    }
  })]) : _vm._e(), _vm._v(" "), _vm.isExtension ? _c('g', {
    attrs: {
      "transform": "translate(56, 8) "
    }
  }, [_c('line', {
    attrs: {
      "stroke": _vm.lineStroke,
      "stroke-linecap": "round",
      "x1": "0",
      "y1": "0",
      "x2": "0",
      "y2": _vm.extensionLineHeight
    }
  })]) : _vm._e(), _vm._v(" "), _vm.hint ? _c('PsHint', {
    ref: "hint",
    attrs: {
      "hint": _vm.hint,
      "transform": _vm.hintTransform,
      "options": _vm.options,
      "parentHeight": _vm.height
    }
  }) : _vm._e(), _vm._v(" "), _c('PsContent', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isMystery,
      expression: "!isMystery"
    }],
    ref: "item",
    attrs: {
      "contents": _vm.contents,
      "transforms": _vm.innerTransforms,
      "options": _vm.options
    },
    on: {
      "changed": _vm.onChanged
    }
  })], 1);
};
var __vue_staticRenderFns__$o = [];

/* style */
const __vue_inject_styles__$o = undefined;
/* scoped */
const __vue_scope_id__$o = "data-v-769ac1d4";
/* module identifier */
const __vue_module_identifier__$o = undefined;
/* functional template */
const __vue_is_functional_template__$o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$q = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$o,
  staticRenderFns: __vue_staticRenderFns__$o
}, __vue_inject_styles__$o, __vue_script__$o, __vue_scope_id__$o, __vue_is_functional_template__$o, __vue_module_identifier__$o, false, undefined, undefined, undefined);
var PsBlockBasic = __vue_component__$q;

var script$n = {
  name: "ps-block-define",
  props: ["content", "transforms", "options"],
  components: {
    PsContentMyBlock,
    PsHint,
    PsContentText
  },
  data() {
    return {
      cornerArc: 4,
      headerArc: 20,
      padding: 10,
      innerWidth: 140,
      innerHeight: 60,
      minHeight: 60,
      separator: 10,
      innerTransforms: {
        x: 0,
        y: 0
      }
    };
  },
  computed: {
    type: function () {
      return this.content.block;
    },
    contents: function () {
      return this.content.contents || [];
    },
    properties: function () {
      return this.content.properties;
    },
    isHighlight: function () {
      return this.content.isHighlight || false;
    },
    isMystery: function () {
      return this.content.isMystery || false;
    },
    isDim: function () {
      if (this.options.colour === colourOptions.BlackWhite && !this.content.isHighlight && this.options.containsHighlight) {
        return true;
      }
      return this.content.isDim || false;
    },
    isMyVar: function () {
      return this.content.isMyVar || false;
    },
    isMyList: function () {
      return this.content.isMyList || false;
    },
    width: function () {
      let width = this.innerWidth + 2 * this.headerArc;
      if (this.options.auto_hints || this.hint !== "" && this.$refs.hint) {
        width += this.$refs.hint.width();
      }
      return width;
    },
    widthSansHint: function () {
      return this.innerWidth + 2 * this.cornerArc;
    },
    printWidth: function () {
      return this.width;
    },
    height: function () {
      return this.innerHeight + this.headerArc + this.strokeWidth - 1;
    },
    points: function () {
      //"M100 10 L300 10 L300 100 L100 100 Z"
      // path = "m 0,0"
      return `m 0, 0 a 20,20 0 0,1 20,-20 h ${this.innerWidth} a 20,20 0 0,1 20,20 v ${this.innerHeight} a 4,4 0 0,1 -4,4 H 48 c -2,0 -3,1 -4,2 l -4,4 c -1,1 -2,2 -4,2 h -12 c -2,0 -3,-1 -4,-2 l -4,-4 c -1,-1 -2,-2 -4,-2 H 4 a 4,4 0 0,1 -4,-4 z`;
    },
    transform: function () {
      if (this.transforms) {
        return `translate(${this.transforms.x}, ${this.transforms.y})`;
      } else {
        return `translate(0, 0)`;
      }
    },
    transformExtensionImage: function () {
      //translate(8, 12)
      const x = 8,
        y = 12;
      return `translate(${x}, ${y})`;
    },
    // colourOption: function() {
    //     return this.instructions.colour || this.options.colour
    // },
    fillColour: function () {
      const options = this.isDim ? this.getDimOptions() : this.options;
      return getFillColour(this.properties, options);
    },
    strokeColour: function () {
      if (this.isHighlight && this.options.colour === colourOptions.BlackWhite) return "#000";
      const options = this.isDim ? this.getDimOptions() : this.options;
      return getStrokeColour(this.properties, options);
    },
    strokeWidth: function () {
      let strokeWidth = getStrokeWeight(this.options);
      if (this.isHighlight && this.options.colour === colourOptions.BlackWhite) return strokeWidth + 1;
      return strokeWidth;
    },
    lineStroke: function () {
      if (this.options.colour === colourOptions.FullColour) {
        return "#0DA57A";
      } else {
        return addHashPrefix(convertToHex(this.options.stroke_colour));
      }
    },
    hint: function () {
      if (this.content.manualHint) return this.content.manualHint;
      if (this.options.auto_hints || this.content.isAutoHint) {
        return this.content.autoHint;
      }
      return "";
    },
    hintTransform: function () {
      return {
        x: this.widthSansHint,
        y: (this.height - this.headerArc + 2 * this.cornerArc) / 2
      };
    },
    showHighlightPath: function () {
      if (this.isHighlight && this.options.colour !== colourOptions.BlackWhite) {
        return true;
      }
      return false;
    },
    mainPathDash: function () {
      // if (
      //   this.isHighlight &&
      //   this.options.colour === drawing.colourOptions.BlackWhite
      // ) {
      //   return "4";
      // }
      return "";
    },
    highlightPathStrokeWidth: function () {
      if (this.options.colour === colourOptions.FullColour) {
        return 3;
      }
      return this.strokeWidth;
    },
    blockOptions: function () {
      return {
        colour: this.options.colour,
        stroke_colour: this.options.stroke_colour,
        stroke_weight: 1,
        text_colour: this.options.text_colour,
        high_contrast: this.options.high_contrast,
        hc_colour: this.options.hc_colour,
        hc_stroke_colour: this.options.hc_stroke_colour
      };
    },
    textFillColour: function () {
      let colour = this.options.text_colour;
      if (this.isDim) {
        colour = lighten(colour, 50);
      }
      if (this.fillColour === "#FFFFFF") {
        return addHashPrefix(convertToHex(colour));
      } else {
        if (this.options.high_contrast) return "#000000";
        return "#FFFFFF";
      }
    },
    defineTextPosition: function () {
      const y = this.innerHeight / 2;
      return `translate(${this.separator}, ${y})`;
    }
  },
  watch: {
    isHighlight: function (newVal, oldVal) {
      if (newVal != oldVal) {
        // if colour is FullColour emit an event with the path and the transformation
        // to the parent. Repeat, IfThen blocks have to listen for the event, add
        // their transformation and re-emit. The drawing blocks has to listen and maintain
        // a data array for highlights and add the highlights to the end of the SVG
        if (this.options.colour === colourOptions.FullColour) {
          this.emitAddHighlight({
            add: newVal
          });
        }
      }
    },
    "options.colour": function (newVal) {
      if (this.isHighlight) {
        this.emitAddHighlight({
          add: newVal === colourOptions.FullColour
        });
      }
    },
    transforms: function (newVal, oldVal) {
      if (this.isHighlight && newVal && oldVal && (newVal.x !== oldVal.x || newVal.y !== oldVal.y)) {
        this.emitAddHighlight({
          add: true
        });
      }
    }
  },
  provide() {
    return {
      blockProperties: this.properties
    };
  },
  methods: {
    getContentsWidth: function () {
      if (this.$refs.item) {
        let width = this.$refs.item.width;
        return width;
      }
      return 0;
    },
    getContentsHeight: function () {
      if (this.$refs.item) {
        return this.$refs.item.height;
      }
      return this.minHeight;
    },
    positionElements: function () {
      this.innerWidth = this.getContentsWidth() + 35;
      let height = this.minHeight + this.getContentsHeight() - 48;
      this.innerHeight = height < this.minHeight ? this.minHeight : height;
      this.setInnerTransforms();
    },
    setInnerTransforms: function () {
      this.innerTransforms.x = this.separator + 55;
      this.innerTransforms.y = (this.height - this.headerArc - 2 * this.cornerArc - this.$refs.item.height) / 2;
    },
    getDimOptions: function () {
      let dimColour = this.options.colour - 1;
      let strokeColour = lighten(this.options.stroke_colour, 50);
      if (dimColour === 0) {
        dimColour = 1;
      }
      return {
        colour: dimColour,
        stroke_colour: strokeColour
      };
    },
    onChanged: function () {
      this.positionElements();
      this.$emit("changed");
    },
    emitAddHighlight: function (options) {
      this.$nextTick(() => {
        this.$emit("add-highlight", {
          path: options.path || this.points,
          transforms: options.transforms || this.transforms,
          add: options.add,
          key: options.key || this.$vnode.key
        });
      });
    }
  },
  created: function () {},
  mounted: function () {
    this.positionElements();
    this.$nextTick(() => {
      if (this.isHighlight && this.options.colour === colourOptions.FullColour) {
        this.emitAddHighlight({
          add: true
        });
      }
    });
  }
};

/* script */
const __vue_script__$n = script$n;

/* template */
var __vue_render__$n = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('g', {
    attrs: {
      "transform": _vm.transform
    }
  }, [_c('path', {
    attrs: {
      "d": _vm.points,
      "stroke": _vm.strokeColour,
      "stroke-width": _vm.strokeWidth,
      "fill": _vm.fillColour,
      "stroke-dasharray": _vm.mainPathDash,
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _vm.showHighlightPath ? _c('path', {
    attrs: {
      "d": _vm.points,
      "stroke": "#000",
      "stroke-width": _vm.highlightPathStrokeWidth,
      "fill": "none",
      "stroke-dasharray": "4",
      "fill-opacity": "1"
    }
  }) : _vm._e(), _vm._v(" "), _vm.hint ? _c('PsHint', {
    ref: "hint",
    attrs: {
      "hint": _vm.hint,
      "transform": _vm.hintTransform,
      "options": _vm.options,
      "parentHeight": _vm.height
    }
  }) : _vm._e(), _vm._v(" "), _c('text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isMystery,
      expression: "!isMystery"
    }],
    staticClass: "scratch-font",
    attrs: {
      "fill": _vm.textFillColour,
      "y": "2",
      "text-anchor": "start",
      "dominant-baseline": "middle",
      "dy": "0",
      "transform": _vm.defineTextPosition
    }
  }, [_vm._v("\n    define\n  ")]), _vm._v(" "), _vm.contents && _vm.contents.length > 0 ? _c('PsContentMyBlock', {
    ref: "item",
    attrs: {
      "content": _vm.content,
      "transforms": _vm.innerTransforms,
      "options": _vm.blockOptions
    },
    on: {
      "changed": _vm.onChanged
    }
  }) : _vm._e(), _vm._v("/>\n")], 1);
};
var __vue_staticRenderFns__$n = [];

/* style */
const __vue_inject_styles__$n = function (inject) {
  if (!inject) return;
  inject("data-v-4569d51e_0", {
    source: ".scratch-font[data-v-4569d51e]{font-family:\"Helvetica Neue\",Helvetica,sans-serif;font-size:12pt;font-weight:500}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$n = "data-v-4569d51e";
/* module identifier */
const __vue_module_identifier__$n = undefined;
/* functional template */
const __vue_is_functional_template__$n = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$p = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$n,
  staticRenderFns: __vue_staticRenderFns__$n
}, __vue_inject_styles__$n, __vue_script__$n, __vue_scope_id__$n, __vue_is_functional_template__$n, __vue_module_identifier__$n, false, createInjector, undefined, undefined);
var PsBlockDefine = __vue_component__$p;

var script$m = {
  name: 'ps-block-event',
  props: ["content", "transforms", "options"],
  components: {
    PsContent,
    PsHint
  },
  data() {
    return {
      cornerArc: 4,
      hatHeight: 22,
      padding: 10,
      innerWidth: 140,
      innerHeight: 40,
      extensionOffset: 56,
      extensionImageHeight: 40,
      innerTransforms: {
        x: 0,
        y: 0
      }
    };
  },
  inject: ['appConfig'],
  computed: {
    type: function () {
      return this.content.block;
    },
    contents: function () {
      return this.content.contents || [];
    },
    properties: function () {
      return this.content.properties;
    },
    isHighlight: function () {
      return this.content.isHighlight || false;
    },
    isMystery: function () {
      return this.content.isMystery || false;
    },
    isDim: function () {
      if (this.options.colour === colourOptions.BlackWhite && !this.content.isHighlight && this.options.containsHighlight) {
        return true;
      }
      return this.content.isDim || false;
    },
    isMyVar: function () {
      return this.content.isMyVar || false;
    },
    isMyList: function () {
      return this.content.isMyList || false;
    },
    width: function () {
      let width = this.innerWidth + 2 * this.cornerArc;
      if (this.options.auto_hints || this.hint !== '' && this.$refs.hint) {
        width += this.$refs.hint.width();
      }
      return width;
    },
    widthSansHint: function () {
      return this.innerWidth + 2 * this.cornerArc;
    },
    printWidth: function () {
      return this.width;
    },
    height: function () {
      return this.innerHeight + this.hatHeight + this.strokeWidth - 1;
    },
    minHeight: function () {
      if (this.isExtension) {
        return 48;
      } else {
        return 40;
      }
    },
    isExtension: function () {
      return this.content.properties.is_extension;
    },
    extensionName: function () {
      return this.content.properties.short_name;
    },
    extensionImage: function () {
      if (!this.isDim && this.options.colour === colourOptions.FullColour) {
        return `${this.appConfig.IMAGE_DIR}/images/colour/${this.extensionName}.svg`;
      } else {
        return `${this.appConfig.IMAGE_DIR}/images/bw/${this.extensionName}.svg`;
      }
    },
    extensionImageSizePixels: function () {
      const extensionImageHeight = this.innerHeight - 8;
      return `${extensionImageHeight}px`;
    },
    points: function () {
      //"M100 10 L300 10 L300 100 L100 100 Z"
      // path = "m 0,0"
      return `m 0,0 c 25,-22 71,-22 96,0 H ${this.innerWidth} a 4,4 0 0,1 4,4 v ${this.innerHeight}  a 4,4 0 0,1 -4,4 H 48   c -2,0 -3,1 -4,2 l -4,4 c -1,1 -2,2 -4,2 h -12 c -2,0 -3,-1 -4,-2 l -4,-4 c -1,-1 -2,-2 -4,-2 H 4 a 4,4 0 0,1 -4,-4 z`;
    },
    transform: function () {
      if (this.transforms) {
        return `translate(${this.transforms.x}, ${this.transforms.y})`;
      } else {
        return `translate(0, 0)`;
      }
    },
    transformExtensionImage: function () {
      //translate(8, 12)
      const x = 8,
        y = 8;
      return `translate(${x}, ${y})`;
    },
    // colourOption: function() {
    //     return this.instructions.colour || this.options.colour
    // },
    fillColour: function () {
      const options = this.isDim ? this.getDimOptions() : this.options;
      return getFillColour(this.properties, options);
    },
    strokeColour: function () {
      if (this.isHighlight && this.options.colour === colourOptions.BlackWhite) return "#000";
      const options = this.isDim ? this.getDimOptions() : this.options;
      return getStrokeColour(this.properties, options);
    },
    strokeWidth: function () {
      let strokeWidth = getStrokeWeight(this.options);
      if (this.isHighlight && this.options.colour === colourOptions.BlackWhite) return strokeWidth + 1;
      return strokeWidth;
    },
    lineStroke: function () {
      if (this.options.colour === colourOptions.FullColour) {
        return "#0DA57A";
      } else {
        return addHashPrefix(convertToHex(this.options.stroke_colour));
      }
    },
    hint: function () {
      if (this.content.manualHint) return this.content.manualHint;
      if (this.options.auto_hints || this.content.isAutoHint) {
        return this.content.autoHint;
      }
      return '';
    },
    hintTransform: function () {
      return {
        x: this.widthSansHint,
        y: (this.height - this.hatHeight + 2 * this.cornerArc) / 2
      };
    },
    showHighlightPath: function () {
      if (this.isHighlight && this.options.colour !== colourOptions.BlackWhite) {
        return true;
      }
      return false;
    },
    mainPathDash: function () {
      // if (this.isHighlight && this.options.colour === drawing.colourOptions.BlackWhite) {
      //     return "4"
      // }
      return "";
    },
    highlightPathStrokeWidth: function () {
      if (this.options.colour === colourOptions.FullColour) {
        return 3;
      }
      return this.strokeWidth;
    },
    extensionLineHeight: function () {
      return this.innerHeight - 8;
    }
  },
  watch: {
    isHighlight: function (newVal, oldVal) {
      if (newVal != oldVal) {
        // if colour is FullColour emit an event with the path and the transformation
        // to the parent. Repeat, IfThen blocks have to listen for the event, add
        // their transformation and re-emit. The drawing blocks has to listen and maintain
        // a data array for highlights and add the highlights to the end of the SVG
        if (this.options.colour === colourOptions.FullColour) {
          this.emitAddHighlight({
            add: newVal
          });
        }
      }
    },
    'options.colour': function (newVal) {
      if (this.isHighlight) {
        this.emitAddHighlight({
          add: newVal === colourOptions.FullColour
        });
      }
    },
    transforms: function (newVal, oldVal) {
      if (this.isHighlight && newVal && oldVal && (newVal.x !== oldVal.x || newVal.y !== oldVal.y)) {
        this.emitAddHighlight({
          add: true
        });
      }
    }
  },
  provide() {
    return {
      blockProperties: this.properties
    };
  },
  methods: {
    getContentsWidth: function () {
      if (this.$refs.item) {
        let width = this.$refs.item.width();
        if (this.isExtension) {
          width += this.extensionOffset;
        }
        return width;
      }
      return 0;
    },
    getContentsHeight: function () {
      if (this.$refs.item) {
        return this.$refs.item.height();
      }
      return this.minHeight;
    },
    getTransforms: function (index) {
      return this.innerTransforms[index];
    },
    positionElements: function () {
      this.innerWidth = this.getContentsWidth();
      let height = this.minHeight + this.getContentsHeight() - 32;
      this.innerHeight = height < this.minHeight ? this.minHeight : height;
      this.setInnerTransforms();
    },
    setInnerTransforms: function () {
      this.innerTransforms = {
        x: 0,
        y: 0
      };
      if (this.isExtension) {
        {
          this.innerTransforms.x += this.extensionOffset;
        }
      }
      if (this.$refs.item) {
        this.innerTransforms.y = (this.height - this.hatHeight + 2 * this.cornerArc - this.$refs.item.height()) / 2;
      }
    },
    getDimOptions: function () {
      let dimColour = this.options.colour - 1;
      let strokeColour = lighten(this.options.stroke_colour, 50);
      if (dimColour === 0) {
        dimColour = 1;
      }
      return {
        colour: dimColour,
        stroke_colour: strokeColour
      };
    },
    onChanged: function () {
      this.positionElements();
      this.$emit('changed');
    },
    emitAddHighlight: function (options) {
      this.$nextTick(() => {
        this.$emit('add-highlight', {
          path: options.path || this.points,
          transforms: options.transforms || this.transforms,
          add: options.add,
          key: options.key || this.$vnode.key
        });
      });
    }
  },
  created: function () {},
  mounted: function () {
    this.positionElements();
    this.$nextTick(() => {
      if (this.isHighlight && this.options.colour === colourOptions.FullColour) {
        this.emitAddHighlight({
          add: true
        });
      }
    });
  }
};

/* script */
const __vue_script__$m = script$m;

/* template */
var __vue_render__$m = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('g', {
    attrs: {
      "transform": _vm.transform
    }
  }, [_c('path', {
    attrs: {
      "d": _vm.points,
      "stroke": _vm.strokeColour,
      "stroke-width": _vm.strokeWidth,
      "fill": _vm.fillColour,
      "stroke-dasharray": _vm.mainPathDash,
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _vm.showHighlightPath ? _c('path', {
    attrs: {
      "d": _vm.points,
      "stroke": "#000",
      "stroke-width": _vm.highlightPathStrokeWidth,
      "fill": "none",
      "stroke-dasharray": "4",
      "fill-opacity": "1"
    }
  }) : _vm._e(), _vm._v(" "), _vm.isExtension ? _c('g', {
    attrs: {
      "transform": _vm.transformExtensionImage
    }
  }, [_c('image', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isMystery,
      expression: "!isMystery"
    }],
    attrs: {
      "height": _vm.extensionImageSizePixels,
      "width": _vm.extensionImageSizePixels,
      "xlink:href": _vm.extensionImage
    }
  })]) : _vm._e(), _vm._v(" "), _vm.isExtension ? _c('g', {
    attrs: {
      "transform": "translate(56, 8) "
    }
  }, [_c('line', {
    attrs: {
      "stroke": _vm.lineStroke,
      "stroke-linecap": "round",
      "x1": "0",
      "y1": "0",
      "x2": "0",
      "y2": _vm.extensionLineHeight
    }
  })]) : _vm._e(), _vm._v(" "), _vm.hint ? _c('PsHint', {
    ref: "hint",
    attrs: {
      "hint": _vm.hint,
      "transform": _vm.hintTransform,
      "options": _vm.options,
      "parentHeight": _vm.height
    }
  }) : _vm._e(), _vm._v(" "), _c('PsContent', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isMystery,
      expression: "!isMystery"
    }],
    ref: "item",
    attrs: {
      "contents": _vm.contents,
      "transforms": _vm.innerTransforms,
      "options": _vm.options
    },
    on: {
      "changed": _vm.onChanged
    }
  })], 1);
};
var __vue_staticRenderFns__$m = [];

/* style */
const __vue_inject_styles__$m = undefined;
/* scoped */
const __vue_scope_id__$m = "data-v-e987d35c";
/* module identifier */
const __vue_module_identifier__$m = undefined;
/* functional template */
const __vue_is_functional_template__$m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$o = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$m,
  staticRenderFns: __vue_staticRenderFns__$m
}, __vue_inject_styles__$m, __vue_script__$m, __vue_scope_id__$m, __vue_is_functional_template__$m, __vue_module_identifier__$m, false, undefined, undefined, undefined);
var PsBlockEvent = __vue_component__$o;

// import PsBlockEvent from './BlockEvent'
var script$l = {
  name: 'ps-block-ifthen',
  props: ["content", "transforms", "options"],
  // components: {
  //     PsBlockEvent,
  //     PsBlockBasic,
  //     // A:() => async () => (await import('@/components/A.vue')).default,
  //     PsBlockRepeat: () => async () => (await import('./BlockRepeat.vue')).default,
  //     PsBlockSeparator,
  //     PsBlockSpace,
  //     PsContent,
  //     PsContentText,
  //     PsHint
  // },
  data() {
    return {
      cornerArc: 4,
      padding: 10,
      innerHeadWidth: 139,
      innerHeadHeight: 40,
      minInnerHeadHeight: 40,
      minInnerHeadWidth: 160,
      tailHeight: 24,
      subStackOffset: 16,
      subStackHeight: 16,
      subStack2Height: 16,
      minSubStackHeight: 16,
      innerTransforms: {
        x: 0,
        y: 0
      },
      blockTransforms: [],
      blockTransforms2: [],
      connectorBottom: '',
      lastSubstackBlockIsEnd: false,
      lastSubstack2BlockIsEnd: false
    };
  },
  computed: {
    type: function () {
      return this.content.block;
    },
    contents: function () {
      return this.content.contents || [];
    },
    properties: function () {
      return this.content.properties;
    },
    isHighlight: function () {
      return this.content.isHighlight || false;
    },
    isMystery: function () {
      return this.content.isMystery || false;
    },
    isDim: function () {
      if (this.options.colour === colourOptions.BlackWhite && !this.content.isHighlight && this.options.containsHighlight) {
        return true;
      }
      return this.content.isDim || false;
    },
    isMyVar: function () {
      if (this.options.colour === colourOptions.BlackWhite && !this.content.isHighlight && this.options.containsHighlight) {
        return true;
      }
      return this.content.isDim || false;
    },
    isMyList: function () {
      return this.content.isMyList || false;
    },
    isEnd: function () {
      return this.content.isEnd || false;
    },
    isElse: function () {
      return this.content.isElse;
    },
    flatInterior: function () {
      return `H ${this.innerHeadWidth} a 4,4 0 0,1 4,4 v ${this.tailHeight} `;
    },
    connectorInterior: function () {
      return `h ${this.connectorShiftB} c 2,0 3,1 4,2 l 4,4 c 1,1 2,2 4,2 h 12 c 2,0 3,-1 4,-2 l 4,-4 c 1,-1 2,-2 4,-2 H ${this.innerHeadWidth} a 4,4 0 0,1 4,4 v ${this.tailHeight} `;
    },
    points: function () {
      //"M100 10 L300 10 L300 100 L100 100 Z"
      // path = "m 0,0"
      let path = `m 0,4 A 4,4 0 0,1 4,0 H 12 c 2,0 3,1 4,2 l 4,4 c 1,1 2,2 4,2 h 12 c 2,0 3,-1 4,-2 l 4,-4 c 1,-1 2,-2 4,-2 H ${this.innerHeadWidth} a 4,4 0 0,1 4,4 v ${this.innerHeadHeight} a 4,4 0 0,1 -4,4 H ${this.connectorShiftA} c -2,0 -3,1 -4,2 l -4,4 c -1,1 -2,2 -4,2 h -12 c -2,0 -3,-1 -4,-2 l -4,-4 c -1,-1 -2,-2 -4,-2 h -${this.connectorShiftB}  a 4,4 0 0,0 -4,4 v ${this.subStackHeight} a 4,4 0 0,0 4,4 `;
      if (this.lastSubstackBlockIsEnd) {
        path += this.flatInterior;
      } else {
        path += this.connectorInterior;
      }
      if (this.content.isElse) {
        path += ' ' + `a 4,4 0 0,1 -4,4 H ${this.connectorShiftA} c -2,0 -3,1 -4,2 l -4,4 c -1,1 -2,2 -4,2 h -12 c -2,0 -3,-1 -4,-2 l -4,-4 c -1,-1 -2,-2 -4,-2 h -${this.connectorShiftB} a 4,4 0 0,0 -4,4 v ${this.subStack2Height} a 4,4 0 0,0 4,4 `;
        if (this.lastSubstack2BlockIsEnd) {
          path += this.flatInterior;
        } else {
          path += this.connectorInterior;
        }
        path += ` a 4,4 0 0,1 -4,4 H 48 c -2,0 -3,1 -4,2 l -4,4 c -1,1 -2,2 -4,2 h -12 c -2,0 -3,-1 -4,-2 l -4,-4 c -1,-1 -2,-2 -4,-2 H 4 a 4,4 0 0,1 -4,-4 z`;
      } else {
        path += ' a 4,4 0 0,1 -4,4 H 48 c -2,0 -3,1 -4,2 l -4,4 c -1,1 -2,2 -4,2 h -12 c -2,0 -3,-1 -4,-2 l -4,-4 c -1,-1 -2,-2 -4,-2 H 4 a 4,4 0 0,1 -4,-4 z';
      }
      return path;
    },
    transform: function () {
      if (this.transforms) {
        return `translate(${this.transforms.x}, ${this.transforms.y})`;
      } else {
        return 'translate(0, 0)';
      }
    },
    substackTransform: function () {
      return `translate(${this.subStackOffset}, ${this.headHeight()})`;
    },
    substack2Transform: function () {
      const substack2Offset = this.headHeight() + this.subStackHeight + this.tailHeight + 16;
      return `translate(${this.subStackOffset}, ${substack2Offset})`;
    },
    numSubstackBlocks: function () {
      if (!this.content.substack) return 0;
      return this.content.substack.length;
    },
    numSubstack2Blocks: function () {
      if (!this.content.substack2) return 0;
      return this.content.substack2.length;
    },
    width: function () {
      let width = this.innerHeadWidth + 2 * this.cornerArc;
      if (this.options.auto_hints || this.hint !== '' && this.$refs.hint) {
        width += this.$refs.hint.width();
      }
      return width;
    },
    widthSansHint: function () {
      return this.innerHeadWidth + 2 * this.cornerArc;
    },
    printWidth: function () {
      let widths = [this.width];
      if (this.$refs.substack) {
        let blockWidths = this.$refs.substack.map(block => (block.printWidth || block.width) + this.subStackOffset + this.strokeWidth - 1);
        widths = widths.concat(blockWidths);
      }
      if (this.$refs.substack2) {
        let blockWidths = this.$refs.substack2.map(block => (block.printWidth || block.width) + this.subStackOffset + this.strokeWidth - 1);
        widths = widths.concat(blockWidths);
      }
      return Math.max(...widths);
    },
    height: function () {
      let height = this.headHeight() + this.tailHeight + this.subStackHeight + 16 + this.strokeWidth - 1;
      if (this.isElse) {
        height += this.subStack2Height + this.tailHeight + 16;
      }
      return height;
    },
    elseTextTransforms: function () {
      return {
        x: 8,
        y: this.headHeight() + this.subStackHeight + 12 + this.tailHeight / 2
      };
    },
    // colourOption: function() {
    //     return this.instructions.colour || this.options.colour
    // },
    fillColour: function () {
      const options = this.isDim ? this.getDimOptions() : this.options;
      return getFillColour(this.properties, options);
    },
    strokeColour: function () {
      if (this.isHighlight && this.options.colour === colourOptions.BlackWhite) return "#000";
      const options = this.isDim ? this.getDimOptions() : this.options;
      return getStrokeColour(this.properties, options);
    },
    strokeWidth: function () {
      let strokeWidth = getStrokeWeight(this.options);
      if (this.isHighlight && this.options.colour === colourOptions.BlackWhite) return strokeWidth + 1;
      return strokeWidth;
    },
    connectorShiftA: function () {
      return 64 + this.strokeWidth - 1;
    },
    connectorShiftB: function () {
      return 8 + this.strokeWidth - 1;
    },
    optionsStrokeWeight: function () {
      return this.options.stroke_weight;
    },
    // optionsStrokeColour: function() {
    //     return this.instructions.colour || this.options.colour
    // },
    elseContent: function () {
      return this.content.elseContent;
    },
    isElseMystery: function () {
      if (this.elseContent) return this.elseContent.isMystery;
      return false;
    },
    hint: function () {
      if (this.content.manualHint) return this.content.manualHint;
      if (this.options.auto_hints || this.content.isAutoHint) {
        return this.content.autoHint;
      }
      return '';
    },
    hintTransform: function () {
      return {
        x: this.widthSansHint,
        y: this.headHeight() / 2
      };
    },
    showHighlightPath: function () {
      if (this.isHighlight && this.options.colour !== colourOptions.BlackWhite) {
        return true;
      }
      return false;
    },
    mainPathDash: function () {
      // if (this.isHighlight && this.options.colour === drawing.colourOptions.BlackWhite) {
      //     return "4"
      // }
      return "";
    },
    highlightPathStrokeWidth: function () {
      if (this.options.colour === colourOptions.FullColour) {
        return 3;
      }
      return this.strokeWidth;
    }
  },
  provide() {
    return {
      blockProperties: this.properties
    };
  },
  watch: {
    numSubstackBlocks: function () {
      this.positionSubstackElements();
      this.$nextTick(() => {
        const height = this.getSubstackHeight() - 2 * this.cornerArc + this.strokeWidth - 1;
        this.subStackHeight = height < this.minSubStackHeight ? this.minSubStackHeight : height;
        this.lastSubstackBlockIsEnd = this.isLastSubstackBlockIsEnd();
        this.emitChanged();
      });
    },
    numSubstack2Blocks: function () {
      this.positionSubstack2Elements();
      this.$nextTick(() => {
        const height = this.getSubstack2Height() - 2 * this.cornerArc + this.strokeWidth - 1;
        this.subStack2Height = height < this.minSubStackHeight ? this.minSubStackHeight : height;
        this.lastSubstack2BlockIsEnd = this.isLastSubstack2BlockIsEnd();
        this.emitChanged();
      });
    },
    isElse: function () {
      this.positionSubstack2Elements();
      this.$nextTick(() => {
        const height = this.getSubstack2Height() - 2 * this.cornerArc + this.strokeWidth - 1;
        this.subStack2Height = height < this.minSubStackHeight ? this.minSubStackHeight : height;
        this.emitChanged();
      });
    },
    optionsStrokeWeight: function () {
      this.bothSubstacksChanged();
    },
    // optionsStrokeColour: function() {
    //     this.bothSubstacksChanged()
    // },
    isHighlight: function (newVal, oldVal) {
      if (newVal != oldVal) {
        // if colour is FullColour emit an event with the path and the transformation
        // to the parent. Repeat, IfThen blocks have to listen for the event, add
        // their transformation and re-emit. The drawing blocks has to listen and maintain
        // a data array for highlights and add the highlights to the end of the SVG
        if (this.options.colour === colourOptions.FullColour) {
          this.emitAddHighlight({
            add: newVal
          });
        }
      }
    },
    'options.colour': function (newVal) {
      if (this.isHighlight) {
        this.emitAddHighlight({
          add: newVal === colourOptions.FullColour
        });
      }
      // this.bothSubstacksChanged()
      this.$nextTick(() => {
        this.positionSubstackElements();
        if (this.isElse) {
          this.positionSubstack2Elements();
        }
        this.emitChanged();
      });
    },
    transforms: function (newVal, oldVal) {
      if (this.isHighlight && newVal && oldVal && (newVal.x !== oldVal.x || newVal.y !== oldVal.y)) {
        this.emitAddHighlight({
          add: true
        });
      }
    }
  },
  methods: {
    headHeight: function () {
      return this.innerHeadHeight + 2 * this.cornerArc;
    },
    getInnerHeadWidth: function () {
      let width = 100;
      if (this.$refs.item) {
        width = this.$refs.item.width();
      }
      return width < this.minInnerHeadWidth ? this.minInnerHeadWidth : width;
    },
    getContentsHeight: function () {
      let height = 32;
      if (this.$refs.item) {
        height = this.$refs.item.height();
      }
      return height;
    },
    getSubstackHeight: function () {
      let height = this.minSubStackHeight;
      if (this.$refs.substack) {
        height = this.$refs.substack.map(block => block.height).reduce((a, b) => a + b, 0);
      }
      return height;
    },
    getSubstack2Height: function () {
      let height = this.minSubStackHeight;
      if (this.$refs.substack2) {
        height = this.$refs.substack2.map(block => block.height).reduce((a, b) => a + b, 0);
      }
      return height;
    },
    positionHeadElements: function () {
      this.innerHeadWidth = this.getInnerHeadWidth();
      const contentsHeight = this.getContentsHeight();
      this.innerHeadHeight = this.minInnerHeadHeight + 8;
      if (contentsHeight > this.minInnerHeadHeight) {
        this.innerHeadHeight += contentsHeight - this.minInnerHeadHeight;
      }
      this.innerTransforms.y = (this.headHeight() - contentsHeight) / 2;
    },
    getSubstackTransforms: function (index) {
      if (this.blockTransforms.length > 0) {
        return this.blockTransforms[index];
      }
    },
    getSubstack2Transforms: function (index) {
      if (this.blockTransforms2 === 0) {
        this.calculateBlockTransforms2();
      }
      if (this.blockTransforms2.length > 0) {
        return this.blockTransforms2[index];
      }
    },
    positionSubstackElements: function () {
      const height = this.getSubstackHeight() - 2 * this.cornerArc + this.strokeWidth - 1;
      this.subStackHeight = height < this.minSubStackHeight ? this.minSubStackHeight : height;
      if (this.content.substack) {
        let y = this.strokeWidth - 1;
        this.blockTransforms = [];
        for (let i = 0; i < this.content.substack.length; i++) {
          const transform = {
            x: this.strokeWidth - 1,
            y: y
          };
          this.blockTransforms.push(transform);
          if (this.$refs.substack && this.$refs.substack[i]) {
            y += this.$refs.substack[i].height;
          }
        }
      }
    },
    calculateBlockTransforms2: function () {
      if (this.content.substack2) {
        let y = this.strokeWidth - 1;
        this.blockTransforms2 = [];
        for (let i = 0; i < this.content.substack2.length; i++) {
          const transform = {
            x: this.strokeWidth - 1,
            y: y
          };
          this.blockTransforms2.push(transform);
          if (this.$refs.substack2 && this.$refs.substack2[i]) {
            y += this.$refs.substack2[i].height;
          }
        }
      }
    },
    positionSubstack2Elements: function () {
      const height = this.getSubstack2Height() - 2 * this.cornerArc + this.strokeWidth - 1;
      this.subStack2Height = height < this.minSubStackHeight ? this.minSubStackHeight : height;
      this.calculateBlockTransforms2();
    },
    getWidth: function () {
      let width = this.innerHeadWidth + 2 * this.cornerArc;
      if (this.hint !== '' && this.$refs.hint) {
        width += this.$refs.hint.width();
      }
      let widths = [width];
      if (this.$refs.substack) {
        let blockWidths = this.$refs.substack.map(item => (item.printWidth || item.width) + this.subStackOffset + this.strokeWidth - 1);
        widths = widths.concat(blockWidths);
      }
      if (this.$refs.substack2) {
        let blockWidths = this.$refs.substack2.map(item => (item.printWidth || item.width) + this.subStackOffset + this.strokeWidth - 1);
        widths = widths.concat(blockWidths);
      }
      return Math.max(...widths);
    },
    onHeadElementsChanged: function () {
      this.positionHeadElements();
      this.emitChanged();
    },
    onSubstackChanged: function () {
      this.positionSubstackElements();
      this.lastSubstackBlockIsEnd = this.isLastSubstackBlockIsEnd();
      this.emitChanged();
    },
    onSubstack2Changed: function () {
      this.positionSubstack2Elements();
      this.lastSubstack2BlockIsEnd = this.isLastSubstack2BlockIsEnd();
      this.emitChanged();
    },
    bothSubstacksChanged: function () {
      this.positionSubstackElements();
      this.positionSubstack2Elements();
      this.emitChanged();
    },
    blockType: function (element) {
      // if (element.block.toLowerCase() === "ifthen" && element.isElse) {
      //     return "ps-block-ifthenelse"
      // }
      return `ps-block-${element.block.toLowerCase()}`;
    },
    getDimOptions: function () {
      let dimColour = this.options.colour - 1;
      let strokeColour = lighten(this.options.stroke_colour, 50);
      if (dimColour === 0) {
        dimColour = 1;
      }
      return {
        colour: dimColour,
        stroke_colour: strokeColour
      };
    },
    isLastSubstackBlockIsEnd: function () {
      if (this.$refs.substack && this.$refs.substack.length > 0) {
        const lastKey = this.$refs.substack.length - 1;
        const last = this.$refs.substack.filter(item => item.$vnode.key === lastKey);
        if (last) {
          return last[0].isEnd;
        }
      }
      return false;
    },
    isLastSubstack2BlockIsEnd: function () {
      if (this.$refs.substack2 && this.$refs.substack2.length > 0) {
        const lastKey = this.$refs.substack2.length - 1;
        const last = this.$refs.substack2.filter(item => item.$vnode.key === lastKey);
        if (last) {
          return last[0].isEnd;
        }
      }
      return false;
    },
    onSubstackHighlighted: function (data) {
      const transforms = {
        x: data.transforms.x + this.transforms.x + this.subStackOffset,
        y: data.transforms.y + this.transforms.y + this.headHeight()
      };
      this.emitAddHighlight({
        path: data.path,
        transforms: transforms,
        add: data.add,
        key: `${this.$vnode.key}-${data.key}`
      });
    },
    onSubstack2Highlighted: function (data) {
      const substack2Offset = this.headHeight() + this.subStackHeight + this.tailHeight + 16;
      const transforms = {
        x: data.transforms.x + this.transforms.x + this.subStackOffset,
        y: data.transforms.y + this.transforms.y + substack2Offset
      };
      this.emitAddHighlight({
        path: data.path,
        transforms: transforms,
        add: data.add,
        key: `${this.$vnode.key}-${data.key}`
      });
    },
    emitAddHighlight: function (options) {
      this.$nextTick(() => {
        this.$emit('add-highlight', {
          path: options.path || this.points,
          transforms: options.transforms || this.transforms,
          add: options.add,
          key: options.key || this.$vnode.key
        });
      });
    },
    emitChanged: function () {
      this.$emit('changed');
    }
  },
  created: function () {},
  mounted: function () {
    this.positionHeadElements();
    this.positionSubstackElements();
    this.positionSubstack2Elements();
    this.lastSubstackBlockIsEnd = this.isLastSubstackBlockIsEnd();
    this.lastSubstack2BlockIsEnd = this.isLastSubstack2BlockIsEnd();
    this.$nextTick(() => {
      if (this.isHighlight && this.options.colour === colourOptions.FullColour) {
        this.emitAddHighlight({
          add: true
        });
      }
    });
  }
};

/* script */
const __vue_script__$l = script$l;

/* template */
var __vue_render__$l = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('g', {
    attrs: {
      "transform": _vm.transform
    }
  }, [_c('path', {
    attrs: {
      "d": _vm.points,
      "stroke": _vm.strokeColour,
      "stroke-width": _vm.strokeWidth,
      "fill": _vm.fillColour,
      "stroke-dasharray": _vm.mainPathDash,
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _vm.hint ? _c('ps-hint', {
    ref: "hint",
    attrs: {
      "hint": _vm.hint,
      "transform": _vm.hintTransform,
      "options": _vm.options,
      "parentHeight": _vm.headHeight()
    }
  }) : _vm._e(), _vm._v(" "), _c('ps-content', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isMystery,
      expression: "!isMystery"
    }],
    ref: "item",
    attrs: {
      "contents": _vm.contents,
      "transforms": _vm.innerTransforms,
      "options": _vm.options
    },
    on: {
      "changed": _vm.onHeadElementsChanged
    }
  }), _vm._v(" "), _vm.content.substack ? [_c('g', {
    attrs: {
      "transform": _vm.substackTransform
    }
  }, _vm._l(_vm.content.substack, function (block, index) {
    return _c(_vm.blockType(block), {
      key: index,
      ref: "substack",
      refInFor: true,
      tag: "component",
      attrs: {
        "content": block,
        "transforms": _vm.getSubstackTransforms(index),
        "options": _vm.options
      },
      on: {
        "changed": _vm.onSubstackChanged,
        "add-highlight": _vm.onSubstackHighlighted
      }
    });
  }), 1)] : _vm._e(), _vm._v(" "), _vm.isElse ? _c('g', [_c('ps-content-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isElseMystery,
      expression: "!isElseMystery"
    }],
    attrs: {
      "content": _vm.content.elseContent,
      "transforms": _vm.elseTextTransforms,
      "options": _vm.options
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.content.substack2 ? [_c('g', {
    attrs: {
      "transform": _vm.substack2Transform
    }
  }, _vm._l(_vm.content.substack2, function (block, index) {
    return _c(_vm.blockType(block), {
      key: index,
      ref: "substack2",
      refInFor: true,
      tag: "component",
      attrs: {
        "content": block,
        "transforms": _vm.getSubstack2Transforms(index),
        "options": _vm.options
      },
      on: {
        "changed": _vm.onSubstack2Changed,
        "add-highlight": _vm.onSubstack2Highlighted
      }
    });
  }), 1)] : _vm._e(), _vm._v(" "), _vm.showHighlightPath ? _c('path', {
    attrs: {
      "d": _vm.points,
      "stroke": "#000",
      "stroke-width": _vm.highlightPathStrokeWidth,
      "fill": "none",
      "stroke-dasharray": "4",
      "fill-opacity": "1"
    }
  }) : _vm._e()], 2);
};
var __vue_staticRenderFns__$l = [];

/* style */
const __vue_inject_styles__$l = undefined;
/* scoped */
const __vue_scope_id__$l = "data-v-2ad8b182";
/* module identifier */
const __vue_module_identifier__$l = undefined;
/* functional template */
const __vue_is_functional_template__$l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$n = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$l,
  staticRenderFns: __vue_staticRenderFns__$l
}, __vue_inject_styles__$l, __vue_script__$l, __vue_scope_id__$l, __vue_is_functional_template__$l, __vue_module_identifier__$l, false, undefined, undefined, undefined);
var PsBlockIfthen = __vue_component__$n;

// import PsBlockEvent from './BlockEvent'
var script$k = {
  name: "ps-block-repeat",
  props: ["content", "transforms", "options"],
  // components: {
  //     PsBlockEvent,
  //     PsBlockBasic,
  //     PsBlockIfthen,
  //     PsBlockSeparator,
  //     PsBlockSpace,
  //     PsContent,
  //     PsHint
  // },
  data() {
    return {
      cornerArc: 4,
      padding: 10,
      innerHeadWidth: 139,
      innerHeadHeight: 40,
      minInnerHeadHeight: 40,
      minInnerHeadWidth: 160,
      tailHeight: 24,
      subStackOffset: 16,
      subStackHeight: 16,
      minSubStackHeight: 16,
      innerTransforms: {
        x: 0,
        y: 0
      },
      blockTransforms: [],
      repeatImageSize: 24,
      lastBlockIsEnd: false,
      flatBottom: "a 4,4 0 0,1 -4,4 H 4 a 4,4 0 0,1 -4,-4 z",
      connectorBottom: "a 4,4 0 0,1 -4,4 H 48 c -2,0 -3,1 -4,2 l -4,4 c -1,1 -2,2 -4,2 h -12 c -2,0 -3,-1 -4,-2 l -4,-4 c -1,-1 -2,-2 -4,-2 H 4 a 4,4 0 0,1 -4,-4 z"
    };
  },
  inject: ["appConfig"],
  computed: {
    type: function () {
      return this.content.block;
    },
    contents: function () {
      return this.content.contents || [];
    },
    properties: function () {
      return this.content.properties;
    },
    isHighlight: function () {
      return this.content.isHighlight || false;
    },
    isMystery: function () {
      return this.content.isMystery || false;
    },
    isDim: function () {
      if (this.options.colour === colourOptions.BlackWhite && !this.content.isHighlight && this.options.containsHighlight) {
        return true;
      }
      return this.content.isDim || false;
    },
    isMyVar: function () {
      return this.content.isMyVar || false;
    },
    isMyList: function () {
      return this.content.isMyList || false;
    },
    isEnd: function () {
      return this.content.isEnd || false;
    },
    flatInterior: function () {
      return `H ${this.innerHeadWidth} a 4,4 0 0,1 4,4 v ${this.tailHeight} `;
    },
    connectorInterior: function () {
      return `h ${this.connectorShiftB} c 2,0 3,1 4,2 l 4,4 c 1,1 2,2 4,2 h 12 c 2,0 3,-1 4,-2 l 4,-4 c 1,-1 2,-2 4,-2 H ${this.innerHeadWidth} a 4,4 0 0,1 4,4 v ${this.tailHeight} `;
    },
    points: function () {
      //"M100 10 L300 10 L300 100 L100 100 Z"
      // path = "m 0,0"
      let path = `m 0,4 A 4,4 0 0,1 4,0 H 12 c 2,0 3,1 4,2 l 4,4 c 1,1 2,2 4,2 h 12 c 2,0 3,-1 4,-2 l 4,-4 c 1,-1 2,-2 4,-2 H ${this.innerHeadWidth} a 4,4 0 0,1 4,4 v ${this.innerHeadHeight} a 4,4 0 0,1 -4,4 H ${this.connectorShiftA} c -2,0 -3,1 -4,2 l -4,4 c -1,1 -2,2 -4,2 h -12 c -2,0 -3,-1 -4,-2 l -4,-4 c -1,-1 -2,-2 -4,-2 h -${this.connectorShiftB} a 4,4 0 0,0 -4,4 v ${this.subStackHeight} a 4,4 0 0,0 4,4 `;
      if (this.lastBlockIsEnd) {
        path += " " + this.flatInterior;
      } else {
        path += " " + this.connectorInterior;
      }
      if (this.isEnd) {
        path += " " + this.flatBottom;
      } else {
        path += " " + this.connectorBottom;
      }
      return path;
    },
    transform: function () {
      if (this.transforms) {
        return `translate(${this.transforms.x}, ${this.transforms.y})`;
      } else {
        return "translate(0, 0)";
      }
    },
    substackTransform: function () {
      return `translate(${this.subStackOffset}, ${this.headHeight()})`;
    },
    numSubstackBlocks: function () {
      if (!this.content.substack) return 0;
      return this.content.substack.length;
    },
    width: function () {
      let width = this.innerHeadWidth + 2 * this.cornerArc;
      if (this.options.auto_hints || this.hint !== "" && this.$refs.hint) {
        width += this.$refs.hint.width();
      }
      return width;
    },
    widthSansHint: function () {
      return this.innerHeadWidth + 2 * this.cornerArc;
    },
    printWidth: function () {
      let widths = [this.width];
      if (this.$refs.substack) {
        let blockWidths = this.$refs.substack.map(block => (block.printWidth || block.width) + this.subStackOffset + this.strokeWidth - 1);
        widths = widths.concat(blockWidths);
      }
      return Math.max(...widths);
    },
    height: function () {
      let height = this.headHeight() + this.tailHeight + this.subStackHeight + 16;
      height += this.strokeWidth - 1;
      return height;
    },
    repeatImageXTranslate: function () {
      return this.innerHeadWidth - this.repeatImageSize;
    },
    repeatImageYTranslate: function () {
      return this.headHeight() + this.subStackHeight + 16 - 4;
    },
    repeatImageTransform: function () {
      return `translate(${this.repeatImageXTranslate}, ${this.repeatImageYTranslate})`;
    },
    // colourOption: function() {
    //     return this.instructions.colour || this.options.colour
    // },
    fillColour: function () {
      const options = this.isDim ? this.getDimOptions() : this.options;
      return getFillColour(this.properties, options);
    },
    strokeColour: function () {
      if (this.isHighlight && this.options.colour === colourOptions.BlackWhite) return "#000";
      const options = this.isDim ? this.getDimOptions() : this.options;
      return getStrokeColour(this.properties, options);
    },
    strokeWidth: function () {
      let strokeWidth = getStrokeWeight(this.options);
      if (this.isHighlight && this.options.colour === colourOptions.BlackWhite) return strokeWidth + 1;
      return strokeWidth;
    },
    imageLink: function () {
      if (!this.isDim && this.options.colour === colourOptions.FullColour) {
        if (this.options.high_contrast) return `${this.appConfig.IMAGE_DIR}/images/bw/repeat-black.svg`;
        return `${this.appConfig.IMAGE_DIR}/images/colour/repeat.svg`;
      } else {
        return `${this.appConfig.IMAGE_DIR}/images/bw/repeat.svg`;
      }
    },
    connectorShiftA: function () {
      return 64 + this.strokeWidth - 1;
    },
    connectorShiftB: function () {
      return 8 + this.strokeWidth - 1;
    },
    optionsStrokeWeight: function () {
      return this.options.stroke_weight;
    },
    // optionsStrokeColour: function() {
    //     return this.instructions.colour || this.options.colour
    // },
    hint: function () {
      if (this.content.manualHint) return this.content.manualHint;
      if (this.options.auto_hints || this.content.isAutoHint) {
        return this.content.autoHint;
      }
      return "";
    },
    hintTransform: function () {
      return {
        x: this.widthSansHint,
        y: this.headHeight() / 2
      };
    },
    showHighlightPath: function () {
      if (this.isHighlight && this.options.colour !== colourOptions.BlackWhite) {
        return true;
      }
      return false;
    },
    mainPathDash: function () {
      // if (
      //   this.isHighlight &&
      //   this.options.colour === drawing.colourOptions.BlackWhite
      // ) {
      //   return "4";
      // }
      return "";
    },
    highlightPathStrokeWidth: function () {
      if (this.options.colour === colourOptions.FullColour) {
        return 3;
      }
      return this.strokeWidth;
    }
  },
  provide() {
    return {
      blockProperties: this.properties
    };
  },
  watch: {
    numSubstackBlocks: function () {
      this.positionSubstackElements();
      this.$nextTick(() => {
        const height = this.getSubstackHeight() - 2 * this.cornerArc + this.strokeWidth - 1;
        this.subStackHeight = height < this.minSubStackHeight ? this.minSubStackHeight : height;
        this.lastBlockIsEnd = this.isLastBlockIsEnd();
        this.emitChanged();
      });
    },
    optionsStrokeWeight: function () {
      this.onSubstackChanged();
    },
    // optionsStrokeColour: function() {
    //     this.onSubstackChanged()
    // },
    isHighlight: function (newVal, oldVal) {
      if (newVal != oldVal) {
        // if colour is FullColour emit an event with the path and the transformation
        // to the parent. Repeat, IfThen blocks have to listen for the event, add
        // their transformation and re-emit. The drawing blocks has to listen and maintain
        // a data array for highlights and add the highlights to the end of the SVG
        if (this.options.colour === colourOptions.FullColour) {
          this.emitAddHighlight({
            add: newVal
          });
        }
      }
    },
    "options.colour": function (newVal) {
      if (this.isHighlight) {
        this.emitAddHighlight({
          add: newVal === colourOptions.FullColour
        });
      }
      // this.onSubstackChanged()
      this.$nextTick(() => {
        this.positionSubstackElements();
        this.emitChanged();
      });
    },
    transforms: function (newVal, oldVal) {
      if (this.isHighlight && newVal && oldVal && (newVal.x !== oldVal.x || newVal.y !== oldVal.y)) {
        this.emitAddHighlight({
          add: true
        });
      }
    }
  },
  methods: {
    headHeight: function () {
      return this.innerHeadHeight + 2 * this.cornerArc;
    },
    getInnerHeadWidth: function () {
      let width = 100;
      if (this.$refs.item) {
        width = this.$refs.item.width();
      }
      return width < this.minInnerHeadWidth ? this.minInnerHeadWidth : width;
    },
    getContentsHeight: function () {
      let height = 32;
      if (this.$refs.item) {
        height = this.$refs.item.height();
      }
      return height;
    },
    getSubstackHeight: function () {
      let height = this.minSubStackHeight;
      if (this.$refs.substack) {
        height = this.$refs.substack.map(block => block.height).reduce((a, b) => a + b, 0);
      }
      return height < this.minSubStackHeight ? this.minSubStackHeight : height;
    },
    positionHeadElements: function () {
      this.innerHeadWidth = this.getInnerHeadWidth();
      const contentsHeight = this.getContentsHeight();
      this.innerHeadHeight = this.minInnerHeadHeight;
      if (contentsHeight > 32) {
        this.innerHeadHeight += contentsHeight - 32;
      }
      this.innerTransforms.y = (this.headHeight() - contentsHeight) / 2;
    },
    getSubstackTransforms: function (index) {
      if (this.blockTransforms.length > 0) {
        return this.blockTransforms[index];
      }
    },
    positionSubstackElements: function () {
      const height = this.getSubstackHeight() - 2 * this.cornerArc + this.strokeWidth - 1;
      this.subStackHeight = height < this.minSubStackHeight ? this.minSubStackHeight : height;
      if (this.content.substack) {
        let y = this.strokeWidth - 1;
        this.blockTransforms = [];
        for (let i = 0; i < this.content.substack.length; i++) {
          const transform = {
            x: this.strokeWidth - 1,
            y: y
          };
          this.blockTransforms.push(transform);
          if (this.$refs.substack && this.$refs.substack[i]) {
            y += this.$refs.substack[i].height;
          }
        }
      }
    },
    onHeadElementsChanged: function () {
      this.positionHeadElements();
      this.emitChanged();
    },
    onSubstackChanged: function () {
      this.positionSubstackElements();
      this.lastBlockIsEnd = this.isLastBlockIsEnd();
      this.emitChanged();
    },
    blockType: function (element) {
      // if (element.block.toLowerCase() === "ifthen" && element.isElse) {
      //     return "ps-block-ifthenelse"
      // }
      return `ps-block-${element.block.toLowerCase()}`;
    },
    imagePixelSize: function (size) {
      return `${size}px`;
    },
    getDimOptions: function () {
      let dimColour = this.options.colour - 1;
      let strokeColour = lighten(this.options.stroke_colour, 50);
      if (dimColour === 0) {
        dimColour = 1;
      }
      return {
        colour: dimColour,
        stroke_colour: strokeColour
      };
    },
    isLastBlockIsEnd: function () {
      if (this.$refs.substack && this.$refs.substack.length > 0) {
        const lastKey = this.$refs.substack.length - 1;
        const last = this.$refs.substack.filter(item => item.$vnode.key === lastKey);
        if (last) {
          return last[0].isEnd;
        }
      }
      return false;
    },
    getWidth: function () {
      let width = this.innerHeadWidth + 2 * this.cornerArc;
      if (this.hint !== "" && this.$refs.hint) {
        width += this.$refs.hint.width();
      }
      let widths = [width];
      if (this.$refs.substack) {
        let blockWidths = this.$refs.substack.map(item => (item.printWidth || item.width) + this.subStackOffset + this.strokeWidth - 1);
        widths = widths.concat(blockWidths);
      }
      return Math.max(...widths);
    },
    onSubstackHighlighted: function (data) {
      const transforms = {
        x: data.transforms.x + this.transforms.x + this.subStackOffset,
        y: data.transforms.y + this.transforms.y + this.headHeight()
      };
      this.emitAddHighlight({
        path: data.path,
        transforms: transforms,
        add: data.add,
        key: `${this.$vnode.key}-${data.key}`
      });
    },
    emitAddHighlight: function (options) {
      this.$nextTick(() => {
        this.$emit("add-highlight", {
          path: options.path || this.points,
          transforms: options.transforms || this.transforms,
          add: options.add,
          key: options.key || this.$vnode.key
        });
      });
    },
    emitChanged: function () {
      this.$emit("changed");
    }
  },
  created: function () {},
  mounted: function () {
    this.positionHeadElements();
    this.positionSubstackElements();
    this.lastBlockIsEnd = this.isLastBlockIsEnd();
    this.$nextTick(() => {
      if (this.isHighlight && this.options.colour === colourOptions.FullColour) {
        this.emitAddHighlight({
          add: true
        });
      }
    });
  }
};

/* script */
const __vue_script__$k = script$k;

/* template */
var __vue_render__$k = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('g', {
    attrs: {
      "transform": _vm.transform
    }
  }, [_c('path', {
    attrs: {
      "d": _vm.points,
      "stroke": _vm.strokeColour,
      "stroke-width": _vm.strokeWidth,
      "fill": _vm.fillColour,
      "stroke-dasharray": _vm.mainPathDash,
      "fill-opacity": "1"
    }
  }), _vm._v(" "), _vm.showHighlightPath ? _c('path', {
    attrs: {
      "d": _vm.points,
      "stroke": "#000",
      "stroke-width": _vm.highlightPathStrokeWidth,
      "fill": "none",
      "stroke-dasharray": "4",
      "fill-opacity": "1"
    }
  }) : _vm._e(), _vm._v(" "), _vm.hint ? _c('ps-hint', {
    ref: "hint",
    attrs: {
      "hint": _vm.hint,
      "transform": _vm.hintTransform,
      "options": _vm.options,
      "parentHeight": _vm.headHeight()
    }
  }) : _vm._e(), _vm._v(" "), _c('ps-content', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.isMystery,
      expression: "!isMystery"
    }],
    ref: "item",
    attrs: {
      "contents": _vm.contents,
      "transforms": _vm.innerTransforms,
      "options": _vm.options
    },
    on: {
      "changed": _vm.onHeadElementsChanged
    }
  }), _vm._v(" "), _c('g', {
    attrs: {
      "transform": _vm.repeatImageTransform
    }
  }, [_c('image', {
    attrs: {
      "height": _vm.imagePixelSize(_vm.repeatImageSize),
      "width": _vm.imagePixelSize(_vm.repeatImageSize),
      "xlink:href": _vm.imageLink
    }
  })]), _vm._v(" "), _vm.content.substack ? [_c('g', {
    attrs: {
      "transform": _vm.substackTransform
    }
  }, _vm._l(_vm.content.substack, function (block, index) {
    return _c(_vm.blockType(block), {
      key: index,
      ref: "substack",
      refInFor: true,
      tag: "component",
      attrs: {
        "content": block,
        "transforms": _vm.getSubstackTransforms(index),
        "options": _vm.options
      },
      on: {
        "changed": _vm.onSubstackChanged,
        "add-highlight": _vm.onSubstackHighlighted
      }
    });
  }), 1)] : _vm._e()], 2);
};
var __vue_staticRenderFns__$k = [];

/* style */
const __vue_inject_styles__$k = undefined;
/* scoped */
const __vue_scope_id__$k = "data-v-4e306d98";
/* module identifier */
const __vue_module_identifier__$k = undefined;
/* functional template */
const __vue_is_functional_template__$k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$m = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$k,
  staticRenderFns: __vue_staticRenderFns__$k
}, __vue_inject_styles__$k, __vue_script__$k, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, undefined, undefined, undefined);
var PsBlockRepeat = __vue_component__$m;

var script$j = {
  name: 'ps-block-separator',
  props: ["content", "transforms", "options"],
  components: {},
  data() {
    return {
      cornerArc: 4,
      padding: 10,
      innerWidth: 139,
      innerHeight: 20,
      minHeight: 24
    };
  },
  computed: {
    type: function () {
      return this.content.block;
    },
    width: function () {
      return this.innerWidth + 2 * this.cornerArc;
    },
    height: function () {
      return this.innerHeight + 2 * this.cornerArc;
    },
    printWidth: function () {
      return this.width;
    },
    points: function () {
      //"M100 10 L300 10 L300 100 L100 100 Z"
      // path = "m 0,0"
      return `m 0,4 A 4,4 0 0,1 4,0 H 12 c 2,0 3,1 4,2 l 4,4 c 1,1 2,2 4,2 h 12 c 2,0 3,-1 4,-2 l 4,-4 c 1,-1 2,-2 4,-2 H ${this.innerWidth} a 4,4 0 0,1 4,4 v ${this.innerHeight}  a 4,4 0 0,1 -4,4 H 48   c -2,0 -3,1 -4,2 l -4,4 c -1,1 -2,2 -4,2 h -12 c -2,0 -3,-1 -4,-2 l -4,-4 c -1,-1 -2,-2 -4,-2 H 4 a 4,4 0 0,1 -4,-4 z`;
    },
    transform: function () {
      if (this.transforms) {
        return `translate(${this.transforms.x}, ${this.transforms.y})`;
      } else {
        return 'translate(0, 0)';
      }
    },
    fillColour: function () {
      return '#FFFFFF';
    },
    strokeColour: function () {
      return '#FFFFFF';
    },
    strokeWidth: function () {
      return getStrokeWeight(this.options);
    }
  },
  methods: {
    getContentsWidth: function () {
      return this.innerWidth;
    },
    getContentsHeight: function () {
      return this.minHeight;
    }
  }
};

/* script */
const __vue_script__$j = script$j;

/* template */
var __vue_render__$j = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('g', {
    attrs: {
      "transform": _vm.transform
    }
  }, [_c('path', {
    attrs: {
      "d": _vm.points,
      "stroke": "none",
      "fill": "none",
      "fill-opacity": "1"
    }
  })]);
};
var __vue_staticRenderFns__$j = [];

/* style */
const __vue_inject_styles__$j = undefined;
/* scoped */
const __vue_scope_id__$j = "data-v-612b76be";
/* module identifier */
const __vue_module_identifier__$j = undefined;
/* functional template */
const __vue_is_functional_template__$j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$l = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$j,
  staticRenderFns: __vue_staticRenderFns__$j
}, __vue_inject_styles__$j, __vue_script__$j, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, undefined, undefined, undefined);
var PsBlockSeparator = __vue_component__$l;

var script$i = {
  name: 'ps-block-space',
  props: ["content", "transforms", "options"],
  components: {},
  data() {
    return {
      cornerArc: 4,
      padding: 10,
      innerWidth: 139,
      innerHeight: 40,
      minHeight: 48
    };
  },
  computed: {
    type: function () {
      return this.content.block;
    },
    width: function () {
      return this.innerWidth + 2 * this.cornerArc;
    },
    height: function () {
      return this.innerHeight + 2 * this.cornerArc;
    },
    printWidth: function () {
      return this.width;
    },
    points: function () {
      //"M100 10 L300 10 L300 100 L100 100 Z"
      // path = "m 0,0"
      return `m 0,4 A 4,4 0 0,1 4,0 H 12 c 2,0 3,1 4,2 l 4,4 c 1,1 2,2 4,2 h 12 c 2,0 3,-1 4,-2 l 4,-4 c 1,-1 2,-2 4,-2 H ${this.innerWidth} a 4,4 0 0,1 4,4 v ${this.innerHeight}  a 4,4 0 0,1 -4,4 H 48   c -2,0 -3,1 -4,2 l -4,4 c -1,1 -2,2 -4,2 h -12 c -2,0 -3,-1 -4,-2 l -4,-4 c -1,-1 -2,-2 -4,-2 H 4 a 4,4 0 0,1 -4,-4 z`;
    },
    transform: function () {
      if (this.transforms) {
        return `translate(${this.transforms.x}, ${this.transforms.y})`;
      } else {
        return 'translate(0, 0)';
      }
    },
    fillColour: function () {
      return '#FFFFFF';
    },
    strokeColour: function () {
      return '#FFFFFF';
    },
    strokeWidth: function () {
      return getStrokeWeight(this.options);
    }
  },
  methods: {
    getContentsWidth: function () {
      return this.innerWidth;
    },
    getContentsHeight: function () {
      return this.minHeight;
    }
  }
};

/* script */
const __vue_script__$i = script$i;

/* template */
var __vue_render__$i = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('g', {
    attrs: {
      "transform": _vm.transform
    }
  }, [_c('path', {
    attrs: {
      "d": _vm.points,
      "stroke": "none",
      "fill": "none",
      "fill-opacity": "1"
    }
  })]);
};
var __vue_staticRenderFns__$i = [];

/* style */
const __vue_inject_styles__$i = undefined;
/* scoped */
const __vue_scope_id__$i = "data-v-45f15570";
/* module identifier */
const __vue_module_identifier__$i = undefined;
/* functional template */
const __vue_is_functional_template__$i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$k = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$i,
  staticRenderFns: __vue_staticRenderFns__$i
}, __vue_inject_styles__$i, __vue_script__$i, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, undefined, undefined, undefined);
var PsBlockSpace = __vue_component__$k;

var script$h = {
  name: 'ps-incrementor',
  props: {
    number: Number,
    min: Number,
    max: Number
  },
  data() {
    return {
      value: this.number
    };
  },
  computed: {
    atMin: function () {
      return this.value === this.min;
    },
    atMax: function () {
      return this.value === this.max;
    }
  },
  methods: {
    decrement: function (e) {
      e.preventDefault();
      this.value = this.value > this.min ? this.value - 1 : this.value;
      this.emitChange();
    },
    increment: function (e) {
      e.preventDefault();
      this.value = this.value < this.max ? this.value + 1 : this.value;
      this.emitChange();
    },
    emitChange: function () {
      this.$emit('change', this.value);
    }
  }
};

/* script */
const __vue_script__$h = script$h;

/* template */
var __vue_render__$h = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "incrementor-container"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.atMin
    },
    on: {
      "click": _vm.decrement
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "disabled": _vm.atMax
    },
    on: {
      "click": _vm.increment
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])]);
};
var __vue_staticRenderFns__$h = [];

/* style */
const __vue_inject_styles__$h = undefined;
/* scoped */
const __vue_scope_id__$h = "data-v-ebd5ba18";
/* module identifier */
const __vue_module_identifier__$h = undefined;
/* functional template */
const __vue_is_functional_template__$h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$j = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$h, __vue_script__$h, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, undefined, undefined, undefined);
var PsIncrementor = __vue_component__$j;

var script$g = {
  name: 'ps-effect',
  props: ['effect', 'size', 'colour', 'direction'],
  data() {
    return {
      id: 'custom-effect'
    };
  },
  computed: {
    isDropshadow: function () {
      return this.effect == 1;
    },
    isGlow: function () {
      return this.effect == 2;
    },
    dx: function () {
      if (this.direction == 1 || this.direction == 4) {
        return parseInt(this.size);
      } else if (this.direction == 2 || this.direction == 3) {
        return -1 * parseInt(this.size);
      }
    },
    dy: function () {
      if (this.direction == 1 || this.direction == 2) {
        return parseInt(this.size);
      } else if (this.direction == 3 || this.direction == 4) {
        return -1 * parseInt(this.size);
      }
    },
    floodColour: function () {
      const colour = this.colour;
      if (this.isDropshadow) {
        return `rgb(${colour}, ${colour}, ${colour})`;
      } else if (this.isGlow) {
        return `#${colour}`;
      }
    }
  }
};

/* script */
const __vue_script__$g = script$g;

/* template */
var __vue_render__$g = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('defs', [_c('filter', {
    attrs: {
      "id": _vm.id
    }
  }, [_vm.isGlow ? [_c('feFlood', {
    attrs: {
      "result": "flood",
      "flood-color": _vm.floodColour,
      "flood-opacity": "1"
    }
  }), _vm._v(" "), _c('feComposite', {
    attrs: {
      "in": "flood",
      "result": "mask",
      "in2": "SourceGraphic",
      "operator": "in"
    }
  }), _vm._v(" "), _c('feMorphology', {
    attrs: {
      "in": "mask",
      "result": "dilated",
      "operator": "dilate",
      "radius": _vm.size
    }
  }), _vm._v(" "), _c('feGaussianBlur', {
    attrs: {
      "in": "dilated",
      "result": "effect",
      "stdDeviation": "4"
    }
  })] : _vm._e(), _vm._v(" "), _vm.isDropshadow ? [_c('feDropShadow', {
    attrs: {
      "dx": _vm.dx,
      "dy": _vm.dy,
      "stdDeviation": "4",
      "flood-color": _vm.floodColour,
      "flood-opacity": "1"
    }
  })] : _vm._e(), _vm._v(" "), _c('feMerge', [_c('feMergeNode', {
    attrs: {
      "in": "effect"
    }
  }), _vm._v(" "), _c('feMergeNode', {
    attrs: {
      "in": "SourceGraphic"
    }
  })], 1)], 2)]);
};
var __vue_staticRenderFns__$g = [];

/* style */
const __vue_inject_styles__$g = undefined;
/* scoped */
const __vue_scope_id__$g = "data-v-3192311b";
/* module identifier */
const __vue_module_identifier__$g = undefined;
/* functional template */
const __vue_is_functional_template__$g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$i = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$g, __vue_script__$g, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, undefined, undefined, undefined);
var PsEffect = __vue_component__$i;

var script$f = {
  name: 'ps-drawing',
  props: ["tabNo", "activeTab", "workingTree", "options", "sizes"],
  components: {
    PsBlockEvent,
    PsBlockBasic,
    PsBlockRepeat,
    PsBlockIfthen,
    PsBlockSeparator,
    PsBlockSpace,
    PsBlockDefine,
    PsContentText,
    PsContentValue,
    PsContentCondition,
    PsContentDropdown,
    PsContentMatrix,
    PsIncrementor,
    PsEffect
  },
  data() {
    return {
      minXOffset: 5,
      minYOffset: 5,
      minWidth: 300,
      minHeight: 300,
      innerTransforms: [],
      width: 0,
      height: 0,
      scaleFactor: 1,
      defaultScaleFactor: 0.81,
      scaleMultiplier: 1.2,
      showInchSizes: false,
      highlights: []
    };
  },
  computed: {
    multiplicationFactor: function () {
      return this.scaleMultiplier ** (this.scaleFactor - 1);
    },
    scale: function () {
      return this.defaultScaleFactor * this.multiplicationFactor;
    },
    yOffset: function () {
      let offset = this.minYOffset * this.multiplicationFactor + this.options.stroke_weight;
      if (this.hasEffect && (this.options.dropshadow_direction == effectDirections.NorthWest || this.options.dropshadow_direction == effectDirections.NorthEast)) {
        offset += this.options.effect_size;
      }
      return offset;
    },
    xOffset: function () {
      let offset = this.minXOffset;
      if (this.hasEffect && (this.options.dropshadow_direction == effectDirections.SouthWest || this.options.dropshadow_direction == effectDirections.NorthWest)) {
        offset += this.options.effect_size;
      }
      return offset;
    },
    numBlocks: function () {
      return this.workingTree.length;
    },
    id: function () {
      return `script_${this.tabNo}`;
    },
    isActive: function () {
      return this.tabNo === this.activeTab;
    },
    strokeWeight: function () {
      return this.options.stroke_weight;
    },
    strokeColour: function () {
      return this.options.colour;
    },
    transform: function () {
      return `translate(${this.xOffset}, ${this.yOffset}) scale(${this.scale})`;
    },
    hasSetWidth: function () {
      const size = this.sizes.filter(size => size.id === this.options.size)[0];
      if (size.width !== null) {
        return true;
      }
      return false;
    },
    dimensions: function () {
      const size = this.sizes.filter(size => size.id === this.options.size)[0];
      if (size.width !== null) {
        let width = size.width,
          height = size.height;
        if (!this.options.potrait) {
          width = size.height;
          height = size.width;
        }
        return {
          width: width,
          height: height
        };
      }
      return {
        width: null,
        height: null
      };
    },
    updatedOptions: function () {
      let options = Object.assign({}, this.options);
      options.colour = parseInt(this.workingTree.instructions.colour) || options.colour;
      options.dpi = parseInt(this.workingTree.instructions.dpi) || options.dpi;
      options.scale_factor = parseFloat(this.workingTree.instructions.scale_factor) || options.scale_factor;
      options.containsHighlight = this.workingTree.containsHighlight;
      return options;
    },
    hasEffect: function () {
      return this.options.effect != 0;
    },
    effectFilter: function () {
      if (this.hasEffect) {
        return 'url(#custom-effect)';
      }
      return '';
    }
  },
  watch: {
    numBlocks: function () {
      this.calculateTransformsNextTick();
    },
    strokeWeight: function () {
      this.calculateTransformsNextTick();
    },
    strokeColour: function () {
      this.calculateTransformsNextTick();
    },
    scaleFactor: function () {
      this.calculateTransformsNextTick();
    },
    'options.auto_hints': function () {
      this.$nextTick(() => {
        this.width = this.getWidth();
      });
    },
    'options.effect': function () {
      this.calculateTransforms();
    }
  },
  methods: {
    calculateTransformsNextTick: function () {
      this.$nextTick(() => {
        // The whole view is rendered, so I can safely access or query
        // the DOM. ¯\_(ツ)_/¯
        this.calculateTransforms();
      });
    },
    calculateTransforms: function () {
      this.innerTransforms = [];
      if (this.workingTree) {
        for (let i = 0; i < this.workingTree.length; i++) {
          this.innerTransforms.push({
            x: 0,
            y: this.itemOffset(i)
          });
        }
        this.width = this.getWidth();
        this.height = this.getHeight();
      }
    },
    getTransforms: function (index) {
      if (this.innerTransforms.length > 0) {
        return this.innerTransforms[index];
      }
    },
    refItem(index) {
      if (this.$refs.blocks) {
        return this.$refs.blocks.find(refItem => {
          return refItem.$vnode.key === index;
        });
      }
    },
    itemOffset: function (index) {
      if (index === 0) {
        if (this.$refs.blocks && this.$refs.blocks[0].$vnode.tag.indexOf('block-event') > 0) {
          return this.$refs.blocks[0].hatHeight - this.$refs.blocks[0].cornerArc - this.minYOffset + 1;
        } else if (this.$refs.blocks && this.$refs.blocks[0].$vnode.tag.indexOf('block-define') > 0) {
          return this.$refs.blocks[0].headerArc - this.minYOffset + 1;
        } else {
          return 0;
        }
      }
      let offset = 0;
      if (this.$refs.blocks) {
        for (let i = 0; i < index; i++) {
          const ref = this.refItem(i);
          if (ref) {
            if (typeof ref.height === 'function') {
              offset += ref.height();
            } else {
              offset += ref.height;
            }
            //if (this.options.colour === drawing.colourOptions.FullColour) offset++
          }
        }
      }
      return offset;
    },
    contentType: function (element) {
      if ('command' in element) {
        return `ps-content-${element.command.toLowerCase()}`;
      } else {
        // if (element.block.toLowerCase() === "ifthen" && element.isElse) {
        //     return "ps-block-ifthenelse"
        // }
        return `ps-block-${element.block.toLowerCase()}`;
      }
    },
    getHeight: function () {
      let height = 0;
      if (this.$refs.blocks) {
        for (let block of this.$refs.blocks) {
          if (typeof block.height === 'function') {
            height += block.height();
          } else {
            height += block.height;
          }
        }
      }
      if (this.hasEffect && (this.options.dropshadow_direction == effectDirections.SouthEast || this.options.dropshadow_direction == effectDirections.SouthWest)) {
        height += this.options.effect_size;
      }
      return height * this.scale + this.yOffset + 2 * this.minYOffset;
    },
    getWidth: function () {
      let width = 0;
      if (this.$refs.blocks) {
        let blockWidths = this.$refs.blocks.map(item => item.printWidth || item.width());
        width += Math.max(...blockWidths);
      }
      if (this.hasEffect && (this.options.dropshadow_direction == effectDirections.SouthEast || this.options.dropshadow_direction == effectDirections.NorthEast)) {
        width += this.options.effect_size;
      }
      return width * this.scale + 2 * this.xOffset;
    },
    round: function (num, decimals) {
      return round(num, decimals);
    },
    pixelSize: function (num) {
      return num * this.options.dpi / 72;
    },
    inchSize: function (num) {
      return this.pixelSize(num) / this.options.dpi;
    },
    onChanged: function () {
      this.calculateTransforms();
    },
    onScaleFactorChanged: function (value) {
      this.scaleFactor = value;
    },
    onBlockHighlighted: function (data) {
      // what happens if a highlight is removed
      if (data.add) {
        const index = this.highlights.findIndex(highlight => highlight.key === data.key);
        // the below fails because -1 test as true but cannot $set a negative index however
        // when changed to index > -1 stated to get ghost highlights. Needs further investigation
        if (index) {
          this.$set(this.highlights, index, data);
        } else {
          this.highlights.push(data);
        }
      } else {
        this.highlights = this.highlights.filter(highlight => !(highlight.key === data.key));
      }
    },
    getHighlightTransform(transforms) {
      return `translate(${transforms.x}, ${transforms.y})`;
    }
  },
  created: function () {
    this.calculateTransforms();
  },
  mounted: function () {
    this.calculateTransforms();
  }
};

/* script */
const __vue_script__$f = script$f;

/* template */
var __vue_render__$f = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "tab-pane fade in svg-container",
    class: {
      active: _vm.isActive,
      show: _vm.isActive
    },
    attrs: {
      "id": _vm.id
    }
  }, [_c('div', {
    staticClass: "svg"
  }, [_c('svg', {
    ref: "drawing",
    attrs: {
      "height": _vm.height,
      "width": _vm.width
    }
  }, [_vm.hasEffect ? _c('PsEffect', {
    attrs: {
      "effect": _vm.options.effect,
      "size": _vm.options.effect_size,
      "colour": _vm.options.effect_colour,
      "direction": _vm.options.dropshadow_direction
    }
  }) : _vm._e(), _vm._v(" "), _c('g', {
    attrs: {
      "transform": _vm.transform,
      "filter": _vm.effectFilter
    }
  }, [_vm._l(_vm.workingTree, function (content, index) {
    return _c(_vm.contentType(content), {
      key: index,
      ref: "blocks",
      refInFor: true,
      tag: "component",
      attrs: {
        "content": content,
        "transforms": _vm.getTransforms(index),
        "options": _vm.updatedOptions
      },
      on: {
        "changed": _vm.onChanged,
        "add-highlight": _vm.onBlockHighlighted
      }
    });
  }), _vm._v(" "), _vm._l(_vm.highlights, function (highlight, index) {
    return _c('path', {
      key: index + 1000,
      attrs: {
        "transform": _vm.getHighlightTransform(highlight.transforms),
        "d": highlight.path,
        "stroke": "#000",
        "stroke-width": 3,
        "fill": "none",
        "stroke-dasharray": "4",
        "fill-opacity": "1"
      }
    });
  })], 2)], 1)]), _vm._v(" "), !_vm.hasSetWidth ? _c('PsIncrementor', {
    staticClass: "incrementor",
    attrs: {
      "number": _vm.scaleFactor,
      "min": 1,
      "max": 10
    },
    on: {
      "change": _vm.onScaleFactorChanged
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "statistics"
  }, [_vm.hasSetWidth ? [_c('span', {
    staticClass: "float-left"
  }, [_vm._v("Image will be scaled to fit " + _vm._s(_vm.dimensions.width) + "in x " + _vm._s(_vm.dimensions.height) + "in")])] : [_c('span', {
    staticClass: "float-left"
  }, [_vm._v("\n                Zoom: " + _vm._s(_vm.scaleFactor) + ", \n                DPI: " + _vm._s(_vm.updatedOptions.dpi) + ", \n                "), _vm.showInchSizes ? [_vm._v("\n                Dimensions (w x h): " + _vm._s(_vm.round(_vm.inchSize(_vm.width), 2)) + "in x " + _vm._s(_vm.round(_vm.inchSize(_vm.height), 2)) + "in\n                ")] : [_vm._v("\n                Dimensions (w x h): " + _vm._s(_vm.round(_vm.pixelSize(_vm.width), 2)) + "px x " + _vm._s(_vm.round(_vm.pixelSize(_vm.height), 2)) + "px\n                ")]], 2), _vm._v(" "), _c('span', {
    staticClass: "float-md-right float-sm-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.showInchSizes,
      expression: "showInchSizes"
    }],
    attrs: {
      "type": "checkbox",
      "id": "show-inches"
    },
    domProps: {
      "checked": Array.isArray(_vm.showInchSizes) ? _vm._i(_vm.showInchSizes, null) > -1 : _vm.showInchSizes
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.showInchSizes,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.showInchSizes = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.showInchSizes = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.showInchSizes = $$c;
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "show-inches"
    }
  }, [_vm._v("Show inches")])])]], 2)], 1);
};
var __vue_staticRenderFns__$f = [];

/* style */
const __vue_inject_styles__$f = undefined;
/* scoped */
const __vue_scope_id__$f = "data-v-5e1eb3dd";
/* module identifier */
const __vue_module_identifier__$f = undefined;
/* functional template */
const __vue_is_functional_template__$f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$h = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$f, __vue_script__$f, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, undefined, undefined, undefined);
var PsDrawing = __vue_component__$h;

var script$e = {
  name: 'ps-drawing-header',
  props: ["tab", "activeTab"],
  data() {
    return {
      tabNo: this.tab.tabNo
    };
  },
  computed: {
    href: function () {
      return `#script_${this.tabNo}`;
    },
    isActive: function () {
      return this.tabNo === this.activeTab;
    }
  },
  methods: {
    onClick: function () {
      this.$emit('tab-clicked', this.tabNo);
    }
  }
};

/* script */
const __vue_script__$e = script$e;

/* template */
var __vue_render__$e = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "data-toggle": "tab",
      "href": _vm.href
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("\n        " + _vm._s(_vm.tab.filename) + "\n    ")])]);
};
var __vue_staticRenderFns__$e = [];

/* style */
const __vue_inject_styles__$e = undefined;
/* scoped */
const __vue_scope_id__$e = "data-v-308a93f9";
/* module identifier */
const __vue_module_identifier__$e = undefined;
/* functional template */
const __vue_is_functional_template__$e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$g = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, undefined, undefined, undefined);
var PsDrawingHeader = __vue_component__$g;

var script$d = {
  name: 'ps-drawing-header-move-dropdown',
  props: ['overflowTab', 'activeTab'],
  data() {
    return {};
  },
  computed: {
    tabNo: function () {
      return this.overflowTab.tabNo;
    },
    isActive: function () {
      return this.activeTab === this.tabNo;
    }
  },
  methods: {
    href: function () {
      return `#script_${this.tabNo}`;
    },
    onClick: function () {
      this.$emit('tab-clicked', this.tabNo);
    }
  }
};

/* script */
const __vue_script__$d = script$d;

/* template */
var __vue_render__$d = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('a', {
    staticClass: "dropdown-item",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "tabNo": _vm.tabNo,
      "href": _vm.href(),
      "data-toggle": "tab"
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._v("\n    " + _vm._s(_vm.overflowTab.filename) + "\n")]);
};
var __vue_staticRenderFns__$d = [];

/* style */
const __vue_inject_styles__$d = undefined;
/* scoped */
const __vue_scope_id__$d = "data-v-152d396f";
/* module identifier */
const __vue_module_identifier__$d = undefined;
/* functional template */
const __vue_is_functional_template__$d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$f = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, undefined, undefined, undefined);
var DrawingHeaderMoreDropDown = __vue_component__$f;

var script$c = {
  name: 'ps-drawing-header-more',
  props: ['overflowTabs', 'activeTab'],
  components: {
    DrawingHeaderMoreDropDown
  },
  data() {
    return {};
  },
  computed: {
    isActive: function () {
      let tab = this.overflowTabs.filter(t => t.tabNo === this.activeTab);
      if (tab.length > 0) return true;
      return false;
    }
  },
  methods: {
    onTabClicked: function (tabNo) {
      this.$emit('tab-clicked', tabNo);
    }
  }
};

/* script */
const __vue_script__$c = script$c;

/* template */
var __vue_render__$c = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('li', {
    staticClass: "nav-item dropdown more-tab"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    class: {
      active: _vm.isActive
    },
    attrs: {
      "data-toggle": "dropdown",
      "href": "#"
    }
  }, [_vm._v("More")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu test"
  }, _vm._l(_vm.overflowTabs, function (item, index) {
    return _c('DrawingHeaderMoreDropDown', {
      key: index,
      attrs: {
        "overflowTab": item,
        "activeTab": _vm.activeTab
      },
      on: {
        "tab-clicked": _vm.onTabClicked
      }
    });
  }), 1)]);
};
var __vue_staticRenderFns__$c = [];

/* style */
const __vue_inject_styles__$c = function (inject) {
  if (!inject) return;
  inject("data-v-0a6e4fc2_0", {
    source: ".test[data-v-0a6e4fc2]{max-height:400px;overflow-y:auto}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$c = "data-v-0a6e4fc2";
/* module identifier */
const __vue_module_identifier__$c = undefined;
/* functional template */
const __vue_is_functional_template__$c = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$e = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, createInjector, undefined, undefined);
var PsDrawingHeaderMore = __vue_component__$e;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

/** Detect free variable `global` from Node.js. */

var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal || freeSelf || Function('return this')();

var _root = root;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return _root.Date.now();
};

var now_1 = now;

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

var _trimmedEndIndex = trimmedEndIndex;

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, _trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

var _baseTrim = baseTrim;

/** Built-in value references. */
var Symbol$1 = _root.Symbol;

var _Symbol = Symbol$1;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto$1.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$1.toString;

/** Built-in value references. */
var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

var _baseGetTag = baseGetTag;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike_1(value) && _baseGetTag(value) == symbolTag);
}

var isSymbol_1 = isSymbol;

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol_1(value)) {
    return NAN;
  }
  if (isObject_1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject_1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = _baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var toNumber_1 = toNumber;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber_1(wait) || 0;
  if (isObject_1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber_1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now_1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now_1());
  }

  function debounced() {
    var time = now_1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

var debounce_1 = debounce;

function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : String(i);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var _class;
class Parser {
  static getBaseText(inner) {
    const specialOpCodes = ["ps_myvar", "ps_mylist"];
    const scratchCommand = inner.scratchCommand;
    let base = inner.base;
    if (!specialOpCodes.includes(scratchCommand.op_code)) {
      base = scratchCommand.block_syntax_with_parameters || scratchCommand.block_syntax;
      if (base.includes("!")) {
        const parts = base.split("!");
        base = parts[1];
      }
    }
    return base;
  }
  static translateWord(word, translations) {
    let translation = word;
    if (translations && translations.length > 0) {
      const matches = translations.filter(entry => entry.editor_translation === translation);
      if (matches.length > 0) {
        translation = matches[0].translation;
      }
    }
    return translation;
  }
}
_class = Parser;
_defineProperty(Parser, "OPENING", ["(", "[", "<"]);
_defineProperty(Parser, "CLOSING", [")", "]", ">"]);
_defineProperty(Parser, "MANUALHINTCHAR", "~");
_defineProperty(Parser, "VALIDINSTRUCTIONS", ["filename",
// 'sprite',
// 'remark',
"scale_factor", "dpi", "color", "colour", "strict"]);
_defineProperty(Parser, "VALIDDIRECTIVES", ["bold", "highlight", "define", "myblock", "mystery", "vanity", "vanity-motion", "vanity-looks", "vanity-sound", "vanity-events", "vanity-control", "vanity-sensing", "vanity-operators", "vanity-variables", "vanity-list", "vanity-myblock", "vanity-music", "vanity-pen", "vanity-video", "vanity-speech", "vanity-translate", "wedo", "makey", "ev3", "microbit", "boost", "fa", "music", "pen", "video", "speech", "translate", "motion", "looks", "sound", "events", "control", "sensing", "operators", "variables", "list", "dim", "autohint"]);
_defineProperty(Parser, "VALIDINNERDIRECTIVES", ["bold", "highlight", "mystery", "myvar", "mylist", "wedo", "makey", "ev3", "microbit", "boost", "fa", "music", "pen", "video", "speech", "translate", "motion", "looks", "sound", "events", "control", "sensing", "operators", "variables", "list", "dim"]);
_defineProperty(Parser, "COMMENTCHAR", "-");
_defineProperty(Parser, "INSTRUCTIONPREFIX", _class.COMMENTCHAR.repeat(2));
_defineProperty(Parser, "SEPARATOR", _class.COMMENTCHAR.repeat(5));
_defineProperty(Parser, "SUBSTITUTES", [{
  op_code: "event_whenflagclicked",
  en_word: "flag",
  command: "Flag"
}, {
  op_code: "motion_turnright",
  en_word: "right",
  command: "TurnRight"
}, {
  op_code: "motion_turnleft",
  en_word: "left",
  command: "TurnLeft"
}]);
_defineProperty(Parser, "SPECIALCHARS", [{
  needle: ",",
  replacement: ""
}, {
  needle: ":",
  replacement: ""
}, {
  needle: "?",
  replacement: ""
}, {
  needle: "%",
  replacement: ""
}, {
  needle: "¿",
  replacement: ""
}, {
  needle: "  ",
  replacement: " "
}]);
_defineProperty(Parser, "recordError", (lineno, error) => {
  return {
    lineno: lineno,
    error: error
  };
});
_defineProperty(Parser, "anyLineHighlighted", script => {
  for (let entry of script) {
    if (entry.text.indexOf('highlight!') > -1) {
      return true;
    }
  }
  return false;
});
_defineProperty(Parser, "isInstruction", line => {
  return line.startsWith(_class.INSTRUCTIONPREFIX);
});
_defineProperty(Parser, "extractInstructions", script => {
  let results = {
    instructions: {},
    errors: [],
    script: []
  };
  for (let i = 0; i < script.length; i++) {
    const line = script[i].text;
    if (_class.isInstruction(line)) {
      //found an instruction
      const retval = _class.parseInstructionLine(line, script[i].original_lineno);
      for (let entry of retval) {
        if (entry.isError) {
          results.errors.push(entry.error);
        } else {
          results.instructions[entry.instruction] = entry.value;
        }
      }
    } else {
      results.script.push(script[i]);
    }
  }
  return results;
});
_defineProperty(Parser, "parseInstructionLine", (line, lineno) => {
  let results = [];
  const stripped = line.replace(_class.INSTRUCTIONPREFIX, "").trim();
  const instructions = stripped.split(",");
  for (let instruction of instructions) {
    const result = _class.parseInstruction(instruction, lineno);
    results.push(result);
  }
  return results;
});
_defineProperty(Parser, "parseInstruction", (instruction, lineno) => {
  let result = {
    instruction: null,
    value: null,
    isError: false,
    error: null
  };
  if (instruction.split(":").length - 1 != 1) {
    result.isError = true;
    result.error = _class.recordError(lineno, `Badly formed instruction. Instructions should be of the form e.g. "-- <instruction1>: <value1> (, <instruction2>: <value2>)"`);
  } else {
    const components = instruction.split(":");
    let command = components[0].trim(),
      value = components[1].trim();
    if (!_class.VALIDINSTRUCTIONS.includes(command)) {
      result.isError = true;
      result.error = _class.recordError(lineno, `Invalid instruction "${command}" provided. Valid instructions are: (${_class.VALIDINSTRUCTIONS.join(", ")})`);
    } else {
      let retval;
      if (command === "filename") {
        retval = _class.validateFilename(value);
      } else if (command === "scale_factor") {
        retval = _class.validateScaleFactor(value);
      } else if (command === "dpi") {
        retval = _class.validateDPI(value);
      } else if (["color", "colour"].includes(command)) {
        command = "colour";
        retval = _class.validateColour(value);
      } else if (command === "strict") {
        retval = _class.validateStrict(value);
      }
      if (retval.isError) {
        result.isError = true;
        result.error = _class.recordError(lineno, retval.error);
      } else {
        result.instruction = command;
        result.value = retval.updatedValue == null ? value : retval.updatedValue;
      }
    }
  }
  return result;
});
_defineProperty(Parser, "validateFilename", filename => {
  const MAXLENGTH = 30;
  let result = {
    isError: false,
    error: null,
    updatedValue: null
  };
  if (filename.length > MAXLENGTH) {
    result.isError = true;
    result.error = `Filenames cannot be longer than ${MAXLENGTH} characters, ${filename.length} provided.`;
  }
  const parts = filename.split(".");
  if (parts.length > 1) {
    const extension = parts[parts.length - 1];
    if (!["jpg", "png"].includes(extension)) {
      result.isError = true;
      result.error = `Invalid filename extension '${extension}'. The supported extensions are 'png' and 'jpg'.`;
    }
  } else {
    result.updatedValue = (filename.trim() || 'untitled') + '.png'; // appending .png if filename has no extension
  }
  return result;
});
_defineProperty(Parser, "validateScaleFactor", value => {
  let result = {
    isError: false,
    error: null,
    updatedValue: null
  };
  if (isNaN(Number(value))) {
    result.isError = true;
    result.error = `Scale factors must be an integer or decimal value. '${value}' is not a valid number`;
  } else {
    const convertedNumber = Number(value);
    if (convertedNumber > 50 || convertedNumber < 1 || convertedNumber % 1 !== 0) {
      result.isError = true;
      result.error = `Scale factors must be integers between 1 and 50`;
    }
  }
  return result;
});
_defineProperty(Parser, "validateDPI", value => {
  let result = {
    isError: false,
    error: null,
    updatedValue: null
  };
  if (!isInt(value)) {
    result.isError = true;
    result.error = `DPI values must be an integer. ${value} is not a valid number`;
  } else {
    const convertedNumber = Number(value);
    const validDPI = [72, 150, 180, 300];
    if (!validDPI.includes(convertedNumber)) {
      result.isError = true;
      result.error = `Invalid DPI value provided. Valid DPI values are ${validDPI.join(", ")}`;
    }
  }
  return result;
});
_defineProperty(Parser, "validateColour", value => {
  let result = {
    isError: false,
    error: null,
    updatedValue: null
  };
  if (!isInt(value)) {
    result.isError = true;
    result.error = `Color values must be an integer. ${value} is not a valid number`;
  } else {
    const convertedNumber = Number(value);
    if (![1, 2, 3].includes(convertedNumber)) {
      result.isError = true;
      result.error = `Color values must be integers between 1 and 3`;
    }
  }
  return result;
});
_defineProperty(Parser, "validateStrict", value => {
  let result = {
    isError: false,
    error: null,
    updatedValue: null
  };
  if (!["yes", "no", "true", "false"].includes(value.toLowerCase())) {
    result.isError = true;
    result.error = `Valid values for "strict" are yes or no`;
  } else {
    if (["yes", "true"].includes(value.toLowerCase())) {
      result.updatedValue = true;
    } else {
      result.updatedValue = false;
    }
  }
  return result;
});
_defineProperty(Parser, "validateInstructionsFirst", script => {
  let errors = [];
  for (let entry of script) {
    if (_class.isInstruction(entry.text) && entry.lineno !== 0) {
      errors.push(_class.recordError(entry.original_lineno, `Instructions "${entry.text}" should be placed at the top of the script.`));
    }
  }
  return errors;
});
_defineProperty(Parser, "checkBrackets", script => {
  let errors = [];
  for (let i = 0; i < script.length; i++) {
    const line = script[i].text;
    if (!_class.isInstruction(line)) {
      const result = _class.checkBracketsLine(line);
      if (!result.valid) {
        errors.push(_class.recordError(script[i].original_lineno, result.error));
      }
    }
  }
  return errors;
});
_defineProperty(Parser, "checkBracketsLine", line => {
  let brackets = [];
  let result = {
    valid: true,
    error: null
  };
  for (let char of line) {
    if (_class.OPENING.includes(char)) {
      const closing = _class.CLOSING[_class.OPENING.indexOf(char)];
      brackets.push(closing);
    }
    if (_class.CLOSING.includes(char)) {
      if (brackets.length === 0) {
        result.valid = false;
        result.error = `Found "${char}" without corresponding opening`;
      } else {
        const closing = brackets.pop();
        if (closing !== char) {
          result.valid = false;
          result.error = `Found "${char}" while looking for "${closing}"`;
        }
      }
    }
  }
  if (brackets.length !== 0) {
    const closing = brackets.pop();
    const opening = _class.OPENING[_class.CLOSING.indexOf(closing)];
    result.valid = false;
    result.error = `Unmatched closing bracket for "${opening}"`;
  }
  return result;
});
_defineProperty(Parser, "getBaseSyntaxes", script => {
  let results = [];
  for (let entry of script) {
    const line = entry.text;
    if (!_class.isInstruction(line)) {
      const result = _class.getBaseSyntax(line);
      entry.syntaxTree = result;
    }
    results.push(entry);
  }
  return results;
});
_defineProperty(Parser, "getBaseSyntax", line => {
  let found = {
    base: "",
    inner: []
  };
  let level = 0;
  let seeking = {
    status: false,
    char: "",
    index: 0,
    level: 0
  };
  let dropdownCount = 0;
  for (let i = 0; i < line.length; i++) {
    const char = line[i];
    if (_class.OPENING.includes(char)) {
      if (!seeking.status) {
        found.base += char;
        seeking.status = true;
        seeking.index = i + 1;
        seeking.level = level;
        seeking.char = _class.CLOSING[_class.OPENING.indexOf(char)];
      } else {
        if (_class.OPENING[_class.CLOSING.indexOf(seeking.char)] === char) {
          level += 1;
        }
      }
    } else if (_class.CLOSING.includes(char)) {
      if (seeking.char === char) {
        if (seeking.level === level) {
          found.base += char;
          const innertext = line.slice(seeking.index, i);
          let inner = _class.getBaseSyntax(innertext);
          inner.openingchar = line[seeking.index - 1];
          if (inner.openingchar === "[") {
            inner.dropdownCount = dropdownCount++;
          }
          found.inner.push(inner);
          seeking.status = false;
          seeking.char = "";
          seeking.index = 0;
          seeking.level = 0;
        } else {
          level -= 1;
        }
      }
    } else {
      if (!seeking.status) {
        found.base += char;
      }
    }
  }
  found.base = _class.removeSpecialChars(found.base);
  found.base = _class.replaceSpecialOperators(found.base);
  return found;
});
_defineProperty(Parser, "containsDirective", (line, directive) => {
  // const regex = new RegExp(`^\s*${directive}!`, "i");
  // return regex.test(line);
  return line.indexOf(`${directive}!`) > -1;
});
_defineProperty(Parser, "removeDirective", (line, directive) => {
  //const regex = new RegExp(`^\s*${directive}!`, "i");
  return line.replace(`${directive}!`, "");
});
_defineProperty(Parser, "extractDirectives", script => {
  // This should be called after getBaseSyntaxes
  let results = script;
  for (let entry of results) {
    // results.push(Parser.extractDirectivesFromSyntaxTree(entry))
    entry.syntaxTree = _class.extractDirectivesFromTreeLevel(entry.syntaxTree);
  }
  return results;
});
_defineProperty(Parser, "extractDirectivesFromTreeLevel", (treeLevel, inner = false) => {
  let result = _class.extractDirectivesEntry(treeLevel, inner);
  treeLevel.base = result.base;
  treeLevel.directives = result.directives;
  for (let entry of treeLevel.inner) {
    const innerResults = _class.extractDirectivesFromTreeLevel(entry, true);
    treeLevel.inner.base = innerResults.base;
    treeLevel.inner.directives = innerResults;
  }
  return treeLevel;
});
_defineProperty(Parser, "extractDirectivesEntry", (treeLevel, inner = false) => {
  let base = treeLevel.base;
  const VALIDDIRECTIVES = inner ? _class.VALIDINNERDIRECTIVES : _class.VALIDDIRECTIVES;
  const directives = VALIDDIRECTIVES.filter(directive => _class.containsDirective(base, directive));
  if (directives.length > 0) {
    for (let directive of directives) {
      base = _class.removeDirective(base, directive);
    }
  }
  treeLevel.base = base;
  treeLevel.directives = directives;
  return treeLevel;
});
_defineProperty(Parser, "extractHints", script => {
  let results = [];
  for (let entry of script) {
    results.push(_class.extractHintsEntry(entry));
  }
  return results;
});
_defineProperty(Parser, "extractHintsEntry", scriptEntry => {
  const parts = scriptEntry.text.split(_class.MANUALHINTCHAR);
  if (parts.length > 1) {
    scriptEntry.text = parts[0].trim();
    scriptEntry.manualHint = parts[1].trim();
  }
  return scriptEntry;
});
_defineProperty(Parser, "removeSpecialChars", line => {
  for (let member of _class.SPECIALCHARS) {
    const regex = new RegExp(`\\${member.needle}`, "gi");
    line = line.replace(regex, member.replacement).trim();
  }
  return line;
});
_defineProperty(Parser, "replaceSpecialOperators", syntax => {
  if (syntax === "()+()") syntax = "() + ()";else if (syntax === "()-()") syntax = "() - ()";else if (syntax === "()*()") syntax = "() * ()";else if (syntax === "()/()") syntax = "() / ()";else if (syntax === "()=()") syntax = "() = ()";
  return syntax;
});
_defineProperty(Parser, "determineLineIndent", (line, char = " ") => {
  // Determines the space indentation for a given line
  for (let i = 0; i < line.length; i++) {
    if (line[i] !== char) {
      return i;
    }
  }
});
_defineProperty(Parser, "determineSpaceIndentUsed", script => {
  //Determines the space indentation by counting the number of spaces
  //of the first line that starts with a space
  for (let entry of script) {
    const line = entry.text;
    if (line.startsWith(" ")) {
      return _class.determineLineIndent(line);
    }
  }
  return 0;
});
_defineProperty(Parser, "checkSpaceIndentation", script => {
  let errors = [];
  const indentation = _class.determineSpaceIndentUsed(script);
  if (indentation > 0) {
    for (let entry of script) {
      const line = entry.text;
      const lineSpace = _class.determineLineIndent(line);
      if (lineSpace % indentation > 0) {
        const error = _class.recordError(entry.original_lineno, `Invalid indentation. ${lineSpace} spaces used. Number of spaces should be a multiple of ${indentation}. Use TAB to indent.`);
        errors.push(error);
      }
    }
  }
  return errors;
});
_defineProperty(Parser, "replaceSpaceIndentation", script => {
  const indentation = _class.determineSpaceIndentUsed(script);
  if (indentation > 0) {
    for (let entry of script) {
      const line = entry.text;
      const lineSpace = _class.determineLineIndent(line);
      const numTabs = lineSpace / indentation;
      if (numTabs > 0) {
        const regex = new RegExp(`^${"\\s".repeat(lineSpace)}`);
        entry.text = entry.text.replace(regex, "\t".repeat(numTabs));
      }
    }
  }
  return script;
});
_defineProperty(Parser, "getIndentation", script => {
  //counts the number of tabs for each line
  for (let entry of script) {
    const line = entry.text;
    const indentation = _class.determineLineIndent(line, "\t");
    entry.indentLevel = indentation;
    entry.text = line.trim();
  }
  return script;
});
_defineProperty(Parser, "hasDirective", (scriptEntry, directive) => {
  if (!scriptEntry.directives) return false;
  return scriptEntry.directives.includes(directive);
});
_defineProperty(Parser, "isDefine", scriptEntry => {
  return _class.hasDirective(scriptEntry, "define");
});
_defineProperty(Parser, "isMyBlock", scriptEntry => {
  return _class.hasDirective(scriptEntry, "myblock");
});
_defineProperty(Parser, "isMystery", scriptEntry => {
  return _class.hasDirective(scriptEntry, "mystery");
});
_defineProperty(Parser, "isAutoHint", scriptEntry => {
  return _class.hasDirective(scriptEntry, "autohint");
});
_defineProperty(Parser, "isDim", scriptEntry => {
  return _class.hasDirective(scriptEntry, "dim");
});
_defineProperty(Parser, "isMyVar", innerSyntax => {
  return _class.hasDirective(innerSyntax, "myvar");
});
_defineProperty(Parser, "isMyList", innerSyntax => {
  return _class.hasDirective(innerSyntax, "mylist");
});
_defineProperty(Parser, "isHighlight", innerSyntax => {
  return _class.hasDirective(innerSyntax, "highlight");
});
_defineProperty(Parser, "isVanity", scriptEntry => {
  if (!scriptEntry.directives) return false;
  for (let directive of scriptEntry.directives) {
    if (directive.match(/vanity(\-.*)?/i)) {
      return true;
    }
  }
  return false;
});
_defineProperty(Parser, "getVanityCategory", scriptEntry => {
  for (let directive of scriptEntry.directives) {
    const match = directive.match(/vanity(\-.*)?/i);
    if (match) {
      if (match[0].includes("-")) {
        const parts = match[0].split("-");
        return parts[1];
      } else {
        return null;
      }
    }
  }
});
_defineProperty(Parser, "isCategory", (scriptEntry, categories) => {
  if (!scriptEntry.directives) return false;
  const shortNames = categories.map(category => category.short_name);
  for (let directive of scriptEntry.directives) {
    if (shortNames.includes(directive)) return true;
  }
  return false;
});
_defineProperty(Parser, "getCategory", (scriptEntry, categories) => {
  const shortNames = categories.map(category => category.short_name);
  if (scriptEntry.directives) {
    for (let directive of scriptEntry.directives) {
      if (shortNames.includes(directive)) return directive;
    }
  }
  return null;
});
_defineProperty(Parser, "createGenericScratchCommand", syntax => {
  return {
    is_container: false,
    is_end: false,
    is_starter: false,
    is_active: true,
    is_command: false,
    command_type: null,
    text_only_command: false,
    options: null,
    op_code: "ps_vanity",
    editor_syntax: syntax,
    editor_syntax_with_parameters: syntax,
    editor_dropdowns: [],
    block_syntax: syntax,
    block_syntax_with_parameters: syntax
  };
});
_defineProperty(Parser, "setBlockLevelFlags", (syntaxTree, categories) => {
  syntaxTree.isDefine = _class.isDefine(syntaxTree);
  syntaxTree.isMyBlock = _class.isMyBlock(syntaxTree);
  syntaxTree.isMystery = _class.isMystery(syntaxTree);
  syntaxTree.isVanity = _class.isVanity(syntaxTree);
  syntaxTree.isHighlight = _class.isHighlight(syntaxTree);
  syntaxTree.isDim = _class.isDim(syntaxTree);
  syntaxTree.isAutoHint = _class.isAutoHint(syntaxTree);
  syntaxTree.isCategory = _class.isCategory(syntaxTree, categories);
});
_defineProperty(Parser, "setInnerLevelFlags", (innerSyntax, categories) => {
  innerSyntax.isMystery = _class.isMystery(innerSyntax);
  innerSyntax.isMyVar = _class.isMyVar(innerSyntax);
  innerSyntax.isMyList = _class.isMyList(innerSyntax);
  innerSyntax.isHighlight = _class.isHighlight(innerSyntax);
  innerSyntax.isDim = _class.isDim(innerSyntax);
  innerSyntax.isCategory = _class.isCategory(innerSyntax, categories);
  innerSyntax.isInner = true;
});
_defineProperty(Parser, "createMyBlock", (command, syntax) => {
  //Need to deep copy the command so that the edits below do not affect categories
  let myblock = JSON.parse(JSON.stringify(command));
  myblock.syntax = syntax;
  myblock.formal_syntax = syntax;
  myblock.editor_syntax = syntax;
  myblock.block_syntax = syntax;
  myblock.is_starter = false;
  myblock.op_code = "ps_myblock";
  return myblock;
});
_defineProperty(Parser, "createDefineBlock", (syntaxTree, commands, myblocks) => {
  let matches = commands.filter(command => command.op_code === "procedures_definition");
  syntaxTree.scratchCommand = JSON.parse(JSON.stringify(matches[0]));
  const namedParameters = _class.nameDefineParameters(syntaxTree);
  syntaxTree.scratchCommand.editor_syntax_with_parameters = namedParameters;
  syntaxTree.scratchCommand.block_syntax_with_parameters = namedParameters;
  const myblockSyntax = syntaxTree.base;
  // as the parser may be called sevaral times before the user finishes adding
  // the define command. We need to ensure that multiple copies of the command
  // are not put into myBlocks
  let newMyBlock = _class.createMyBlock(syntaxTree.scratchCommand, myblockSyntax);
  let duplicates = myblocks.filter(block => block.syntax === newMyBlock.syntax);
  if (duplicates.length === 0) myblocks.push(newMyBlock);
});
_defineProperty(Parser, "getScratchCommand", (syntaxTree, commands, categories, myblocks = [], strict = true) => {
  let matches = [];
  const syntax = syntaxTree.base.toLowerCase();
  if (syntaxTree.isVanity) {
    const command = _class.createGenericScratchCommand(syntaxTree.base);
    const name = _class.getVanityCategory(syntaxTree);
    if (name) {
      const category = categories.filter(category => category.short_name === name);
      if (category.length > 0) {
        command.category = category[0];
      }
    }
    if (!command.category) {
      const random = Math.floor(Math.random() * 10);
      command.category = categories[random];
    }
    command.category.isFaux = true;
    matches = [command];
  } else if (syntaxTree.isDefine) {
    matches = commands.filter(command => command.op_code === "procedures_definition");
  } else if (syntaxTree.isMyVar) {
    matches = commands.filter(command => command.op_code === "ps_myvar");
  } else if (syntaxTree.isMyList) {
    matches = commands.filter(command => command.op_code === "ps_mylist");
  } else if (syntaxTree.isMyBlock) {
    // check if the block has been defined
    matches = myblocks.filter(myblock => myblock.editor_syntax.toLowerCase() === syntax);
    // if not defined and strict = no then add the block
    if (matches.length == 0 && !strict) {
      _class.createDefineBlock(syntaxTree, commands, myblocks);
      matches = myblocks.filter(myblock => myblock.editor_syntax.toLowerCase() === syntax);
    }
  } else if (syntaxTree.isCategory) {
    const category = _class.getCategory(syntaxTree, categories);
    matches = commands.filter(command => command.editor_syntax.toLowerCase() === syntax && command.category.short_name === category);
  } else {
    // space should only validate as a primary command on non-inner commands e.g.
    // forever
    //     space -- this space should be matched with the space command
    // when [space] key pressed -- this space should NOT be matched with the space command
    const ignoredCommands = ["define"];
    const innerIgnoredCommands = ["space", "myvar", "mylist"];
    if (!(syntaxTree.isInner && innerIgnoredCommands.includes(syntax)) && !ignoredCommands.includes(syntax)) {
      matches = commands.filter(command => command.editor_syntax.toLowerCase() === syntax);
      if (matches.length === 0) {
        //An attempt is made to match against the myBlocks in case the user fails
        //to mark a custom block with the myblock! directive
        matches = myblocks.filter(myblock => myblock.editor_syntax.toLowerCase() === syntax);
      }
    }
  }
  return matches;
});
_defineProperty(Parser, "matchByDropDowns", (syntaxTree, matches) => {
  const inner = syntaxTree.inner;
  let dropdownMatches = [];
  // tracks which dropdown value in inner is being evaluated
  let position = 0;
  // for each entry in inner
  for (let i = 0; i < inner.length; i++) {
    const entry = inner[i];
    if (entry.openingchar === "[") {
      // only if entry is in a drop down field
      for (let match of matches) {
        // for each match get the dropdown
        const dropdowns = match.editor_dropdowns;
        // position in dropdown should match position of dropdown in inner
        // make sure that dropdowns have an element in that position
        if (dropdowns.length >= position + 1) {
          const regex = new RegExp(dropdowns[position].value, "i");
          // test the regular expression if it's a match return the entry
          if (regex.test(entry.base)) {
            dropdownMatches.push(match);
          }
        }
      }
      position++;
    }
  }
  // if none of the dropdown values match return the original matches.
  if (dropdownMatches.length > 0) return dropdownMatches;else return matches;
});
_defineProperty(Parser, "prioritiseNonExtension", matches => {
  // test with "when [] key pressed" which occurs in both Control and Makey Makey
  let nonExtensionBlocks = matches.filter(match => !match.category.is_extension);
  if (nonExtensionBlocks.length > 0) return nonExtensionBlocks;else return matches;
});
_defineProperty(Parser, "nameDefineParameters", syntaxTree => {
  let syntaxWithParameters = syntaxTree.base;
  // let usedParameters = []
  if (syntaxTree.inner) {
    for (let i = 0; i < syntaxTree.inner.length; i++) {
      const openingchar = syntaxTree.inner[i].openingchar;
      const closingchar = _class.CLOSING[_class.OPENING.indexOf(openingchar)];
      const parameter = syntaxTree.inner[i].base;
      const target = `${openingchar}${closingchar}`;
      const replacement = `${openingchar}${parameter}${closingchar}`;
      syntaxWithParameters = syntaxWithParameters.replace(target, replacement);
    }
  }
  return syntaxWithParameters;
});
_defineProperty(Parser, "cleanupMyBlocks", (myBlocks, command) => {
  return myBlocks.filter(item => !command.startsWith(item.syntax));
});
_defineProperty(Parser, "assignDropDownOptions", (inner, i, match) => {
  if (match.editor_dropdowns && match.editor_dropdowns[i]) {
    inner.regex = match.editor_dropdowns[i].value;
  }
});
_defineProperty(Parser, "validateSyntax", (script, commands, categories, myblocks, strict) => {
  let errors = [];
  let newMyBlocks = [];
  for (let entry of script) {
    const line = entry.text;
    if (!_class.isInstruction(line)) {
      _class.setBlockLevelFlags(entry.syntaxTree, categories);
      let matches = _class.getScratchCommand(entry.syntaxTree, commands, categories, myblocks, strict);
      if (matches.length > 1) {
        matches = _class.matchByDropDowns(entry.syntaxTree, matches);
      }
      if (matches.length > 1) {
        matches = _class.prioritiseNonExtension(matches);
      }
      if (matches.length === 0) {
        //No matches so raise an error
        errors.push(_class.recordError(entry.original_lineno, "Invalid syntax"));
      }
      if (matches.length > 1) {
        //More than one match so raise error
        const categories = matches.map(match => match.category.short_name);
        errors.push(_class.recordError(entry.original_lineno, `${line} match blocks from the following categories (${categories.join(", ")}). Use a category directive e.g. ${categories[0]}!${line} to identify the intended block.`));
      }
      if (matches.length === 1) {
        entry.syntaxTree.scratchCommand = JSON.parse(JSON.stringify(matches[0]));
        //if isDefine then added block to myblocks
        if (entry.syntaxTree.isDefine) {
          const namedParameters = _class.nameDefineParameters(entry.syntaxTree);
          entry.syntaxTree.scratchCommand.editor_syntax_with_parameters = namedParameters;
          entry.syntaxTree.scratchCommand.block_syntax_with_parameters = namedParameters;
          const myblockSyntax = entry.syntaxTree.base;
          // as the parser may be called sevaral times before the user finishes adding
          // the define command. We need to ensure that multiple copies of the command
          // are not put into myBlocks
          newMyBlocks = _class.cleanupMyBlocks(newMyBlocks, myblockSyntax);
          newMyBlocks.push(_class.createMyBlock(entry.syntaxTree.scratchCommand, myblockSyntax));
        }
        //validate inner commands scriptEntry.syntaxTree.inner recursively
        for (let i = 0; i < entry.syntaxTree.inner.length; i++) {
          let item = entry.syntaxTree.inner[i];
          // copy dropdown options to item
          if (item.openingchar === "[") {
            _class.assignDropDownOptions(item, i, matches[0]);
          }
          const innerErrors = _class.validateSubCommandsSyntax(item, commands, categories, entry.syntaxTree);
          for (let error of innerErrors) {
            errors.push(_class.recordError(entry.original_lineno, error));
          }
        }
      }
    }
  }
  newMyBlocks.forEach(newBlock => {
    let matches = myblocks.filter(block => block.syntax === newBlock.syntax);
    if (matches.length === 0) myblocks.push(newBlock);
  });
  return errors;
});
_defineProperty(Parser, "validateSubCommandsSyntax", (entry, commands, categories, parent) => {
  let errors = [];
  _class.setInnerLevelFlags(entry, categories);
  let matches = _class.getScratchCommand(entry, commands, categories);
  if (matches.length > 1) {
    matches = _class.matchByDropDowns(entry, matches);
  }
  if (matches.length > 1) {
    matches = _class.prioritiseNonExtension(matches);
  }
  // loudness in when [loudness] gt (10) should not validate to the loudness in sensing
  // value commands cannot be contained in square dropdown fields
  if (matches.length >= 1 && entry.openingchar === "[") {
    let remove = [];
    for (let match of matches) {
      const dropdown = parent.scratchCommand.editor_dropdowns[entry.dropdownCount];
      if (dropdown.is_square && match.is_command && match.command_type.toLowerCase() === "value") {
        remove.push(match.op_code);
      }
    }
    matches = matches.filter(c => !remove.includes(c.op_code));
  }
  if (matches.length > 1) {
    //More than one match so raise error
    const categories = matches.map(match => match.category.short_name);
    const line = entry.base;
    errors.push(`${line} matches blocks from the following categories (${categories.join(", ")}). Use a category directive e.g. ${categories[0]}!${line} to identify the intended block.`);
  }
  if (matches.length === 1) {
    entry.scratchCommand = matches[0];
  }
  //matches.length === 0 does not constitute an error for inner commands unless
  //the base contains any of the OPENING or CLOSING characters
  //do another validation here that when matches.length === 0 the text does not contain
  //any of the OPENING nor CLOSING characters so that move ([10]) steps won't validate
  //Parser.OPENING.map(o => `\\\\${o}`).join('|'), Parser.CLOSING.map(o => `\\\\${o}`).join('|')
  if (matches.length === 0) {
    const regexStr = _class.OPENING.concat(_class.CLOSING).map(o => `\\${o}`).join("|");
    const regex = new RegExp(regexStr);
    if (regex.test(entry.base)) {
      errors.push(`Invalid line syntax "... ${entry.base} ..."`);
    }
    // validate entry.base against the dropdown regex if it exists
    if (entry.openingchar === "[" && entry.regex) {
      const regex = new RegExp(entry.regex, "i");
      if (!regex.test(entry.base)) {
        errors.push(`Invalid value '${entry.base}' provided for dropdown field`);
      }
    }
  }
  //validate inner commands entry.inner recursively
  for (let i = 0; i < entry.inner.length; i++) {
    let item = entry.inner[i];
    if (matches.length === 1 && item.openingchar === "[") {
      _class.assignDropDownOptions(item, i, matches[0]);
    }
    const innerErrors = _class.validateSubCommandsSyntax(item, commands, categories, entry);
    errors.concat(innerErrors);
  }
  return errors;
});
//for inner commands with a scratchCommand put those into separte containers maybe do this
//  when the drawing elements are being created based on if the entry has a command with
//  is_command === true && command_type === "value"
//check that starter blocks have a lineno === 1
_defineProperty(Parser, "validateStarterBlocks", script => {
  let errors = [];
  for (let entry of script) {
    if (entry.syntaxTree.scratchCommand) {
      const command = entry.syntaxTree.scratchCommand;
      if (command.is_starter && entry.lineno !== 1) {
        errors.push(_class.recordError(entry.original_lineno, `Hat blocks have to be the first block in a script. Did you forget to separate multiple scripts with "-----". Otherwise use the instruction "strict: no"`));
      }
    }
  }
  return errors;
});
//find parents based on indentation
_defineProperty(Parser, "determineParents", script => {
  // this methods needs to be called after the following methods
  //  replaceSpaceIndentation
  //  getIndentation
  //  validateScripts
  // as it relies on information provided by those three methods
  let errors = [];
  for (let i = 0; i < script.length; i++) {
    const entry = script[i];
    const command = entry.syntaxTree.scratchCommand;
    if (command && command.op_code === "ps_else") {
      //else entry parent must be an if on the same indent level
      const parent = _class.determineElseParent(script, i);
      if (parent === null) {
        errors.push(_class.recordError(entry.original_lineno, `Line indented ${entry.indentLevel} but no corresponding if statement found at same level`));
      } else {
        entry.parent = parent;
      }
    } else if (entry.indentLevel > 0) {
      const parent = _class.determineParent(script, i);
      if (parent === null) {
        errors.push(_class.recordError(entry.original_lineno, `Line indented ${entry.indentLevel} but no parent found at level ${entry.indentLevel - 1}`));
      } else {
        //ensure the parent is a container
        const parentCommand = script[parent].syntaxTree.scratchCommand;
        if (parentCommand && parentCommand.is_container) {
          //if parent is else then make the parent the parent of the else
          if (parentCommand.op_code === "ps_else") {
            entry.parent = script[parent].parent;
          } else {
            entry.parent = parent;
          }
        } else {
          errors.push(_class.recordError(entry.original_lineno, `Line indented under a parent which is not a container`));
        }
      }
    }
  }
  return errors;
});
_defineProperty(Parser, "determineParent", (script, position) => {
  for (let i = position - 1; i >= 0; i--) {
    if (script[i].indentLevel === script[position].indentLevel - 1) {
      return i;
    }
  }
  return null;
});
_defineProperty(Parser, "determineElseParent", (script, position) => {
  for (let i = position - 1; i >= 0; i--) {
    const syntaxTree = script[i].syntaxTree;
    if (script[i].indentLevel === script[position].indentLevel && syntaxTree.scratchCommand && syntaxTree.scratchCommand.op_code === "control_if") {
      return i;
    }
  }
  return null;
});
_defineProperty(Parser, "getBlockName", syntaxTree => {
  const command = syntaxTree.scratchCommand;
  let blockname = "Basic";
  if (command.op_code !== "motion_ifonedgebounce") {
    if (command.op_code === "microbit_displaySymbol") {
      blockname = "Basic";
    } else if (command.op_code.includes("_when") || command.op_code === "control_start_as_clone") {
      blockname = "Event";
    } else if (command.op_code === "control_if") {
      blockname = "IfThen";
    } else if (command.op_code === "ps_else") {
      blockname = "Else";
    } else if (command.op_code === "control_repeat" || command.op_code === "control_forever" || command.op_code === "control_repeat_until") {
      blockname = "Repeat";
    } else if (command.op_code === "ps_space") {
      blockname = "Space";
    } else if (command.op_code === "ps_separator") {
      blockname = "Separator";
    } else if (command.op_code === "procedures_definition") {
      blockname = "Define";
    }
  }
  return blockname;
});
_defineProperty(Parser, "getCommandName", text => {
  let commandname = "Text";
  if (text === "(" || text === "value") {
    commandname = "Value";
  } else if (text === "<" || text === "condition") {
    commandname = "Condition";
  } else if (text === "[") {
    commandname = "DropDown";
  }
  return commandname;
});
// static extractBaseConfig = (syntaxTree, options) => {
//     let config = {}
//     config.block = Parser.getBlockName(syntaxTree)
//     config.properties = syntaxTree.scratchCommand.category
//     config.isEnd = syntaxTree.scratchCommand.is_end
//     config.highlight = syntaxTree.isHighlight
//     config.isMystery = syntaxTree.isMystery
//     config.isDim = syntaxTree.isDim
//     config.autohint = syntaxTree.isAutoHint || options.autoHints
//     config.colourOption = options.colourOption
//     config.strokeColour = options.strokeColour
//     config.strokeWeight = options.strokeWeight
//     config.textColour = options.textColour
//     config.contents = Parser.extractInnerConfig(syntaxTree, options)
//     return config
// }
_defineProperty(Parser, "setInnerConfigFlags", (config, inner) => {
  config.isHighlight = inner.isHighlight;
  config.isMystery = inner.isMystery;
  config.isDim = inner.isDim;
  config.isMyVar = inner.isMyVar;
  config.isMyList = inner.isMyList;
  config.isAutoHint = inner.isAutoHint;
  return config;
});
_defineProperty(Parser, "extractInnerConfig", (inner, wordTranslations) => {
  let configs = [];
  if (inner.scratchCommand) {
    let config = {};
    const base = _class.getBaseText(inner);
    if (base.includes("(") || base.includes("[") || base.includes("<")) {
      const parts = _class.splitBase(base);
      const parameters = inner.inner;
      let dropdownPosition = 0;
      if (inner.scratchCommand.is_command) {
        config.command = _class.getCommandName(inner.scratchCommand.command_type);
      } else {
        config.block = _class.getBlockName(inner);
        config.isEnd = inner.scratchCommand.is_end;
      }
      config.properties = inner.scratchCommand.category;
      config.op_code = inner.scratchCommand.op_code;
      config.contents = [];
      for (let part of parts) {
        if (_class.OPENING.includes(part[0])) {
          let inner_config = {};
          inner_config.command = _class.getCommandName(part[0]);
          const parameterName = part.replace("(", "").replace("[", "").replace("<", "").replace(")", "").replace("]", "").replace(">", "");
          const parameter = parameters.filter(entry => entry.name === parameterName);
          if (parameter.length > 0) {
            inner_config.contents = _class.extractInnerConfig(parameter[0], wordTranslations);
          }
          //For drop downs determine if they are square
          if (part[0] === "[") {
            const dropdowns = inner.scratchCommand.block_dropdowns;
            inner_config.isSquare = dropdowns[dropdownPosition].is_square;
            dropdownPosition++;
          }
          // Parser.setInnerConfigFlags(inner_config, inner)
          config.contents.push(inner_config);
        } else {
          let newpart = part;
          if (part === "gt") newpart = ">";
          if (part === "lt") newpart = "<";
          // config.contents.push(
          //     Parser.setInnerConfigFlags({
          //         command: Parser.getCommandName(part),
          //         value: newpart
          //     }, inner)
          // )
          config.contents.push({
            command: _class.getCommandName(part),
            value: newpart
          });
        }
        // }
      }
      config = _class.setInnerConfigFlags(config, inner);
      configs.push(config);
    } else {
      if (inner.scratchCommand.is_command) {
        config.command = inner.scratchCommand.command_type;
        if (inner.scratchCommand.command_type.toLowerCase() === "value") {
          //Value commands should be encapsulated in an inner value
          config.contents = [_class.setInnerConfigFlags({
            command: _class.getCommandName(base),
            value: base
          }, inner)];
        } else {
          config.contents = [_class.setInnerConfigFlags({
            command: "Text",
            value: _class.translateWord(base, wordTranslations)
          }, inner)];
        }
      } else {
        config.block = _class.getBlockName(inner);
        config.contents = [_class.setInnerConfigFlags({
          command: "Text",
          value: _class.translateWord(base, wordTranslations)
        }, inner)];
        config.isEnd = inner.scratchCommand.is_end;
      }
      config.properties = inner.scratchCommand.category;
      config.op_code = inner.scratchCommand.op_code;
      config.textOnlyCommand = inner.scratchCommand.text_only_command;
      config = _class.setInnerConfigFlags(config, inner);
      configs.push(config);
    }
  } else {
    //Need to check if there is a word translation for base
    //Need to know the editor_language and block_language
    let base = inner.base;
    // if (wordTranslations && wordTranslations.length > 0) {
    //     const translation = wordTranslations.filter(entry => entry.editor_translation === base)
    //     if (translation.length > 0) {
    //         base = translation[0].translation
    //     }
    // }
    configs.push(_class.setInnerConfigFlags({
      command: _class.getCommandName(base),
      value: _class.translateWord(base, wordTranslations)
    }, inner));
  }
  return configs;
});
_defineProperty(Parser, "splitBase", base => {
  let results = [];
  const parts = base.trim().split(" ");
  let text = "";
  for (let i = 0; i < parts.length; i++) {
    if (_class.OPENING.includes(parts[i][0])) {
      if (text !== "") {
        results.push(text.trim());
        text = "";
      }
      results.push(parts[i]);
    } else {
      text += text === "" ? parts[i] : " " + parts[i];
    }
  }
  if (text != "") {
    results.push(text.trim());
  }
  return results;
});
_defineProperty(Parser, "nameInnerParameters", syntaxTree => {
  if (syntaxTree.scratchCommand) {
    const syntax_with_parameters = syntaxTree.scratchCommand.editor_syntax_with_parameters;
    if (syntax_with_parameters !== null) {
      const regex = new RegExp("([\\(|\\[|\\<].*?[\\)|\\]|\\>])", "gi");
      const matches = syntax_with_parameters.match(regex);
      for (let i = 0; i < syntaxTree.inner.length; i++) {
        syntaxTree.inner[i].name = matches[i].replace("(", "").replace("[", "").replace("<", "").replace(")", "").replace("]", "").replace(">", "");
        if (syntaxTree.inner[i].inner.length > 0) {
          _class.nameInnerParameters(syntaxTree.inner[i]);
        }
      }
    }
  }
});
_defineProperty(Parser, "performSubstitution", (blockconfig, blockLanguage, wordTranslations) => {
  const triggers = _class.SUBSTITUTES.map(entry => entry.op_code);
  for (let block of blockconfig) {
    if (triggers.includes(block.op_code)) {
      const substitute = _class.SUBSTITUTES.filter(entry => entry.op_code === block.op_code)[0];
      let word = substitute.en_word;
      if (blockLanguage.tag !== "en") {
        const translation = wordTranslations.filter(entry => entry.language.tag === blockLanguage.tag && entry.en_word === word);
        word = translation[0].translation;
      }
      let target = -1;
      for (let i = 0; i < block.contents.length; i++) {
        const content = block.contents[i];
        if (content.value && content.value.includes(word)) {
          target = i;
          break;
        }
      }
      if (target > -1) {
        let content = block.contents[target];
        const parts = content.value.split(word).map(w => w.trim()).filter(item => item !== "");
        const position = content.value.indexOf(word);
        const stringRep = JSON.stringify(content);
        if (position === 0) {
          content.command = content.value = substitute.command;
          let first = JSON.parse(stringRep);
          first.value = parts[0];
          block.contents.splice(1, 0, first);
          if (parts.length > 1) {
            let second = JSON.parse(stringRep);
            second.value = parts[1];
            block.contents.splice(2, 0, second);
          }
        } else {
          content.value = parts[0];
          let first = JSON.parse(stringRep);
          first.command = first.value = substitute.command;
          block.contents.splice(1, 0, first);
          if (parts.length > 1) {
            let second = JSON.parse(stringRep);
            second.value = parts[1];
            block.contents.splice(2, 0, second);
          }
        }
      }
    }
  }
});
_defineProperty(Parser, "getCategoryTranslation", (number, categories) => {
  const category = categories.filter(entry => entry.number === number);
  if (category.length > 0) {
    return category[0].translation;
  } else {
    return null;
  }
});
_defineProperty(Parser, "getAutoHints", (blockConfig, categories) => {
  //For vanity blocks where isFaux is set to true autoHints = ''
  if (blockConfig.properties.isFaux) return "";
  let autoHints = [_class.getCategoryTranslation(blockConfig.properties.number, categories)];
  for (let content of blockConfig.contents) {
    autoHints = autoHints.concat(_class.getContentsAutoHints(content, categories));
  }
  if (autoHints.length > 1) {
    return [...new Set(autoHints)].join("/");
  } else {
    return autoHints[0];
  }
});
_defineProperty(Parser, "getContentsAutoHints", (content, categories) => {
  let autoHints = [];
  if (content.properties) {
    autoHints.push(_class.getCategoryTranslation(content.properties.number, categories));
  }
  if (content.contents) {
    for (let entry of content.contents) {
      autoHints = autoHints.concat(_class.getContentsAutoHints(entry, categories));
    }
  }
  return autoHints;
});
_defineProperty(Parser, "createBlockConfig", (script, wordTranslations) => {
  // The method needs to be called after
  //      validateScripts
  //      determineParents
  let config = [];
  // const options = {
  //     colourOption: this.colourOption,
  //     strokeColour: this.strokeColour,
  //     strokeWeight: this.strokeWeight,
  //     textColour: this.textColour,
  //     autohints: this.autoHints
  // }
  for (let entry of script) {
    if (!_class.isInstruction(entry.syntaxTree.base)) {
      _class.nameInnerParameters(entry.syntaxTree);
      let baseConfig = _class.extractInnerConfig(entry.syntaxTree, wordTranslations);
      //assign to parent if parent !== undefined
      if ("parent" in entry) {
        baseConfig[0].parent = entry.parent;
      }
      if ("manualHint" in entry) {
        baseConfig[0].manualHint = entry.manualHint;
      }
      config.push(baseConfig[0]);
    }
  }
  return config;
});
_defineProperty(Parser, "modifyMicrobitDisplaySymbol", blockConfigs => {
  for (let blockConfig of blockConfigs) {
    if (blockConfig.op_code === "microbit_displaySymbol") {
      blockConfig.contents[1].contents[0].command = "Matrix";
    }
  }
});
_defineProperty(Parser, "setAutoHints", (blockConfigs, categories) => {
  for (let blockConfig of blockConfigs) {
    blockConfig.autoHint = _class.getAutoHints(blockConfig, categories);
  }
});
_defineProperty(Parser, "createWorkingTree", blockConfigs => {
  let workingTree = [];
  for (let blockConfig of blockConfigs) {
    if ("parent" in blockConfig) {
      if (blockConfig.block === "Else") {
        blockConfigs[blockConfig.parent].isElse = true;
        blockConfigs[blockConfig.parent].elseContent = blockConfig.contents[0];
      } else {
        if (blockConfigs[blockConfig.parent].isElse) {
          if ("substack2" in blockConfigs[blockConfig.parent]) {
            blockConfigs[blockConfig.parent].substack2.push(blockConfig);
          } else {
            blockConfigs[blockConfig.parent].substack2 = [blockConfig];
          }
        } else {
          if ("substack" in blockConfigs[blockConfig.parent]) {
            blockConfigs[blockConfig.parent].substack.push(blockConfig);
          } else {
            blockConfigs[blockConfig.parent].substack = [blockConfig];
          }
        }
      }
    } else {
      workingTree.push(blockConfig);
    }
  }
  return workingTree;
});

class Processor {
  constructor(api, options = {}) {
    _defineProperty(this, "init", async () => {
      if (!this.loaded) {
        this.colourOption = this.options.colourOption || defaults.colourOption;
        this.strokeColour = this.options.strokeColour || defaults.strokeColour;
        this.textColour = this.options.textColour || defaults.textColour;
        this.strokeWeight = this.options.strokeWeight ? this.options.strokeWeight : this.colourOption === colourOptions.BlackWhite ? 3 : this.colourOption === colourOptions.ColourOutline ? 3 : 1;
        this.autoHints = this.options.autoHints || defaults.autoHints;
        this.size = this.options.size || defaults.size;
        this.dpi = this.options.dpi || defaults.dpi;
        this.strict = this.options.strict || true;
        this.myBlocks = this.options.myBlocks || [];
        this.languages = await Processor.loadSupportedLanguages(this.api);
        this.blockLanguage = this.getBlockLanguage();
        this.editorLanguage = this.getEditorLanguage();
        this.commands = await Processor.loadCommands(this.api, this.editorLanguage.id, this.blockLanguage.id);
        this.categories = await Processor.loadCategories(this.api, this.blockLanguage.id);
        this.wordTranslations = await Processor.loadWordTranslations(this.api, this.editorLanguage.id, this.blockLanguage.id);
        this.loaded = true;
      }
    });
    _defineProperty(this, "getBlockLanguage", () => {
      const id = this.options.blockLanguage || defaults.blockLanguage;
      const language = this.languages.filter(language => language.id === id);
      if (language.length > 0) return language[0];
      return this.getLanguage(1);
    });
    _defineProperty(this, "getEditorLanguage", () => {
      const id = this.options.editorLanguage || defaults.editorLanguage;
      const language = this.languages.filter(language => language.id === id);
      if (language.length > 0) return language[0];
      return this.getLanguage(1);
    });
    _defineProperty(this, "getLanguage", id => {
      const language = this.languages.filter(language => language.id === id);
      if (language.length > 0) return language[0];
      return null;
    });
    _defineProperty(this, "splitLines", scripts => {
      return scripts.split('\n');
    });
    _defineProperty(this, "splitScripts", scripts => {
      const lines = this.splitLines(scripts),
        separator = "-".repeat(5),
        instruction = "-".repeat(2);
      let results = [],
        result = [],
        lineno = 0;
      for (let i = 0; i < lines.length; i++) {
        const line = lines[i];
        if (line.startsWith(separator)) {
          if (result.length > 0) {
            results.push(result);
          }
          result = [];
          lineno = 0;
        } else {
          if (line.trim().length > 0) {
            if (!line.startsWith(instruction)) {
              lineno++;
            }
            result.push({
              'original_lineno': i + 1,
              'lineno': lineno,
              'text': line
            });
          }
        }
      }
      if (result.length > 0) {
        results.push(result);
      }
      return results;
    });
    _defineProperty(this, "getErrors", (script, commands, categories, myblocks) => {
      // validateInstructionsFirst(script) return errors
      // extractInsructions(script) return { instructions: , errors: , script: }
      // checkBrackets(script) return errors
      // replaceSpaceIndentation(script) returns script -- not sure if the return is necessary
      // getIndentation(script) returns script -- not sure if the return is necessary
      // getBaseSyntaxes(script) returns results
      // extractDirectives(script) returns script -- not sure if the return is necessary
      // extractHints(script) return script -- not sure if the return is necessary
      // validateSyntax(script, commands, categories, myblocks) returns errors
      // validateStarterBlocks(script) returns errors
      // determineParents(script) return errors
      let errors = [];
      let instructions = null;
      let updatedScript = null;
      errors = errors.concat(Parser.validateInstructionsFirst(script));
      const results = Parser.extractInstructions(script);
      errors = errors.concat(results.errors);
      instructions = results.instructions;
      updatedScript = results.script;
      errors = errors.concat(Parser.checkSpaceIndentation(updatedScript));
      errors = errors.concat(Parser.checkBrackets(updatedScript));
      Parser.replaceSpaceIndentation(updatedScript);
      Parser.getIndentation(updatedScript);
      Parser.extractHints(updatedScript);
      Parser.getBaseSyntaxes(updatedScript);
      Parser.extractDirectives(updatedScript);
      const strict = instructions.strict == null ? this.strict : instructions.strict;
      const newerrors = Parser.validateSyntax(updatedScript, commands, categories, myblocks, strict);
      errors = errors.concat(newerrors);

      // console.log(this.strict)
      // console.log(instructions)
      // console.log(strict)
      if (strict) {
        errors = errors.concat(Parser.validateStarterBlocks(updatedScript));
      }
      errors = errors.concat(Parser.determineParents(updatedScript));
      return {
        errors: errors,
        instructions: instructions,
        script: updatedScript
      };
    });
    _defineProperty(this, "getWorkingTree", (script, categories, blockLanguage, wordTranslations) => {
      // createBlockConfig(script, categories) return blockConfig in JSON format
      // performSubstitutions(config, this.blockLanguage, this.wordTranslations)
      // setAutoHints(blockConfigs, categories)
      // createWorkingTree(blockConfig)
      let config = Parser.createBlockConfig(script, wordTranslations);
      Parser.modifyMicrobitDisplaySymbol(config);
      Parser.performSubstitution(config, blockLanguage, wordTranslations);
      Parser.setAutoHints(config, categories);
      return Parser.createWorkingTree(config);
    });
    _defineProperty(this, "compileErrorReport", (scripts, errors) => {
      let results = [];
      if (errors.length > 0) {
        for (let script of scripts) {
          for (let entry of script) {
            const lineNo = entry.original_lineno;
            const lineErrors = errors.filter(entry => entry.lineno === lineNo).map(entry => entry.error);
            if (lineErrors.length > 0) {
              results.push({
                lineNo: lineNo,
                errors: lineErrors
              });
            }
          }
        }
      }
      return results;
    });
    _defineProperty(this, "process", scriptLines => {
      const scripts = this.splitScripts(scriptLines);
      let errors = [];
      let workingTrees = [];
      for (let i = 0; i < scripts.length; i++) {
        let script = scripts[i];
        const stepOne = this.getErrors(script, this.commands, this.categories, this.myBlocks);
        if (stepOne.errors.length > 0) {
          errors = errors.concat(stepOne.errors);
        } else {
          let workingTree = this.getWorkingTree(stepOne.script, this.categories, this.blockLanguage, this.wordTranslations);
          workingTree.script = script;
          workingTree.instructions = stepOne.instructions;
          workingTree.containsHighlight = Parser.anyLineHighlighted(script);
          workingTrees.push(workingTree);
        }
      }
      return {
        errors: this.compileErrorReport(scripts, errors),
        workingTrees: workingTrees
      };
    });
    _defineProperty(this, "getOriginalScript", script => {
      let lines = script.map(item => item.text);
      return lines.join('\n');
    });
    _defineProperty(this, "reset", () => {
      this.myBlocks = [];
    });
    this.api = api;
    this.options = options;
    this.loaded = false;
    this.myBlocks = [];
  }
}
_defineProperty(Processor, "loadSupportedLanguages", api => {
  return api.getSupportedLanguages();
});
_defineProperty(Processor, "loadCommands", (api, editorLanguageID, blockLanguageID) => {
  return api.getCommands(editorLanguageID, blockLanguageID);
});
_defineProperty(Processor, "loadCategories", (api, languageID) => {
  return api.getCategories(languageID);
});
_defineProperty(Processor, "loadWordTranslations", (api, editorLanguageID, blockLanguageID) => {
  return api.getWordTranslations(editorLanguageID, blockLanguageID);
});

const data = `{"instructions": [{"text": "filename", "frequency": 19229}, {"text": "scale_factor", "frequency": 144}, {"text": "strict", "frequency": 0}], "directives": {"outer": [{"text": "myblock", "frequency": 733, "category": "myblock", "isExtension": false, "deviceRequired": false}, {"text": "define", "frequency": 464}, {"text": "highlight", "frequency": 444}, {"text": "variables", "frequency": 366, "category": "variables", "isExtension": false, "deviceRequired": false}, {"text": "mystery", "frequency": 291}, {"text": "events", "frequency": 232, "category": "events", "isExtension": false, "deviceRequired": false}, {"text": "vanity", "frequency": 116}, {"text": "vanity-motion", "frequency": 111}, {"text": "looks", "frequency": 60, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "makey", "frequency": 25, "category": "makey", "isExtension": true, "deviceRequired": true}, {"text": "vanity-looks", "frequency": 13}, {"text": "vanity-events", "frequency": 10}, {"text": "vanity-sound", "frequency": 10}, {"text": "sound", "frequency": 9, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "vanity-sensing", "frequency": 8}, {"text": "vanity-control", "frequency": 3}, {"text": "vanity-operators", "frequency": 2}, {"text": "boost", "frequency": 1, "category": "boost", "isExtension": true, "deviceRequired": true}, {"text": "microbit", "frequency": 1, "category": "microbit", "isExtension": true, "deviceRequired": true}, {"text": "vanity-pen", "frequency": 1}, {"text": "vanity-variables", "frequency": 1}, {"text": "wedo", "frequency": 1, "category": "wedo", "isExtension": true, "deviceRequired": true}, {"text": "autohint", "frequency": 0}, {"text": "bold", "frequency": 0}, {"text": "control", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "ev3", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "fa", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true}, {"text": "list", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false}, {"text": "motion", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "music", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "operators", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "pen", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "sensing", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "speech", "frequency": 0, "category": "speech", "isExtension": true, "deviceRequired": false}, {"text": "translate", "frequency": 0, "category": "translate", "isExtension": true, "deviceRequired": false}, {"text": "vanity-list", "frequency": 0}, {"text": "vanity-music", "frequency": 0}, {"text": "vanity-myblock", "frequency": 0}, {"text": "vanity-speech", "frequency": 0}, {"text": "vanity-translate", "frequency": 0}, {"text": "vanity-video", "frequency": 0}, {"text": "video", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false}], "inner": [{"text": "myvar", "frequency": 6497}, {"text": "highlight", "frequency": 444}, {"text": "variables", "frequency": 366, "category": "variables", "isExtension": false, "deviceRequired": false}, {"text": "mystery", "frequency": 291}, {"text": "events", "frequency": 232, "category": "events", "isExtension": false, "deviceRequired": false}, {"text": "mylist", "frequency": 74}, {"text": "looks", "frequency": 60, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "makey", "frequency": 25, "category": "makey", "isExtension": true, "deviceRequired": true}, {"text": "sound", "frequency": 9, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "boost", "frequency": 1, "category": "boost", "isExtension": true, "deviceRequired": true}, {"text": "microbit", "frequency": 1, "category": "microbit", "isExtension": true, "deviceRequired": true}, {"text": "wedo", "frequency": 1, "category": "wedo", "isExtension": true, "deviceRequired": true}, {"text": "bold", "frequency": 0}, {"text": "control", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "ev3", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "fa", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true}, {"text": "list", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false}, {"text": "motion", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "music", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "operators", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "pen", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "sensing", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "speech", "frequency": 0, "category": "speech", "isExtension": true, "deviceRequired": false}, {"text": "translate", "frequency": 0, "category": "translate", "isExtension": true, "deviceRequired": false}, {"text": "video", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false}]}, "commands": {"en": {"blocks": [{"text": "if <> then", "frequency": 4651, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "set [] to ()", "frequency": 4560, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "when flag clicked", "frequency": 4470, "category": "events", "isExtension": false, "deviceRequired": false}, {"text": "move () steps", "frequency": 2671, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "say () for () seconds", "frequency": 2180, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "forever", "frequency": 1934, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "wait () seconds", "frequency": 1858, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "change [] by ()", "frequency": 1797, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "else", "frequency": 1582, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "repeat ()", "frequency": 1506, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "ask () and wait", "frequency": 1393, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "show", "frequency": 1229, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "switch costume to []", "frequency": 1214, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "COSTUME", "isSquare": false, "values": []}]}, {"text": "hide", "frequency": 1150, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "point in direction ()", "frequency": 1135, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "turn right () degrees", "frequency": 988, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "add () to []", "frequency": 952, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "when i receive []", "frequency": 876, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_OPTION", "isSquare": true, "values": []}]}, {"text": "pen down", "frequency": 796, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "say ()", "frequency": 768, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "switch backdrop to []", "frequency": 684, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": false, "values": []}]}, {"text": "hide list []", "frequency": 683, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "events!when [] key pressed", "frequency": 645, "category": "events", "isExtension": false, "deviceRequired": false, "displayText": "when [] key pressed", "clashWithDevice": true, "dropdowns": [{"name": "KEY_OPTION", "isSquare": true, "values": ["space", "up arrow", "down arrow", "left arrow", "right arrow", "any", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}]}, {"text": "makey!when [] key pressed", "frequency": 645, "category": "makey", "isExtension": true, "deviceRequired": true, "displayText": "when [] key pressed", "clashWithDevice": true, "dropdowns": [{"name": "KEY", "isSquare": false, "values": ["space", "up arrow", "down arrow", "left arrow", "right arrow", "w", "a", "s", "d", "f", "g"]}]}, {"text": "change y by ()", "frequency": 607, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "broadcast []", "frequency": 606, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_INPUT", "isSquare": false, "values": []}]}, {"text": "go to x () y ()", "frequency": 591, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "change x by ()", "frequency": 560, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "stop []", "frequency": 542, "category": "control", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "STOP_OPTION", "isSquare": true, "values": ["all", "this script", "other scripts in sprite"]}]}, {"text": "space", "frequency": 537, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "repeat until <>", "frequency": 531, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "pen up", "frequency": 467, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "erase all", "frequency": 438, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "turn left () degrees", "frequency": 426, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "go to []", "frequency": 372, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TO", "isSquare": false, "values": ["random position", "mouse-pointer"]}]}, {"text": "delete this clone", "frequency": 364, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "next costume", "frequency": 356, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "when this sprite clicked", "frequency": 355, "category": "events", "isExtension": false, "deviceRequired": false}, {"text": "play sound [] until done", "frequency": 334, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "SOUND_MENU", "isSquare": false, "values": []}]}, {"text": "speak ()", "frequency": 330, "category": "speech", "isExtension": true, "deviceRequired": false}, {"text": "when i start as a clone", "frequency": 294, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "start sound []", "frequency": 287, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "SOUND_MENU", "isSquare": false, "values": []}]}, {"text": "set pen color to ()", "frequency": 283, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "create clone of []", "frequency": 278, "category": "control", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "CLONE_OPTION", "isSquare": false, "values": ["myself"]}]}, {"text": "set pen size to ()", "frequency": 257, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "when backdrop switches to []", "frequency": 249, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": true, "values": []}]}, {"text": "show list []", "frequency": 211, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "set rotation style []", "frequency": 206, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "STYLE", "isSquare": true, "values": ["left-right", "don't rotate", "all around"]}]}, {"text": "glide () secs to x () y ()", "frequency": 175, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "wait until <>", "frequency": 159, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "set x to ()", "frequency": 153, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "set size to ()", "frequency": 141, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "set y to ()", "frequency": 132, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "delete () of []", "frequency": 119, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "point towards []", "frequency": 119, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TOWARDS", "isSquare": false, "values": ["mouse-pointer"]}]}, {"text": "change pen [] by ()", "frequency": 118, "category": "pen", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "COLOR_PARAM", "isSquare": false, "values": ["color", "saturation", "brightness", "transparency"]}]}, {"text": "delete all of []", "frequency": 117, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "hide variable []", "frequency": 111, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "broadcast [] and wait", "frequency": 104, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_INPUT", "isSquare": false, "values": []}]}, {"text": "change size by ()", "frequency": 104, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "go to [] layer", "frequency": 97, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "FRONT_BACK", "isSquare": true, "values": ["front", "back"]}]}, {"text": "show variable []", "frequency": 83, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "glide () secs to []", "frequency": 73, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TO", "isSquare": false, "values": ["random position", "mouse-pointer"]}]}, {"text": "replace item () of [] with ()", "frequency": 72, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "change pen size by ()", "frequency": 71, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "looks!change [] effect by ()", "frequency": 63, "category": "looks", "isExtension": false, "deviceRequired": false, "displayText": "change [] effect by ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["color", "fisheye", "whirl", "pixelate", "mosaic", "brightness", "ghost"]}]}, {"text": "sound!change [] effect by ()", "frequency": 63, "category": "sound", "isExtension": false, "deviceRequired": false, "displayText": "change [] effect by ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["pitch", "pan left/right"]}]}, {"text": "stamp", "frequency": 57, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "stop all sounds", "frequency": 57, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "if on edge bounce", "frequency": 54, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "next backdrop", "frequency": 48, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "think () for () seconds", "frequency": 48, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "change volume by ()", "frequency": 44, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "looks!set [] effect to ()", "frequency": 41, "category": "looks", "isExtension": false, "deviceRequired": false, "displayText": "set [] effect to ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["color", "fisheye", "whirl", "pixelate", "mosaic", "brightness", "ghost"]}]}, {"text": "sound!set [] effect to ()", "frequency": 41, "category": "sound", "isExtension": false, "deviceRequired": false, "displayText": "set [] effect to ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["pitch", "pan left/right"]}]}, {"text": "clear graphic effects", "frequency": 35, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "set pen [] to ()", "frequency": 29, "category": "pen", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "COLOR_PARAM", "isSquare": false, "values": ["color", "saturation", "brightness", "transparency"]}]}, {"text": "think ()", "frequency": 23, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "insert () at () of []", "frequency": 21, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "reset timer", "frequency": 20, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "go [] () layers", "frequency": 11, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "FORWARD_BACKWARD", "isSquare": true, "values": ["forward", "backward"]}]}, {"text": "play drum [] for () beats", "frequency": 11, "category": "music", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "DRUM", "isSquare": false, "values": ["snare drum", "bass drum", "side stick", "crash cymbal", "open hi-hat", "closed hi-hat", "tamborine", "hand clap", "claves", "wood block", "cowbell", "triangle", "bongo", "conga", "cabasa", "guiro", "vibraslap", "culca"]}]}, {"text": "set voice to []", "frequency": 11, "category": "speech", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "VOICE", "isSquare": false, "values": ["alto", "tenor", "squeak", "giant", "kitten"]}]}, {"text": "when [] gt ()", "frequency": 11, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "WHENGREATERTHANMENU", "isSquare": true, "values": ["loudness", "timer"]}]}, {"text": "clear sound effects", "frequency": 10, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "separator", "frequency": 9, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "play note () for () beats", "frequency": 8, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "set drag mode []", "frequency": 7, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "DRAG_MODE", "isSquare": true, "values": ["draggable", "non draggable"]}]}, {"text": "turn video []", "frequency": 4, "category": "video", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "VIDEO_STATE", "isSquare": false, "values": ["on", "off", "on flipped"]}]}, {"text": "set language to []", "frequency": 3, "category": "speech", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "LANGUAGE", "isSquare": false, "values": ["arabic", "chinese", "chinese mandarin", "chinese mandarin", "danish", "dutch", "english", "french", "german", "hindi", "icelandic", "italian", "japanese", "korean", "norwegian", "polish", "portuguese brazilian", "portuguese", "romanian", "russian", "spanish", "spanish latin american", "swedish", "turkish", "welsh"]}]}, {"text": "display []", "frequency": 2, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MATRIX", "isSquare": false, "values": ["[ox]", "[01]{25}"]}]}, {"text": "rest for () beats", "frequency": 2, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "set instrument to []", "frequency": 2, "category": "music", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "INSTRUMENT", "isSquare": false, "values": ["piano", "electric piano", "organ", "guitar", "electric guitar", "bass", "pizzicato", "cello", "trombone", "carinet", "saxophone", "flute", "wodden flute", "bassoon", "choir", "vibraphone", "music box", "steel drum", "marimba", "synth lead", "synth pad"]}]}, {"text": "set video transparency to ()", "frequency": 2, "category": "video", "isExtension": true, "deviceRequired": false}, {"text": "set volume to ()", "frequency": 1, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "beep note () for () secs", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "boost!set light color to ()", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "set light color to ()", "clashWithDevice": true}, {"text": "boost!when tilted []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "when tilted []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["up", "down", "left", "right", "any"]}]}, {"text": "change tempo by ()", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "clear display", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true}, {"text": "define", "frequency": 0, "category": "myblock", "isExtension": false, "deviceRequired": false}, {"text": "display text ()", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true}, {"text": "fa!when []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "displayText": "when []", "clashWithDevice": true, "dropdowns": [{"name": "GESTURE", "isSquare": false, "values": ["shaken", "started falling", "turned face up", "turned face down"]}]}, {"text": "fa!when tilted []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "displayText": "when tilted []", "clashWithDevice": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["front", "back", "left", "right", "any"]}]}, {"text": "microbit!when []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "when []", "clashWithDevice": true, "dropdowns": [{"name": "GESTURE", "isSquare": false, "values": ["moved", "shaken", "jumped"]}]}, {"text": "microbit!when tilted []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "when tilted []", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["front", "back", "left", "right", "any"]}]}, {"text": "motor [] set power ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "motor [] turn that way for () seconds", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "motor [] turn this way for () seconds", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "set [] direction to []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "all motors"]}, {"name": "MOTOR_DIRECTION", "isSquare": false, "values": ["this way", "that way", "reverse"]}]}, {"text": "set [] power to ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "all motors"]}]}, {"text": "set motor [] direction []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}, {"name": "MOTOR_DIRECTION", "isSquare": false, "values": ["this way", "that way", "reverse"]}]}, {"text": "set motor [] speed to ()", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "set tempo to ()", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "switch backdrop to [] and wait", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": false, "values": []}]}, {"text": "turn [] off", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "all motors"]}]}, {"text": "turn [] on", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "all motors"]}]}, {"text": "turn [] on for () seconds", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "all motors"]}]}, {"text": "turn motor [] for () rotations", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "turn motor [] for () seconds", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "turn motor [] off", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "turn motor [] on", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "wedo!set light color to ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "set light color to ()", "clashWithDevice": true}, {"text": "wedo!when tilted []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "when tilted []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["up", "down", "left", "right", "any"]}]}, {"text": "when [] brick seen", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "COLOR", "isSquare": false, "values": ["red", "blue", "green", "yellow", "white", "black", "any color"]}]}, {"text": "when [] button pressed", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "BTN", "isSquare": false, "values": ["A", "B", "Any"]}]}, {"text": "when [] pressed in order", "frequency": 0, "category": "makey", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "SEQUENCE", "isSquare": false, "values": ["left up right", "right up left", "left right", "right left", "up down", "down up", "up right down left", "up left down right", "up up down down left right left right"]}]}, {"text": "when brightness lt ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "when button [] pressed", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["1", "2", "3", "4"]}]}, {"text": "when distance [] ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "OP", "isSquare": false, "values": ["lt", "gt"]}]}, {"text": "when distance lt ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "when force sensor []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PUSH_PULL", "isSquare": false, "values": ["pushed", "pulled"]}]}, {"text": "when pin [] connected", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PIN", "isSquare": false, "values": ["0", "1", "2"]}]}, {"text": "when video motion gt ()", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false}], "values": [{"text": "answer", "frequency": 1923, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "join () ()", "frequency": 940, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() * ()", "frequency": 853, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "pick random () to ()", "frequency": 570, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "letter () of ()", "frequency": 492, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() + ()", "frequency": 464, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() - ()", "frequency": 325, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() / ()", "frequency": 312, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "item () of []", "frequency": 309, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "x position", "frequency": 266, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "y position", "frequency": 260, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "length of []", "frequency": 197, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "() mod ()", "frequency": 182, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "length of ()", "frequency": 141, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "[] of ()", "frequency": 135, "category": "operators", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "OPERATOR", "isSquare": true, "values": ["abs", "floor", "ceiling", "sqrt", "sin", "cos", "tan", "asin", "acos", "atan", "ln", "log", "e^", "10^"]}]}, {"text": "direction", "frequency": 99, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "costume []", "frequency": 85, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "NUMBER_NAME", "isSquare": true, "values": ["number", "name"]}]}, {"text": "[] of []", "frequency": 75, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "PROPERTY", "isSquare": true, "values": ["backdrop #", "backdrop name", "volume", "x position", "y position", "direction", "costume #", "costume name", "size"]}, {"name": "OBJECT", "isSquare": false, "values": ["stage"]}]}, {"text": "timer", "frequency": 38, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "round ()", "frequency": 32, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "item # of () in []", "frequency": 28, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "size", "frequency": 26, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "mouse x", "frequency": 23, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "days since 2000", "frequency": 17, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "current []", "frequency": 15, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "CURRENTMENU", "isSquare": true, "values": ["year", "month", "date", "day of week", "hour", "minute", "second"]}]}, {"text": "distance to []", "frequency": 15, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "DISTANCETOMENU", "isSquare": false, "values": ["mouse-pointer"]}]}, {"text": "loudness", "frequency": 13, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "backdrop []", "frequency": 12, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "NUMBER_NAME", "isSquare": true, "values": ["number", "name"]}]}, {"text": "ev3!distance", "frequency": 11, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "distance", "clashWithDevice": true}, {"text": "wedo!distance", "frequency": 11, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "distance", "clashWithDevice": true}, {"text": "brightness", "frequency": 10, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "mouse y", "frequency": 8, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "username", "frequency": 6, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "translate () to []", "frequency": 5, "category": "translate", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "LANGUAGE", "isSquare": false, "values": []}]}, {"text": "volume", "frequency": 5, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "language", "frequency": 3, "category": "translate", "isExtension": true, "deviceRequired": false}, {"text": "tempo", "frequency": 3, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "video [] on []", "frequency": 3, "category": "video", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "ATTRIBUTE", "isSquare": false, "values": ["motion", "direction"]}, {"name": "SUBJECT", "isSquare": false, "values": ["stage"]}]}, {"text": "acceleration []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["x", "y", "z"]}]}, {"text": "boost!motor [] position", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "motor [] position", "clashWithDevice": true, "dropdowns": [{"name": "MOTOR_REPORTER_ID", "isSquare": false, "values": []}]}, {"text": "boost!tilt angle []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "tilt angle []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION", "isSquare": false, "values": ["up", "down", "left", "right", "any"]}]}, {"text": "ev3", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "ev3!motor [] position", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "motor [] position", "clashWithDevice": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "fa!tilt angle []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "displayText": "tilt angle []", "clashWithDevice": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["front", "back", "left", "right"]}]}, {"text": "force", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true}, {"text": "microbit!tilt angle []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "tilt angle []", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["front", "back", "left", "right"]}]}, {"text": "spin speed []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["x", "y", "z"]}]}, {"text": "wedo", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true}, {"text": "wedo!tilt angle []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "tilt angle []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION", "isSquare": false, "values": ["up", "down", "left", "right"]}]}], "conditions": [{"text": "() = ()", "frequency": 2221, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() gt ()", "frequency": 900, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() lt ()", "frequency": 678, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "<> or <>", "frequency": 447, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "<> and <>", "frequency": 378, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "touching color ()", "frequency": 350, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "key [] pressed", "frequency": 207, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "KEY_OPTION", "isSquare": false, "values": ["space", "up arrow", "down arrow", "left arrow", "right arrow", "any", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}]}, {"text": "touching []", "frequency": 176, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TOUCHINGOBJECTMENU", "isSquare": false, "values": ["mouse-pointer", "edge"]}]}, {"text": "not <>", "frequency": 162, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "mouse down", "frequency": 20, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "falling", "frequency": 14, "category": "fa", "isExtension": true, "deviceRequired": true}, {"text": "() contains ()", "frequency": 4, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "color () is touching ()", "frequency": 4, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "[] button pressed", "frequency": 2, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "BTN", "isSquare": false, "values": ["A", "B", "Any"]}]}, {"text": "fa!tilted []", "frequency": 2, "category": "fa", "isExtension": true, "deviceRequired": true, "displayText": "tilted []", "clashWithDevice": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["front", "back", "left", "right", "any"]}]}, {"text": "microbit!tilted []", "frequency": 2, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "tilted []", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["front", "back", "left", "right", "any"]}]}, {"text": "wedo!tilted []", "frequency": 2, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "tilted []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["up", "down", "left", "right", "any"]}]}, {"text": "[] contains ()", "frequency": 1, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "button [] pressed", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["1", "2", "3", "4"]}]}, {"text": "seeing [] brick", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "COLOR", "isSquare": false, "values": ["red", "blue", "green", "yellow", "white", "black", "any color"]}]}]}, "fr": {"blocks": [{"text": "quand drapeau est cliqu\u00e9", "frequency": 3374, "category": "events", "isExtension": false, "deviceRequired": false}, {"text": "avancer de () pas", "frequency": 2892, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "si <> alors", "frequency": 1893, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "mettre [] \u00e0 ()", "frequency": 1870, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "attendre () secondes", "frequency": 1850, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "r\u00e9p\u00e9ter ind\u00e9finiment", "frequency": 1409, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "s'orienter \u00e0 ()", "frequency": 1371, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "dire () pendant () secondes", "frequency": 1331, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "r\u00e9p\u00e9ter () fois", "frequency": 1194, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "cacher", "frequency": 1070, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "montrer", "frequency": 879, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "tourner droite de () degr\u00e9s", "frequency": 866, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "stylo en position d'\u00e9criture", "frequency": 830, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "quand la touche [] est press\u00e9e", "frequency": 788, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "KEY_OPTION", "isSquare": true, "values": ["espace", "fl\u00e8che haut", "fl\u00e8che bas", "fl\u00e8che gauche", "fl\u00e8che droite", "n'importe laquelle", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}]}, {"text": "tourner gauche de () degr\u00e9s", "frequency": 648, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "effacer tout", "frequency": 598, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "quand je re\u00e7ois []", "frequency": 557, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_OPTION", "isSquare": true, "values": []}]}, {"text": "demander () et attendre", "frequency": 531, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "ajouter () \u00e0 x", "frequency": 468, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "ajouter () \u00e0 y", "frequency": 466, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "basculer sur le costume []", "frequency": 432, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "COSTUME", "isSquare": false, "values": []}]}, {"text": "costume suivant", "frequency": 425, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "envoyer \u00e0 tous []", "frequency": 371, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_INPUT", "isSquare": false, "values": []}]}, {"text": "dire ()", "frequency": 364, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "rebondir si le bord est atteint", "frequency": 356, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "relever le stylo", "frequency": 339, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "mettre la couleur du stylo \u00e0 ()", "frequency": 319, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "mettre la taille du stylo \u00e0 ()", "frequency": 302, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "aller \u00e0 []", "frequency": 301, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TO", "isSquare": false, "values": ["position al\u00e9atoire", "pointeur de souris"]}]}, {"text": "basculer sur l'arri\u00e8re-plan []", "frequency": 273, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": false, "values": []}]}, {"text": "list!ajouter () \u00e0 []", "frequency": 266, "category": "list", "isExtension": false, "deviceRequired": false, "displayText": "ajouter () \u00e0 []", "clashWithDevice": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "variables!ajouter () \u00e0 []", "frequency": 266, "category": "variables", "isExtension": false, "deviceRequired": false, "displayText": "ajouter () \u00e0 []", "clashWithDevice": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "quand l'arri\u00e8re-plan bascule sur []", "frequency": 236, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": true, "values": []}]}, {"text": "stop []", "frequency": 217, "category": "control", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "STOP_OPTION", "isSquare": true, "values": ["tout", "ce script", "autres scripts dans sprite"]}]}, {"text": "jouer le son []", "frequency": 195, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "SOUND_MENU", "isSquare": false, "values": []}]}, {"text": "fixer le sens de rotation []", "frequency": 161, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "STYLE", "isSquare": true, "values": ["gauche-droite", "ne tourne pas", "\u00e0 360"]}]}, {"text": "sinon", "frequency": 160, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "quand ce sprite est cliqu\u00e9", "frequency": 147, "category": "events", "isExtension": false, "deviceRequired": false}, {"text": "mettre y \u00e0 ()", "frequency": 117, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "glisser en () secondes \u00e0 []", "frequency": 116, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TO", "isSquare": false, "values": ["position al\u00e9atoire", "pointeur de souris"]}]}, {"text": "jouer le son [] jusqu'au bout", "frequency": 109, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "SOUND_MENU", "isSquare": false, "values": []}]}, {"text": "r\u00e9p\u00e9ter jusqu'\u00e0 ce que <>", "frequency": 107, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "s'orienter vers []", "frequency": 83, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TOWARDS", "isSquare": false, "values": ["pointeur de souris"]}]}, {"text": "penser \u00e0 () pendant () secondes", "frequency": 67, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "looks!ajouter () \u00e0 l'effet []", "frequency": 65, "category": "looks", "isExtension": false, "deviceRequired": false, "displayText": "ajouter () \u00e0 l'effet []", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["couleur", "\u0153il de poisson", "tournoyer", "pixeliser", "mosa\u00efque", "luminosit\u00e9", "fant\u00f4me"]}]}, {"text": "sound!ajouter () \u00e0 l'effet []", "frequency": 65, "category": "sound", "isExtension": false, "deviceRequired": false, "displayText": "ajouter () \u00e0 l'effet []", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["hauteur", "st\u00e9r\u00e9o gauche/droite"]}]}, {"text": "ajouter () \u00e0 la [] du stylo", "frequency": 52, "category": "pen", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "COLOR_PARAM", "isSquare": false, "values": ["couleur", "saturation", "luminosit\u00e9", "transparence"]}]}, {"text": "ajouter () \u00e0 la taille", "frequency": 43, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "aller \u00e0 l' [] plan", "frequency": 43, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "FRONT_BACK", "isSquare": true, "values": ["avant", "arri\u00e8re"]}]}, {"text": "cacher la variable []", "frequency": 38, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "jouer du tambour [] pendant () temps", "frequency": 33, "category": "music", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "DRUM", "isSquare": false, "values": ["caisse claire", "grosse caisse", "side stick", "cymbale crash", "charleston ouvert", "charleston ferm\u00e9", "tamborine", "claquement de main", "claves", "bloc de bois", "cloche de vache", "triangle", "bongo", "conga", "cabasa", "guiro", "vibraslap", "culca"]}]}, {"text": "mettre x \u00e0 ()", "frequency": 33, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "cr\u00e9er un clone de []", "frequency": 30, "category": "control", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "CLONE_OPTION", "isSquare": false, "values": ["moi-m\u00eame"]}]}, {"text": "montrer la variable []", "frequency": 29, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "attendre jusqu'\u00e0 ce que <>", "frequency": 27, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "ajouter () \u00e0 la taille du stylo", "frequency": 26, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "arri\u00e8re-plan suivant", "frequency": 25, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "envoyer \u00e0 tous [] et attendre", "frequency": 25, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_INPUT", "isSquare": false, "values": []}]}, {"text": "supprimer ce clone", "frequency": 25, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "quand je commence comme un clone", "frequency": 24, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "ajouter () au volume", "frequency": 19, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "space", "frequency": 19, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "arr\u00eater tous les sons", "frequency": 18, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "prononcer ()", "frequency": 18, "category": "speech", "isExtension": true, "deviceRequired": false}, {"text": "penser \u00e0 ()", "frequency": 15, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "mettre la [] du stylo \u00e0 ()", "frequency": 13, "category": "pen", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "COLOR_PARAM", "isSquare": false, "values": ["couleur", "saturation", "luminosit\u00e9", "transparence"]}]}, {"text": "estampiller", "frequency": 12, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "r\u00e9initialiser le chronom\u00e8tre", "frequency": 12, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "jouer la note () pendant () temps", "frequency": 11, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "looks!mettre l'effet [] \u00e0 ()", "frequency": 10, "category": "looks", "isExtension": false, "deviceRequired": false, "displayText": "mettre l'effet [] \u00e0 ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["couleur", "\u0153il de poisson", "tournoyer", "pixeliser", "mosa\u00efque", "luminosit\u00e9", "fant\u00f4me"]}]}, {"text": "sound!mettre l'effet [] \u00e0 ()", "frequency": 10, "category": "sound", "isExtension": false, "deviceRequired": false, "displayText": "mettre l'effet [] \u00e0 ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["hauteur", "st\u00e9r\u00e9o gauche/droite"]}]}, {"text": "remplacer l'\u00e9l\u00e9ment () de la liste [] par ()", "frequency": 6, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "supprimer l'\u00e9l\u00e9ment () de []", "frequency": 6, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "annuler les effets graphiques", "frequency": 5, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "annuler tous les effets sonores", "frequency": 5, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "cacher la liste []", "frequency": 4, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "choisir l'instrument n\u00b0 []", "frequency": 4, "category": "music", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "INSTRUMENT", "isSquare": false, "values": ["piano", "piano \u00e9lectrique", "orgue", "guitare", "electric guitar", "basse", "pizzicato", "violoncelle", "trombone", "carinet", "saxophone", "fl\u00fbte", "wodden flute", "bassoon", "chorale", "vibraphone", "bo\u00eete \u00e0 musique", "steel drum", "marimba", "lead synth\u00e9tis\u00e9", "pad synth\u00e9tis\u00e9"]}]}, {"text": "choisir la voix du []", "frequency": 3, "category": "speech", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "VOICE", "isSquare": false, "values": ["alto", "t\u00e9nor", "piailler", "g\u00e9ant", "chaton"]}]}, {"text": "mettre la langue \u00e0 []", "frequency": 3, "category": "speech", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "LANGUAGE", "isSquare": false, "values": ["arabe", "chinese", "mandarin chinois", "mandarin chinois", "danois", "n\u00e9erlandais", "anglais", "fran\u00e7ais", "allemand", "hindi", "islandais", "italien", "japonais", "cor\u00e9en", "norv\u00e9gien", "polonais", "portugais br\u00e9silien", "portugais", "roumain", "russe", "espagnol", "espagnol latino-am\u00e9ricain", "su\u00e9dois", "turc", "welsh"]}]}, {"text": "quand le [] gt ()", "frequency": 3, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "WHENGREATERTHANMENU", "isSquare": true, "values": ["volume sonore", "chronom\u00e8tre"]}]}, {"text": "aller \u00e0 x () y ()", "frequency": 2, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "d\u00e9placer de () plans vers l' []", "frequency": 2, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "FORWARD_BACKWARD", "isSquare": true, "values": ["avant", "arri\u00e8re"]}]}, {"text": "faire une pause pendant () temps", "frequency": 2, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "montrer la liste []", "frequency": 2, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "supprimer tous les \u00e9l\u00e9ments de la liste []", "frequency": 2, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "mettre la transparence vid\u00e9o sur ()", "frequency": 1, "category": "video", "isExtension": true, "deviceRequired": false}, {"text": "mettre le tempo \u00e0 ()", "frequency": 1, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "mettre le volume \u00e0 ()", "frequency": 1, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "vid\u00e9o []", "frequency": 1, "category": "video", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "VIDEO_STATE", "isSquare": false, "values": ["activ\u00e9e", "d\u00e9sactiv\u00e9e", "effet miroir"]}]}, {"text": "afficher []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MATRIX", "isSquare": false, "values": ["[ox]", "[01]{25}"]}]}, {"text": "afficher le texte ()", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true}, {"text": "ajouter () au tempo", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "allumer le moteur []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["moteur", "motor A", "motor B", "tous les moteurs"]}]}, {"text": "allumer le moteur [] pendant () secondes", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["moteur", "motor A", "motor B", "tous les moteurs"]}]}, {"text": "basculer sur l'arri\u00e8re-plan [] et attendre", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": false, "values": []}]}, {"text": "boost!when tilted []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "when tilted []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["vers le haut", "vers le bas", "gauche", "droite", "n'importe laquelle"]}]}, {"text": "effacer l'\u00e9cran", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true}, {"text": "ev3!faire tourner le moteur [] dans ce sens pendant () secondes", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "faire tourner le moteur [] dans ce sens pendant () secondes", "clashWithDevice": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "ev3!faire tourner le moteur [] dans ce sens pendant () secondes", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "faire tourner le moteur [] dans ce sens pendant () secondes", "clashWithDevice": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "ev3!mettre la puissance du moteur [] \u00e0 ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "mettre la puissance du moteur [] \u00e0 ()", "clashWithDevice": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "ev3!quand le bouton [] est appuy\u00e9", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "quand le bouton [] est appuy\u00e9", "clashWithDevice": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["1", "2", "3", "4"]}]}, {"text": "fa!quand []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "displayText": "quand []", "clashWithDevice": true, "dropdowns": [{"name": "GESTURE", "isSquare": false, "values": ["secou\u00e9", "commen\u00e7ant \u00e0 tomber", "tourn\u00e9 vers le haut", "tourn\u00e9 vers lae bas"]}]}, {"text": "fa!when tilted []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "displayText": "when tilted []", "clashWithDevice": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["avant", "arri\u00e8re", "gauche", "droite", "n'importe laquelle"]}]}, {"text": "glisser en () secondes \u00e0 x () y ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "ins\u00e9rer () en position () de []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "jouer la note () pendant () secondes", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "mettre la couleur de la lampe \u00e0 ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true}, {"text": "mettre la direction du moteur [] \u00e0 []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["moteur", "motor A", "motor B", "tous les moteurs"]}, {"name": "MOTOR_DIRECTION", "isSquare": false, "values": ["par ici", "par l\u00e0", "invers\u00e9"]}]}, {"text": "mettre la taille \u00e0 () de la taille initiale", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "mettre mode de glissement \u00e0 []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "DRAG_MODE", "isSquare": true, "values": ["glissable", "non glissable"]}]}, {"text": "microbit!quand []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "quand []", "clashWithDevice": true, "dropdowns": [{"name": "GESTURE", "isSquare": false, "values": ["boug\u00e9", "secou\u00e9", "saut\u00e9"]}]}, {"text": "microbit!quand inclin\u00e9 []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "quand inclin\u00e9 []", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["avant", "arri\u00e8re", "gauche", "droite", "n'importe laquelle"]}]}, {"text": "microbit!quand le bouton [] est appuy\u00e9", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "quand le bouton [] est appuy\u00e9", "clashWithDevice": true, "dropdowns": [{"name": "BTN", "isSquare": false, "values": ["A", "B", "Any"]}]}, {"text": "quand [] sont press\u00e9s dans l'ordre", "frequency": 0, "category": "makey", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "SEQUENCE", "isSquare": false, "values": ["gauche haut droite", "droite haut gauche", "gauche droite", "droite gauche", "haut bas", "bas haut", "haut droite bas gauche", "haut gauche bas droite", "haut haut bas bas gauche droite gauche droite"]}]}, {"text": "quand la broche [] est connect\u00e9e", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PIN", "isSquare": false, "values": ["0", "1", "2"]}]}, {"text": "quand la distance [] ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "OP", "isSquare": false, "values": ["lt", "gt"]}]}, {"text": "quand la distance lt ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "quand la luminosit\u00e9 ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "quand la touche [] press\u00e9e", "frequency": 0, "category": "makey", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "KEY", "isSquare": false, "values": ["espace", "fl\u00e8che haut", "fl\u00e8che bas", "fl\u00e8che gauche", "fl\u00e8che droite", "w", "a", "s", "d", "f", "g"]}]}, {"text": "quand le capteur de force est \u00e0 []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PUSH_PULL", "isSquare": false, "values": ["pouss\u00e9", "tir\u00e9"]}]}, {"text": "quand mouvement vid\u00e9o gt ()", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false}, {"text": "separator", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "set light color to ()", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true}, {"text": "set motor [] direction []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}, {"name": "MOTOR_DIRECTION", "isSquare": false, "values": ["par ici", "par l\u00e0", "invers\u00e9"]}]}, {"text": "set motor [] speed to ()", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "turn motor [] for () rotations", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "turn motor [] for () seconds", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "turn motor [] off", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "turn motor [] on", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "wedo!mettre la puissance du moteur [] \u00e0 ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "mettre la puissance du moteur [] \u00e0 ()", "clashWithDevice": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["moteur", "motor A", "motor B", "tous les moteurs"]}]}, {"text": "wedo!quand inclin\u00e9 []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "quand inclin\u00e9 []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["vers le haut", "vers le bas", "gauche", "droite", "n'importe laquelle"]}]}, {"text": "when [] brick seen", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "COLOR", "isSquare": false, "values": ["rouge", "bleu", "vert", "jaune", "blanc", "nior", "toutes les couleurs"]}]}, {"text": "\u00e9teindre le moteur []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["moteur", "motor A", "motor B", "tous les moteurs"]}]}], "values": [{"text": "r\u00e9ponse", "frequency": 515, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "regrouper () et ()", "frequency": 266, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() * ()", "frequency": 233, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() + ()", "frequency": 175, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "nombre al\u00e9aetire entre () et ()", "frequency": 108, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() - ()", "frequency": 81, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() / ()", "frequency": 75, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() modulo ()", "frequency": 37, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "[] de ()", "frequency": 25, "category": "operators", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "OPERATOR", "isSquare": true, "values": ["abs", "plancher", "plafond", "racine", "sin", "cos", "tan", "asin", "acos", "atan", "ln", "log", "e^", "10^"]}]}, {"text": "lettre () de ()", "frequency": 20, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "direction", "frequency": 19, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "ordonn\u00e9e y", "frequency": 14, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "chronom\u00e8tre", "frequency": 12, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "\u00e9l\u00e9ment () de []", "frequency": 11, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "abscisse x", "frequency": 10, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "souris x", "frequency": 10, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "arrondi de ()", "frequency": 8, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "longueur de ()", "frequency": 8, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "[] actuelle", "frequency": 5, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "CURRENTMENU", "isSquare": true, "values": ["ann\u00e9e", "mois", "date", "jour de la semaine", "heure", "minute", "seconde"]}]}, {"text": "longueur de []", "frequency": 5, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "[] de []", "frequency": 4, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "PROPERTY", "isSquare": true, "values": ["num\u00e9ro de l'arri\u00e8re-plan", "nom de l'arri\u00e8re-plan", "volume", "abscisse x", "ordonn\u00e9e y", "direction", "num\u00e9ro de costume", "nom du costume", "taille"]}, {"name": "OBJECT", "isSquare": false, "values": ["sc\u00e8ne"]}]}, {"text": "volume", "frequency": 3, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "volume sonore", "frequency": 3, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "position de () dans []", "frequency": 2, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "souris y", "frequency": 2, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "distance de []", "frequency": 1, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "DISTANCETOMENU", "isSquare": false, "values": ["pointeur de souris"]}]}, {"text": "[] de l'arri\u00e8re-plan", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "NUMBER_NAME", "isSquare": true, "values": ["num\u00e9ro", "nom"]}]}, {"text": "[] du costume", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "NUMBER_NAME", "isSquare": true, "values": ["num\u00e9ro", "nom"]}]}, {"text": "acc\u00e9l\u00e9ration []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["x", "y", "z"]}]}, {"text": "boost!tilt angle []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "tilt angle []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION", "isSquare": false, "values": ["vers le haut", "vers le bas", "gauche", "droite", "n'importe laquelle"]}]}, {"text": "ev3!distance", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "distance", "clashWithDevice": true}, {"text": "fa!tilt angle []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "displayText": "tilt angle []", "clashWithDevice": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["avant", "arri\u00e8re", "gauche", "droite"]}]}, {"text": "force", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true}, {"text": "jours depuis 2000", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "langue", "frequency": 0, "category": "translate", "isExtension": true, "deviceRequired": false}, {"text": "luminosit\u00e9", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "microbit!angle d'inclinaison []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "angle d'inclinaison []", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["avant", "arri\u00e8re", "gauche", "droite"]}]}, {"text": "motor [] position", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_REPORTER_ID", "isSquare": false, "values": []}]}, {"text": "nom d'utilisateur", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "position du moteur []", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "spin speed []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["x", "y", "z"]}]}, {"text": "taille", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "tempo", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "traduire () en []", "frequency": 0, "category": "translate", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "LANGUAGE", "isSquare": false, "values": []}]}, {"text": "vid\u00e9o [] sur []", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "ATTRIBUTE", "isSquare": false, "values": ["mouvement", "direction"]}, {"name": "SUBJECT", "isSquare": false, "values": ["sc\u00e8ne"]}]}, {"text": "wedo!angle d'inclinaison []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "angle d'inclinaison []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION", "isSquare": false, "values": ["vers le haut", "vers le bas", "gauche", "droite"]}]}, {"text": "wedo!distance", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "distance", "clashWithDevice": true}], "conditions": [{"text": "() = ()", "frequency": 95, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() gt ()", "frequency": 73, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() lt ()", "frequency": 54, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "<> et <>", "frequency": 24, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "<> ou <>", "frequency": 20, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "non <>", "frequency": 9, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "touche [] press\u00e9e", "frequency": 8, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "KEY_OPTION", "isSquare": false, "values": ["espace", "fl\u00e8che haut", "fl\u00e8che bas", "fl\u00e8che gauche", "fl\u00e8che droite", "n'importe laquelle", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}]}, {"text": "touche le []", "frequency": 7, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TOUCHINGOBJECTMENU", "isSquare": false, "values": ["pointeur de souris", "bord"]}]}, {"text": "() contient ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "[] contient ()", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "couleur () touche ()", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "couleur () touch\u00e9e", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "ev3!bouton [] appuy\u00e9", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "bouton [] appuy\u00e9", "clashWithDevice": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["1", "2", "3", "4"]}]}, {"text": "inclinaison []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["avant", "arri\u00e8re", "gauche", "droite", "n'importe laquelle"]}]}, {"text": "inclin\u00e9 []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["vers le haut", "vers le bas", "gauche", "droite", "n'importe laquelle"]}]}, {"text": "microbit!bouton [] appuy\u00e9", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "bouton [] appuy\u00e9", "clashWithDevice": true, "dropdowns": [{"name": "BTN", "isSquare": false, "values": ["A", "B", "Any"]}]}, {"text": "seeing [] brick", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "COLOR", "isSquare": false, "values": ["rouge", "bleu", "vert", "jaune", "blanc", "nior", "toutes les couleurs"]}]}, {"text": "souris press\u00e9e", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "tilted []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["avant", "arri\u00e8re", "gauche", "droite", "n'importe laquelle"]}]}, {"text": "tombe", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true}]}, "es419": {"blocks": [{"text": "si <> entonces", "frequency": 30, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "al presionar la bandera", "frequency": 23, "category": "events", "isExtension": false, "deviceRequired": false}, {"text": "mover () pasos", "frequency": 19, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "looks!decir ()", "frequency": 14, "category": "looks", "isExtension": false, "deviceRequired": false, "displayText": "decir ()", "clashWithDevice": false}, {"text": "speech!decir ()", "frequency": 14, "category": "speech", "isExtension": true, "deviceRequired": false, "displayText": "decir ()", "clashWithDevice": false}, {"text": "space", "frequency": 13, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "si no", "frequency": 11, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "cambiar x en ()", "frequency": 5, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "ocultar", "frequency": 5, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "por siempre", "frequency": 5, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "establecer [] a ()", "frequency": 4, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "cambiar y en ()", "frequency": 3, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "detener []", "frequency": 3, "category": "control", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "STOP_OPTION", "isSquare": true, "values": ["todos", "este programa", "otros programas en el objeto"]}]}, {"text": "events!al presionar la tecla []", "frequency": 3, "category": "events", "isExtension": false, "deviceRequired": false, "displayText": "al presionar la tecla []", "clashWithDevice": true, "dropdowns": [{"name": "KEY_OPTION", "isSquare": true, "values": ["espacio", "flecha arriba", "flecha abajo", "flecha izquierda", "flecha derecha", "cualquiera", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}]}, {"text": "girar a la derecha () grados", "frequency": 3, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "girar a la izquierda () grados", "frequency": 3, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "makey!al presionar la tecla []", "frequency": 3, "category": "makey", "isExtension": true, "deviceRequired": true, "displayText": "al presionar la tecla []", "clashWithDevice": true, "dropdowns": [{"name": "KEY", "isSquare": false, "values": ["espacio", "flecha arriba", "flecha abajo", "flecha izquierda", "flecha derecha", "w", "a", "s", "d", "f", "g"]}]}, {"text": "rebotar si toca un borde", "frequency": 3, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "al recibir []", "frequency": 2, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_OPTION", "isSquare": true, "values": []}]}, {"text": "cambiar fondo a []", "frequency": 2, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": false, "values": []}]}, {"text": "decir () por () segundos", "frequency": 2, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "enviar []", "frequency": 2, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_INPUT", "isSquare": false, "values": []}]}, {"text": "repetir ()", "frequency": 2, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "al comenzar como clon", "frequency": 1, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "al hacer clic en este objeto", "frequency": 1, "category": "events", "isExtension": false, "deviceRequired": false}, {"text": "apuntar en direcci\u00f3n ()", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "apuntar hacia []", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TOWARDS", "isSquare": false, "values": ["puntero del rot\u00f3n"]}]}, {"text": "crear clon de []", "frequency": 1, "category": "control", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "CLONE_OPTION", "isSquare": false, "values": ["mi mismo"]}]}, {"text": "cuando [] gt ()", "frequency": 1, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "WHENGREATERTHANMENU", "isSquare": true, "values": ["volumen del sonido", "cron\u00f3metro"]}]}, {"text": "cuando el fondo cambie a []", "frequency": 1, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": true, "values": []}]}, {"text": "deslizar en () segs a []", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TO", "isSquare": false, "values": ["posici\u00f3n aleatoria", "puntero del rot\u00f3n"]}]}, {"text": "eliminar este clon", "frequency": 1, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "enviar [] y esperar", "frequency": 1, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_INPUT", "isSquare": false, "values": []}]}, {"text": "esperar () segundos", "frequency": 1, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "esperar hasta que <>", "frequency": 1, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "fijar x a ()", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "fijar y a ()", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "ir a []", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TO", "isSquare": false, "values": ["posici\u00f3n aleatoria", "puntero del rot\u00f3n"]}]}, {"text": "repetir hasta que <>", "frequency": 1, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "Eliminar todos de []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "[] video", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "VIDEO_STATE", "isSquare": false, "values": ["activar", "desactivar", "invertir"]}]}, {"text": "al [] el sensor de presi\u00f3n", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PUSH_PULL", "isSquare": false, "values": ["presionado", "tirado"]}]}, {"text": "al conectar el pin []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PIN", "isSquare": false, "values": ["0", "1", "2"]}]}, {"text": "al inclinar []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["del frente", "de atr\u00e1s", "izquierda", "derecha", "cualquiera"]}]}, {"text": "al inclinarse hacia []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["del frente", "de atr\u00e1s", "izquierda", "derecha", "cualquiera"]}]}, {"text": "al presionar [] en orden", "frequency": 0, "category": "makey", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "SEQUENCE", "isSquare": false, "values": ["izquierda arriba derecha", "derecha arriba izquierda", "izquierda derecha", "derecha izquierda", "arriba abajo", "abajo arriba", "arriba derecha abajo izquierda", "arriba izquierda abajo derecha", "arriba arriba abajo abajo izquierda derecha izquierda derecha"]}]}, {"text": "al presionar el bot\u00f3n []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "BTN", "isSquare": false, "values": ["A", "B", "Any"]}]}, {"text": "al ver un bloque []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "COLOR", "isSquare": false, "values": ["roja", "azul", "verde", "amarilla", "blanca", "negra", "de cualquier color"]}]}, {"text": "apagar []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "todos los motores"]}]}, {"text": "apagar motor []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "a\u00f1adir () a []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "boost!al inclinarse []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "al inclinarse []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["arriba", "abajo", "izquierda", "derecha", "cualquiera"]}]}, {"text": "boost!establecer color de luz a ()", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "establecer color de luz a ()", "clashWithDevice": true}, {"text": "borrar efectos de sonido", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "borrar todo", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "cambiar [] en ()", "frequency": 0, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "cambiar disfraz a []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "COSTUME", "isSquare": false, "values": []}]}, {"text": "cambiar efecto [] en ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["altura", "paneo izquierda/derecha"]}]}, {"text": "cambiar el [] del l\u00e1piz en ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "COLOR_PARAM", "isSquare": false, "values": ["color", "saturaci\u00f3n", "brillo", "transparencia"]}]}, {"text": "cambiar el efecto [] en ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["color", "ojo de pez", "remolino", "pixelar", "mosaico", "brillo", "desvanecer"]}]}, {"text": "cambiar el tama\u00f1o del l\u00e1piz en ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "cambiar el tempo en ()", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "cambiar fondo a [] y esperar", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": false, "values": []}]}, {"text": "cambiar tama\u00f1o en ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "cambiar volumen en ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "cuando el bot\u00f3n [] est\u00e1 presionado", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["1", "2", "3", "4"]}]}, {"text": "cuando el movimiento del video sea gt ()", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false}, {"text": "cuando la distancia [] ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "OP", "isSquare": false, "values": ["lt", "gt"]}]}, {"text": "cuando la distancia sea lt ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "cunado el brillo sea lt ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "descansar por () pulsos", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "deslizar en () segs a x () y ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "detener todos los sonidos", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "eliminar () de []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "encender []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "todos los motores"]}]}, {"text": "encender [] por () segundos", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "todos los motores"]}]}, {"text": "encender motor []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "encender motor [] durante () rotaciones", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "encender motor [] durante () segundos", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "esconder lista []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "establecer [] de l\u00e1piz a ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "COLOR_PARAM", "isSquare": false, "values": ["color", "saturaci\u00f3n", "brillo", "transparencia"]}]}, {"text": "establecer color de l\u00e1piz a ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "establecer direcci\u00f3n de [] a []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "todos los motores"]}, {"name": "MOTOR_DIRECTION", "isSquare": false, "values": ["hacia ac\u00e1", "hacia all\u00e1", "reversa"]}]}, {"text": "establecer fuerza de [] a ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "todos los motores"]}]}, {"text": "establecer fuerza del motor [] a ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "establecer tama\u00f1o de l\u00e1piz a ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "fa!cuando []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "displayText": "cuando []", "clashWithDevice": true, "dropdowns": [{"name": "GESTURE", "isSquare": false, "values": ["sacudirse", "comenzar a caer", "voltearse boca arriba", "voltearse boca abajo"]}]}, {"text": "fijar direcci\u00f3n del motor [] []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}, {"name": "MOTOR_DIRECTION", "isSquare": false, "values": ["hacia ac\u00e1", "hacia all\u00e1", "reversa"]}]}, {"text": "fijar estilo de rotaci\u00f3n []", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "STYLE", "isSquare": true, "values": ["izquierda-derecha", "no rotar", "en todas direcciones"]}]}, {"text": "fijar idioma a []", "frequency": 0, "category": "speech", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "LANGUAGE", "isSquare": false, "values": ["\u00e1r\u00e1be", "chinese", "Chino Mandar\u00edn", "Chino Mandar\u00edn", "dan\u00e9s", "neerland\u00e9s", "ingl\u00e9s", "franc\u00e9s", "alem\u00e1n", "hindi", "island\u00e9s", "italiano", "japon\u00e9s", "coreano", "noruego", "polaco", "portugu\u00e9s brasile\u00f1o", "portugu\u00e9s", "rumano", "ruso", "espa\u00f1ol", "espa\u00f1ol latinoamericano", "sueco", "turco", "welsh"]}]}, {"text": "fijar instrumento a []", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "INSTRUMENT", "isSquare": false, "values": ["piano", "piano el\u00e9ctrico", "\u00f3rgano", "guitarra", "guitarra el\u00e9ctrica", "bajo", "pizzicato", "violonchelo", "tromb\u00f3n", "carinet", "saxof\u00f3n", "flauta", "wodden flute", "fagot", "choir", "vibr\u00e1fono", "caja de musica", "tambor met\u00e1lico", "marimba", "sintetizador mel\u00f3dico", "sintetizador de fondo"]}]}, {"text": "fijar modo de arrastre a []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "DRAG_MODE", "isSquare": true, "values": ["arrastrable", "no arrastrable"]}]}, {"text": "fijar tama\u00f1o a ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "fijar tempo a ()", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "fijar transparencia de video a ()", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false}, {"text": "fijar velocidad del motor [] a ()", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "fijar volumen a ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "fijar voz a []", "frequency": 0, "category": "speech", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "VOICE", "isSquare": false, "values": ["alto", "tenor", "chirrido", "gigante", "gatito"]}]}, {"text": "fondo siguiente", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "girar el motor [] hacia ac\u00e1 por () segundos", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "girar el motor [] hacia all\u00e1 por () segundos", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "insertar () en () de []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "ir () capas hacia []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "FORWARD_BACKWARD", "isSquare": true, "values": ["adelante", "atr\u00e1s"]}]}, {"text": "ir a la capa []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "FRONT_BACK", "isSquare": true, "values": ["del frente", "de atr\u00e1s"]}]}, {"text": "ir a x () y ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "limpiar pantalla", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true}, {"text": "looks!fijar efecto [] a ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "displayText": "fijar efecto [] a ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["color", "ojo de pez", "remolino", "pixelar", "mosaico", "brillo", "desvanecer"]}]}, {"text": "l\u00e1piz abajo", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "l\u00e1piz arriba", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "microbit!cuando []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "cuando []", "clashWithDevice": true, "dropdowns": [{"name": "GESTURE", "isSquare": false, "values": ["se mueva", "sacudirse", "salte"]}]}, {"text": "mostrar", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "mostrar []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MATRIX", "isSquare": false, "values": ["[ox]", "[01]{25}"]}]}, {"text": "mostrar lista []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "mostrar texto ()", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true}, {"text": "mostrar variable []", "frequency": 0, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "ocultar variable []", "frequency": 0, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "pensar ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "pensar () por () segundos", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "preguntar () y esperar", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "quitar efectos gr\u00e1ficos", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "reemplazar elemento () de [] con ()", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "reiniciar cron\u00f3metro", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "sellar", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "separator", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "siguiente disfraz", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "sound!fijar efecto [] a ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false, "displayText": "fijar efecto [] a ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["altura", "paneo izquierda/derecha"]}]}, {"text": "tocar el tambor [] por () pulsos", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "DRUM", "isSquare": false, "values": ["caja", "bombo", "goldpe lateral", "platillo crash", "Charles abierto", "Charles cerrado", "tamborine", "palmada", "claves", "caja china", "cencerro", "triangle", "bongo", "conga", "cabasa", "g\u00fciro", "vibraslap", "culca"]}]}, {"text": "tocar la nota () por () pulsos", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "tocar nota () durante () segundos", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "tocar sonido []", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "SOUND_MENU", "isSquare": false, "values": []}]}, {"text": "tocar sonido [] hasta terminar", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "SOUND_MENU", "isSquare": false, "values": []}]}, {"text": "wedo!al inclinarse []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "al inclinarse []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["arriba", "abajo", "izquierda", "derecha", "cualquiera"]}]}, {"text": "wedo!establecer color de luz a ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "establecer color de luz a ()", "clashWithDevice": true}], "values": [{"text": "direcci\u00f3n", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "posici\u00f3n en x", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "posici\u00f3n en y", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "volumen del sonido", "frequency": 1, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "() * ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() + ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() - ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() / ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() m\u00f3d ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "[] actual", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "CURRENTMENU", "isSquare": true, "values": ["ano", "mes", "dia", "dia de la semana", "hora", "minuto", "segundo"]}]}, {"text": "[] de ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "OPERATOR", "isSquare": true, "values": ["valor absoluto", "piso", "techo", "raiz cuadrada", "seno", "coseno", "tangente", "arcoseno", "arcocoseno", "arcotangente", "logaritmo natural", "logaritmo en base 10", "e^", "10^"]}]}, {"text": "[] de []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "PROPERTY", "isSquare": true, "values": ["# de fondo", "nombre de fondo", "volumen", "posici\u00f3n en x", "posici\u00f3n en y", "direcci\u00f3n", "# de disfraz", "nombre del disfraz", "tama\u00f1o"]}, {"name": "OBJECT", "isSquare": false, "values": ["escenario"]}]}, {"text": "[] del video en []", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "ATTRIBUTE", "isSquare": false, "values": ["movimiento", "direcci\u00f3n"]}, {"name": "SUBJECT", "isSquare": false, "values": ["escenario"]}]}, {"text": "aceleraci\u00f3n []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["x", "y", "z"]}]}, {"text": "boost!posici\u00f3n del motor []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "posici\u00f3n del motor []", "clashWithDevice": true, "dropdowns": [{"name": "MOTOR_REPORTER_ID", "isSquare": false, "values": []}]}, {"text": "boost!\u00e1ngulo de inclinaci\u00f3n []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "\u00e1ngulo de inclinaci\u00f3n []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION", "isSquare": false, "values": ["arriba", "abajo", "izquierda", "derecha", "cualquiera"]}]}, {"text": "brillo", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "cron\u00f3metro", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "disfraz []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "NUMBER_NAME", "isSquare": true, "values": ["n\u00famero", "nombre"]}]}, {"text": "distancia a []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "DISTANCETOMENU", "isSquare": false, "values": ["puntero del rot\u00f3n"]}]}, {"text": "d\u00edas desde el 2000", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "elemento # () en []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "elemento () de []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "ev3!distancia", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "distancia", "clashWithDevice": true}, {"text": "ev3!posici\u00f3n del motor []", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "posici\u00f3n del motor []", "clashWithDevice": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "fondo []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "NUMBER_NAME", "isSquare": true, "values": ["n\u00famero", "nombre"]}]}, {"text": "fuerza", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true}, {"text": "lenguaje", "frequency": 0, "category": "translate", "isExtension": true, "deviceRequired": false}, {"text": "letra () de ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "longitud de ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "longitud de []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "microbit!\u00e1ngulo de inclinaci\u00f3n []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "\u00e1ngulo de inclinaci\u00f3n []", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["del frente", "de atr\u00e1s", "izquierda", "derecha"]}]}, {"text": "nombre de usuario", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "n\u00famero al azar entre () y ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "posici\u00f3n x del rat\u00f3n", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "posici\u00f3n y del rat\u00f3n", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "redondear ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "respuesta", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "tama\u00f1o", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "tempo", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "traducir () al []", "frequency": 0, "category": "translate", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "LANGUAGE", "isSquare": false, "values": []}]}, {"text": "unir () ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "velocidad de giro []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["x", "y", "z"]}]}, {"text": "volumen", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "wedo!distancia", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "distancia", "clashWithDevice": true}, {"text": "wedo!\u00e1ngulo de inclinaci\u00f3n []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "\u00e1ngulo de inclinaci\u00f3n []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION", "isSquare": false, "values": ["arriba", "abajo", "izquierda", "derecha"]}]}, {"text": "\u00e1ngulo de inclinaci\u00f3n hacia []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["del frente", "de atr\u00e1s", "izquierda", "derecha"]}]}], "conditions": [{"text": "() lt ()", "frequency": 1, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() = ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() contiene ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() gt ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "<> o <>", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "<> y <>", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "[] contiene ()", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "bot\u00f3n [] presionado", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "BTN", "isSquare": false, "values": ["A", "B", "Any"]}]}, {"text": "cayendo", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true}, {"text": "color () est\u00e1 tocando ()", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "est\u00e1 presionado el bot\u00f3n []", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["1", "2", "3", "4"]}]}, {"text": "inclinado hacia []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["del frente", "de atr\u00e1s", "izquierda", "derecha", "cualquiera"]}]}, {"text": "microbit!inclinado []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "inclinado []", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["del frente", "de atr\u00e1s", "izquierda", "derecha", "cualquiera"]}]}, {"text": "no <>", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "rat\u00f3n presionado", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "tecla [] presionada", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "KEY_OPTION", "isSquare": false, "values": ["espacio", "flecha arriba", "flecha abajo", "flecha izquierda", "flecha derecha", "cualquiera", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}]}, {"text": "tocando []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TOUCHINGOBJECTMENU", "isSquare": false, "values": ["puntero del rot\u00f3n", "el borde"]}]}, {"text": "tocando el color ()", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "viendo un bloque []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "COLOR", "isSquare": false, "values": ["roja", "azul", "verde", "amarilla", "blanca", "negra", "de cualquier color"]}]}, {"text": "wedo!inclinado []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "inclinado []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["arriba", "abajo", "izquierda", "derecha", "cualquiera"]}]}]}, "it": {"blocks": [{"text": "se <> allora", "frequency": 59, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "quando si clicca su bandiera", "frequency": 55, "category": "events", "isExtension": false, "deviceRequired": false}, {"text": "quando ricevo []", "frequency": 50, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_OPTION", "isSquare": true, "values": []}]}, {"text": "nascondi", "frequency": 43, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "invia a tutti []", "frequency": 40, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_INPUT", "isSquare": false, "values": []}]}, {"text": "mostra", "frequency": 32, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "per sempre", "frequency": 32, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "porta [] a ()", "frequency": 30, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "cambia [] di ()", "frequency": 25, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "dire () per () secondi", "frequency": 24, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "vai dove x \u00e8 ()", "frequency": 18, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "altrimenti", "frequency": 17, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "attendi () secondi", "frequency": 15, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "quando vengo clonato", "frequency": 15, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "ripeti () volte", "frequency": 15, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "passa al costume []", "frequency": 14, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "COSTUME", "isSquare": false, "values": []}]}, {"text": "fai () passi", "frequency": 13, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "ripeti fino a quando <>", "frequency": 13, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "crea clone di []", "frequency": 12, "category": "control", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "CLONE_OPTION", "isSquare": false, "values": ["me stesso"]}]}, {"text": "ferma []", "frequency": 12, "category": "control", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "STOP_OPTION", "isSquare": true, "values": ["tutto", "questo script", "tutti gli altri script dello sprite"]}]}, {"text": "ruota destra di () gradi", "frequency": 12, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "elimina questo clone", "frequency": 10, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "punta in direzione ()", "frequency": 10, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "passa allo sfondo []", "frequency": 9, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": false, "values": []}]}, {"text": "cancella () da []", "frequency": 8, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "events!quando si preme il tasto []", "frequency": 8, "category": "events", "isExtension": false, "deviceRequired": false, "displayText": "quando si preme il tasto []", "clashWithDevice": true, "dropdowns": [{"name": "KEY_OPTION", "isSquare": true, "values": ["spazio", "freccia su", "freccia gi\u00f9", "freccia sinistra", "freccia destra", "qualunque", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}]}, {"text": "makey!quando si preme il tasto []", "frequency": 8, "category": "makey", "isExtension": true, "deviceRequired": true, "displayText": "quando si preme il tasto []", "clashWithDevice": true, "dropdowns": [{"name": "KEY", "isSquare": false, "values": ["spazio", "freccia su", "freccia gi\u00f9", "freccia sinistra", "freccia destra", "w", "a", "s", "d", "f", "g"]}]}, {"text": "passa al costume seguente", "frequency": 8, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "quando si clicca questo sprite", "frequency": 8, "category": "events", "isExtension": false, "deviceRequired": false}, {"text": "ruota sinistra di () gradi", "frequency": 8, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "vai dove y \u00e8 ()", "frequency": 8, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "cambia x di ()", "frequency": 7, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "raggiungi []", "frequency": 7, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TO", "isSquare": false, "values": ["posizione a caso", "puntatore del mouse"]}]}, {"text": "invia a tutti [] e attendi", "frequency": 5, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_INPUT", "isSquare": false, "values": []}]}, {"text": "riproduci suono [] e attendi la fine", "frequency": 5, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "SOUND_MENU", "isSquare": false, "values": []}]}, {"text": "aggiungi () a []", "frequency": 4, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "avvia riproduzione suono []", "frequency": 4, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "SOUND_MENU", "isSquare": false, "values": []}]}, {"text": "rimbalza quando tocchi il bordo", "frequency": 4, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "chiedi () e attendi", "frequency": 3, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "attendi fino a quando <>", "frequency": 1, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "cambia y di ()", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "dire ()", "frequency": 1, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "looks!cambia effetto [] di ()", "frequency": 1, "category": "looks", "isExtension": false, "deviceRequired": false, "displayText": "cambia effetto [] di ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["colore", "fish-eye", "mulinello", "effetto pixel", "mosaico", "luminosit\u00e0", "fantasma"]}]}, {"text": "penna gi\u00f9", "frequency": 1, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "porta colore penna a ()", "frequency": 1, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "porta dimensione penna a ()", "frequency": 1, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "pulisci", "frequency": 1, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "punta verso []", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TOWARDS", "isSquare": false, "values": ["puntatore del mouse"]}]}, {"text": "sound!cambia effetto [] di ()", "frequency": 1, "category": "sound", "isExtension": false, "deviceRequired": false, "displayText": "cambia effetto [] di ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["frequenza", "panning sinistra/destra"]}]}, {"text": "[] il video della webcam", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "VIDEO_STATE", "isSquare": false, "values": ["accendi", "spegni", "accendi e inverti orizzontalmente"]}]}, {"text": "accendi []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motore", "motore A", "motore B", "tutti i motori"]}]}, {"text": "accendi [] per () secondi", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motore", "motore A", "motore B", "tutti i motori"]}]}, {"text": "accendi motore []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "accendi motore [] per () rotazioni", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "accendi motore [] per () secondi", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "azione il motore [] nell'altra direzione per () secondi", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "aziouna il motore [] in questa direzione per () secondi", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "azzera cronometro", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "boost!porta colore luci a ()", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "porta colore luci a ()", "clashWithDevice": true}, {"text": "boost!porta potenza [] a ()", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "porta potenza [] a ()", "clashWithDevice": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "boost!quando inclinato []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "quando inclinato []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["in su", "in gi\u00f9", "sinistra", "destra", "qualunque"]}]}, {"text": "cambia [] penna di ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "COLOR_PARAM", "isSquare": false, "values": ["colore", "intensit\u00e0 colore", "luminosit\u00e0", "trasparenza"]}]}, {"text": "cambia dimensione di ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "cambia dimensione penna di ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "cambia tempo di ()", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "cambia volume di ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "cancella display", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true}, {"text": "cancella tutto da []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "emetti nota () per () secondi", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "ev3!quando pulsante [] premuto", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "quando pulsante [] premuto", "clashWithDevice": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["1", "2", "3", "4"]}]}, {"text": "fa!quando []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "displayText": "quando []", "clashWithDevice": true, "dropdowns": [{"name": "GESTURE", "isSquare": false, "values": ["si scuote", "inizia a cadere", "\u00e8 a faccia in su", "\u00e8 a faccia in gi\u00f9"]}]}, {"text": "fa!quando inclinato []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "displayText": "quando inclinato []", "clashWithDevice": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["primo", "secondo", "sinistra", "destra", "qualunque"]}]}, {"text": "ferma tutti i suoni", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "imposta tempo a () bpm", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "inserisci () alla posizione () di []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "looks!porta effetto [] a ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "displayText": "porta effetto [] a ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["colore", "fish-eye", "mulinello", "effetto pixel", "mosaico", "luminosit\u00e0", "fantasma"]}]}, {"text": "microbit!quando []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "quando []", "clashWithDevice": true, "dropdowns": [{"name": "GESTURE", "isSquare": false, "values": ["si muove", "si scuote", "salta"]}]}, {"text": "microbit!quando inclinato []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "quando inclinato []", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["primo", "secondo", "sinistra", "destra", "qualunque"]}]}, {"text": "microbit!quando pulsante [] premuto", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "quando pulsante [] premuto", "clashWithDevice": true, "dropdowns": [{"name": "BTN", "isSquare": false, "values": ["A", "B", "Any"]}]}, {"text": "mostra [] su mostra", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MATRIX", "isSquare": false, "values": ["[ox]", "[01]{25}"]}]}, {"text": "mostra la lista []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "mostra la variabile []", "frequency": 0, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "mostra testo ()", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true}, {"text": "nascondi la lista []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "nascondi la variabile []", "frequency": 0, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "passa a strumento []", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "INSTRUMENT", "isSquare": false, "values": ["piano", "Piano elettrico", "Organo", "Chitarra", "Chitarra elettrica", "Basso elettrica", "pizzicato", "Violoncello", "trombone", "carinet", "Sassofono", "Flauto", "wodden flute", "Fagotto", "Coro", "Vibrafono", "Carillon", "steel drum", "marimba", "Sintetizzatore", "Sintetizzatore suoni di sottofondo"]}]}, {"text": "passa allo sfondo [] e attendi", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": false, "values": []}]}, {"text": "passa allo sfondo seguente", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "pausa di () battute", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "penna su", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "pensa ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "pensa () per () secondi", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "porta [] penna a ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "COLOR_PARAM", "isSquare": false, "values": ["colore", "intensit\u00e0 colore", "luminosit\u00e0", "trasparenza"]}]}, {"text": "porta dimensione a ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "porta direzione [] a []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motore", "motore A", "motore B", "tutti i motori"]}, {"name": "MOTOR_DIRECTION", "isSquare": false, "values": ["da questa parte", "da quella parte", "inversa"]}]}, {"text": "porta direzione motore [] a []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}, {"name": "MOTOR_DIRECTION", "isSquare": false, "values": ["da questa parte", "da quella parte", "inversa"]}]}, {"text": "porta potenza motore [] a ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "porta trasparenza webcam a ()", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false}, {"text": "porta volume a ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "pronuncia ()", "frequency": 0, "category": "speech", "isExtension": true, "deviceRequired": false}, {"text": "quando [] gt ()", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "WHENGREATERTHANMENU", "isSquare": true, "values": ["volume microfono", "cronometro"]}]}, {"text": "quando distanza [] ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "OP", "isSquare": false, "values": ["lt", "gt"]}]}, {"text": "quando distanza lt ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "quando il pin [] \u00e8 collegato", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PIN", "isSquare": false, "values": ["0", "1", "2"]}]}, {"text": "quando il sensore di forza rileva che []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PUSH_PULL", "isSquare": false, "values": ["\u00e8 a faccia in su", "\u00e8 a faccia in gi\u00f9"]}]}, {"text": "quando lo sfondo passa a []", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": true, "values": []}]}, {"text": "quando luminosit\u00e0 lt ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "quando movimento video \u00e8 gt ()", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false}, {"text": "quando si preme la sequenza di tasti []", "frequency": 0, "category": "makey", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "SEQUENCE", "isSquare": false, "values": ["a sinistra su a destra", "a destra su a sinistra", "a sinistra a destra", "a destra a sinistra", "su gi\u00f9", "gi\u00f9 su", "su a destra gi\u00f9 a sinistra", "su a sinistra gi\u00f9 a destra", "su su gi\u00f9 gi\u00f9 a sinistra a destra a sinistra a destra"]}]}, {"text": "quando vedo mattoncino []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "COLOR", "isSquare": false, "values": ["rosso", "blu", "verde", "giallo", "bianco", "nero", "colore qualunque"]}]}, {"text": "rendi lo sprite []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "DRAG_MODE", "isSquare": true, "values": ["trascinabile", "non trascinabile"]}]}, {"text": "rimuovi effetti audio", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "rimuovi effetti grafici", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "scivola in () secondi a []", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TO", "isSquare": false, "values": ["posizione a caso", "puntatore del mouse"]}]}, {"text": "scivola in () secondi a x () y ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "separator", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "sostituisci elemento () di [] con ()", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "sound!porta effetto [] a ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false, "displayText": "porta effetto [] a ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["frequenza", "panning sinistra/destra"]}]}, {"text": "space", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "spegni []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motore", "motore A", "motore B", "tutti i motori"]}]}, {"text": "spegni motore []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "suona il tamburo [] per () battute", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "DRUM", "isSquare": false, "values": ["Rullante", "Grancassa", "Bacchette", "Piatto Crash", "Hi-Hat aperto", "Charleston", "Tamburello", "Baltimano", "Legnetti", "Blocchetto di legno", "Campanaccio", "Triangolo", "bongo", "conga", "cabasa", "guiro", "vibraslap", "culca"]}]}, {"text": "suona la nota () per () battute", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "timbra", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "usa lingua []", "frequency": 0, "category": "speech", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "LANGUAGE", "isSquare": false, "values": ["Arabo", "chinese", "Cinese mandarino", "Cinese mandarino", "Danese", "Olandese", "Inglese", "Francese", "Tedesco", "hindi", "Islandese", "Italiano", "Giapponese", "Coreano", "Norvegese", "Polacco", "Portoghese brasiliano", "Portoghese", "Rumeno", "Russo", "Spagnolo", "Spagnolo latino americano", "Svedese", "Turco", "Gallese"]}]}, {"text": "usa stile rotazione []", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "STYLE", "isSquare": true, "values": ["sinistra-destra", "non ruotare", "pu\u00f2 ruotare"]}]}, {"text": "usa voce []", "frequency": 0, "category": "speech", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "VOICE", "isSquare": false, "values": ["da contralto", "da tenore", "stridula", "de gigante", "da gattino"]}]}, {"text": "vai [] di () livelli", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "FORWARD_BACKWARD", "isSquare": true, "values": ["avanti", "indietro"]}]}, {"text": "vai a x () y ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "vai in [] piano", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "FRONT_BACK", "isSquare": true, "values": ["primo", "secondo"]}]}, {"text": "wedo!porta colore luci a ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "porta colore luci a ()", "clashWithDevice": true}, {"text": "wedo!porta potenza [] a ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "porta potenza [] a ()", "clashWithDevice": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motore", "motore A", "motore B", "tutti i motori"]}]}, {"text": "wedo!quando inclinato []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "quando inclinato []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["in su", "in gi\u00f9", "sinistra", "destra", "qualunque"]}]}], "values": [{"text": "numero a caso tra () e ()", "frequency": 18, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() * ()", "frequency": 6, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() + ()", "frequency": 4, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "[] di []", "frequency": 4, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "PROPERTY", "isSquare": true, "values": ["numero dello sfondo", "nome dello sfondo", "volume", "posizione x", "posizione y", "direzione", "numero del costume", "nome del costume", "dimensione"]}, {"name": "OBJECT", "isSquare": false, "values": ["stage"]}]}, {"text": "resto della divisione di () diviso ()", "frequency": 4, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "risposta", "frequency": 4, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "() - ()", "frequency": 2, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "lettera () di ()", "frequency": 2, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "lunghezza di ()", "frequency": 2, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "unione di () e ()", "frequency": 2, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "x del mouse", "frequency": 2, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "() / ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "[] attuale", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "CURRENTMENU", "isSquare": true, "values": ["anno", "mese", "data", "giorno della settimana", "ora", "minuto", "secondo"]}]}, {"text": "[] costume", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "NUMBER_NAME", "isSquare": true, "values": ["numero", "nome"]}]}, {"text": "[] del video su []", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "ATTRIBUTE", "isSquare": false, "values": ["Movimento", "direzione"]}, {"name": "SUBJECT", "isSquare": false, "values": ["stage"]}]}, {"text": "[] di ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "OPERATOR", "isSquare": true, "values": ["valore assoluto", "intero inferiore", "intero superiore", "radice quadrata", "sen", "cos", "tan", "arcsen", "arccos", "arctan", "ln", "log", "e^", "10^"]}]}, {"text": "[] sfondo", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "NUMBER_NAME", "isSquare": true, "values": ["numero", "nome"]}]}, {"text": "accelerazione []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["x", "y", "z"]}]}, {"text": "arrotonda ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "boost!angolo inclinazione []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "angolo inclinazione []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION", "isSquare": false, "values": ["in su", "in gi\u00f9", "sinistra", "destra", "qualunque"]}]}, {"text": "boost!posizione motore []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "posizione motore []", "clashWithDevice": true, "dropdowns": [{"name": "MOTOR_REPORTER_ID", "isSquare": false, "values": []}]}, {"text": "cronometro", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "dimensione", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "direzione", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "distanza da []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "DISTANCETOMENU", "isSquare": false, "values": ["puntatore del mouse"]}]}, {"text": "elemento () di []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "ev3!distanza", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "distanza", "clashWithDevice": true}, {"text": "ev3!posizione motore []", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "posizione motore []", "clashWithDevice": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "fa!angolo inclinazione []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "displayText": "angolo inclinazione []", "clashWithDevice": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["primo", "secondo", "sinistra", "destra"]}]}, {"text": "forza", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true}, {"text": "giorni trascorsi dal 2000", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "lingua", "frequency": 0, "category": "translate", "isExtension": true, "deviceRequired": false}, {"text": "luminosit\u00e0", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "lunghezza di []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "microbit!angolo inclinazione []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "angolo inclinazione []", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["primo", "secondo", "sinistra", "destra"]}]}, {"text": "posizione di () in []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "posizione x", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "posizione y", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "tempo", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "traduci () in []", "frequency": 0, "category": "translate", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "LANGUAGE", "isSquare": false, "values": []}]}, {"text": "username", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "velocit\u00e0 di rotazione []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["x", "y", "z"]}]}, {"text": "volume", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "volume microfono", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "wedo!angolo inclinazione []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "angolo inclinazione []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION", "isSquare": false, "values": ["in su", "in gi\u00f9", "sinistra", "destra"]}]}, {"text": "wedo!distanza", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "distanza", "clashWithDevice": true}, {"text": "y del mouse", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}], "conditions": [{"text": "() = ()", "frequency": 6, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() lt ()", "frequency": 4, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "sta toccando il colore ()", "frequency": 3, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "() gt ()", "frequency": 2, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "<> e <>", "frequency": 2, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "<> o <>", "frequency": 2, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "non <>", "frequency": 2, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "sta toccando []", "frequency": 2, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TOUCHINGOBJECTMENU", "isSquare": false, "values": ["puntatore del mouse", "bordo"]}]}, {"text": "() contiene ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "[] contiene ()", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "ev3!pulsante [] premuto", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "pulsante [] premuto", "clashWithDevice": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["1", "2", "3", "4"]}]}, {"text": "fa!inclinato []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "displayText": "inclinato []", "clashWithDevice": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["primo", "secondo", "sinistra", "destra", "qualunque"]}]}, {"text": "il colore () sta toccando il colore ()", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "microbit!inclinato []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "inclinato []", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["primo", "secondo", "sinistra", "destra", "qualunque"]}]}, {"text": "microbit!pulsante [] premuto", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "pulsante [] premuto", "clashWithDevice": true, "dropdowns": [{"name": "BTN", "isSquare": false, "values": ["A", "B", "Any"]}]}, {"text": "pulsante del mouse premuto", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "sto cadendo", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true}, {"text": "tasto [] premuto", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "KEY_OPTION", "isSquare": false, "values": ["spazio", "freccia su", "freccia gi\u00f9", "freccia sinistra", "freccia destra", "qualunque", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}]}, {"text": "vedo mattoncino []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "COLOR", "isSquare": false, "values": ["rosso", "blu", "verde", "giallo", "bianco", "nero", "colore qualunque"]}]}, {"text": "wedo!inclinato []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "inclinato []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["in su", "in gi\u00f9", "sinistra", "destra", "qualunque"]}]}]}, "pt": {"blocks": [{"text": "repete para sempre", "frequency": 35, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "altera a tua direc\u00e7\u00e3o para () \u00b0", "frequency": 30, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "anda () passos", "frequency": 24, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "pergunta () e espera pela resposta", "frequency": 24, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "repete () vezes", "frequency": 14, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "cria um clone de []", "frequency": 8, "category": "control", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "CLONE_OPTION", "isSquare": false, "values": ["ti mesmo"]}]}, {"text": "altera [] para ()", "frequency": 7, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "difunde a mensagem [] e espera", "frequency": 7, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_INPUT", "isSquare": false, "values": []}]}, {"text": "diz () durante () s", "frequency": 7, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "gira direita () \u00b0", "frequency": 7, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "mostra-te", "frequency": 7, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "desliza em () s em direc\u00e7\u00e3o a []", "frequency": 6, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TO", "isSquare": false, "values": ["uma posi\u00e7\u00e3o ao acaso", "o ponteiro do rato"]}]}, {"text": "p\u00e1ra []", "frequency": 6, "category": "control", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "STOP_OPTION", "isSquare": true, "values": ["tudo", "este gui\u00e3o", "os teus outros gui\u00f5es"]}]}, {"text": "aponta em direc\u00e7\u00e3o a []", "frequency": 5, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TOWARDS", "isSquare": false, "values": ["o ponteiro do rato"]}]}, {"text": "esconde-te", "frequency": 5, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "muda o teu traje para []", "frequency": 5, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "COSTUME", "isSquare": false, "values": []}]}, {"text": "espera () s", "frequency": 4, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "adiciona () ao teu y", "frequency": 3, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "adiciona a [] o valor ()", "frequency": 3, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "altera a espessura da tua caneta para ()", "frequency": 3, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "baixa a tua caneta", "frequency": 3, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "toca o som []", "frequency": 3, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "SOUND_MENU", "isSquare": false, "values": []}]}, {"text": "altera a cor da tua caneta para ()", "frequency": 2, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "apaga tudo do palco", "frequency": 2, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "carimba-te", "frequency": 2, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "espera at\u00e9 que <>", "frequency": 2, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "remove-te como clone", "frequency": 2, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "vai para []", "frequency": 2, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TO", "isSquare": false, "values": ["uma posi\u00e7\u00e3o ao acaso", "o ponteiro do rato"]}]}, {"text": "adiciona () ao teu x", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "diz ()", "frequency": 1, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "esconde a vari\u00e1vel []", "frequency": 1, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "gira esquerda () \u00b0", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "levanta a tua caneta", "frequency": 1, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "toca o som [] at\u00e9 terminar", "frequency": 1, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "SOUND_MENU", "isSquare": false, "values": []}]}, {"text": "Quando [] forem pressionadas por ordem", "frequency": 0, "category": "makey", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "SEQUENCE", "isSquare": false, "values": ["esquerda cima direita", "direita cima esquerda", "esquerda direita", "direita esquerda", "cima baixo", "baixo cima", "cima direita baixo esquerda", "cima esquerda baixo direita", "cima cima baixo baixo esquerda direita esquerda direita"]}]}, {"text": "Quando a brilho for menor que ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "Quando a dist\u00e2ncia for [] ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "OP", "isSquare": false, "values": ["lt", "gt"]}]}, {"text": "Quando a dist\u00e2ncia for menor que ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "Quando a tecla [] for pressionada", "frequency": 0, "category": "makey", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "KEY", "isSquare": false, "values": ["espa\u00e7o", "seta para cima", "seta para baixo", "seta para a esquerda", "seta para a direita", "w", "a", "s", "d", "f", "g"]}]}, {"text": "Quando algu\u00e9m clicar em bandeira", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false}, {"text": "Quando algu\u00e9m clicar em ti", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false}, {"text": "Quando algu\u00e9m pressionar a tecla []", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "KEY_OPTION", "isSquare": true, "values": ["espa\u00e7o", "seta para cima", "seta para baixo", "seta para a esquerda", "seta para a direita", "qualquer", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}]}, {"text": "Quando fores criado como um clone", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "Quando o cen\u00e1rio mudar para []", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": true, "values": []}]}, {"text": "Quando o movimento do v\u00eddeo exceder ()", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false}, {"text": "Quando o pino [] for ligado", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PIN", "isSquare": false, "values": ["0", "1", "2"]}]}, {"text": "Quando o sensor de for\u00e7a []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PUSH_PULL", "isSquare": false, "values": ["empurrado", "puxado"]}]}, {"text": "Quando o valor do sensor o [] exceder ()", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "WHENGREATERTHANMENU", "isSquare": true, "values": ["volume no microfone", "valor do cron\u00f3metro"]}]}, {"text": "Quando receberes a mensagem []", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_OPTION", "isSquare": true, "values": []}]}, {"text": "Quando vir o tijolo []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "COLOR", "isSquare": false, "values": ["vermelho", "azul", "verde", "amarelo", "branco", "breto", "de qualquer cor"]}]}, {"text": "[] () camadas", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "FORWARD_BACKWARD", "isSquare": true, "values": ["avan\u00e7a", "recua"]}]}, {"text": "acrescenta () a []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "adiciona () ao teu tamanho", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "adiciona () ao teu volume", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "adiciona () bpm ao teu andamento", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "adiciona () \u00e0 espessura da tua caneta", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "adiciona a [] da tua caneta o valor ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "COLOR_PARAM", "isSquare": false, "values": ["cor", "a satura\u00e7\u00e3o", "brilho", "a transpar\u00eancia"]}]}, {"text": "altera [] da tua caneta para ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "COLOR_PARAM", "isSquare": false, "values": ["cor", "a satura\u00e7\u00e3o", "brilho", "a transpar\u00eancia"]}]}, {"text": "altera a direc\u00e7\u00e3o de [] para []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["o motor", "o motor A", "o motor B", "todos os motores"]}, {"name": "MOTOR_DIRECTION", "isSquare": false, "values": ["aqui", "ali", "tr\u00e1s"]}]}, {"text": "altera a direc\u00e7\u00e3o do motor [] para []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}, {"name": "MOTOR_DIRECTION", "isSquare": false, "values": ["aqui", "ali", "tr\u00e1s"]}]}, {"text": "altera a l\u00edngua para []", "frequency": 0, "category": "speech", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "LANGUAGE", "isSquare": false, "values": ["arabic", "chinese", "mandarim chin\u00eas", "mandarim chin\u00eas", "danish", "dutch", "english", "french", "german", "hindi", "icelandic", "italian", "japanese", "korean", "norwegian", "polish", "portugu\u00eas brasileiro", "portuguese", "romanian", "russian", "spanish", "Espanhol latino-americano", "swedish", "turkish", "welsh"]}]}, {"text": "altera a pot\u00eancia de [] para ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["o motor", "o motor A", "o motor B", "todos os motores"]}]}, {"text": "altera a pot\u00eancia do motor [] para ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "altera a teu instrumento para []", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "INSTRUMENT", "isSquare": false, "values": ["piano", "piano el\u00e9ctrico", "\u00f3rg\u00e3o", "guitarra", "guitarra el\u00e9ctica", "baixo", "pizzicato", "violoncelo", "trombone", "carinet", "saxofone", "flauta transversal", "wodden flute", "fagote", "choir", "vibraphone", "caixa de m\u00fasica", "tambor de a\u00e7o", "marimba", "sintetizador mel\u00f3dico", "sintetizador de fundo"]}]}, {"text": "altera a transpar\u00eancia do v\u00eddeo para ()", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false}, {"text": "altera a velocidade do motor [] para ()", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "altera a voz para []", "frequency": 0, "category": "speech", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "VOICE", "isSquare": false, "values": ["alto", "tenor", "guincho", "gigante", "gatinho"]}]}, {"text": "altera o estado do v\u00eddeo para []", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "VIDEO_STATE", "isSquare": false, "values": ["ligado", "desligado", "ligado e espelhado"]}]}, {"text": "altera o teu andamento para () bpm", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "altera o teu estilo de rota\u00e7\u00e3o para []", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "STYLE", "isSquare": true, "values": ["olha apenas para a esquerda e para a direita", "n\u00e3o gires", "gira a toda a volta"]}]}, {"text": "altera o teu modo de arrasto para []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "DRAG_MODE", "isSquare": true, "values": ["arrast\u00e1vel", "n\u00e3o arrast\u00e1vel"]}]}, {"text": "altera o teu tamanho para ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "altera o teu volume para ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "altera o teu x para ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "altera o teu y para ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "apaga o ecr\u00e3", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true}, {"text": "at\u00e9 que <> repete", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "boost!Quando for inclinado para []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "Quando for inclinado para []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["cima", "para baixo", "esquerda", "direita", "qualquer"]}]}, {"text": "boost!altera a cor da luz para ()", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "altera a cor da luz para ()", "clashWithDevice": true}, {"text": "cancela os teus efeitos gr\u00e1ficos", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "cancela todos os teus efeitos sonoros", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "desliga []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["o motor", "o motor A", "o motor B", "todos os motores"]}]}, {"text": "desliga o motor []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "desliza em () s para a posi\u00e7\u00e3o x () y ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "difunde a mensagem []", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_INPUT", "isSquare": false, "values": []}]}, {"text": "esconde a lista []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "ev3!Quando o bot\u00e3o [] for pressionado", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "Quando o bot\u00e3o [] for pressionado", "clashWithDevice": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["1", "2", "3", "4"]}]}, {"text": "fa!Quando []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "displayText": "Quando []", "clashWithDevice": true, "dropdowns": [{"name": "GESTURE", "isSquare": false, "values": ["for abanado", "come\u00e7ar a cair", "est\u00e1 com a face para cima", "est\u00e1 com a face para baixo"]}]}, {"text": "fa!Quando for inclinado para []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "displayText": "Quando for inclinado para []", "clashWithDevice": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["frontal", "traseira", "esquerda", "direita", "qualquer"]}]}, {"text": "fala ()", "frequency": 0, "category": "speech", "isExtension": true, "deviceRequired": false}, {"text": "faz uma pausa de () tempos", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "insere () como () de []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "liga []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["o motor", "o motor A", "o motor B", "todos os motores"]}]}, {"text": "liga [] durante () s", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["o motor", "o motor A", "o motor B", "todos os motores"]}]}, {"text": "liga o motor []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "looks!adiciona ao teu efeito [] o valor ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "displayText": "adiciona ao teu efeito [] o valor ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["cor", "olho de peixe", "romoinho", "pixeliza\u00e7\u00e3o", "mosaico", "brilho", "fantasma"]}]}, {"text": "looks!altera o teu efeito [] para ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "displayText": "altera o teu efeito [] para ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["cor", "olho de peixe", "romoinho", "pixeliza\u00e7\u00e3o", "mosaico", "brilho", "fantasma"]}]}, {"text": "microbit!Quando []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "Quando []", "clashWithDevice": true, "dropdowns": [{"name": "GESTURE", "isSquare": false, "values": ["se mover", "for abanado", "saltar"]}]}, {"text": "microbit!Quando for inclinado para []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "Quando for inclinado para []", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["frontal", "traseira", "esquerda", "direita", "qualquer"]}]}, {"text": "microbit!Quando o bot\u00e3o [] for pressionado", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "Quando o bot\u00e3o [] for pressionado", "clashWithDevice": true, "dropdowns": [{"name": "BTN", "isSquare": false, "values": ["A", "B", "Any"]}]}, {"text": "mostra []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MATRIX", "isSquare": false, "values": ["[ox]", "[01]{25}"]}]}, {"text": "mostra a lista []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "mostra a vari\u00e1vel []", "frequency": 0, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "mostra o texto ()", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true}, {"text": "muda o cen\u00e1rio para []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": false, "values": []}]}, {"text": "muda o cen\u00e1rio para [] e espere", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": false, "values": []}]}, {"text": "passa para o teu pr\u00f3ximo cen\u00e1rio", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "passa para o teu pr\u00f3ximo traje", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "pensa ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "pensa () durante () s", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "p\u00e1ra todos os sons", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "reinicia o cron\u00f3metro", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "remove () de []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "remove tudo de []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "roda o motor [] durante () s", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "roda o motor [] para ali durante () s", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "roda o motor [] para aqui durante () s", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "roda o motor [] rota\u00e7\u00f5es ()", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "se <> ent\u00e3o", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "se estiveres a bater na borda ressalta", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "sen\u00e3o", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "separator", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "sound!adiciona ao teu efeito [] o valor ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false, "displayText": "adiciona ao teu efeito [] o valor ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["tom", "canal esquerdo/direito"]}]}, {"text": "sound!altera o teu efeito [] para ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false, "displayText": "altera o teu efeito [] para ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["tom", "canal esquerdo/direito"]}]}, {"text": "space", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "substitui () de [] por ()", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "toca a nota () durante () s", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "toca a nota () durante () tempos", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "toca a percuss\u00e3o [] durante () tempos", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "DRUM", "isSquare": false, "values": ["Caixa", "Bombo", "Golpe no Fuste da Tarola", "Proto de Ataque", "Pratos de Choque Abertos", "Pratos de Choque Fechados", "tamborine", "Palmas", "claves", "wood block", "Caneca", "triangle", "bongo", "conga", "Caba\u00e7a", "Reco-Reco", "vibraslap", "culca"]}]}, {"text": "vai para a camada []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "FRONT_BACK", "isSquare": true, "values": ["frontal", "traseira"]}]}, {"text": "vai para a posi\u00e7\u00e3o x () y ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "wedo!Quando for inclinado para []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "Quando for inclinado para []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["cima", "para baixo", "esquerda", "direita", "qualquer"]}]}, {"text": "wedo!altera a cor da luz para ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "altera a cor da luz para ()", "clashWithDevice": true}], "values": [{"text": "um valor ao acaso entre () e ()", "frequency": 9, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() + ()", "frequency": 2, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "a direc\u00e7\u00e3o", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "() * ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() - ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() / ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() de []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "[] actual", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "CURRENTMENU", "isSquare": true, "values": ["o ano", "o m\u00eas", "o data", "o dia da semana", "a hora", "o minuto", "o segundo"]}]}, {"text": "[] de ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "OPERATOR", "isSquare": true, "values": ["o valor absoluto", "o ch\u00e3o o maior inteiro n\u00e3o superior", "o tecto menor inteiro n\u00e3o inferior", "a raiz quadrada", "o seno", "o cosseno", "a tangente", "o arco-seno", "o arco-cosseno", "o arco-tangente", "o logaritmo natural", "o lagoritmo", "e^", "10^"]}]}, {"text": "[] de []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "PROPERTY", "isSquare": true, "values": ["o n\u00famero de cen\u00e1rio", "o nome do cen\u00e1rio", "o volume", "o x da tua posi\u00e7\u00e3o", "o y da tua posi\u00e7\u00e3o", "a direc\u00e7\u00e3o", "o n\u00famero do traje", "o nome do traje", "o tamanho"]}, {"name": "OBJECT", "isSquare": false, "values": ["o palco"]}]}, {"text": "[] do v\u00eddeo em []", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "ATTRIBUTE", "isSquare": false, "values": ["o movimento", "a direc\u00e7\u00e3o"]}, {"name": "SUBJECT", "isSquare": false, "values": ["o palco"]}]}, {"text": "a acelera\u00e7\u00e3o []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["x", "y", "z"]}]}, {"text": "a dist\u00e2ncia at\u00e9 []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "DISTANCETOMENU", "isSquare": false, "values": ["o ponteiro do rato"]}]}, {"text": "a for\u00e7a", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true}, {"text": "a jun\u00e7\u00e3o de () com ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "a l\u00edngua", "frequency": 0, "category": "translate", "isExtension": true, "deviceRequired": false}, {"text": "a resposta", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "a tradu\u00e7\u00e3o de () para []", "frequency": 0, "category": "translate", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "LANGUAGE", "isSquare": false, "values": []}]}, {"text": "a velocidade de rota\u00e7\u00e3o []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["x", "y", "z"]}]}, {"text": "boost!a posi\u00e7\u00e3o do motor []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "a posi\u00e7\u00e3o do motor []", "clashWithDevice": true, "dropdowns": [{"name": "MOTOR_REPORTER_ID", "isSquare": false, "values": []}]}, {"text": "boost!o \u00e2ngulo da inclina\u00e7\u00e3o para []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "o \u00e2ngulo da inclina\u00e7\u00e3o para []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION", "isSquare": false, "values": ["cima", "para baixo", "esquerda", "direita", "qualquer"]}]}, {"text": "ev3!a dist\u00e2ncia", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "a dist\u00e2ncia", "clashWithDevice": true}, {"text": "ev3!a posi\u00e7\u00e3o do motor []", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "a posi\u00e7\u00e3o do motor []", "clashWithDevice": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "microbit!o \u00e2ngulo da inclina\u00e7\u00e3o para []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "o \u00e2ngulo da inclina\u00e7\u00e3o para []", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["frontal", "traseira", "esquerda", "direita"]}]}, {"text": "o [] do cen\u00e1rio", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "NUMBER_NAME", "isSquare": true, "values": ["n\u00famero", "nome"]}]}, {"text": "o [] do traje", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "NUMBER_NAME", "isSquare": true, "values": ["n\u00famero", "nome"]}]}, {"text": "o andamento", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "o arredondamento de ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "o brilho", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "o caractere () de ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "o comprimento de ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "o comprimento de []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "o nome de utilizador", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "o n\u00famero de dias desde 2000", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "o n\u00famero do item () em []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "o resto de () a dividir por ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "o tamanho", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "o valor do cron\u00f3metro", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "o volume", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "o volume no microfone", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "o x da posi\u00e7\u00e3o do rato", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "o x da tua posi\u00e7\u00e3o", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "o y da posi\u00e7\u00e3o do rato", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "o y da tua posi\u00e7\u00e3o", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "o \u00e2ngulo de inclina\u00e7\u00e3o para []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["frontal", "traseira", "esquerda", "direita"]}]}, {"text": "wedo!a dist\u00e2ncia", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "a dist\u00e2ncia", "clashWithDevice": true}, {"text": "wedo!o \u00e2ngulo da inclina\u00e7\u00e3o para []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "o \u00e2ngulo da inclina\u00e7\u00e3o para []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION", "isSquare": false, "values": ["cima", "para baixo", "esquerda", "direita"]}]}], "conditions": [{"text": "() = ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() cont\u00e9m ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() gt ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() lt ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "<> e <>", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "<> ou <>", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "[] cont\u00e9m ()", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "a cair", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true}, {"text": "a cor () est\u00e1 a tocar na cor ()", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "a tecla [] est\u00e1 a ser pressionada", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "KEY_OPTION", "isSquare": false, "values": ["espa\u00e7o", "seta para cima", "seta para baixo", "seta para a esquerda", "seta para a direita", "qualquer", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}]}, {"text": "est\u00e1 a ver um tijolo []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "COLOR", "isSquare": false, "values": ["vermelho", "azul", "verde", "amarelo", "branco", "breto", "de qualquer cor"]}]}, {"text": "est\u00e1s a tocar em []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TOUCHINGOBJECTMENU", "isSquare": false, "values": ["o ponteiro do rato", "a borda"]}]}, {"text": "est\u00e1s a tocar na cor ()", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "ev3!o bot\u00e3o [] est\u00e1 a ser pressionado", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "o bot\u00e3o [] est\u00e1 a ser pressionado", "clashWithDevice": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["1", "2", "3", "4"]}]}, {"text": "fa!est\u00e1 inclinado para []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "displayText": "est\u00e1 inclinado para []", "clashWithDevice": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["frontal", "traseira", "esquerda", "direita", "qualquer"]}]}, {"text": "microbit!est\u00e1 inclinado para []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "est\u00e1 inclinado para []", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["frontal", "traseira", "esquerda", "direita", "qualquer"]}]}, {"text": "microbit!o bot\u00e3o [] est\u00e1 a ser pressionado", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "o bot\u00e3o [] est\u00e1 a ser pressionado", "clashWithDevice": true, "dropdowns": [{"name": "BTN", "isSquare": false, "values": ["A", "B", "Any"]}]}, {"text": "o bot\u00e3o do rato est\u00e1 pressionado", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "wedo!est\u00e1 inclinado para []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "est\u00e1 inclinado para []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["cima", "para baixo", "esquerda", "direita", "qualquer"]}]}, {"text": "\u00e9 falso que <>", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}]}, "ptbr": {"blocks": [{"text": "quando bandeira for clicado", "frequency": 413, "category": "events", "isExtension": false, "deviceRequired": false}, {"text": "se <> ent\u00e3o", "frequency": 259, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "mude [] para ()", "frequency": 255, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "espere () seg", "frequency": 233, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "sempre", "frequency": 207, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "mova () passos", "frequency": 206, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "diga () por () segundos", "frequency": 191, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "repita () vezes", "frequency": 132, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "space", "frequency": 113, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "gire direita () graus", "frequency": 101, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "mostre", "frequency": 82, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "quando eu receber []", "frequency": 81, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_OPTION", "isSquare": true, "values": []}]}, {"text": "esconda", "frequency": 79, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "aponte para a dire\u00e7\u00e3o ()", "frequency": 77, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "pergunte () e espere", "frequency": 75, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "aponte para []", "frequency": 66, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TOWARDS", "isSquare": false, "values": ["ponteiro do mouse"]}]}, {"text": "quando eu come\u00e7ar como um clone", "frequency": 63, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "v\u00e1 para []", "frequency": 62, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TO", "isSquare": false, "values": ["posi\u00e7\u00e3o aleat\u00f3ria", "ponteiro do mouse"]}]}, {"text": "transmita []", "frequency": 61, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_INPUT", "isSquare": false, "values": []}]}, {"text": "mude para a fantasia []", "frequency": 54, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "COSTUME", "isSquare": false, "values": []}]}, {"text": "adicione () a y", "frequency": 50, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "crie clone de []", "frequency": 50, "category": "control", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "CLONE_OPTION", "isSquare": false, "values": ["este ator"]}]}, {"text": "apague tudo", "frequency": 48, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "sen\u00e3o", "frequency": 48, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "gire esquerda () graus", "frequency": 47, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "pare []", "frequency": 47, "category": "control", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "STOP_OPTION", "isSquare": true, "values": ["todos", "este script", "outros scripts no ator"]}]}, {"text": "toque o som []", "frequency": 45, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "SOUND_MENU", "isSquare": false, "values": []}]}, {"text": "use a caneta", "frequency": 45, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "toque o som [] at\u00e9 o fim", "frequency": 40, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "SOUND_MENU", "isSquare": false, "values": []}]}, {"text": "quando este ator for clicado", "frequency": 31, "category": "events", "isExtension": false, "deviceRequired": false}, {"text": "defina o efeito [] como ()", "frequency": 30, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["cor", "olho de peixe", "turbilh\u00e3o", "pixelado", "mosaico", "brilho", "fantasma"]}]}, {"text": "apague este clone", "frequency": 28, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "diga ()", "frequency": 26, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "mude a cor da caneta para ()", "frequency": 26, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "espere at\u00e9 que <>", "frequency": 23, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "mude para o cen\u00e1rio []", "frequency": 23, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": false, "values": []}]}, {"text": "pr\u00f3xima fantasia", "frequency": 23, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "adicione () a x", "frequency": 22, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "mude () ao efeito []", "frequency": 17, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["cor", "olho de peixe", "turbilh\u00e3o", "pixelado", "mosaico", "brilho", "fantasma"]}]}, {"text": "mude () no tamanho", "frequency": 17, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "mude x para ()", "frequency": 17, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "mude o tamanho da caneta para ()", "frequency": 16, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "pr\u00f3ximo cen\u00e1rio", "frequency": 16, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "esconda a vari\u00e1vel []", "frequency": 15, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "quando o cen\u00e1rio mudar para []", "frequency": 14, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": true, "values": []}]}, {"text": "levante a caneta", "frequency": 13, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "deslize por () segs. at\u00e9 []", "frequency": 11, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TO", "isSquare": false, "values": ["posi\u00e7\u00e3o aleat\u00f3ria", "ponteiro do mouse"]}]}, {"text": "events!quando a tecla [] for pressionada", "frequency": 11, "category": "events", "isExtension": false, "deviceRequired": false, "displayText": "quando a tecla [] for pressionada", "clashWithDevice": true, "dropdowns": [{"name": "KEY_OPTION", "isSquare": true, "values": ["espa\u00e7o", "seta para cima", "seta para baixo", "seta para esquerda", "seta para direita", "qualquer", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}]}, {"text": "makey!quando a tecla [] for pressionada", "frequency": 11, "category": "makey", "isExtension": true, "deviceRequired": true, "displayText": "quando a tecla [] for pressionada", "clashWithDevice": true, "dropdowns": [{"name": "KEY", "isSquare": false, "values": ["espa\u00e7o", "seta para cima", "seta para baixo", "seta para esquerda", "seta para direita", "w", "a", "s", "d", "f", "g"]}]}, {"text": "mude y para ()", "frequency": 11, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "transmita [] e espere", "frequency": 10, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_INPUT", "isSquare": false, "values": []}]}, {"text": "carimbe", "frequency": 9, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "mostre a vari\u00e1vel []", "frequency": 9, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "pense () por () segundos", "frequency": 8, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "remova os efeitos gr\u00e1ficos", "frequency": 8, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "pare todos os sons", "frequency": 7, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "repita at\u00e9 que <>", "frequency": 7, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "defina modo de arrasto para []", "frequency": 6, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "DRAG_MODE", "isSquare": true, "values": ["arrast\u00e1vel", "n\u00e3o arrast\u00e1vel"]}]}, {"text": "defina o estilo de rota\u00e7\u00e3o para []", "frequency": 6, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "STYLE", "isSquare": true, "values": ["esquerda-direita", "n\u00e3o rotacionar", "rota\u00e7\u00e3o completa"]}]}, {"text": "mude () no efeito []", "frequency": 6, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["tom", "balan\u00e7o esquerda/direita"]}]}, {"text": "mude volume em ()", "frequency": 6, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "pense ()", "frequency": 6, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "v\u00e1 para x () y ()", "frequency": 6, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "adicione () ao tamanho da caneta", "frequency": 5, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "quando [] gt ()", "frequency": 5, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "WHENGREATERTHANMENU", "isSquare": true, "values": ["ruido", "cron\u00f3metro"]}]}, {"text": "remova os efeitos sonoros", "frequency": 5, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "zere o cron\u00f4metro", "frequency": 5, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "mude o efeito [] para ()", "frequency": 4, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["tom", "balan\u00e7o esquerda/direita"]}]}, {"text": "defina o tamanho como ()", "frequency": 3, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "apague () de []", "frequency": 1, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "apague todos os itens de []", "frequency": 1, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "defina o idioma como []", "frequency": 1, "category": "speech", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "LANGUAGE", "isSquare": false, "values": ["arabic", "chinese", "chinese mandarin", "chinese mandarin", "danish", "dutch", "english", "french", "german", "hindi", "icelandic", "italian", "japanese", "korean", "norwegian", "polish", "portuguese brazilian", "portuguese", "romanian", "russian", "spanish", "spanish latin american", "swedish", "turkish", "welsh"]}]}, {"text": "deslize por () segs. at\u00e9 x () y ()", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "esconda a lista []", "frequency": 1, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "falar ()", "frequency": 1, "category": "speech", "isExtension": true, "deviceRequired": false}, {"text": "insira () na posi\u00e7\u00e3o () de []", "frequency": 1, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "mostre a lista []", "frequency": 1, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "substitua o item () de [] por ()", "frequency": 1, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "V\u00e1 para [] () camadas", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "FORWARD_BACKWARD", "isSquare": true, "values": ["para frente", "tr\u00e1s"]}]}, {"text": "V\u00e1 para a camada []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "FRONT_BACK", "isSquare": true, "values": ["de frente", "de tr\u00e1s"]}]}, {"text": "adicione [] () da caneta", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "COLOR_PARAM", "isSquare": false, "values": ["a cor", "a satura\u00e7\u00e3o", "ao brilho", "a transpar\u00eancia"]}]}, {"text": "ajuste ritmo para ()", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "ajuste transpar\u00eancia do v\u00eddeo para ()", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false}, {"text": "alterar ritmo por ()", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "boost!defina a cor como ()", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "defina a cor como ()", "clashWithDevice": true}, {"text": "boost!desligue o motor []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "desligue o motor []", "clashWithDevice": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "boost!ligue o motor []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "ligue o motor []", "clashWithDevice": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "boost!ligue o motor [] por () segundos", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "ligue o motor [] por () segundos", "clashWithDevice": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "boost!quando inclinado para []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "quando inclinado para []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["para cima", "baixo", "esquerda", "direita", "qualquer"]}]}, {"text": "defina a dire\u00e7\u00e3o de [] como []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "todos os motores"]}, {"name": "MOTOR_DIRECTION", "isSquare": false, "values": ["por aqui", "por ai", "inverter"]}]}, {"text": "defina a pot\u00eancia de [] como ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "todos os motores"]}]}, {"text": "defina pot\u00eancia do motor [] em ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "definir voz para []", "frequency": 0, "category": "speech", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "VOICE", "isSquare": false, "values": ["loud", "tenor", "rangido", "gigante", "gatinho"]}]}, {"text": "exiba []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MATRIX", "isSquare": false, "values": ["[ox]", "[01]{25}"]}]}, {"text": "exiba o texto ()", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true}, {"text": "fa!quando []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "displayText": "quando []", "clashWithDevice": true, "dropdowns": [{"name": "GESTURE", "isSquare": false, "values": ["agitou", "come\u00e7ar a cair", "virado para cima", "virado para baixo"]}]}, {"text": "gire o motor [] naquele sentido por () segundos", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "gire o motor [] nesse sentido por () segundos", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "ligue o motor [] por () rota\u00e7\u00f5es", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "limpe a tela", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true}, {"text": "list!adicione () a []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "displayText": "adicione () a []", "clashWithDevice": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "microbit!quando []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "quando []", "clashWithDevice": true, "dropdowns": [{"name": "GESTURE", "isSquare": false, "values": ["moveu", "agitou", "pulou"]}]}, {"text": "microbit!quando inclinado para []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "quando inclinado para []", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["de frente", "de tr\u00e1s", "esquerda", "direita", "qualquer"]}]}, {"text": "mudar instrumento para []", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "INSTRUMENT", "isSquare": false, "values": ["Piano", "Teclado", "\u00d3rg\u00e3o", "Viol\u00e3o", "Guitarra El\u00e9trica", "Baixo", "pizzicato", "Violoncelo", "trombone", "carinet", "Saxofone", "Flauta", "wodden flute", "Fagote", "Coral", "vibraphone", "Caixa de M\u00fasica", "Tambor de A\u00e7o", "marimba", "synth lead", "synth pad"]}]}, {"text": "mude [] da caneta para ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "COLOR_PARAM", "isSquare": false, "values": ["a cor", "a satura\u00e7\u00e3o", "ao brilho", "a transpar\u00eancia"]}]}, {"text": "mude a dire\u00e7\u00e3o do motor [] para []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}, {"name": "MOTOR_DIRECTION", "isSquare": false, "values": ["por aqui", "por ai", "inverter"]}]}, {"text": "mude a velocidade do motor [] para ()", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "mude o volume para ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "mude para o cen\u00e1rio [] e espere", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": false, "values": []}]}, {"text": "mude v\u00eddeo []", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "VIDEO_STATE", "isSquare": false, "values": ["ligado", "desligado", "inverter"]}]}, {"text": "pausa por () batidas", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "quando [] forem pressionados em ordem", "frequency": 0, "category": "makey", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "SEQUENCE", "isSquare": false, "values": ["esquerda para cima direita", "direita para cima esquerda", "esquerda direita", "direita esquerda", "para cima baixo", "baixo para cima", "para cima direita baixo esquerda", "para cima esquerda baixo direita", "para cima para cima baixo baixo esquerda direita esquerda direita"]}]}, {"text": "quando bot\u00e3o [] estiver pressionado", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["1", "2", "3", "4"]}]}, {"text": "quando brilho lt ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "quando dist\u00e2ncia [] ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "OP", "isSquare": false, "values": ["lt", "gt"]}]}, {"text": "quando dist\u00e2ncia lt ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "quando intitulado []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["de frente", "de tr\u00e1s", "esquerda", "direita", "qualquer"]}]}, {"text": "quando o bot\u00e3o [] estiver pressionado", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "BTN", "isSquare": false, "values": ["A", "B", "Any"]}]}, {"text": "quando o pino [] estiver conectado", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PIN", "isSquare": false, "values": ["0", "1", "2"]}]}, {"text": "quando o sensor de for\u00e7a estiver sendo []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PUSH_PULL", "isSquare": false, "values": ["empurrado", "puxado"]}]}, {"text": "quando um tijolo [] for visto", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "COLOR", "isSquare": false, "values": ["vermelho", "azul", "verde", "amarelo", "branco", "preto", "qualquer cor"]}]}, {"text": "quanto detectar sensor de v\u00eddeo gt ()", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false}, {"text": "se tocar na borda volte", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "separator", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "som de bip () por () segundos", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "toque a nota () por () batidas", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "toque instrumento [] por () batidas", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "DRUM", "isSquare": false, "values": ["Tarol", "Bumbo", "Bast\u00e3o Lateral", "Prato", "Prato Hi-Hat", "Prato Chimbau", "tamborine", "Palmas", "Claves Cubanas", "wood block", "Chocalho", "triangle", "Bong\u00f4", "conga", "Afox\u00e9", "Guiro", "Queixada", "culca"]}]}, {"text": "variables!adicione () a []", "frequency": 0, "category": "variables", "isExtension": false, "deviceRequired": false, "displayText": "adicione () a []", "clashWithDevice": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "wedo!defina a cor como ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "defina a cor como ()", "clashWithDevice": true}, {"text": "wedo!desligue o motor []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "desligue o motor []", "clashWithDevice": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "todos os motores"]}]}, {"text": "wedo!ligue o motor []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "ligue o motor []", "clashWithDevice": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "todos os motores"]}]}, {"text": "wedo!ligue o motor [] por () segundos", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "ligue o motor [] por () segundos", "clashWithDevice": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "todos os motores"]}]}, {"text": "wedo!quando inclinado para []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "quando inclinado para []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["para cima", "baixo", "esquerda", "direita", "qualquer"]}]}], "values": [{"text": "n\u00famero aleat\u00f3rio entre () e ()", "frequency": 143, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() / ()", "frequency": 55, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() * ()", "frequency": 52, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "resposta", "frequency": 52, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "dire\u00e7\u00e3o", "frequency": 22, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "junte () com ()", "frequency": 20, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "arredondamento de ()", "frequency": 14, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "ev3!dist\u00e2ncia", "frequency": 12, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "dist\u00e2ncia", "clashWithDevice": true}, {"text": "posi\u00e7\u00e3o y", "frequency": 12, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "wedo!dist\u00e2ncia", "frequency": 12, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "dist\u00e2ncia", "clashWithDevice": true}, {"text": "() - ()", "frequency": 11, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "fantasia []", "frequency": 10, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "NUMBER_NAME", "isSquare": true, "values": ["n\u00famero", "nome"]}]}, {"text": "letra () de ()", "frequency": 10, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "posi\u00e7\u00e3o x", "frequency": 10, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "() + ()", "frequency": 9, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "tamanho", "frequency": 9, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "[] atual", "frequency": 6, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "CURRENTMENU", "isSquare": true, "values": ["ano", "m\u00eas", "data", "dia da semana", "hora", "minuto", "segundo"]}]}, {"text": "ru\u00eddo", "frequency": 6, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "cen\u00e1rio []", "frequency": 5, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "NUMBER_NAME", "isSquare": true, "values": ["n\u00famero", "nome"]}]}, {"text": "tamanho de ()", "frequency": 5, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "[] de ()", "frequency": 4, "category": "operators", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "OPERATOR", "isSquare": true, "values": ["m\u00f4dulo", "arredondamento para baixo de", "arredondamento para cima de", "raiz quadrada", "sen", "cos", "tg", "arcsen", "arccos", "arctg", "ln", "logaritmo", "e^", "10^"]}]}, {"text": "resto de () por ()", "frequency": 4, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "volume", "frequency": 4, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "[] de []", "frequency": 3, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "PROPERTY", "isSquare": true, "values": ["n\u00b0 do cen\u00e1rio", "nome de cen\u00e1rio", "volume", "posi\u00e7\u00e3o x", "posi\u00e7\u00e3o y", "dire\u00e7\u00e3o", "n\u00famero da fantasia", "nome da fantasia", "tamanho"]}, {"name": "OBJECT", "isSquare": false, "values": ["palco"]}]}, {"text": "brilho", "frequency": 3, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "cron\u00f4metro", "frequency": 3, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "dist\u00e2ncia at\u00e9 []", "frequency": 3, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "DISTANCETOMENU", "isSquare": false, "values": ["ponteiro do mouse"]}]}, {"text": "nome de usu\u00e1rio", "frequency": 3, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "n\u00famero de dias desde 2000", "frequency": 3, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "posi\u00e7\u00e3o x do mouse", "frequency": 3, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "posi\u00e7\u00e3o y do mouse", "frequency": 3, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "item # de () em []", "frequency": 1, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "item () de []", "frequency": 1, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "tamanho de []", "frequency": 1, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "traduzir () para []", "frequency": 1, "category": "translate", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "LANGUAGE", "isSquare": false, "values": []}]}, {"text": "acelera\u00e7\u00e3o []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["x", "y", "z"]}]}, {"text": "boost!posi\u00e7\u00e3o do motor []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "posi\u00e7\u00e3o do motor []", "clashWithDevice": true, "dropdowns": [{"name": "MOTOR_REPORTER_ID", "isSquare": false, "values": []}]}, {"text": "boost!\u00e2ngulo de inclina\u00e7\u00e3o []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "\u00e2ngulo de inclina\u00e7\u00e3o []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION", "isSquare": false, "values": ["para cima", "baixo", "esquerda", "direita", "qualquer"]}]}, {"text": "ev3!posi\u00e7\u00e3o do motor []", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "posi\u00e7\u00e3o do motor []", "clashWithDevice": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "for\u00e7a", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true}, {"text": "idioma", "frequency": 0, "category": "translate", "isExtension": true, "deviceRequired": false}, {"text": "inclinar \u00e2ngulo []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["de frente", "de tr\u00e1s", "esquerda", "direita"]}]}, {"text": "ritmo", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "velocidade de rota\u00e7\u00e3o []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["x", "y", "z"]}]}, {"text": "v\u00eddeo [] para []", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "ATTRIBUTE", "isSquare": false, "values": ["movimento", "dire\u00e7\u00e3o"]}, {"name": "SUBJECT", "isSquare": false, "values": ["palco"]}]}, {"text": "wedo!\u00e2ngulo de inclina\u00e7\u00e3o []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "\u00e2ngulo de inclina\u00e7\u00e3o []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION", "isSquare": false, "values": ["para cima", "baixo", "esquerda", "direita"]}]}, {"text": "\u00e2ngulo de inclina\u00e7\u00e3o para []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["de frente", "de tr\u00e1s", "esquerda", "direita"]}]}], "conditions": [{"text": "() = ()", "frequency": 42, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() gt ()", "frequency": 17, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "<> ou <>", "frequency": 15, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "tocando na cor ()", "frequency": 12, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "() lt ()", "frequency": 9, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "tecla [] pressionada", "frequency": 8, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "KEY_OPTION", "isSquare": false, "values": ["espa\u00e7o", "seta para cima", "seta para baixo", "seta para esquerda", "seta para direita", "qualquer", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}]}, {"text": "<> e <>", "frequency": 7, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "n\u00e3o <>", "frequency": 6, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "tocando em []", "frequency": 1, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TOUCHINGOBJECTMENU", "isSquare": false, "values": ["ponteiro do mouse", "borda"]}]}, {"text": "() cont\u00e9m ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "[] cont\u00e9m ()", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "a cor () est\u00e1 tocando na cor ()", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "caindo", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true}, {"text": "ev3!bot\u00e3o [] pressionado", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "bot\u00e3o [] pressionado", "clashWithDevice": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["1", "2", "3", "4"]}]}, {"text": "intitulado []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["de frente", "de tr\u00e1s", "esquerda", "direita", "qualquer"]}]}, {"text": "microbit!bot\u00e3o [] pressionado", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "bot\u00e3o [] pressionado", "clashWithDevice": true, "dropdowns": [{"name": "BTN", "isSquare": false, "values": ["A", "B", "Any"]}]}, {"text": "microbit!inclinado para []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "inclinado para []", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["de frente", "de tr\u00e1s", "esquerda", "direita", "qualquer"]}]}, {"text": "mouse pressionado", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "vendo tijolo []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "COLOR", "isSquare": false, "values": ["vermelho", "azul", "verde", "amarelo", "branco", "preto", "qualquer cor"]}]}, {"text": "wedo!inclinado para []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "inclinado para []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["para cima", "baixo", "esquerda", "direita", "qualquer"]}]}]}, "de": {"blocks": [{"text": "setze [] auf ()", "frequency": 35, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "wiederhole () mal", "frequency": 18, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "sonst", "frequency": 12, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "\u00e4ndere y um ()", "frequency": 11, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "sende [] an alle", "frequency": 10, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_INPUT", "isSquare": false, "values": []}]}, {"text": "\u00e4ndere [] um ()", "frequency": 10, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "frage () und warte", "frequency": 9, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "verstecke dich", "frequency": 4, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "stoppe []", "frequency": 3, "category": "control", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "STOP_OPTION", "isSquare": true, "values": ["alles", "dieses Skript", "andere Skripte der Figur"]}]}, {"text": "l\u00f6sche alles", "frequency": 2, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "wiederhole bis <>", "frequency": 2, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "wiederhole fortlaufend", "frequency": 2, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "\u00e4ndere x um ()", "frequency": 2, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "warte bis <>", "frequency": 1, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "zeige dich", "frequency": 1, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "Schalte Motor [] aus", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "Schalte Motor [] ein", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "Schalte Motor [] f\u00fcr () Sekunden ein", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "Schalte Motor [] f\u00fcr () Umdrehungen ein", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "Setze Richtung von Motor [] auf []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}, {"name": "MOTOR_DIRECTION", "isSquare": false, "values": ["rechtsherum", "linksherum", "andersherum"]}]}, {"text": "Setze von Motor [] die Geschwindigkeit auf ()", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "Wenn Abstand [] ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "OP", "isSquare": false, "values": ["lt", "gt"]}]}, {"text": "Wenn Abstand lt ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "Wenn Flagge angeklickt wird", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false}, {"text": "Wenn Helligkeit lt ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "Wenn Knopf [] gedr\u00fcckt wird", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "BTN", "isSquare": false, "values": ["A", "B", "Any"]}]}, {"text": "Wenn Kraftsensor []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PUSH_PULL", "isSquare": false, "values": ["gedr\u00fcckt", "gezogen"]}]}, {"text": "Wenn Pin [] angeschlossen ist", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PIN", "isSquare": false, "values": ["0", "1", "2"]}]}, {"text": "Wenn Taste [] gedr\u00fcckt", "frequency": 0, "category": "makey", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "KEY", "isSquare": false, "values": ["Leertaste", "Pfeil nach oben", "Pfeil nach unten", "Pfeil nach links", "Pfeil nach rechts", "w", "a", "s", "d", "f", "g"]}]}, {"text": "Wenn Taste [] gedr\u00fcckt wird", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "KEY_OPTION", "isSquare": true, "values": ["Leertaste", "Pfeil nach oben", "Pfeil nach unten", "Pfeil nach links", "Pfeil nach rechts", "beliebiges", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}]}, {"text": "Wenn Video-Bewegung gt ()", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false}, {"text": "Wenn [] der Reihe nach gedr\u00fcckt", "frequency": 0, "category": "makey", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "SEQUENCE", "isSquare": false, "values": ["links nach oben nach rechts", "rechts nach oben nach links", "link nach rechts", "rechts nach links", "oben nach unten", "unten nach oben", "oben nach rechts nach unten nach links", "oben nach links nach unten nach rechts", "oben nach oben nach unten nach unten nach links nach rechts nach links nach rechts"]}]}, {"text": "Wenn [] gesehen wird", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "COLOR", "isSquare": false, "values": ["Rot", "Blau", "Gr\u00fcn", "Gelb", "Weiss", "Schwarz", "Irgendeine Farbe"]}]}, {"text": "Wenn [] gt ()", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "WHENGREATERTHANMENU", "isSquare": true, "values": ["Lautst\u00e4rke", "Stoppuhr"]}]}, {"text": "Wenn das B\u00fchnenbild zu [] wechselt", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": true, "values": []}]}, {"text": "Wenn der Knopf [] gedr\u00fcckt wird", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["1", "2", "3", "4"]}]}, {"text": "Wenn diese Figur angeklickt wird", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false}, {"text": "Wenn geneigt []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["vorderster", "hinterster", "links", "rechts", "beliebiges"]}]}, {"text": "Wenn ich [] empfange", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_OPTION", "isSquare": true, "values": []}]}, {"text": "Wenn ich als Klon entstehe", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "boost!Wenn [] geneigt", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "Wenn [] geneigt", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["oben", "unten", "links", "rechts", "beliebiges"]}]}, {"text": "boost!setze Lichtfarbe auf ()", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "setze Lichtfarbe auf ()", "clashWithDevice": true}, {"text": "denke ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "denke () f\u00fcr () Sekunden", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "drehe Motor [] f\u00fcr () Sekunden linksherum", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "drehe Motor [] f\u00fcr () Sekunden rechtsherum", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "drehe dich links um () Grad", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "drehe dich rechts um () Grad", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "drehe dich zu []", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TOWARDS", "isSquare": false, "values": ["Mauszeiger"]}]}, {"text": "ersetze Element () von [] durch ()", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "erzeuge Klon von []", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "CLONE_OPTION", "isSquare": false, "values": ["mir selbst"]}]}, {"text": "fa!Wenn []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "displayText": "Wenn []", "clashWithDevice": true, "dropdowns": [{"name": "GESTURE", "isSquare": false, "values": ["geschuttelt", "begonnen zu fallen", "nach oben gerichtet", "nach unten gerichtet"]}]}, {"text": "falls <> dann", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "f\u00fcge () bei () in [] ein", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "f\u00fcge () zu [] hinzu", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "gehe () Ebenen nach []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "FORWARD_BACKWARD", "isSquare": true, "values": ["vorne", "hinten"]}]}, {"text": "gehe () er Schritt", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "gehe zu []", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TO", "isSquare": false, "values": ["Zufallsposition", "Mauszeiger"]}]}, {"text": "gehe zu [] Ebene", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "FRONT_BACK", "isSquare": true, "values": ["vorderster", "hinterster"]}]}, {"text": "gehe zu x () y ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "gleite in () Sek. zu []", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TO", "isSquare": false, "values": ["Zufallsposition", "Mauszeiger"]}]}, {"text": "gleite in () Sek. zu x () y ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "hinterlasse Abdruck", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "looks!sage ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "displayText": "sage ()", "clashWithDevice": false}, {"text": "looks!setze Effekt [] auf ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "displayText": "setze Effekt [] auf ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["Farbe", "Fischauge", "Wirbel", "Pixel", "Mosaik", "Helligkeit", "Durchsichtigkeit"]}]}, {"text": "looks!\u00e4ndere Effekt [] um ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "displayText": "\u00e4ndere Effekt [] um ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["Farbe", "Fischauge", "Wirbel", "Pixel", "Mosaik", "Helligkeit", "Durchsichtigkeit"]}]}, {"text": "l\u00f6sche () aus []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "l\u00f6sche alles aus []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "l\u00f6sche diesen Klon", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "microbit!Wenn []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "Wenn []", "clashWithDevice": true, "dropdowns": [{"name": "GESTURE", "isSquare": false, "values": ["bewegt", "geschuttelt", "hochgeh\u00fcpft"]}]}, {"text": "microbit!Wenn [] geneigt", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "Wenn [] geneigt", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["vorderster", "hinterster", "links", "rechts", "beliebiges"]}]}, {"text": "pausiere () Schl\u00e4ge", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "piepse Note () f\u00fcr () Sek.", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "pralle vom Rand ab", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "sage () f\u00fcr () Sekunden", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "schalte Grafikeffekte aus", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "schalte Klangeffekte aus", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "schalte Stift aus", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "schalte Stift ein", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "schalte Video []", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "VIDEO_STATE", "isSquare": false, "values": ["an", "aus", "auf gespiegelt"]}]}, {"text": "schalte [] an", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "alle Motoren"]}]}, {"text": "schalte [] aus", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "alle Motoren"]}]}, {"text": "schalte [] f\u00fcr () Sekunden an", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "alle Motoren"]}]}, {"text": "sende [] an alle und warte", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_INPUT", "isSquare": false, "values": []}]}, {"text": "separator", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "setze Drehtyp auf []", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "STYLE", "isSquare": true, "values": ["links-rechts", "nicht drehen", "rundherum"]}]}, {"text": "setze Gr\u00f6\u00dfe auf ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "setze Instrument auf []", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "INSTRUMENT", "isSquare": false, "values": ["Klavier", "E-Piano", "Orgel", "Gitarre", "E-Gitarre", "Bass-Gitarre", "pizzicato", "cello", "Posaune", "carinet", "Saxophon", "Querfl\u00f6te", "wodden flute", "Fagott", "Chor", "Vibraphon", "Musikbox", "Steel-Drum", "marimba", "Lead-Synthesizer", "Pan Synthesizer"]}]}, {"text": "setze Lautst\u00e4rke auf ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "setze Leistung von Motor [] auf ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "setze Leistung von [] auf ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "alle Motoren"]}]}, {"text": "setze Richtung auf () Grad", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "setze Richtung von [] auf []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "alle Motoren"]}, {"name": "MOTOR_DIRECTION", "isSquare": false, "values": ["rechtsherum", "linksherum", "andersherum"]}]}, {"text": "setze Sprache auf []", "frequency": 0, "category": "speech", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "LANGUAGE", "isSquare": false, "values": ["Arabisch", "chinese", "Chinesisch Mandarin", "Chinesisch Mandarin", "D\u00e4nisch", "Niederl\u00e4ndisch", "Englisch", "Franz\u00f6sisch", "Deutsch", "hindi", "Isl\u00e4ndisch", "Italienisch", "Japanisch", "Koreanisch", "Norwegisch", "Polnisch", "Portugiesisch Brasilianisch", "Portugiesisch", "Rum\u00e4nisch", "Russisch", "Spanisch", "Spanisch Lateinamerikanisch", "Schwedisch", "T\u00fcrkisch", "Walisisch"]}]}, {"text": "setze Stift [] auf ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "COLOR_PARAM", "isSquare": false, "values": ["Farbe", "S\u00e4ttigung", "Helligkeit", "Transparenz"]}]}, {"text": "setze Stiftdicke auf ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "setze Stiftfarbe auf ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "setze Stoppuhr zur\u00fcck", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "setze Tempo auf ()", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "setze Video-Transparenz auf ()", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false}, {"text": "setze Ziehbarkeit auf []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "DRAG_MODE", "isSquare": true, "values": ["ziehbar", "nicht ziehbar"]}]}, {"text": "setze x auf ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "setze y auf ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "sound!setze Effekt [] auf ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false, "displayText": "setze Effekt [] auf ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["H\u00f6he", "Aussteuern links/rechts"]}]}, {"text": "sound!\u00e4ndere Effekt [] um ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false, "displayText": "\u00e4ndere Effekt [] um ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["H\u00f6he", "Aussteuern links/rechts"]}]}, {"text": "space", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "speech!sage ()", "frequency": 0, "category": "speech", "isExtension": true, "deviceRequired": false, "displayText": "sage ()", "clashWithDevice": false}, {"text": "spiele Klang []", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "SOUND_MENU", "isSquare": false, "values": []}]}, {"text": "spiele Klang [] ganz", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "SOUND_MENU", "isSquare": false, "values": []}]}, {"text": "spiele Schlaginstrument [] f\u00fcr () Schl\u00e4ge", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "DRUM", "isSquare": false, "values": ["Snare-Drum", "Basstrommel", "Side-Stick", "Crash-Becken", "Offene Hi-Hat", "Geschlossene Hi-Hat", "Tamburin", "Klatschen", "Klangst\u00e4be", "Holzblock", "Kuhglocke", "Triangel", "bongo", "Konga", "cabasa", "G\u00fciro", "vibraslap", "culca"]}]}, {"text": "spiele Ton () f\u00fcr () Schl\u00e4ge", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "stoppe alle Kl\u00e4nge", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "verstecke Liste []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "verstecke Variable []", "frequency": 0, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "warte () Sekunden", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "wechsle zu B\u00fchnenbild []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": false, "values": []}]}, {"text": "wechsle zu B\u00fchnenbild [] und warte", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": false, "values": []}]}, {"text": "wechsle zu Kost\u00fcm []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "COSTUME", "isSquare": false, "values": []}]}, {"text": "wechsle zum n\u00e4chsten B\u00fchnenbild", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "wechsle zum n\u00e4chsten Kost\u00fcm", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "wedo!Wenn [] geneigt", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "Wenn [] geneigt", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["oben", "unten", "links", "rechts", "beliebiges"]}]}, {"text": "wedo!setze Lichtfarbe auf ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "setze Lichtfarbe auf ()", "clashWithDevice": true}, {"text": "zeige Liste []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "zeige Text () an", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true}, {"text": "zeige Variable []", "frequency": 0, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "zeige [] an", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MATRIX", "isSquare": false, "values": ["[ox]", "[01]{25}"]}]}, {"text": "zeige nichts an", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true}, {"text": "\u00e4ndere Gr\u00f6\u00dfe um ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "\u00e4ndere Lautst\u00e4rke um ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "\u00e4ndere Stift [] um ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "COLOR_PARAM", "isSquare": false, "values": ["Farbe", "S\u00e4ttigung", "Helligkeit", "Transparenz"]}]}, {"text": "\u00e4ndere Stiftdicke um ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "\u00e4ndere Tempo um ()", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "\u00e4ndere die Stimme zu []", "frequency": 0, "category": "speech", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "VOICE", "isSquare": false, "values": ["Alt", "Tenor", "Quietschen", "Riese", "K\u00e4tzchen"]}]}], "values": [{"text": "() * ()", "frequency": 3, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() + ()", "frequency": 3, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() / ()", "frequency": 2, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "verbinde () und ()", "frequency": 2, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() - ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() gerundet", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() mod ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "Antwort", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "Benutzername", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "Beschleunigung []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["x", "y", "z"]}]}, {"text": "B\u00fchnenbild []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "NUMBER_NAME", "isSquare": true, "values": ["Nummer", "Name"]}]}, {"text": "Element () von []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "Entfernung von []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "DISTANCETOMENU", "isSquare": false, "values": ["Mauszeiger"]}]}, {"text": "Gr\u00f6\u00dfe", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "Helligkeit", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "Kost\u00fcm []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "NUMBER_NAME", "isSquare": true, "values": ["Nummer", "Name"]}]}, {"text": "Kraft", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true}, {"text": "L\u00e4nge von ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "L\u00e4nge von []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "Maus x-Position", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "Maus y-Position", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "Nummer von () in []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "Position des Motors []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_REPORTER_ID", "isSquare": false, "values": []}]}, {"text": "Position von Motor []", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "Richtung", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "Rotationsgeschwindigkeit []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["x", "y", "z"]}]}, {"text": "Sprache", "frequency": 0, "category": "translate", "isExtension": true, "deviceRequired": false}, {"text": "Stoppuhr", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "Tage seit 2000", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "Tempo", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "Video- [] von []", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "ATTRIBUTE", "isSquare": false, "values": ["Bewegung", "Richtung"]}, {"name": "SUBJECT", "isSquare": false, "values": ["B\u00fchne"]}]}, {"text": "Zeichen () von ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "Zufallszahl von () bis ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "[] von ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "OPERATOR", "isSquare": true, "values": ["Betrag", "aabrunden", "aufrunden", "Wurzel", "sin", "cos", "tan", "asin", "acos", "atan", "ln", "log", "e^", "10^"]}]}, {"text": "[] von []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "PROPERTY", "isSquare": true, "values": ["B\u00fchnenbildnummer", "B\u00fchnenbildname", "Lautst\u00e4rke", "x-Position", "y-Position", "Richtung", "Kost\u00fcmnummer", "Kost\u00fcmname", "Gr\u00f6\u00dfe"]}, {"name": "OBJECT", "isSquare": false, "values": ["B\u00fchne"]}]}, {"text": "boost!Neigungswinkel []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "Neigungswinkel []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION", "isSquare": false, "values": ["oben", "unten", "links", "rechts", "beliebiges"]}]}, {"text": "ev3!Abstand", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "Abstand", "clashWithDevice": true}, {"text": "fa!Neigungswinkel []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "displayText": "Neigungswinkel []", "clashWithDevice": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["vorderster", "hinterster", "links", "rechts"]}]}, {"text": "im Moment []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "CURRENTMENU", "isSquare": true, "values": ["Jahr", "Monat", "Datum", "Wochentag", "Stunde", "Minute", "Sekunde"]}]}, {"text": "microbit!Neigungswinkel []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "Neigungswinkel []", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["vorderster", "hinterster", "links", "rechts"]}]}, {"text": "sensing!Lautst\u00e4rke", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "displayText": "Lautst\u00e4rke", "clashWithDevice": false}, {"text": "sound!Lautst\u00e4rke", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false, "displayText": "Lautst\u00e4rke", "clashWithDevice": false}, {"text": "wedo!Abstand", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "Abstand", "clashWithDevice": true}, {"text": "wedo!Neigungswinkel []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "Neigungswinkel []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION", "isSquare": false, "values": ["oben", "unten", "links", "rechts"]}]}, {"text": "x-Position", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "y-Position", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "\u00fcbersetze () nach []", "frequency": 0, "category": "translate", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "LANGUAGE", "isSquare": false, "values": []}]}], "conditions": [{"text": "() = ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() enth\u00e4lt ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() gt ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() lt ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "<> oder <>", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "<> und <>", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "Farbe () ber\u00fchrt ()", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "Maustaste gedr\u00fcckt", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "Sehe Farbe []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "COLOR", "isSquare": false, "values": ["Rot", "Blau", "Gr\u00fcn", "Gelb", "Weiss", "Schwarz", "Irgendeine Farbe"]}]}, {"text": "Taste [] gedr\u00fcckt", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "KEY_OPTION", "isSquare": false, "values": ["Leertaste", "Pfeil nach oben", "Pfeil nach unten", "Pfeil nach links", "Pfeil nach rechts", "beliebiges", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}]}, {"text": "[] enth\u00e4lt ()", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "ev3!Knopf [] gedr\u00fcckt", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "Knopf [] gedr\u00fcckt", "clashWithDevice": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["1", "2", "3", "4"]}]}, {"text": "fallend", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true}, {"text": "geneigt []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["vorderster", "hinterster", "links", "rechts", "beliebiges"]}]}, {"text": "microbit!Knopf [] gedr\u00fcckt", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "Knopf [] gedr\u00fcckt", "clashWithDevice": true, "dropdowns": [{"name": "BTN", "isSquare": false, "values": ["A", "B", "Any"]}]}, {"text": "microbit![] geneigt", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "[] geneigt", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["vorderster", "hinterster", "links", "rechts", "beliebiges"]}]}, {"text": "nicht <>", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "wedo![] geneigt", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "[] geneigt", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["oben", "unten", "links", "rechts", "beliebiges"]}]}, {"text": "wird Farbe () ber\u00fchrt", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "wird [] ber\u00fchrt", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TOUCHINGOBJECTMENU", "isSquare": false, "values": ["Mauszeiger", "Rand"]}]}]}, "es": {"blocks": [{"text": "dar a [] el valor ()", "frequency": 42, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "al hacer clic en la bandera", "frequency": 41, "category": "events", "isExtension": false, "deviceRequired": false}, {"text": "si <> entonces", "frequency": 31, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "mover () pasos", "frequency": 27, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "por siempre", "frequency": 23, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "al recibir []", "frequency": 18, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_OPTION", "isSquare": true, "values": []}]}, {"text": "esconder", "frequency": 18, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "preguntar () y esperar", "frequency": 14, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "mostrar", "frequency": 12, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "apuntar en direcci\u00f3n ()", "frequency": 9, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "sumar a [] ()", "frequency": 9, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "detener []", "frequency": 8, "category": "control", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "STOP_OPTION", "isSquare": true, "values": ["todos", "este programa", "otros programas en el objeto"]}]}, {"text": "esperar () segundos", "frequency": 8, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "repetir ()", "frequency": 8, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "cambiar fondo a []", "frequency": 6, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": false, "values": []}]}, {"text": "enviar []", "frequency": 6, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_INPUT", "isSquare": false, "values": []}]}, {"text": "girar a la derecha () grados", "frequency": 6, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "ir a []", "frequency": 5, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TO", "isSquare": false, "values": ["posici\u00f3n aleatoria", "puntero del rot\u00f3n"]}]}, {"text": "siguiente disfraz", "frequency": 5, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "looks!decir ()", "frequency": 4, "category": "looks", "isExtension": false, "deviceRequired": false, "displayText": "decir ()", "clashWithDevice": false}, {"text": "repetir hasta que <>", "frequency": 4, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "speech!decir ()", "frequency": 4, "category": "speech", "isExtension": true, "deviceRequired": false, "displayText": "decir ()", "clashWithDevice": false}, {"text": "decir () durante () segundos", "frequency": 2, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "girar a la izquierda () grados", "frequency": 2, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "si no", "frequency": 2, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "sumar a x ()", "frequency": 2, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "events!al presionar tecla []", "frequency": 1, "category": "events", "isExtension": false, "deviceRequired": false, "displayText": "al presionar tecla []", "clashWithDevice": true, "dropdowns": [{"name": "KEY_OPTION", "isSquare": true, "values": ["espacio", "flecha arriba", "flecha abajo", "flecha izquierda", "flecha derecha", "cualquiera", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}]}, {"text": "fijar estilo de rotaci\u00f3n a []", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "STYLE", "isSquare": true, "values": ["izquierda-derecha", "no rotar", "en todas direcciones"]}]}, {"text": "makey!al presionar tecla []", "frequency": 1, "category": "makey", "isExtension": true, "deviceRequired": true, "displayText": "al presionar tecla []", "clashWithDevice": true, "dropdowns": [{"name": "KEY", "isSquare": false, "values": ["espacio", "flecha arriba", "flecha abajo", "flecha izquierda", "flecha derecha", "w", "a", "s", "d", "f", "g"]}]}, {"text": "[] v\u00eddeo", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "VIDEO_STATE", "isSquare": false, "values": ["encender", "apagar", "invertir"]}]}, {"text": "al comenzar como clon", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "al conectar pin []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PIN", "isSquare": false, "values": ["0", "1", "2"]}]}, {"text": "al hacer clic en este objeto", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false}, {"text": "al inclinar []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["delantera", "trasera", "izquierda", "derecha", "cualquiera"]}]}, {"text": "al presionar [] en orden", "frequency": 0, "category": "makey", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "SEQUENCE", "isSquare": false, "values": ["izquierda arriba derecha", "derecha arriba izquierda", "izquierda derecha", "derecha izquierda", "arriba abajo", "abajo arriba", "arriba derecha abajo izquierda", "arriba izquierda abajo derecha", "arriba arriba abajo abajo izquierda derecha izquierda derecha"]}]}, {"text": "apagar []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "todos los motores"]}]}, {"text": "apagar motor []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "apuntar hacia []", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TOWARDS", "isSquare": false, "values": ["puntero del rot\u00f3n"]}]}, {"text": "asignar voz a []", "frequency": 0, "category": "speech", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "VOICE", "isSquare": false, "values": ["contralto", "tenor", "chillido", "gigante", "gatito"]}]}, {"text": "a\u00f1adir () a []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "bajar l\u00e1piz", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "boost!al inclinar hacia []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "al inclinar hacia []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["arriba", "abajo", "izquierda", "derecha", "cualquiera"]}]}, {"text": "boost!fijar color de la luz a ()", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "fijar color de la luz a ()", "clashWithDevice": true}, {"text": "borrar todo", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "cambiar [] de l\u00e1piz por ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "COLOR_PARAM", "isSquare": false, "values": ["color", "saturaci\u00f3n", "brillo", "transparencia"]}]}, {"text": "cambiar disfraz a []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "COSTUME", "isSquare": false, "values": []}]}, {"text": "cambiar fondo a [] y esperar", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": false, "values": []}]}, {"text": "cambiar tama\u00f1o de l\u00e1piz por ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "cambiar tama\u00f1o por ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "cambiar tempo por ()", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "cambiar volumen por ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "crear clon de []", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "CLONE_OPTION", "isSquare": false, "values": ["mi mismo"]}]}, {"text": "cuando [] gt ()", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "WHENGREATERTHANMENU", "isSquare": true, "values": ["volumen del sonido", "cron\u00f3metro"]}]}, {"text": "cuando brillo lt ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "cuando distancia [] ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "OP", "isSquare": false, "values": ["lt", "gt"]}]}, {"text": "cuando distancia lt ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "cuando el fondo cambie a []", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": true, "values": []}]}, {"text": "cuando el sensor de fuerza []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PUSH_PULL", "isSquare": false, "values": ["tire", "empuje"]}]}, {"text": "cuando movimiento de video gt ()", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false}, {"text": "cuando vea pieza []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "COLOR", "isSquare": false, "values": ["roja", "azul", "verde", "amarilla", "blanca", "negra", "de cualquier color"]}]}, {"text": "dar a x el valor ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "dar a y el valor ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "dar al tempo el valor ()", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "deslizar en () segs a []", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TO", "isSquare": false, "values": ["posici\u00f3n aleatoria", "puntero del rot\u00f3n"]}]}, {"text": "deslizar en () segs a x () y ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "detener todos los sonidos", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "eliminar () de []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "eliminar este clon", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "eliminar todos de []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "encender []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "todos los motores"]}]}, {"text": "encender [] durante () segundos", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "todos los motores"]}]}, {"text": "encender motor []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "enviar [] y esperar", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_INPUT", "isSquare": false, "values": []}]}, {"text": "esconder lista []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "esconder variable []", "frequency": 0, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "esperar hasta que <>", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "ev3!al presionar bot\u00f3n []", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "al presionar bot\u00f3n []", "clashWithDevice": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["1", "2", "3", "4"]}]}, {"text": "fa!al []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "displayText": "al []", "clashWithDevice": true, "dropdowns": [{"name": "GESTURE", "isSquare": false, "values": ["agitar", "comenzar a caer", "girar hacia arriba", "girar hacia abajo"]}]}, {"text": "fijar [] de l\u00e1piz a ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "COLOR_PARAM", "isSquare": false, "values": ["color", "saturaci\u00f3n", "brillo", "transparencia"]}]}, {"text": "fijar color de l\u00e1piz a ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "fijar direcci\u00f3n de [] a []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "todos los motores"]}, {"name": "MOTOR_DIRECTION", "isSquare": false, "values": ["otro lado", "un lado", "inversa"]}]}, {"text": "fijar direcci\u00f3n del motor [] []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}, {"name": "MOTOR_DIRECTION", "isSquare": false, "values": ["otro lado", "un lado", "inversa"]}]}, {"text": "fijar idioma a []", "frequency": 0, "category": "speech", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "LANGUAGE", "isSquare": false, "values": ["\u00e1r\u00e1be", "chinese", "Chino Mandar\u00edn", "Chino Mandar\u00edn", "dan\u00e9s", "neerland\u00e9s", "ingl\u00e9s", "franc\u00e9s", "alem\u00e1n", "hindi", "island\u00e9s", "italiano", "japon\u00e9s", "coreano", "noruego", "polaco", "portugu\u00e9s brasile\u00f1o", "portugu\u00e9s", "rumano", "ruso", "espa\u00f1ol", "espa\u00f1ol latinoamericano", "sueco", "turco", "welsh"]}]}, {"text": "fijar instrumento a []", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "INSTRUMENT", "isSquare": false, "values": ["piano", "piano el\u00e9ctrico", "\u00f3rgano", "guitarra", "guitarra el\u00e9ctrica", "bajo", "pizzicato", "violonchelo", "tromb\u00f3n", "carinet", "saxof\u00f3n", "flauta", "wodden flute", "fagot", "choir", "vibr\u00e1fono", "caja de musica", "tambor met\u00e1lico", "marimba", "sintetizador mel\u00f3dico", "sintetizador de fondo"]}]}, {"text": "fijar modo de arrastre a []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "DRAG_MODE", "isSquare": true, "values": ["arrastrable", "no arrastrable"]}]}, {"text": "fijar potencia de [] a ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "todos los motores"]}]}, {"text": "fijar tama\u00f1o al ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "fijar tama\u00f1o de l\u00e1piz a ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "fijar transparencia de v\u00eddeo a ()", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false}, {"text": "fijar velocidad del motor [] al ()", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "fijar volumen al ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "girar motor [] () segundos", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "girar motor [] () vueltas", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "iniciar sonido []", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "SOUND_MENU", "isSquare": false, "values": []}]}, {"text": "insertar () en () de []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "ir () capas hacia []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "FORWARD_BACKWARD", "isSquare": true, "values": ["delante", "atr\u00e1s"]}]}, {"text": "ir a capa []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "FRONT_BACK", "isSquare": true, "values": ["delantera", "trasera"]}]}, {"text": "ir a x () y ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "limpiar pantalla", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true}, {"text": "looks!dar al efecto [] el valor ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "displayText": "dar al efecto [] el valor ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["color", "ojo de pez", "remolino", "pixelar", "mosaico", "brillo", "desvanecer"]}]}, {"text": "looks!sumar al efecto [] ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "displayText": "sumar al efecto [] ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["color", "ojo de pez", "remolino", "pixelar", "mosaico", "brillo", "desvanecer"]}]}, {"text": "microbit!al []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "al []", "clashWithDevice": true, "dropdowns": [{"name": "GESTURE", "isSquare": false, "values": ["mover", "agitar", "saltar"]}]}, {"text": "microbit!al inclinar hacia []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "al inclinar hacia []", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["delantera", "trasera", "izquierda", "derecha", "cualquiera"]}]}, {"text": "microbit!al presionar bot\u00f3n []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "al presionar bot\u00f3n []", "clashWithDevice": true, "dropdowns": [{"name": "BTN", "isSquare": false, "values": ["A", "B", "Any"]}]}, {"text": "mostrar []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MATRIX", "isSquare": false, "values": ["[ox]", "[01]{25}"]}]}, {"text": "mostrar lista []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "mostrar texto ()", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true}, {"text": "mostrar variable []", "frequency": 0, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "motor [] fijar potencia a ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "motor [] girar a un lado () segundos", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "motor [] girar al otro lado () segundos", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "pensar ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "pensar () durante () segundos", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "quitar efectos de sonido", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "quitar efectos gr\u00e1ficos", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "reemplazar elemento () de [] con ()", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "reiniciar cron\u00f3metro", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "sellar", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "separator", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "si toca un borde rebotar", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "siguiente fondo", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "silencio de () tiempos", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "sound!dar al efecto [] el valor ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false, "displayText": "dar al efecto [] el valor ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["altura", "balance izquierda/derecha"]}]}, {"text": "sound!sumar al efecto [] ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false, "displayText": "sumar al efecto [] ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["altura", "balance izquierda/derecha"]}]}, {"text": "space", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "subir l\u00e1piz", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "sumar a y ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "tocar nota () durante () segundos", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "tocar nota () durante () tiempos", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "tocar sonido [] hasta que termine", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "SOUND_MENU", "isSquare": false, "values": []}]}, {"text": "tocar tambor [] durante () tiempos", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "DRUM", "isSquare": false, "values": ["caja", "bombo", "goldpe lateral", "platillo crash", "Charles abierto", "Charles cerrado", "tamborine", "palmada", "claves", "wood block", "cencerro", "triangle", "bongo", "conga", "cabasa", "g\u00fciro", "vibraslap", "culca"]}]}, {"text": "wedo!al inclinar hacia []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "al inclinar hacia []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["arriba", "abajo", "izquierda", "derecha", "cualquiera"]}]}, {"text": "wedo!fijar color de la luz a ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "fijar color de la luz a ()", "clashWithDevice": true}], "values": [{"text": "unir () ()", "frequency": 26, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "respuesta", "frequency": 23, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "() * ()", "frequency": 6, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() + ()", "frequency": 6, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() - ()", "frequency": 4, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() m\u00f3dulo ()", "frequency": 4, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "n\u00famero aleayrio entre () y ()", "frequency": 4, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "# de elemento de () en []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "() / ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "[] actual", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "CURRENTMENU", "isSquare": true, "values": ["ano", "mes", "dia", "dia de la semana", "hora", "minuto", "segundo"]}]}, {"text": "[] de ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "OPERATOR", "isSquare": true, "values": ["valor absoluto", "suelo", "techo", "raiz cuadrada", "sen", "cos", "tan", "arcsen", "arccos", "arctan", "ln", "log", "e^", "10^"]}]}, {"text": "[] de []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "PROPERTY", "isSquare": true, "values": ["# de fondo", "nombre de fondo", "volumen", "posici\u00f3n en x", "posici\u00f3n en y", "direcci\u00f3n", "# de disfraz", "nombre de disfraz", "tama\u00f1o"]}, {"name": "OBJECT", "isSquare": false, "values": ["escenario"]}]}, {"text": "[] de disfraz", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "NUMBER_NAME", "isSquare": true, "values": ["n\u00famero", "nombre"]}]}, {"text": "[] de fondo", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "NUMBER_NAME", "isSquare": true, "values": ["n\u00famero", "nombre"]}]}, {"text": "[] de v\u00eddeo en []", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "ATTRIBUTE", "isSquare": false, "values": ["movimiento", "direcci\u00f3n"]}, {"name": "SUBJECT", "isSquare": false, "values": ["escenario"]}]}, {"text": "aceleraci\u00f3n []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["x", "y", "z"]}]}, {"text": "boost!posici\u00f3n del motor []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "posici\u00f3n del motor []", "clashWithDevice": true, "dropdowns": [{"name": "MOTOR_REPORTER_ID", "isSquare": false, "values": []}]}, {"text": "boost!\u00e1ngulo de inclinaci\u00f3n hacia []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "\u00e1ngulo de inclinaci\u00f3n hacia []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION", "isSquare": false, "values": ["arriba", "abajo", "izquierda", "derecha", "cualquiera"]}]}, {"text": "brillo", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "cron\u00f3metro", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "direcci\u00f3n", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "distancia a []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "DISTANCETOMENU", "isSquare": false, "values": ["puntero del rot\u00f3n"]}]}, {"text": "d\u00edas desde el 2000", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "elemento () de []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "ev3!distancia", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "distancia", "clashWithDevice": true}, {"text": "ev3!posici\u00f3n del motor []", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "posici\u00f3n del motor []", "clashWithDevice": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "fuerza", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true}, {"text": "idioma", "frequency": 0, "category": "translate", "isExtension": true, "deviceRequired": false}, {"text": "letra () de ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "longitud de ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "longitud de []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "microbit!\u00e1ngulo de inclinaci\u00f3n hacia []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "\u00e1ngulo de inclinaci\u00f3n hacia []", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["delantera", "trasera", "izquierda", "derecha"]}]}, {"text": "nombre de usuario", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "posici\u00f3n en x", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "posici\u00f3n en y", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "posici\u00f3n x del rat\u00f3n", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "posici\u00f3n y del rat\u00f3n", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "redondear ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "tama\u00f1o", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "tempo", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "traducir () al []", "frequency": 0, "category": "translate", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "LANGUAGE", "isSquare": false, "values": []}]}, {"text": "velocidad de giro []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["x", "y", "z"]}]}, {"text": "volumen", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "volumen del sonido", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "wedo!distancia", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "distancia", "clashWithDevice": true}, {"text": "wedo!\u00e1ngulo de inclinaci\u00f3n hacia []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "\u00e1ngulo de inclinaci\u00f3n hacia []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION", "isSquare": false, "values": ["arriba", "abajo", "izquierda", "derecha"]}]}, {"text": "\u00e1ngulo de inclinaci\u00f3n []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["delantera", "trasera", "izquierda", "derecha"]}]}], "conditions": [{"text": "() = ()", "frequency": 9, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "<> y <>", "frequency": 8, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() gt ()", "frequency": 4, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() est\u00e1 en ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() est\u00e1 en []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "() lt ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "<> o <>", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "cayendo", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true}, {"text": "color () tocando ()", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "ev3!bot\u00f3n [] presionado", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "bot\u00f3n [] presionado", "clashWithDevice": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["1", "2", "3", "4"]}]}, {"text": "inclinado []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["delantera", "trasera", "izquierda", "derecha", "cualquiera"]}]}, {"text": "microbit!bot\u00f3n [] presionado", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "bot\u00f3n [] presionado", "clashWithDevice": true, "dropdowns": [{"name": "BTN", "isSquare": false, "values": ["A", "B", "Any"]}]}, {"text": "microbit!inclinado hacia []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "inclinado hacia []", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["delantera", "trasera", "izquierda", "derecha", "cualquiera"]}]}, {"text": "no <>", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "rat\u00f3n presionado", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "tecla [] presionada", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "KEY_OPTION", "isSquare": false, "values": ["espacio", "flecha arriba", "flecha abajo", "flecha izquierda", "flecha derecha", "cualquiera", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}]}, {"text": "tocando []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TOUCHINGOBJECTMENU", "isSquare": false, "values": ["puntero del rot\u00f3n", "borde"]}]}, {"text": "tocando el color ()", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "ve pieza []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "COLOR", "isSquare": false, "values": ["roja", "azul", "verde", "amarilla", "blanca", "negra", "de cualquier color"]}]}, {"text": "wedo!inclinado hacia []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "inclinado hacia []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["arriba", "abajo", "izquierda", "derecha", "cualquiera"]}]}]}, "fi": {"blocks": [{"text": "kun klikataan lippu", "frequency": 8, "category": "events", "isExtension": false, "deviceRequired": false}, {"text": "kun t\u00e4t\u00e4 hahmoa klikataan", "frequency": 8, "category": "events", "isExtension": false, "deviceRequired": false}, {"text": "sano () () sekunnin ajan", "frequency": 7, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "soita \u00e4\u00e4ni []", "frequency": 7, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "SOUND_MENU", "isSquare": false, "values": []}]}, {"text": "odota () sekuntia", "frequency": 6, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "liiku () askelta", "frequency": 5, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "kun painetaan []", "frequency": 4, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "KEY_OPTION", "isSquare": true, "values": ["v\u00e4lily\u00f6nti", "nuoli yl\u00f6s", "nuoli alas", "nuoli vasemmalle", "nuoli oikealle", "mik\u00e4 tahansa", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}]}, {"text": "lis\u00e4\u00e4 [] tehostetta arvolla ()", "frequency": 4, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["v\u00e4ri", "kalansilm\u00e4", "py\u00f6rre", "piksel\u00f6i", "mosaiikki", "kirkkaus", "haamu"]}]}, {"text": "aseta [] arvoon ()", "frequency": 3, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "aseta kyn\u00e4n kooksi ()", "frequency": 3, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "aseta kyn\u00e4n v\u00e4riksi ()", "frequency": 2, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "ikuisesti", "frequency": 2, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "jos <> niin", "frequency": 2, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "kyn\u00e4 yl\u00f6s", "frequency": 2, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "lis\u00e4\u00e4 muuttujaan [] arvo ()", "frequency": 2, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "pyyhi kaikki", "frequency": 2, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "sano ()", "frequency": 2, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "soita nuottia () () iskun ajan", "frequency": 2, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "aseta xn arvoksi ()", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "kimpoa reunasta", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "kyn\u00e4 alas", "frequency": 1, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "k\u00e4\u00e4nny oikea () astetta", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "lis\u00e4\u00e4 \u00e4\u00e4nenvoimakkuutta arvolla ()", "frequency": 1, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "liu'u () sekuntia sijaintiin x () y ()", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "luo klooni hahmosta []", "frequency": 1, "category": "control", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "CLONE_OPTION", "isSquare": false, "values": ["min\u00e4 itse"]}]}, {"text": "mene sijaintiin x () y ()", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "osoita suuntaan ()", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "piilota", "frequency": 1, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "pys\u00e4yt\u00e4 kaikki \u00e4\u00e4net", "frequency": 1, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "soita rumpua [] () iskun ajan", "frequency": 1, "category": "music", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "DRUM", "isSquare": false, "values": ["Virvelirumpu", "Bassorumpu", "Sivuisku rumpuun", "Crash-lautanen", "Avoin hi-hat", "Suljettu hi-hat", "tamborine", "Taputus", "Rytmikapulat", "Puupalikka", "Lahm\u00e4nkello", "Traingeli", "Bongo-rumpu", "Conga-rumpu", "cabasa", "guiro", "vibraslap", "culca"]}]}, {"text": "soita \u00e4\u00e4ni [] loppuun", "frequency": 1, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "SOUND_MENU", "isSquare": false, "values": []}]}, {"text": "tai muuten", "frequency": 1, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "toista () kertaa", "frequency": 1, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "ajattele ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "ajattele () () sekunnin ajan", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "aseta kieleksi []", "frequency": 0, "category": "speech", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "LANGUAGE", "isSquare": false, "values": ["arabia", "chinese", "chinese mandarin", "chinese mandarin", "tanska", "hollanti", "englanti", "ranska", "saksa", "hindi", "islanti", "italia", "japani", "korea", "norja", "puola", "portuguese brazilian", "portugali", "romania", "ven\u00e4j\u00e4", "espanja", "spanish latin american", "ruotsi", "turkki", "kymri"]}]}, {"text": "aseta kiertotyyliksi []", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "STYLE", "isSquare": true, "values": ["vasen-oikea", "\u00e4l\u00e4 kierr\u00e4", "joka suuntaan"]}]}, {"text": "aseta koko arvoon ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "aseta kyn\u00e4n v\u00e4rin [] arvoksi ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "COLOR_PARAM", "isSquare": false, "values": ["v\u00e4ri", "v\u00e4rikyll\u00e4isyys", "kirkkaus", "l\u00e4pin\u00e4kyvyys"]}]}, {"text": "aseta moottorin [] nopeudeksi ()", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "aseta moottorin [] teho arvoon ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "kaikki moottorit"]}]}, {"text": "aseta moottorin [] tehoksi ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "aseta raahaustilaksi []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "DRAG_MODE", "isSquare": true, "values": ["raahaus sallittu", "raahaus ei sallittu"]}]}, {"text": "aseta soittimeksi []", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "INSTRUMENT", "isSquare": false, "values": ["piano", "S\u00e4hk\u00f6piano", "Urut", "Kitara", "S\u00e4hk\u00f6kitara", "basso", "N\u00e4pp\u00e4ily", "sello", "pasuuna", "carinet", "saksofoni", "huilu", "wodden flute", "Fagotti", "Kuoro", "Vibrafoni", "Soittorasia", "Tynnyrirumpu", "marimba", "Syntetisaattori lead-efekti", "Syntetisaattori pad-efekti"]}]}, {"text": "aseta tempoksi ()", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "aseta videon l\u00e4pin\u00e4kyvyys arvoon ()", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false}, {"text": "aseta yn arvoksi ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "aseta \u00e4\u00e4neksi []", "frequency": 0, "category": "speech", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "VOICE", "isSquare": false, "values": ["altto", "tenori", "vingahdus", "j\u00e4tti", "kissanpentu"]}]}, {"text": "aseta \u00e4\u00e4nenvoimakkuudeksi ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "boost!aseta moottorin [] suunnaksi []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "aseta moottorin [] suunnaksi []", "clashWithDevice": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}, {"name": "MOTOR_DIRECTION", "isSquare": false, "values": ["t\u00e4h\u00e4n suuntaan", "tuohon suuntaan", "vaihda suuntaa"]}]}, {"text": "boost!aseta valon v\u00e4riksi ()", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "aseta valon v\u00e4riksi ()", "clashWithDevice": true}, {"text": "boost!kun kallistettu suuntaan []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "kun kallistettu suuntaan []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["yl\u00f6s", "alas", "vasen", "oikea", "mik\u00e4 tahansa"]}]}, {"text": "fa!kun on []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "displayText": "kun on []", "clashWithDevice": true, "dropdowns": [{"name": "GESTURE", "isSquare": false, "values": ["ravistettu", "putoaminen alkoi", "k\u00e4\u00e4nnetty yl\u00f6sp\u00e4in", "k\u00e4\u00e4nnetty alasp\u00e4in"]}]}, {"text": "kasvata kokoa arvolla ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "korvaa listan () kohdan [] arvo arvolla ()", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "kun [] -n\u00e4pp\u00e4int\u00e4 painetaan", "frequency": 0, "category": "makey", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "KEY", "isSquare": false, "values": ["v\u00e4lily\u00f6nti", "nuoli yl\u00f6s", "nuoli alas", "nuoli vasemmalle", "nuoli oikealle", "w", "a", "s", "d", "f", "g"]}]}, {"text": "kun [] gt ()", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "WHENGREATERTHANMENU", "isSquare": true, "values": ["\u00e4\u00e4nentaso", "ajastin"]}]}, {"text": "kun [] n\u00e4hty", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "COLOR", "isSquare": false, "values": ["punainen", "sininen", "vihre\u00e4", "keltainen", "valkoinen", "musta", "mik\u00e4 tahansa v\u00e4ri"]}]}, {"text": "kun [] painetaan j\u00e4rjestyksess\u00e4", "frequency": 0, "category": "makey", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "SEQUENCE", "isSquare": false, "values": ["vasen yl\u00f6s oikea", "oikea yl\u00f6s vasen", "vasen oikea", "oikea vasen", "yl\u00f6s alas", "alas yl\u00f6s", "yl\u00f6s oikea alas vasen", "yl\u00f6s vasen alas oikea", "yl\u00f6s yl\u00f6s alas alas vasen oikea vasen oikea"]}]}, {"text": "kun aloitan kloonina", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "kun et\u00e4isyys [] ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "OP", "isSquare": false, "values": ["lt", "gt"]}]}, {"text": "kun et\u00e4isyys lt ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "kun kallistus []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["etu", "taka", "vasen", "oikea", "mik\u00e4 tahansa"]}]}, {"text": "kun kirkkaus lt ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "kun nappia [] painetaan", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "BTN", "isSquare": false, "values": ["A", "B", "Any"]}]}, {"text": "kun nappia painetaan portissa []", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["1", "2", "3", "4"]}]}, {"text": "kun nasta [] yhdistetty", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PIN", "isSquare": false, "values": ["0", "1", "2"]}]}, {"text": "kun taustaksi vaihtuu []", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": true, "values": []}]}, {"text": "kun vastaanotan []", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_OPTION", "isSquare": true, "values": []}]}, {"text": "kun videon liike gt ()", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false}, {"text": "kun voima-anturia []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PUSH_PULL", "isSquare": false, "values": ["ty\u00f6nnet\u00e4\u00e4n", "vedet\u00e4\u00e4n"]}]}, {"text": "kysy () ja odota", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "kytke video []", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "VIDEO_STATE", "isSquare": false, "values": ["p\u00e4\u00e4lle", "pois", "k\u00e4\u00e4nnett\u00e4ess\u00e4"]}]}, {"text": "k\u00e4ynnist\u00e4 moottori [] () kierroksen ajan", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "k\u00e4ynnist\u00e4 moottori [] () sekunniksi", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "k\u00e4\u00e4nny vasen () astetta", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "k\u00e4\u00e4nn\u00e4 moottoria [] my\u00f6t\u00e4p\u00e4iv\u00e4\u00e4n () sekuntia", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "k\u00e4\u00e4nn\u00e4 moottoria [] vastap\u00e4iv\u00e4\u00e4n () sekuntia", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "laita [] pois p\u00e4\u00e4lt\u00e4", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "kaikki moottorit"]}]}, {"text": "laita [] p\u00e4\u00e4lle", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "kaikki moottorit"]}]}, {"text": "laita [] p\u00e4\u00e4lle () sekunniksi", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "kaikki moottorit"]}]}, {"text": "laita moottori [] pois p\u00e4\u00e4lt\u00e4", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "laita moottori [] p\u00e4\u00e4lle", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "leimaa", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "lis\u00e4\u00e4 () kohtaan () listassa []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "lis\u00e4\u00e4 () listaan []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "lis\u00e4\u00e4 kyn\u00e4n kokoa arvolla ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "lis\u00e4\u00e4 kyn\u00e4n v\u00e4ri\u00e4 [] arvolla ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "COLOR_PARAM", "isSquare": false, "values": ["v\u00e4ri", "v\u00e4rikyll\u00e4isyys", "kirkkaus", "l\u00e4pin\u00e4kyvyys"]}]}, {"text": "lis\u00e4\u00e4 tehosteeseen [] arvo ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["s\u00e4velkorkeus", "panoroi vasen/oikea"]}]}, {"text": "lis\u00e4\u00e4 tempoa arvolla ()", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "lis\u00e4\u00e4 xn arvoon ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "lis\u00e4\u00e4 yn arvoon ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "liu'u () sekuntia sijaintiin []", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TO", "isSquare": false, "values": ["satunnainen sijainti", "hiiren osoitin"]}]}, {"text": "looks!aseta tehoste [] arvoon ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "displayText": "aseta tehoste [] arvoon ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["v\u00e4ri", "kalansilm\u00e4", "py\u00f6rre", "piksel\u00f6i", "mosaiikki", "kirkkaus", "haamu"]}]}, {"text": "l\u00e4het\u00e4 []", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_INPUT", "isSquare": false, "values": []}]}, {"text": "l\u00e4het\u00e4 [] ja odota", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_INPUT", "isSquare": false, "values": []}]}, {"text": "mene [] () tasoa", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "FORWARD_BACKWARD", "isSquare": true, "values": ["eteenp\u00e4in", "taaksep\u00e4in"]}]}, {"text": "mene [] alalle", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "FRONT_BACK", "isSquare": true, "values": ["etu", "taka"]}]}, {"text": "mene sijaintiin []", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TO", "isSquare": false, "values": ["satunnainen sijainti", "hiiren osoitin"]}]}, {"text": "microbit!kun kallistettu suuntaan []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "kun kallistettu suuntaan []", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["etu", "taka", "vasen", "oikea", "mik\u00e4 tahansa"]}]}, {"text": "microbit!kun on []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "kun on []", "clashWithDevice": true, "dropdowns": [{"name": "GESTURE", "isSquare": false, "values": ["siirretty", "ravistettu", "hyp\u00e4tty"]}]}, {"text": "nollaa ajastin", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "n\u00e4yt\u00e4", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "n\u00e4yt\u00e4 []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MATRIX", "isSquare": false, "values": ["[ox]", "[01]{25}"]}]}, {"text": "n\u00e4yt\u00e4 lista []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "n\u00e4yt\u00e4 muuttuja []", "frequency": 0, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "n\u00e4yt\u00e4 teksti ()", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true}, {"text": "odota kunnes <>", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "osoita kohti []", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TOWARDS", "isSquare": false, "values": ["hiiren osoitin"]}]}, {"text": "piilota lista []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "piilota muuttuja []", "frequency": 0, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "poista () listasta []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "poista graafiset tehosteet", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "poista kaikki listasta []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "poista t\u00e4m\u00e4 klooni", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "poista \u00e4\u00e4niefektit", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "puhu ()", "frequency": 0, "category": "speech", "isExtension": true, "deviceRequired": false}, {"text": "pys\u00e4yt\u00e4 []", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "STOP_OPTION", "isSquare": true, "values": ["kaikki", "t\u00e4m\u00e4 koodi", "hahmon muut koodit"]}]}, {"text": "separator", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "seuraava asuste", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "seuraava tausta", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "soita nuottia () () sekuntia", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "sound!aseta tehoste [] arvoon ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false, "displayText": "aseta tehoste [] arvoon ()", "clashWithDevice": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["s\u00e4velkorkeus", "panoroi vasen/oikea"]}]}, {"text": "space", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "tauko () iskun ajan", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "toista kunnes <>", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "tyhjenn\u00e4 n\u00e4ytt\u00f6", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true}, {"text": "vaihda asusteeksi []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "COSTUME", "isSquare": false, "values": []}]}, {"text": "vaihda taustaksi []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": false, "values": []}]}, {"text": "vaihda taustaksi [] ja odota", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": false, "values": []}]}, {"text": "wedo!aseta moottorin [] suunnaksi []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "aseta moottorin [] suunnaksi []", "clashWithDevice": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "kaikki moottorit"]}, {"name": "MOTOR_DIRECTION", "isSquare": false, "values": ["t\u00e4h\u00e4n suuntaan", "tuohon suuntaan", "vaihda suuntaa"]}]}, {"text": "wedo!aseta valon v\u00e4riksi ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "aseta valon v\u00e4riksi ()", "clashWithDevice": true}, {"text": "wedo!kun kallistettu suuntaan []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "kun kallistettu suuntaan []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["yl\u00f6s", "alas", "vasen", "oikea", "mik\u00e4 tahansa"]}]}], "values": [{"text": "() + ()", "frequency": 2, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "kohteen [] []", "frequency": 2, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "OBJECT", "isSquare": false, "values": ["suunta"]}, {"name": "PROPERTY", "isSquare": true, "values": ["taustan numero", "taustan nimi", "\u00e4\u00e4nenvoimakkuus", "x-sijainti", "y-sijainti", "esiintymislava", "asusteen numero", "asusteen nimi", "koko"]}]}, {"text": "() * ()", "frequency": 1, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() - ()", "frequency": 1, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "suunta", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "valitse satunnaisluku v\u00e4lilt\u00e4 () \u2013 ()", "frequency": 1, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "x-sijainti", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "y-sijainti", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "() . kirjain sanasta ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() / ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "[] luvusta ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "OPERATOR", "isSquare": true, "values": ["itseisarvo", "py\u00f6rist\u00e4 alasp\u00e4in", "py\u00f6rist\u00e4 yl\u00f6sp\u00e4in", "neliojuuri", "sini", "krosini", "tangentti", "asin", "acos", "atan", "lunnnollinen logaritmi", "10-kantainen logaritmi", "e^", "10^"]}]}, {"text": "ajastin", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "asuste []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "NUMBER_NAME", "isSquare": true, "values": ["luku", "nimi"]}]}, {"text": "boost!kallista suuntaan []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "kallista suuntaan []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION", "isSquare": false, "values": ["yl\u00f6s", "alas", "vasen", "oikea", "mik\u00e4 tahansa"]}]}, {"text": "boost!moottorin [] asento", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "moottorin [] asento", "clashWithDevice": true, "dropdowns": [{"name": "MOTOR_REPORTER_ID", "isSquare": false, "values": []}]}, {"text": "et\u00e4isyys kohteeseen []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "DISTANCETOMENU", "isSquare": false, "values": ["hiiren osoitin"]}]}, {"text": "ev3!et\u00e4isyys", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "et\u00e4isyys", "clashWithDevice": true}, {"text": "ev3!moottorin [] asento", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "moottorin [] asento", "clashWithDevice": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "hiiren x-sijainti", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "hiiren y-sijainti", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "kallistuskulma []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["etu", "taka", "vasen", "oikea"]}]}, {"text": "kieli", "frequency": 0, "category": "translate", "isExtension": true, "deviceRequired": false}, {"text": "kiihtyvyys []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["x", "y", "z"]}]}, {"text": "kirkkaus", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "kohteen () numero listassa []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "koko", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "k\u00e4ytt\u00e4j\u00e4nimi", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "k\u00e4\u00e4nn\u00e4 () kielelle []", "frequency": 0, "category": "translate", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "LANGUAGE", "isSquare": false, "values": []}]}, {"text": "listan () . kohde []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "listan pituus []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "lukujen () ja () jakoj\u00e4\u00e4nn\u00f6s", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "microbit!kallista suuntaan []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "kallista suuntaan []", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["etu", "taka", "vasen", "oikea"]}]}, {"text": "n [] videolla []", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "ATTRIBUTE", "isSquare": false, "values": ["hahmo", "esiintymislava"]}, {"name": "SUBJECT", "isSquare": false, "values": ["suunta"]}]}, {"text": "nykyinen []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "CURRENTMENU", "isSquare": true, "values": ["vuosi", "kuukausi", "p\u00e4iv\u00e4ys", "viikonp\u00e4iv\u00e4", "tunti", "minuutti", "sekunti"]}]}, {"text": "py\u00f6rimisnopeus []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["x", "y", "z"]}]}, {"text": "py\u00f6rist\u00e4 ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "p\u00e4ivi\u00e4 vuoden 2000 j\u00e4lkeen", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "sanan () pituus", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "tausta []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "NUMBER_NAME", "isSquare": true, "values": ["luku", "nimi"]}]}, {"text": "tempo", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "vastaus", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "voima", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true}, {"text": "wedo!et\u00e4isyys", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "et\u00e4isyys", "clashWithDevice": true}, {"text": "wedo!kallista suuntaan []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "kallista suuntaan []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION", "isSquare": false, "values": ["yl\u00f6s", "alas", "vasen", "oikea"]}]}, {"text": "yhdist\u00e4 () ja ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "\u00e4\u00e4nentaso", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "\u00e4\u00e4nenvoimakkuus", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}], "conditions": [{"text": "() = ()", "frequency": 1, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() gt ()", "frequency": 1, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "ei <>", "frequency": 1, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "koskettaako []", "frequency": 1, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TOUCHINGOBJECTMENU", "isSquare": false, "values": ["hiiren osoitin", "reuna"]}]}, {"text": "() lt ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() sis\u00e4lt\u00e4\u00e4 ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "<> ja <>", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "<> tai <>", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "[] sis\u00e4lt\u00e4\u00e4 ()", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "koskeeko v\u00e4ri () v\u00e4ri\u00e4 ()", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "koskettaako v\u00e4ri\u00e4 ()", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "n\u00e4keek\u00f6 v\u00e4rin []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "COLOR", "isSquare": false, "values": ["punainen", "sininen", "vihre\u00e4", "keltainen", "valkoinen", "musta", "mik\u00e4 tahansa v\u00e4ri"]}]}, {"text": "onko hiiren nappi painettu", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "onko kallistettu suuntaan []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["yl\u00f6s", "alas", "vasen", "oikea", "mik\u00e4 tahansa"]}]}, {"text": "onko kallistus []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["etu", "taka", "vasen", "oikea", "mik\u00e4 tahansa"]}]}, {"text": "onko kallistus suuntaan []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["etu", "taka", "vasen", "oikea", "mik\u00e4 tahansa"]}]}, {"text": "onko nappia [] painettu", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "BTN", "isSquare": false, "values": ["A", "B", "Any"]}]}, {"text": "onko nappia painettu portissa []", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["1", "2", "3", "4"]}]}, {"text": "onko n\u00e4pp\u00e4in [] painettu", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "KEY_OPTION", "isSquare": false, "values": ["v\u00e4lily\u00f6nti", "nuoli yl\u00f6s", "nuoli alas", "nuoli vasemmalle", "nuoli oikealle", "mik\u00e4 tahansa", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}]}, {"text": "putoaako", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true}]}, "nl": {"blocks": [{"text": "neem () stappen", "frequency": 12, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "wanneer op vlag wordt geklikt", "frequency": 11, "category": "events", "isExtension": false, "deviceRequired": false}, {"text": "herhaal ()", "frequency": 8, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "draai rechts af () graden", "frequency": 7, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "als <> dan", "frequency": 6, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "herhaal", "frequency": 6, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "pen neer", "frequency": 5, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "maak [] ()", "frequency": 4, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "maak pendikte ()", "frequency": 4, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "wacht () sec.", "frequency": 4, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "zeg () () sec.", "frequency": 4, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "wanneer [] is ingedrukt", "frequency": 3, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "KEY_OPTION", "isSquare": true, "values": ["spatiebalk", "pijltje omhoog", "pijltje omlaag", "pijltje links", "pijltje rechts", "willekeurig", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}]}, {"text": "verander pen [] met ()", "frequency": 2, "category": "pen", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "COLOR_PARAM", "isSquare": false, "values": ["kleur", "verzadiging", "helderheid", "doorzichtigheid"]}]}, {"text": "verander uiterlijk naar []", "frequency": 2, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "COSTUME", "isSquare": false, "values": []}]}, {"text": "verander x met ()", "frequency": 2, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "verander y met ()", "frequency": 2, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "verdwijn", "frequency": 2, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "anders", "frequency": 1, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "draai links af () graden", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "ga naar []", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TO", "isSquare": false, "values": ["willekeurige positie", "muisaanwijzer"]}]}, {"text": "keer om aan de rand", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "maak een kloon van []", "frequency": 1, "category": "control", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "CLONE_OPTION", "isSquare": false, "values": ["mijzelf"]}]}, {"text": "maak penkleur ()", "frequency": 1, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "start geluid []", "frequency": 1, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "SOUND_MENU", "isSquare": false, "values": []}]}, {"text": "stop []", "frequency": 1, "category": "control", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "STOP_OPTION", "isSquare": true, "values": ["alle", "dit script", "andere scripts in sprite"]}]}, {"text": "verander [] met ()", "frequency": 1, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "verander grootte met ()", "frequency": 1, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "verschijn", "frequency": 1, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "volgend uiterlijk", "frequency": 1, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "wanneer ik signaal [] ontvang", "frequency": 1, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_OPTION", "isSquare": true, "values": []}]}, {"text": "zend signaal []", "frequency": 1, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_INPUT", "isSquare": false, "values": []}]}, {"text": "() maten rust", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "als []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "GESTURE", "isSquare": false, "values": ["bewogen", "geschud", "gesprongen"]}]}, {"text": "als [] gekanteld", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["voor", "achter", "links af", "rechts af", "willekeurig"]}]}, {"text": "als [] steen gezien", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "COLOR", "isSquare": false, "values": ["rood", "blauw", "groen", "geel", "wit", "zwart", "willekeurige kleur"]}]}, {"text": "als afstand [] ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "OP", "isSquare": false, "values": ["lt", "gt"]}]}, {"text": "als afstand lt ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "als helderheid lt ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "boost!als gekanteld naar []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "als gekanteld naar []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["omhoog", "omlaag", "links af", "rechts af", "willekeurig"]}]}, {"text": "boost!zet lichtkleur op ()", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "zet lichtkleur op ()", "clashWithDevice": true}, {"text": "denk ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "denk () () sec.", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "display []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MATRIX", "isSquare": false, "values": ["[ox]", "[01]{25}"]}]}, {"text": "draai motor [] () seconde daarheen", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "draai motor [] () seconde hierheen", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "ev3!als knop [] ingedrukt is", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "als knop [] ingedrukt is", "clashWithDevice": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["1", "2", "3", "4"]}]}, {"text": "ga naar [] () lagen", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "FORWARD_BACKWARD", "isSquare": true, "values": ["voren", "achteren"]}]}, {"text": "ga naar laag []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "FRONT_BACK", "isSquare": true, "values": ["voor", "achter"]}]}, {"text": "ga naar x () y ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "herhaal tot <>", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "looks!zeg ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "displayText": "zeg ()", "clashWithDevice": false}, {"text": "looks!zet alle effecten uit", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "displayText": "zet alle effecten uit", "clashWithDevice": false}, {"text": "maak draaistijl []", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "STYLE", "isSquare": true, "values": ["links-rechts", "niet draaien", "helemaal rond"]}]}, {"text": "maak grootte ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "maak instrument []", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "INSTRUMENT", "isSquare": false, "values": ["piano", "Elektrische Piano", "Orgel", "Gitaar", "Elektrische Gitaar", "Bas", "pizzicato", "cello", "trombone", "carinet", "Saxofoon", "Fluit", "wodden flute", "Fagot", "Koor", "Vibrafoon", "Speeldoos", "Steelbrum", "marimba", "synth lead", "synth pad"]}]}, {"text": "maak pen [] ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "COLOR_PARAM", "isSquare": false, "values": ["kleur", "verzadiging", "helderheid", "doorzichtigheid"]}]}, {"text": "maak tempo ()", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "maak x ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "maak y ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "microbit!als gekanteld naar []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "als gekanteld naar []", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["voor", "achter", "links af", "rechts af", "willekeurig"]}]}, {"text": "microbit!als knop [] ingedrukt is", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "als knop [] ingedrukt is", "clashWithDevice": true, "dropdowns": [{"name": "BTN", "isSquare": false, "values": ["A", "B", "Any"]}]}, {"text": "pen op", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "richt naar () graden", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "richt naar []", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TOWARDS", "isSquare": false, "values": ["muisaanwijzer"]}]}, {"text": "schuif in () sec. naar []", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TO", "isSquare": false, "values": ["willekeurige positie", "muisaanwijzer"]}]}, {"text": "schuif in () sec. naar x () y ()", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "separator", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "sound!zet alle effecten uit", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false, "displayText": "zet alle effecten uit", "clashWithDevice": false}, {"text": "space", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "speech!zeg ()", "frequency": 0, "category": "speech", "isExtension": true, "deviceRequired": false, "displayText": "zeg ()", "clashWithDevice": false}, {"text": "speel drum [] gedurende () maten", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "DRUM", "isSquare": false, "values": ["Snarentrom", "Basdrum", "side stick", "Crashbekken", "Open Hihat", "Gesloten Hihat", "Tamboerijn", "Handklap", "claves", "wood block", "Keobel", "Triangel", "bongo", "conga", "Kabassa", "G\u00fciro", "vibraslap", "culca"]}]}, {"text": "speel noot () () seconde", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "speel noot () gedurende () maten", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "start geluid [] en wacht", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "SOUND_MENU", "isSquare": false, "values": []}]}, {"text": "stel de taal in op []", "frequency": 0, "category": "speech", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "LANGUAGE", "isSquare": false, "values": ["Arabisch", "chinese", "Chinees mandarijn", "Chinees mandarijn", "Deens", "Nederlands", "Engels", "Frans", "Duits", "hindi", "IJslands", "Italiaans", "Japans", "koreaans", "Noors", "Pools", "Portugees Braziliaans", "Portugees", "Roemeense", "Russisch", "Spaans", "Spaans Latijns-Amerikaans", "Zweeds", "Turks", "Wels"]}]}, {"text": "stempel", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "stop alle geluiden", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "toon lijst []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "toon tekst ()", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true}, {"text": "toon variabele []", "frequency": 0, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "verander [] -effect met ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["toonhoogte", "kanaal links/rechts"]}]}, {"text": "verander [] effect met ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["kleur", "vissenoog", "draaikolk", "pixeleren", "moza\u00efek", "helderheid", "transparant"]}]}, {"text": "verander achtergrond naar []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": false, "values": []}]}, {"text": "verander achtergrond naar [] en wacht", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": false, "values": []}]}, {"text": "verander pendikte met ()", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "verander tempo met ()", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "verander volume met ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}, {"text": "verberg lijst []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "verberg variabele []", "frequency": 0, "category": "variables", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "VARIABLE", "isSquare": true, "values": []}]}, {"text": "vervang item () van [] door ()", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "verwijder () van []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "verwijder alle van []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "verwijder deze kloon", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "voeg () toe aan []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "voeg () toe op () van []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "volgende achtergrond", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "vraag () en wacht", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "wacht tot <>", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "wanneer []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "GESTURE", "isSquare": false, "values": ["geschud", "begonnen te valten", "gericht naar boven", "gericht naar beneden"]}]}, {"text": "wanneer [] gt ()", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "WHENGREATERTHANMENU", "isSquare": true, "values": ["volume", "klok"]}]}, {"text": "wanneer [] in deze volgorde wordt ingedrukt", "frequency": 0, "category": "makey", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "SEQUENCE", "isSquare": false, "values": ["links omhoog rechts", "rechts omhoog links", "links rechts", "rechts links", "omhoog omlaag", "omlaag omhoog", "omhoog rechts omlaag links", "omhoog links omlaag rechts", "omhoog omhoog omlaag omlaag links rechts links rechts"]}]}, {"text": "wanneer [] toets ingedrukt wordt", "frequency": 0, "category": "makey", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "KEY", "isSquare": false, "values": ["spatiebalk", "pijltje omhoog", "pijltje omlaag", "pijltje links", "pijltje rechts", "w", "a", "s", "d", "f", "g"]}]}, {"text": "wanneer achtergrond verandert naar []", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BACKDROP", "isSquare": true, "values": []}]}, {"text": "wanneer ik als kloon start", "frequency": 0, "category": "control", "isExtension": false, "deviceRequired": false}, {"text": "wanneer krachtsensor []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PUSH_PULL", "isSquare": false, "values": ["gedrukt", "getrokken"]}]}, {"text": "wanneer op deze sprite wordt geklikt", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false}, {"text": "wanneer pin [] is verbonden", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PIN", "isSquare": false, "values": ["0", "1", "2"]}]}, {"text": "wanneer video beweging gt ()", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false}, {"text": "wedo!als gekanteld naar []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "als gekanteld naar []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["omhoog", "omlaag", "links af", "rechts af", "willekeurig"]}]}, {"text": "wedo!zet lichtkleur op ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "zet lichtkleur op ()", "clashWithDevice": true}, {"text": "wis alles", "frequency": 0, "category": "pen", "isExtension": true, "deviceRequired": false}, {"text": "wis het display", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true}, {"text": "zend signaal [] en wacht", "frequency": 0, "category": "events", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "BROADCAST_INPUT", "isSquare": false, "values": []}]}, {"text": "zet [] () seconde aan", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "alle motoren"]}]}, {"text": "zet [] aan", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "alle motoren"]}]}, {"text": "zet [] effect op ()", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["kleur", "vissenoog", "draaikolk", "pixeleren", "moza\u00efek", "helderheid", "transparant"]}]}, {"text": "zet [] kracht op ()", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "alle motoren"]}]}, {"text": "zet [] richting op []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "alle motoren"]}, {"name": "MOTOR_DIRECTION", "isSquare": false, "values": ["hierheen", "daarheen", "omkeren"]}]}, {"text": "zet [] uit", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["motor", "motor A", "motor B", "alle motoren"]}]}, {"text": "zet effect [] op ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "EFFECT", "isSquare": true, "values": ["toonhoogte", "kanaal links/rechts"]}]}, {"text": "zet klok op 0", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "zet motor [] () seconde aan", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "zet motor [] aan", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "zet motor [] aan voor () omwentelingen", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "zet motor [] op ()", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "zet motor [] richting op []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}, {"name": "MOTOR_DIRECTION", "isSquare": false, "values": ["hierheen", "daarheen", "omkeren"]}]}, {"text": "zet motor [] snelheid op ()", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "zet motor [] uit", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "MOTOR_ID", "isSquare": false, "values": ["A", "B", "C", "D", "AB", "ABCD"]}]}, {"text": "zet sleepbaar op []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "DRAG_MODE", "isSquare": true, "values": ["sleepbaar", "niet sleepbaar"]}]}, {"text": "zet stem op []", "frequency": 0, "category": "speech", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "VOICE", "isSquare": false, "values": ["alt", "tenor", "piep", "reus", "katje"]}]}, {"text": "zet video []", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "VIDEO_STATE", "isSquare": false, "values": ["aan", "uit", "aan gespiegeld"]}]}, {"text": "zet video transparantie op ()", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false}, {"text": "zet volume op ()", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false}], "values": [{"text": "x-positie", "frequency": 1, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "() * ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() + ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() - ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() / ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() modulo ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "[] van ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "OPERATOR", "isSquare": true, "values": ["absoluut", "beneden", "boven", "wortel", "sin", "cos", "tan", "asin", "acos", "atan", "ln", "log", "e^", "10^"]}]}, {"text": "[] van []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "PROPERTY", "isSquare": true, "values": ["achtergrond #", "achtergrond naam", "volume", "x-positie", "y-positie", "richting", "uiterlijk #", "naam uiterlijk", "grootte"]}, {"name": "OBJECT", "isSquare": false, "values": ["speelveld"]}]}, {"text": "achtergrond []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "NUMBER_NAME", "isSquare": true, "values": ["nummer", "naam"]}]}, {"text": "afgerond ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "afstand tot []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "DISTANCETOMENU", "isSquare": false, "values": ["muisaanwijzer"]}]}, {"text": "antwoord", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "boost!kantelhoek []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "kantelhoek []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION", "isSquare": false, "values": ["omhoog", "omlaag", "links af", "rechts af", "willekeurig"]}]}, {"text": "boost!motor [] positie", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "displayText": "motor [] positie", "clashWithDevice": true, "dropdowns": [{"name": "MOTOR_REPORTER_ID", "isSquare": false, "values": []}]}, {"text": "dagen sinds 2000", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "draaisnelheid []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["x", "y", "z"]}]}, {"text": "ev3!afstand", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "afstand", "clashWithDevice": true}, {"text": "ev3!motor [] positie", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "motor [] positie", "clashWithDevice": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["A", "B", "C", "D"]}]}, {"text": "fa!kantelhoek []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "displayText": "kantelhoek []", "clashWithDevice": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["voor", "achter", "links af", "rechts af"]}]}, {"text": "gebruikersnaam", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "grootte", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false}, {"text": "helderheid", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true}, {"text": "huidige []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "CURRENTMENU", "isSquare": true, "values": ["jaar", "maand", "datum", "dag van de week", "uur", "minuut", "seconde"]}]}, {"text": "item # van () in []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "item () van []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "klok", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "kracht", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true}, {"text": "lengte van ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "lengte van []", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "letter () van ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "microbit!kantelhoek []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "kantelhoek []", "clashWithDevice": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["voor", "achter", "links af", "rechts af"]}]}, {"text": "muis x", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "muis y", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "richting", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}, {"text": "sensing!volume", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "displayText": "volume", "clashWithDevice": false}, {"text": "sound!volume", "frequency": 0, "category": "sound", "isExtension": false, "deviceRequired": false, "displayText": "volume", "clashWithDevice": false}, {"text": "taal", "frequency": 0, "category": "translate", "isExtension": true, "deviceRequired": false}, {"text": "tempo", "frequency": 0, "category": "music", "isExtension": true, "deviceRequired": false}, {"text": "uiterlijk []", "frequency": 0, "category": "looks", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "NUMBER_NAME", "isSquare": true, "values": ["nummer", "naam"]}]}, {"text": "versnelling []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["x", "y", "z"]}]}, {"text": "vertaal () naar []", "frequency": 0, "category": "translate", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "LANGUAGE", "isSquare": false, "values": []}]}, {"text": "video [] van []", "frequency": 0, "category": "video", "isExtension": true, "deviceRequired": false, "dropdowns": [{"name": "ATTRIBUTE", "isSquare": false, "values": ["beweging", "richting"]}, {"name": "SUBJECT", "isSquare": false, "values": ["speelveld"]}]}, {"text": "voeg () en () samen", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "wedo!afstand", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "afstand", "clashWithDevice": true}, {"text": "wedo!kantelhoek []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "kantelhoek []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION", "isSquare": false, "values": ["omhoog", "omlaag", "links af", "rechts af"]}]}, {"text": "willekeurig getal tussen () en ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "y-positie", "frequency": 0, "category": "motion", "isExtension": false, "deviceRequired": false}], "conditions": [{"text": "raak ik kleur ()", "frequency": 2, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "() gt ()", "frequency": 1, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "<> of <>", "frequency": 1, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() = ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() bevat ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "() lt ()", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "<> en <>", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "[] bevat ()", "frequency": 0, "category": "list", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "LIST", "isSquare": true, "values": []}]}, {"text": "ev3!knop [] ingedrukt", "frequency": 0, "category": "ev3", "isExtension": true, "deviceRequired": true, "displayText": "knop [] ingedrukt", "clashWithDevice": true, "dropdowns": [{"name": "PORT", "isSquare": false, "values": ["1", "2", "3", "4"]}]}, {"text": "fa!gekanteld []", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true, "displayText": "gekanteld []", "clashWithDevice": true, "dropdowns": [{"name": "TILT", "isSquare": false, "values": ["voor", "achter", "links af", "rechts af", "willekeurig"]}]}, {"text": "gekanteld naar []", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "DIRECTION", "isSquare": false, "values": ["voor", "achter", "links af", "rechts af", "willekeurig"]}]}, {"text": "is steen []", "frequency": 0, "category": "boost", "isExtension": true, "deviceRequired": true, "dropdowns": [{"name": "COLOR", "isSquare": false, "values": ["rood", "blauw", "groen", "geel", "wit", "zwart", "willekeurige kleur"]}]}, {"text": "microbit!knop [] ingedrukt", "frequency": 0, "category": "microbit", "isExtension": true, "deviceRequired": true, "displayText": "knop [] ingedrukt", "clashWithDevice": true, "dropdowns": [{"name": "BTN", "isSquare": false, "values": ["A", "B", "Any"]}]}, {"text": "muis ingedrukt", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "niet <>", "frequency": 0, "category": "operators", "isExtension": false, "deviceRequired": false}, {"text": "raak ik []", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "TOUCHINGOBJECTMENU", "isSquare": false, "values": ["muisaanwijzer", "rand"]}]}, {"text": "raakt kleur () kleur ()", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false}, {"text": "toets [] ingedrukt", "frequency": 0, "category": "sensing", "isExtension": false, "deviceRequired": false, "dropdowns": [{"name": "KEY_OPTION", "isSquare": false, "values": ["spatiebalk", "pijltje omhoog", "pijltje omlaag", "pijltje links", "pijltje rechts", "willekeurig", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}]}, {"text": "vallend", "frequency": 0, "category": "fa", "isExtension": true, "deviceRequired": true}, {"text": "wedo!gekanteld []", "frequency": 0, "category": "wedo", "isExtension": true, "deviceRequired": true, "displayText": "gekanteld []", "clashWithDevice": true, "dropdowns": [{"name": "TILT_DIRECTION_ANY", "isSquare": false, "values": ["omhoog", "omlaag", "links af", "rechts af", "willekeurig"]}]}]}}}`;
const scratchHints = JSON.parse(data);
var scratchHints$1 = scratchHints;

function isFirstLine(cm, lineNo) {
  if (lineNo == 0) return true;
  for (let i = lineNo - 1; i >= 0; i--) {
    let line = cm.getLine(i);
    line = line.trim();
    // if new script line found return true
    if (line.startsWith('-----')) return true;
    // if line is found that is not blank return false
    if (line.trim() !== '') return false;
  }
  return true;
}
function showInstructions(cm) {
  let cursor = cm.getCursor(),
    line = cm.getLine(cursor.line),
    lineNo = cursor.line,
    instructions = [];

  // console.log(isFirstLine(cm, lineNo))
  if (isFirstLine(cm, lineNo)) {
    if (/filename\:\s?[^\s]+\.$/.test(line)) {
      return {
        list: ['png', 'jpg'],
        from: {
          line: lineNo,
          ch: cursor.ch
        },
        to: {
          line: lineNo,
          ch: line.length
        }
      };
    } else if (/strict\:\s?[^\s]+\.$/.test(line)) {
      return {
        list: ['no', 'yes'],
        from: {
          line: lineNo,
          ch: cursor.ch
        },
        to: {
          line: lineNo,
          ch: line.length
        }
      };
    } else {
      if (line.indexOf('filename') == -1) instructions.push('filename:');
      if (line.indexOf('scale_factor') == -1) instructions.push('scale_factor:');
      if (line.indexOf('strict') == -1) instructions.push('strict:');
    }
  } else {
    return {
      list: [{
        text: '-----'
      }],
      from: {
        line: lineNo,
        ch: 0
      },
      to: {
        line: lineNo,
        ch: line.length
      }
    };
  }
  let search = line.replace('--', '').trim();
  let pos = '--'.length;
  if (line.indexOf(',') > -1) {
    pos = line.lastIndexOf(',');
    search = line.substring(pos + 1).trim();
    if (line.length > pos + 1 && line[pos + 1] === ' ') {
      pos += 2;
    } else {
      pos += 1;
    }
  }
  return {
    list: instructions.filter(i => i.startsWith(search)).map(i => {
      const text = line[line.length - 1] !== ' ' ? ` ${i}` : i;
      return {
        text: text,
        category: 'instruction'
      };
    }),
    from: {
      line: lineNo,
      ch: pos
    },
    to: {
      line: lineNo,
      ch: line.length
    }
  };
}
let commandType = [{
  opening: "(",
  closing: ")",
  type: "value"
}, {
  opening: "<",
  closing: ">",
  type: "condition"
}, {
  opening: "[",
  closing: "]",
  type: "dropdown"
}];
const OPENING = commandType.map(c => c.opening);
const CLOSING = commandType.map(c => c.closing);
function findClosingElement(line, element) {
  let brackets = [];
  for (let i = 0; i < line.length; i++) {
    let char = line[i];
    if (OPENING.includes(char)) {
      brackets.push({
        char: CLOSING[OPENING.indexOf(char)],
        pos: i
      });
    }
    if (CLOSING.includes(char)) {
      if (brackets.length == 0) {
        brackets.push({
          char: char,
          pos: i
        });
        break;
      }
      if (brackets.length > 0 && brackets[brackets.length - 1].char == char) {
        brackets.pop();
      }
    }
  }
  const found = brackets.filter(b => b.char == element);
  if (found.length > 0) {
    return found[0].pos;
  } else {
    if (brackets.length > 0) {
      return brackets[brackets.length - 1].pos; //line.length
    }
    return 0;
  }
}
function hasOuterDirectives(line) {
  const directives = scratchHints$1.directives.outer;
  let matches = directives.map(d => {
    return {
      index: line.indexOf(`${d.text}!`),
      directive: d
    };
  }).filter(m => m.index !== -1).sort((a, b) => {
    a.index - b.index;
  }).map(m => m.directive.text);
  return {
    has: matches.length > 0,
    directives: matches
  };
}
function isPossibleDirective(candidate) {
  const specialMarks = [...OPENING, ...CLOSING];
  const results = specialMarks.map(s => candidate.indexOf(s)).filter(r => r > -1);
  return results.length === -1;
}
function getCommandType(cursor, line) {
  let pos = cursor.ch,
    head = line.substring(0, pos),
    tail = line.substring(pos);

  // console.log(`cursor.pos: ${pos}, head: ${head}, tail: ${tail}`)
  let brackets = [];
  for (let i = 0; i < head.length; i++) {
    let char = head[i];
    if (OPENING.includes(char)) {
      brackets.push({
        char: CLOSING[OPENING.indexOf(char)],
        pos: i
      });
    }
    if (CLOSING.includes(char)) {
      if (brackets.length > 0 && brackets[brackets.length - 1].char == char) {
        brackets.pop();
      }
    }
  }
  // console.log('Brackets')
  // console.log(brackets)
  if (brackets.length > 0) {
    // check if an inner directive is being entered
    const exclamation_pos = tail.indexOf('!');
    if (exclamation_pos > -1) {
      return {
        type: "innerdirective",
        from: brackets[brackets.length - 1].pos,
        to: exclamation_pos - 1
      };
    }
    // not an inner directive
    let found = commandType.filter(c => c.closing == brackets[brackets.length - 1].char);
    let to = line.length;
    if (tail.length > 0) {
      to = findClosingElement(tail, found[0].closing) + pos;
    }
    let from = brackets[brackets.length - 1].pos + 1;
    // Handle special case of returning a condition in a situation where the head looks like "...<("
    if (found[0].type == "value" || found[0].type == "condition") {
      const lookback = from + 1 - to + 1;
      // console.log(`Lookback: ${lookback}`)
      // console.log(`head[from - lookback]: ${head[from - lookback]}`)
      if (head.length > lookback - 1 && head[from - lookback] == "<") {
        found = commandType.filter(c => c.opening == '<');
        if (from == to) from--;
      }
    }
    if (found[0].type == "value") {
      const lookback = from + 1 - to + 1;
      // console.log(`Lookback: ${lookback}`)
      // console.log(`head[from - lookback]: ${head[from - lookback]}`)
      if (head.length > lookback - 1 && head[from - lookback] == "(") {
        // found = commandType.filter(c => c.opening == '(')
        if (from == to) from--;
      }
    }
    if (found[0].type == "dropdown") {
      const lookback = from + 1 - to + 1;
      // console.log(`Lookback: ${lookback}`)
      // console.log(`head[from - lookback]: ${head[from - lookback]}`)
      if (head.length > lookback - 1 && head[from - lookback] == "(") {
        found = commandType.filter(c => c.opening == '(');
        if (from == to) from--;
      }
    }
    return {
      type: found[0].type,
      syntax: Parser.getBaseSyntax(line.substring(from, to)),
      from: from,
      to: to
    };
  }

  // if the tail contains an exclamation mark the cursor might be in the middle of a directive
  const exclamation_pos = tail.indexOf('-1');
  if (exclamation_pos > -1) {
    if (isPossibleDirective(tail)) {
      let from = head.indexOf('!');
      if (from == -1) from = 0;else from++;
      return {
        type: "outerdirective",
        from: from,
        to: exclamation_pos - 1
      };
    }
  }
  let from = Parser.determineLineIndent(line);
  if (hasOuterDirectives(head).has) {
    from = head.lastIndexOf('!');
    if (from > -1) from++;
  }

  //need to check if block has a directive at the beginning
  return {
    type: "block",
    syntax: Parser.getBaseSyntax(head),
    from: from,
    to: head.length,
    hasTrailing: tail.length > 0
  };
}
function getDropdownSuggestions(text, cursor, line, language, show_device_extensions) {
  const pos = cursor.ch - 1;
  let found = false,
    head = '',
    level = 0,
    seeking = null,
    dropdown_pos = 0,
    stops = ['(', '<'];
  for (let i = pos; i >= 0; i--) {
    let char = line[i];
    if (!found) {
      if (char == '[') {
        head = char;
        found = true;
      }
    } else {
      if (OPENING.indexOf(char) > -1) {
        if (stops.indexOf(char) > -1 && seeking == null && level == 0) break;
        if (seeking == char) {
          head = char + head;
          seeking = null;
          level--;
        }
      } else if (CLOSING.indexOf(char) > -1) {
        if (char == ']') dropdown_pos++;
        seeking = OPENING[CLOSING.indexOf(char)];
        level++;
        head = char + head;
      } else {
        if (seeking == null) head = char + head;
      }
    }
  }
  found = false;
  level = 0;
  let tail = '';
  stops = [')', '>'];
  for (let i = pos; i < line.length; i++) {
    let char = line[i];
    if (!found) {
      if (char == ']') {
        tail = char;
        found = true;
      }
    } else {
      if (CLOSING.indexOf(char) > -1) {
        if (stops.indexOf(char) > -1 && seeking == null && level == 0) break;
        if (seeking == char) {
          tail += char;
          seeking = null;
          level--;
        }
      } else if (OPENING.indexOf(char) > -1) {
        seeking = CLOSING[OPENING.indexOf(char)];
        level++;
        tail += char;
      } else {
        if (seeking == null) tail += char;
      }
    }
  }
  const parent = (head + tail).trim();
  console.log(`Parent: ${parent}, dropdown pos: ${dropdown_pos}`);
  let dropdowns = [];
  let candidates = [...scratchHints$1.commands[language].blocks, ...scratchHints$1.commands[language].values, ...scratchHints$1.commands[language].conditions];
  if (!show_device_extensions) {
    candidates = candidates.filter(o => !o.deviceRequired);
  }
  let matches = candidates.filter(c => normalise(c.text).startsWith(normalise(parent)));
  console.log('Matches');
  console.log(matches);
  matches.forEach(b => b.dropdowns[dropdown_pos].values.forEach(v => {
    if (v.toLowerCase().startsWith(text)) dropdowns.push({
      text: v,
      category: null
    });
  }));
  console.log('Dropdowns first pass');
  console.log(dropdowns);
  if (matches.length == 1 && !matches[0].dropdowns[dropdown_pos].isSquare) {
    let values = scratchHints$1.commands[language].values.filter(h => normalise(h.text).startsWith(text));
    if (!show_device_extensions) {
      values = values.filter(v => !v.deviceRequired);
    }
    values.forEach(v => {
      if (v.text.toLowerCase().startsWith(text)) dropdowns.push({
        text: v.text,
        category: v.category
      });
    });
  }
  console.log('Dropdowns final');
  console.log(dropdowns);
  return dropdowns;
}
function expandBlockWithValues(block, syntax, level = 1) {
  const DUMMYTEXT = 'ZXCVBNM;'; // This should be a string which would never be entered
  let updatedBlock = block;
  for (let item of syntax.inner) {
    const needle = `${item.openingchar}${CLOSING[OPENING.indexOf(item.openingchar)]}`;
    // replace empty strings '' which would result in empty fields () with dummy text
    // that way completed fields which are empty can be differentiated from 
    // empty fields which haven't yet been populated. Without this 
    // go to x ((x position) + ()) y (y position) gets completed as
    // go to x ((x position) + (y position)) y () after accepting the hint
    // go to x () y ()
    const replacementText = item.base === '' ? DUMMYTEXT : item.base;
    const replacement = `${item.openingchar}${replacementText}${CLOSING[OPENING.indexOf(item.openingchar)]}`;
    updatedBlock = updatedBlock.replace(needle, replacement);
    if (item.inner) {
      updatedBlock = expandBlockWithValues(updatedBlock, item, level + 1);
    }
  }
  if (level === 1) {
    updatedBlock = updatedBlock.replace(`(${DUMMYTEXT})`, '()').replace(`<${DUMMYTEXT}>`, '<>').replace(`[${DUMMYTEXT}]`, '[]');
  }
  return updatedBlock;
}
function removeOuterDirectives(block) {
  return block.substring(block.lastIndexOf('!') + 1);
}
function normalise(text) {
  return removeOuterDirectives(text).toLowerCase();
}
function updateTextAndDisplayText(blocks, syntax) {
  let newBlocks = blocks.map(b => {
    return {
      ...b,
      displayText: removeOuterDirectives(b.text)
    };
  });
  newBlocks.forEach(b => b.text = expandBlockWithValues(b.text, syntax));
  return newBlocks;
}
function calculateMatchQuality(block, line) {
  // basic function to calculate the quality of the match e.g. if
  // the line's length/block's length == 1 then they're a perfect
  // match with a score of 100.0 
  if (block.toLowerCase().startsWith(line)) {
    const score = line.length / block.length * 100;
    if (score > 90) return score;else return 25;
  }
  return 0;
}
function showHints(cm, language, show_device_extensions) {
  // if inside an unbalance ( or < or [
  // need to consider user editing directive e.g. motion!move (10) steps, if the cursor
  // is placed before the exclamation mark then only directives should be considered
  // if cursor is placed after exclamation then blocks should be considered
  let cursor = cm.getCursor(),
    line = cm.getLine(cursor.line),
    lineNo = cursor.line,
    suggestions = [],
    directives = [],
    from = null,
    to = null,
    showDisplayText = false;

  // console.log('Cursor')
  // console.log(cursor)
  let commandType = getCommandType(cursor, line);
  // console.log('Command type')
  // console.log(commandType)
  let text = line.substring(commandType.from, commandType.to).toLowerCase();
  // console.log('text')
  // console.log(text)
  switch (commandType.type) {
    case "value":
      if (line.trim() !== commandType.syntax.base) {
        text = commandType.syntax.base.toLowerCase();
        showDisplayText = true;
      }
      let values = scratchHints$1.commands[language].values.filter(h => normalise(h.text).startsWith(text));
      if (!show_device_extensions) {
        values = values.filter(v => !v.deviceRequired);
      }
      if (showDisplayText) {
        values = updateTextAndDisplayText(values, commandType.syntax);
      }
      directives = scratchHints$1.directives.inner.filter(h => h.text.startsWith(text)).map(d => {
        return {
          text: `${d.text}!`,
          category: "directive"
        };
      });
      suggestions = [...values, ...directives];
      break;
    case "condition":
      if (line !== commandType.syntax.base) {
        text = commandType.syntax.base.toLowerCase();
        showDisplayText = true;
      }
      let conditions = scratchHints$1.commands[language].conditions.filter(h => normalise(h.text).startsWith(text));
      if (!show_device_extensions) {
        conditions = conditions.filter(c => !c.deviceRequired);
      }
      if (showDisplayText) {
        conditions = updateTextAndDisplayText(conditions, commandType.syntax);
      }
      directives = scratchHints$1.directives.inner.filter(h => h.text.startsWith(text)).map(d => {
        return {
          text: `${d.text}!`,
          category: "directive"
        };
      });
      suggestions = [...conditions, ...directives];
      break;
    case "dropdown":
      suggestions = getDropdownSuggestions(text, cursor, line, language, show_device_extensions);
      break;
    case "innerdirective":
      let inner = scratchHints$1.directives.inner;
      if (!show_device_extensions) {
        inner = inner.filter(o => !o.deviceRequired);
      }
      suggestions = inner.filter(h => h.text.startsWith(text)).map(d => {
        return {
          text: `${d.text}!`,
          category: "directive"
        };
      });
      break;
    case "outerdirective":
      let outer = scratchHints$1.directives.outer;
      if (!show_device_extensions) {
        outer = outer.filter(o => !o.deviceRequired);
      }
      suggestions = outer.filter(h => h.text.startsWith(text)).map(d => {
        return {
          text: `${d.text}!`,
          category: "directive"
        };
      });
      break;
    case "block":
      if (line !== commandType.syntax.base) {
        text = removeOuterDirectives(commandType.syntax.base.toLowerCase());
        // console.log('Updated text')
        // console.log(text)
        showDisplayText = true;
      }
      let blocks = [];
      if (!commandType.hasTrailing) {
        blocks = scratchHints$1.commands[language].blocks;
        if (!show_device_extensions) {
          blocks = blocks.filter(b => !b.deviceRequired);
          blocks = blocks.map(b => {
            if (b.clashWithDevice) {
              return {
                ...b,
                text: removeOuterDirectives(b.text)
              };
            } else {
              return b;
            }
          });
        }
        blocks = blocks.filter(b => normalise(b.text).startsWith(text)).map(b => {
          return {
            ...b,
            score: calculateMatchQuality(b.text, text)
          };
        }).sort((a, b) => b.score - a.score);
        if (showDisplayText) {
          blocks = updateTextAndDisplayText(blocks, commandType.syntax);
        }
      }
      const currentDirectives = hasOuterDirectives(line);
      if (currentDirectives.has) {
        // Check if a manual directive was provided for a block with an auto directive e.g.
        // change [] effect by ()
        for (let block of blocks) {
          for (let directive of currentDirectives.directives) {
            if (block.text.indexOf(`${directive}!`) > -1) {
              block.text = block.text.replace(`${directive}!`, '');
            }
          }
        }
      } else {
        directives = scratchHints$1.directives.outer;
        if (!show_device_extensions) {
          directives = directives.filter(b => !b.deviceRequired);
        }
        directives = directives.filter(h => h.text.startsWith(text)).map(d => {
          return {
            text: `${d.text}!`,
            category: "directive"
          };
        });
      }
      suggestions = [...blocks, ...directives];
      // from = Parser.determineLineIndent(line) + commandType.from
      // to = Parser.determineLineIndent(line) + commandType.to
      break;
  }
  return {
    list: suggestions,
    from: {
      line: lineNo,
      ch: from || commandType.from
    },
    to: {
      line: lineNo,
      ch: to || commandType.to
    }
  };
}
function autocomplete(cm, language, show_device_extensions) {
  // if it is an instruction line then return instructions
  // if it is an instruction line and filename: as been entered then when . is entered then show [png, jpg]
  // if there is an open ( i.e. on that is not closed then we need to return values
  // if there is an open < then we need to return conditions
  // if there is an open [ then we need to return drop down values from all matching commands
  // when a - is entered should -- filename:, -----, and -- scale_factor as options
  // otherwise show blocks and directives
  let cursor = cm.getCursor(),
    line = cm.getLine(cursor.line);
  // console.log(line)
  let hints = [];
  if (line.startsWith('--')) {
    hints = showInstructions(cm);
  } else {
    hints = showHints(cm, language, show_device_extensions);
  }
  // add className to hints
  if (hints) {
    for (let item of hints.list) {
      if (typeof item == 'object') {
        if (item.category) {
          item.className = `CodeMirror-scratch-completion CodeMirror-scratch-completion-${item.category}`;
        }
      }
    }
  }
  // console.log('Hints')
  // console.log(hints)    
  return hints;
}

// export default function hints(cm, options) {
//     const language = options.language.tag
//     const show_device_extensions = options.show_device_extensions || false
//     return parse(cm, language, show_device_extensions)
// }

const EventBus = new Vue();
const EVENT_REDRAWPREVIEW = 'REDRAWPREVIEW';

var script$b = {
  name: "ps-import-file",
  props: ["name", "options"],
  data() {
    return {
      maxUploadSize: this.appConfig.maxUploadSize
    };
  },
  inject: ["appConfig"],
  methods: {
    uploadFile: function (event) {
      const files = event.target.files; // $('#upload').prop('files');
      if (files.length > 0) {
        const file = files[0];
        //Check that the file uploaded is less than some max size.
        if (file.size > this.maxUploadSize) {
          if (this.showErrorMessage) this.showErrorMessage(`Uploaded file is too large. Maximum accepted size is ${this.maxUploadSize}MB.`);
        } else {
          const fileparts = file.name.split(".");
          const ext = fileparts[fileparts.length - 1];
          if (ext === "sb3" || ext === "zip") {
            this.extractAsFormData(file);
          } else {
            const reader = new FileReader();
            reader.onerror = function (e) {
              if (this.showErrorMessage) this.showErrorMessage(e.message);
            };
            reader.obabort = function (e) {};
            reader.onload = () => {
              let result = reader.result;
              // this.editor.setValue(result);
              this.emitFileUploaded(result);
              //Reset file name to empty in case user wants to re-upload the same file
              this.resetUpload();
            };
            reader.readAsText(file);
          }
        }
      }
    },
    extractAsFormData: function (file) {
      if (this.appConfig.loading) this.appConfig.loading(true);
      this.appConfig.convertSB3(this.options.editor_language, file).then(result => {
        if (this.appConfig.loading) this.appConfig.loading(false);
        this.resetUpload();
        if (result.error) {
          // The card had an error when trying to attach it to a customer
          throw result;
        }
        return result;
      }).then(result => {
        // this.editor.setValue(result.markdown);
        this.emitFileUploaded(result.markdown);
      }).catch(error => {
        this.displayError(error);
      });
    },
    resetUpload: function () {
      this.$refs.upload.value = "";
    },
    displayError: function (event) {
      if (event.error) {
        if (this.appConfig.showErrorMessage) this.appConfig.showErrorMessage(event.error.message);
      } else {
        if (this.appConfig.clearErrorMessages) this.appConfig.clearErrorMessages();
      }
    },
    simulateUploadClick: function () {
      const uploadBtn = this.$refs.upload;
      uploadBtn.click();
    },
    emitFileUploaded: function (data) {
      this.$emit("file-uploaded", data);
    }
  }
};

/* script */
const __vue_script__$b = script$b;

/* template */
var __vue_render__$b = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "col"
  }, [_c('input', {
    ref: "upload",
    staticClass: "btn",
    attrs: {
      "type": "file",
      "id": "upload",
      "accept": ".txt,.sb3",
      "hidden": ""
    },
    on: {
      "change": _vm.uploadFile
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input_submit",
    attrs: {
      "id": "btn-upload",
      "type": "button",
      "value": _vm.name
    },
    on: {
      "click": _vm.simulateUploadClick
    }
  })]);
};
var __vue_staticRenderFns__$b = [];

/* style */
const __vue_inject_styles__$b = undefined;
/* scoped */
const __vue_scope_id__$b = "data-v-36670288";
/* module identifier */
const __vue_module_identifier__$b = undefined;
/* functional template */
const __vue_is_functional_template__$b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$d = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, undefined, undefined, undefined);
var PsImportFile = __vue_component__$d;

var script$a = {
  name: 'ps-error-line',
  props: ['error'],
  data() {
    return {};
  },
  computed: {
    lineNo: function () {
      return this.error.lineNo;
    }
  }
};

/* script */
const __vue_script__$a = script$a;

/* template */
var __vue_render__$a = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "error-line"
  }, [_c('tr', [_c('td', {
    staticClass: "error-line-header"
  }, [_vm._v("Line")]), _vm._v(" "), _c('td', {
    staticClass: "error-line-no"
  }, [_vm._v(_vm._s(_vm.lineNo) + ":")]), _vm._v(" "), _c('td', _vm._l(_vm.error.errors, function (line, index) {
    return _c('div', {
      key: index
    }, [_vm._v(_vm._s(line))]);
  }), 0)])]);
};
var __vue_staticRenderFns__$a = [];

/* style */
const __vue_inject_styles__$a = undefined;
/* scoped */
const __vue_scope_id__$a = "data-v-2597483c";
/* module identifier */
const __vue_module_identifier__$a = undefined;
/* functional template */
const __vue_is_functional_template__$a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$c = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, undefined, undefined, undefined);
var PsErrorLine = __vue_component__$c;

var script$9 = {
  name: 'ps-errors',
  props: ['errors'],
  components: {
    PsErrorLine
  },
  data() {
    return {
      expanded: false
    };
  },
  computed: {
    number: function () {
      return this.errors.length || 0;
    },
    hasErrors: function () {
      return this.errors && this.errors.length > 0;
    },
    errorIcon: function () {
      if (this.expanded) {
        return "fa-angle-down";
      } else {
        return "fa-angle-up";
      }
    }
  },
  methods: {
    onErrorIconClicked: function () {
      this.expanded = !this.expanded;
      const elements = document.querySelectorAll(".show-errors .details");
      if (this.expanded) {
        addClass(elements[0], "errors-expanded");
      } else {
        removeClass(elements[0], "errors-expanded");
      }
      this.$emit('errors-clicked', this.expanded);
    }
  }
};

/* script */
const __vue_script__$9 = script$9;

/* template */
var __vue_render__$9 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "show-errors"
  }, [_c('div', {
    staticClass: "header",
    class: {
      errors: _vm.hasErrors
    }
  }, [_c('span', [_c('strong', [_vm._v("Errors: " + _vm._s(_vm.number))])]), _vm._v(" "), _c('div', {
    staticClass: "error_msg_icon float-right",
    on: {
      "click": _vm.onErrorIconClicked
    }
  }, [_c('span', {
    staticClass: "error-icon"
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.errorIcon,
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.expanded,
      expression: "expanded"
    }],
    staticClass: "details"
  }, [_c('tbody', _vm._l(_vm.errors, function (error, index) {
    return _c('PsErrorLine', {
      key: index,
      attrs: {
        "error": error
      }
    });
  }), 1)])]);
};
var __vue_staticRenderFns__$9 = [];

/* style */
const __vue_inject_styles__$9 = function (inject) {
  if (!inject) return;
  inject("data-v-0a52942f_0", {
    source: ".errors[data-v-0a52942f]{background-color:#e41a1a}.errors span[data-v-0a52942f]{color:#fff}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$9 = "data-v-0a52942f";
/* module identifier */
const __vue_module_identifier__$9 = undefined;
/* functional template */
const __vue_is_functional_template__$9 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$b = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, createInjector, undefined, undefined);
var PsErrors = __vue_component__$b;

var script$8 = {
  name: "ps-editor-overlay",
  props: [],
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    clearClicked: function (e) {
      this.$emit("clear-editor");
      e.preventDefault();
    },
    copyClicked: function (e) {
      this.$emit("copy-editor");
      e.preventDefault();
    },
    pasteClicked: function (e) {
      this.$emit("paste-editor");
      e.preventDefault();
    },
    saveClicked: function (e) {
      this.$emit("save-editor");
      e.preventDefault();
    }
  }
};

/* script */
const __vue_script__$8 = script$8;

/* template */
var __vue_render__$8 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_c('button', {
    staticClass: "btn",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Save to file"
    },
    on: {
      "click": _vm.saveClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Copy to clipboard"
    },
    on: {
      "click": _vm.copyClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-files-o"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Paste clipboard"
    },
    on: {
      "click": _vm.pasteClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "data-toggle": "tooltip",
      "title": "Clear editor"
    },
    on: {
      "click": _vm.clearClicked
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]);
};
var __vue_staticRenderFns__$8 = [];

/* style */
const __vue_inject_styles__$8 = function (inject) {
  if (!inject) return;
  inject("data-v-d2388c90_0", {
    source: ".btn[data-v-d2388c90]{padding:0;width:20px;height:20px;margin-right:5px;color:#747474}.btn[data-v-d2388c90]:hover{cursor:pointer;color:#000}.btn .fa[data-v-d2388c90]:hover{cursor:pointer}.btn[data-v-d2388c90]:active,.btn[data-v-d2388c90]:focus{outline:0!important;box-shadow:none}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$8 = "data-v-d2388c90";
/* module identifier */
const __vue_module_identifier__$8 = undefined;
/* functional template */
const __vue_is_functional_template__$8 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$a = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, createInjector, undefined, undefined);
var PsEditorOverlay = __vue_component__$a;

var script$7 = {
  name: "ps-editor",
  props: ["languages", "options", "placeholder"],
  components: {
    PsImportFile,
    PsErrors,
    PsEditorOverlay
  },
  data() {
    return {
      markdown: "",
      editor: null,
      processor: null,
      initialised: false,
      errors: [],
      previewInfo: {
        filenames: [],
        workingTrees: []
      },
      autoAddLine: false,
      defaultLanguage: 1
    };
  },
  inject: ["appConfig"],
  // watch: {
  //   blockLanguage: function() {
  //     this.initialiseProcessor();
  //   },
  // },
  computed: {
    editorLanguage: function () {
      return this.options.editor_language;
    },
    blockLanguage: function () {
      return this.options.language;
    },
    language: function () {
      const matches = this.languages.filter(l => l.id == this.editorLanguage);
      if (matches) {
        return matches[0];
      }
      return null;
    },
    hintOptions: function () {
      return {
        hint: this.hints,
        completeSingle: false
      };
    }
  },
  watch: {
    blockLanguage: function () {
      this.initialiseProcessor();
    },
    "options.enable_autocomplete": function (value) {
      if (this.editor) {
        this.editor.setOption("hintOptions", value && this.hintOptions);
      }
    },
    "options.editor_text_size": function () {
      if (this.editor) this.setFontSize();
    },
    "options.indent_unit": function (newValue, oldValue) {
      if (this.editor) {
        this.editor.setOption("indentUnit", parseInt(this.options.indent_unit));
        this.editor.setOption("tabSize", parseInt(this.options.indent_unit));
        this.updateExistingIndentations(newValue, oldValue);
      }
    }
  },
  methods: {
    updateExistingIndentations: function (to, from) {
      // let newLines = []
      this.editor.eachLine(l => {
        // newLines.push(l.text.replaceAll(' '.repeat(from), ' '.repeat(to)))
        l.text = l.text.replaceAll(' '.repeat(from), ' '.repeat(to));
      });
      // this.editor.setValue(newLines.join('\n'))
      this.editor.refresh();
      // this.editor.focus()
    },
    moveToNextEmptyField: function (cm, line = null) {
      let cursor = cm.getCursor();
      line = cm.getLine(cursor.line).trim();
      // console.log('cm.getLine(line')
      // console.log(cm.getLine(line))
      let positions = ['()', '<>', '[]'].map(e => line.indexOf(e)).filter(v => v > -1);
      if (positions.length > 0) {
        // console.log('Positions')
        // console.log(positions)
        let pos = Math.min(...positions) + 1;
        const indentation = cm.getLine(cursor.line).indexOf(line);
        this.editor.setCursor({
          line: cursor.line,
          ch: pos + indentation
        });
      } else {
        let result = Parser.checkBracketsLine(cm.getLine(cursor.line));
        // console.log('checkBrackets line')
        // console.log(result)
        if (result.valid) {
          this.editor.setCursor({
            line: cursor.line,
            ch: cm.getLine(cursor.line).length
          });
        }
      }
    },
    toggleHighlight: function (cm) {
      //line.search(/[^\s]/) // finds the position of the first non-white space character
    },
    findCorrespondingIf: function (cm, lineNo) {
      const ifs = ['if <', 'si <',, 'se <',, 'falls <', 'als <', 'jos <'];
      if (lineNo > 0) {
        for (let i = lineNo - 1; i >= 0; i--) {
          const line = cm.getLine(i);
          const matches = ifs.filter(i => line.trim().startsWith(i));
          if (matches.length > 0) {
            return line;
          }
        }
      }
      return null;
    },
    determineIndentation: function (line, indentUnit) {
      if (line.length == 0) return 0;
      for (let i = 0; i < line.length; i++) {
        if (line[i] != ' ') return i / indentUnit;
      }
    },
    dedentElse: function (cm, elseLine, lineNo) {
      const indentUnit = cm.options.indentUnit;
      const elseIndentation = this.determineIndentation(elseLine, indentUnit);
      const ifLine = this.findCorrespondingIf(cm, lineNo);
      if (ifLine) {
        const ifIndentation = this.determineIndentation(ifLine, indentUnit);
        if (elseIndentation > ifIndentation) return true;
      }
      return false;
    },
    hints: function (cm, options) {
      /* Do not move this function inside of autocomplete.js as having it there creates an intermittent
         error in show_hints, 't is not a function' which when googled could not be found */
      const elses = ['tai muuten', 'anders', 'altrimenti', 'sonst', 'senão', 'senão', 'si no', 'si no', 'else', 'sinon'];
      const language = this.language.tag;
      const show_device_extensions = this.options.include_device_extensions || false;
      let result = autocomplete(cm, language, show_device_extensions);
      let cursor = cm.getCursor(),
        line = cm.getLine(cursor.line);
      if (result) CodeMirror.on(result, "pick", completion => {
        // console.log('Value has been selected:')
        // console.log(completion)
        // console.log('Cursor position:')
        // console.log(cursor.ch)
        // console.log(cursor.line)
        // console.log(Parser.determineLineIndent(line))
        let value = completion.text || completion;
        if (elses.indexOf(value.trim()) > -1) {
          // console.log('Found an else: ' + value.trim())
          // need to find the corresponding if and if the indentation level is greater than that of 
          // the if then subtract from indent
          if (this.dedentElse(cm, line, cursor.line)) {
            cm.indentLine(cursor.line, "subtract");
          }
        }
        //check if value selected if a directive, if not move to the next empty field
        if (value[value.length - 1] !== '!') {
          this.moveToNextEmptyField(cm);
        }
      });
      return result;
    },
    getMode: function () {
      let mode = 'text/x-scratch';
      if (this.language.tag != "en") {
        mode = "text/x-scratch-" + this.language.tag;
      }
      return {
        name: mode,
        globalVars: true
      };
    },
    editorLanguageChanged: function () {
      // console.log(this.editorLanguage);
      let mime = "text/x-scratch";
      if (this.language.tag == "en") {
        mime = "text/x-scratch";
      } else {
        mime = "text/x-scratch-" + this.language.tag;
        "scratch-" + this.language.tag;
      }
      this.editor.setOption("mode", mime);
      //CodeMirror.autoLoadMode(this.editor, mode);
      this.initialiseProcessor();
      this.emitEditorLanguageChanged();
    },
    setDefaultLanguage: function () {
      saveDefaultLanguage(this.options.editorLanguage);
    },
    editorChanged: function (instance, changeObj) {
      if (this.appConfig.clearErrorMessages) this.appConfig.clearErrorMessages();
      this.markdown = this.editor.getValue();
      this.processor.init().then(() => {
        // the following method is debounced 500 ms
        this.debouncedParse(this.markdown, changeObj.from.line);
        // uncomment the following and comment out the debounced version to call it immediately
        // this.parse(changeObj.from.line)
      }).catch(e => {
        if (this.appConfig.showErrorMessage) this.appConfig.showErrorMessage("An error occurred attempting the call to the Parser");
      });
    },
    parse: function (value, lineNo) {
      if (this.appConfig.loading) this.appConfig.loading(true);
      const results = this.processor.process(value);
      this.errors = results.errors;
      this.markErrors();
      const newPreviewInfo = {
        workingTrees: results.workingTrees
      };
      this.previewInfo = newPreviewInfo;
      if (this.errors.length === 0) {
        EventBus.$emit(EVENT_REDRAWPREVIEW, {
          info: this.previewInfo,
          count: this.previewInfo ? this.previewInfo.length : 0,
          lineNo: lineNo
        });
      }
      if (this.autoAddLine) {
        this.autoAddLine = false;
        this.addNewLine();
      }
      if (this.appConfig.loading) this.appConfig.loading(false);
    },
    initialiseEditor: function () {
      this.editor = CodeMirror.fromTextArea(document.getElementById("markdown"), {
        // extraKeys: {"Ctrl-Space": "autocomplete"},
        lineNumbers: true,
        mode: this.getMode(),
        indentUnit: parseInt(this.options.indent_unit),
        tabSize: this.indentSize,
        extraKeys: {
          "Ctrl-M": cm => {
            this.moveToNextEmptyField(cm);
          },
          "Cmd-M": cm => {
            this.moveToNextEmptyField(cm);
          },
          "Alt-H": cm => {
            this.toggleHighlight(cm);
          },
          Tab: function (cm) {
            if (cm.somethingSelected()) {
              cm.indentSelection("add");
            } else {
              cm.replaceSelection(cm.getOption("indentWithTabs") ? "\t" : Array(cm.getOption("indentUnit") + 1).join(" "), "end", "+input");
            }
          },
          Backspace: cm => {
            const cursor = cm.getCursor(),
              line = cm.getLine(cursor.line),
              pos = cursor.ch,
              head = line.substring(0, pos); // portion of line to left of cursor
            // console.log(`Backspace line: ${line}`)
            let amount = -1;
            if (/^\s*$/.test(head) && head.length > 0) {
              // Tests if the head is only white space
              const indentUnit = cm.options.indentUnit;
              // Check if the line is an integral multiple of the indentUnit
              if (line.length % indentUnit == 0) {
                // backspace in indentUnit increments
                amount = -cm.options.indentUnit;
              } else {
                // backspace to an integral indentUnit by removing the excess
                amount = -(line.length % indentUnit);
              }
            }
            deleteBackwardChar(cm, amount);
          }
        }
      });
      if (this.options.enable_autocomplete) {
        this.editor.setOption("hintOptions", this.hintOptions);
      }
      this.editor.on("change", (instance, changeObj) => this.editorChanged(instance, changeObj));
      this.editor.on("inputRead", function (instance) {
        if (instance.state.completionActive) {
          return;
        }
        var cur = instance.getCursor();
        instance.getTokenAt(cur);
        //if (token.type && token.type != "comment") {
        CodeMirror.commands.autocomplete(instance);
        //}
      });
      this.editor.on("scroll", instance => this.editorScrolled(instance));
      this.editor.setSize("100%", "100%");
      // Possible values Small: 12, Default: 14, Large: 18, Largest: 22
      this.setFontSize();
    },
    setFontSize: function () {
      switch (this.options.editor_text_size) {
        case "1":
          this.editor.getWrapperElement().style["font-size"] = "12px";
          break;
        case "2":
          //Normal
          this.editor.getWrapperElement().style["font-size"] = "14px";
          break;
        case "3":
          //Larger
          this.editor.getWrapperElement().style["font-size"] = "18px";
          break;
        case "4":
          //Largest
          this.editor.getWrapperElement().style["font-size"] = "22px";
          break;
      }
      this.editor.refresh();
    },
    initialiseProcessor: function () {
      this.initialised = false;
      if (this.appConfig.loading) this.appConfig.loading(true);
      if (this.appConfig.clearErrorMessages) this.appConfig.clearErrorMessages();
      this.processor = new Processor(this.appConfig.api, {
        editorLanguage: this.editorLanguage,
        blockLanguage: this.blockLanguage,
        strict: true
      });
      this.processor.init().then(() => {
        this.initialised = true;
        if (!this.editor) {
          this.initialiseEditor();
        }
        this.editor.setValue(this.markdown);
        if (this.appConfig.loading) this.appConfig.loading(false);
      }).catch(e => {
        // console.log(e)
        if (this.appConfig.loading) this.appConfig.loading(false);
        if (this.appConfig.showErrorMessage) this.appConfig.showErrorMessage("An error occurred attempting to initialise the Processor");
      });
    },
    markErrors: function () {
      const cmGutterElements = "CodeMirror-linenumber CodeMirror-gutter-elt";
      const elements = document.getElementsByClassName(cmGutterElements);
      for (let element of elements) {
        const lineNo = element.innerText;
        const lineErrors = this.errors.filter(item => item.lineNo == lineNo).map(item => item.errors);
        if (lineErrors.length > 0) {
          element.style.backgroundColor = "red";
          element.style.color = "white";
          element.style.cursor = "pointer";
          element.setAttribute("data-toggle", "tooltip");
          element.setAttribute("title", lineErrors.join("<br>"));
        } else {
          element.style.backgroundColor = "";
          element.style.color = "";
          element.style.cursor = "";
          element.removeAttribute("data-toggle");
          element.removeAttribute("title");
        }
      }
    },
    editorScrolled: function (instance) {
      this.markErrors();
    },
    supportTabInTextBox: function () {
      HTMLTextAreaElement.prototype.getCaretPosition = function () {
        //return the caret position of the textarea
        return this.selectionStart;
      };
      HTMLTextAreaElement.prototype.setCaretPosition = function (position) {
        //change the caret position of the textarea
        this.selectionStart = position;
        this.selectionEnd = position;
        this.focus();
      };
      HTMLTextAreaElement.prototype.hasSelection = function () {
        //if the textarea has selection then return true
        if (this.selectionStart == this.selectionEnd) {
          return false;
        } else {
          return true;
        }
      };
      HTMLTextAreaElement.prototype.getSelectedText = function () {
        //return the selection text
        return this.value.substring(this.selectionStart, this.selectionEnd);
      };
      HTMLTextAreaElement.prototype.setSelection = function (start, end) {
        //change the selection area of the textarea
        this.selectionStart = start;
        this.selectionEnd = end;
        this.focus();
      };
      var textarea = document.getElementsByTagName("textarea")[0];
      if (textarea) {
        textarea.onkeydown = function (event) {
          event.key || event.keyCode; //replace references to event.keyCode with key in below code
          //support tab on textarea
          if (event.keyCode == 9) {
            //tab was pressed
            var newCaretPosition;
            newCaretPosition = textarea.getCaretPosition() + "    ".length;
            textarea.value = textarea.value.substring(0, textarea.getCaretPosition()) + "    " + textarea.value.substring(textarea.getCaretPosition(), textarea.value.length);
            textarea.setCaretPosition(newCaretPosition);
            return false;
          }
          if (event.keyCode == 8) {
            //backspace
            if (textarea.value.substring(textarea.getCaretPosition() - 4, textarea.getCaretPosition()) == "    ") {
              //it's a tab space
              var newCaretPosition;
              newCaretPosition = textarea.getCaretPosition() - 3;
              textarea.value = textarea.value.substring(0, textarea.getCaretPosition() - 3) + textarea.value.substring(textarea.getCaretPosition(), textarea.value.length);
              textarea.setCaretPosition(newCaretPosition);
            }
          }
          if (event.keyCode == 37) {
            //left arrow
            var newCaretPosition;
            if (textarea.value.substring(textarea.getCaretPosition() - 4, textarea.getCaretPosition()) == "    ") {
              //it's a tab space
              newCaretPosition = textarea.getCaretPosition() - 3;
              textarea.setCaretPosition(newCaretPosition);
            }
          }
          if (event.keyCode == 39) {
            //right arrow
            var newCaretPosition;
            if (textarea.value.substring(textarea.getCaretPosition() + 4, textarea.getCaretPosition()) == "    ") {
              //it's a tab space
              newCaretPosition = textarea.getCaretPosition() + 3;
              textarea.setCaretPosition(newCaretPosition);
            }
          }
        };
      }
    },
    emitEditorLanguageChanged: function () {
      this.$emit("editor-language-changed");
    },
    onErrorsClicked: function (expanded) {
      let elements = document.getElementsByClassName("editor");
      if (expanded) {
        addClass(elements[0], "errors-expanded");
      } else {
        removeClass(elements[0], "errors-expanded");
      }
    },
    setMarkdown: function (markdown) {
      // The following line fixes an error with SB3 imports when the myblock! statement
      // occurs before the define! statement which results in the error 'Invalid syntax'
      // on the myblock! line. We cannot control the order of the scripts when imported
      // via SB3. Adding a new line to the editor causes the parse function to be called
      // again.
      this.autoAddLine = true;
      this.markdown = markdown;
      if (this.editor) this.editor.setValue(this.markdown);
    },
    clearMarkdown: function () {
      //This method is used to clear the markdown
      this.markdown = "";
      if (this.editor) this.editor.setValue(this.markdown);
    },
    focus: function () {
      if (this.editor) this.editor.focus();
    },
    addNewLine: function () {
      let doc = this.editor.getDoc();
      let pos = {
        line: doc.size + 5,
        ch: 0
      };
      doc.replaceRange("\n", pos);
    },
    clearEditor: function () {
      if (this.editor) this.editor.setValue("");
      this.processor.reset();
    },
    copyEditor: function () {
      if (this.editor) navigator.clipboard.writeText(this.editor.getValue());
    },
    pasteEditor: function () {
      if (this.editor) {
        this.editor.focus();
        navigator.clipboard.readText().then(cliptext => {
          //console.log(cliptext);
          this.editor.setValue(cliptext);
        });
      }
    },
    saveEditor: function () {
      let markdown = this.editor.getValue();
      if (markdown) {
        var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(this.editor.getValue());
        var dlAnchorElem = document.getElementById("downloadAnchorElem");
        dlAnchorElem.setAttribute("href", dataStr);
        dlAnchorElem.setAttribute("download", "script.txt");
        dlAnchorElem.click();
      }
    }
  },
  created: function () {
    this.initialiseProcessor();
    this.debouncedParse = debounce_1(this.parse, 500);
  },
  mounted: function () {
    // this.initialiseEditor()
    this.supportTabInTextBox();
  }
};

/* script */
const __vue_script__$7 = script$7;

/* template */
var __vue_render__$7 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_c('div', [_c('label', {
    attrs: {
      "for": "editor_language"
    }
  }, [_vm._v("Language")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.editor_language,
      expression: "options.editor_language"
    }],
    attrs: {
      "name": "editor_language",
      "id": "id_editor_language"
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.options, "editor_language", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, _vm.editorLanguageChanged]
    }
  }, _vm._l(_vm.languages, function (language, index) {
    return _c('option', {
      key: index,
      attrs: {
        "data-tag": language.tag
      },
      domProps: {
        "value": language.id
      }
    }, [_vm._v(_vm._s(language.name))]);
  }), 0)]), _vm._v(" "), _c('p', [_vm._v("Multiple scripts can be separated with "), _c('nobr', [_vm._v("-----")]), _vm._v(" (5 dashes)")], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "editor"
  }, [_c('PsEditorOverlay', {
    staticClass: "floating-top-right",
    on: {
      "clear-editor": _vm.clearEditor,
      "copy-editor": _vm.copyEditor,
      "paste-editor": _vm.pasteEditor,
      "save-editor": _vm.saveEditor
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.markdown,
      expression: "markdown"
    }],
    attrs: {
      "name": "markdown",
      "id": "markdown",
      "cols": "40",
      "rows": "10",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.markdown
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.markdown = $event.target.value;
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "errors-container"
  }, [_c('PsErrors', {
    attrs: {
      "errors": _vm.errors
    },
    on: {
      "errors-clicked": _vm.onErrorsClicked
    }
  })], 1)]), _vm._v(" "), _c('a', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "downloadAnchorElem"
    }
  })]);
};
var __vue_staticRenderFns__$7 = [];

/* style */
const __vue_inject_styles__$7 = function (inject) {
  if (!inject) return;
  inject("data-v-16524c7a_0", {
    source: ".CodeMirror-cursor{height:21px!important}.editor{position:relative}.floating-top-right{position:absolute;z-index:1;top:-20px;right:10px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$7 = undefined;
/* module identifier */
const __vue_module_identifier__$7 = undefined;
/* functional template */
const __vue_is_functional_template__$7 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$9 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, createInjector, undefined, undefined);
var PsEditor = __vue_component__$9;

var script$6 = {
  name: 'ps-options',
  props: ["languages", "options", "sizes", "colourOptions", "advancedFeatures"],
  data() {
    return {};
  },
  computed: {
    textColour: function () {
      const colour = this.options.text_colour;
      return `rgb(${colour}, ${colour}, ${colour})`;
    },
    strokeColour: function () {
      const colour = this.options.stroke_colour;
      return `rgb(${colour}, ${colour}, ${colour})`;
    },
    sameAsBorderColour: function () {
      return this.options.same_as_border_colour;
    }
  },
  watch: {
    strokeColour: function () {
      this.setStrokeColour();
    },
    textColour: function () {
      this.setTextColour();
    },
    sameAsBorderColour: function () {
      this.options.text_colour = this.options.stroke_colour;
    }
  },
  methods: {
    setStrokeColour: function () {
      document.getElementById("colour-selected").style.setProperty('background-color', this.strokeColour);
    },
    setTextColour: function () {
      document.getElementById("text-colour-selected").style.setProperty('background-color', this.textColour);
    },
    blockLanguageChanged: function () {},
    sizeDisabled: function (id) {
      if (!this.advancedFeatures && id > 1) return true;
      return false;
    },
    onSizeChange: function () {
      this.$emit('size-changed');
    }
  },
  mounted: function () {
    this.setStrokeColour();
    this.setTextColour();
  }
};

/* script */
const __vue_script__$6 = script$6;

/* template */
var __vue_render__$6 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "custom-control custom-checkbox",
    attrs: {
      "id": "div_id_save_as_default"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.save_as_default,
      expression: "options.save_as_default"
    }],
    staticClass: "checkboxinput custom-control-input",
    attrs: {
      "type": "checkbox",
      "name": "save_as_default",
      "id": "id_save_as_default"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.save_as_default) ? _vm._i(_vm.options.save_as_default, null) > -1 : _vm.options.save_as_default
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.options.save_as_default,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.options, "save_as_default", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.options, "save_as_default", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.options, "save_as_default", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "id_save_as_default"
    }
  }, [_vm._v("\n                Save as defaults\n            ")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "accordion"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "collapse show",
    attrs: {
      "id": "collapseOne",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "div_id_colour"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {}, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.colour,
      expression: "options.colour"
    }],
    staticClass: "select form-control",
    attrs: {
      "name": "colour",
      "id": "id_colour"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.options, "colour", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.colourOptions, function (colourOption, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": colourOption.value
      }
    }, [_vm._v(_vm._s(colourOption.name))]);
  }), 0)])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "color_rgb"
  }, [_c('li', [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "div_id_stroke_colour"
    }
  }, [_c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.options.stroke_colour,
      expression: "options.stroke_colour",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "numberinput form-control",
    attrs: {
      "type": "number",
      "name": "stroke_colour",
      "min": "0",
      "max": "255",
      "required": "",
      "id": "id_stroke_colour"
    },
    domProps: {
      "value": _vm.options.stroke_colour
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.$set(_vm.options, "stroke_colour", _vm._n($event.target.value));
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  })])])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "custom-control custom-checkbox",
    attrs: {
      "id": "div_id_auto_hints"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.auto_hints,
      expression: "options.auto_hints"
    }],
    staticClass: "checkboxinput custom-control-input",
    attrs: {
      "type": "checkbox",
      "name": "auto_hints",
      "id": "id_auto_hints"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.auto_hints) ? _vm._i(_vm.options.auto_hints, null) > -1 : _vm.options.auto_hints
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.options.auto_hints,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.options, "auto_hints", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.options, "auto_hints", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.options, "auto_hints", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "id_auto_hints"
    }
  }, [_vm._v("\n                                Auto hints\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "custom-control custom-checkbox",
    attrs: {
      "id": "div_id_iterative"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.iterative,
      expression: "options.iterative"
    }],
    staticClass: "checkboxinput custom-control-input",
    attrs: {
      "type": "checkbox",
      "name": "iterative",
      "id": "id_iterative"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.iterative) ? _vm._i(_vm.options.iterative, null) > -1 : _vm.options.iterative
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.options.iterative,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.options, "iterative", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.options, "iterative", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.options, "iterative", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "id_iterative"
    }
  }, [_vm._v("\n                                Is iterative?\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "div_id_size"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {}, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.size,
      expression: "options.size"
    }],
    staticClass: "select form-control",
    attrs: {
      "name": "size",
      "id": "id_size"
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.options, "size", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, _vm.onSizeChange]
    }
  }, _vm._l(_vm.sizes, function (size, index) {
    return _c('option', {
      key: index,
      attrs: {
        "disabled": _vm.sizeDisabled(size.id)
      },
      domProps: {
        "value": size.id
      }
    }, [_vm._v(_vm._s(size.name))]);
  }), 0)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "collapseTwo",
      "data-parent": "#accordion"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "div_id_language"
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {}, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.language,
      expression: "options.language"
    }],
    staticClass: "select form-control",
    attrs: {
      "name": "language",
      "id": "id_language"
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.options, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, function ($event) {
        return _vm.blockLanguageChanged();
      }]
    }
  }, [_vm._v(">\n                                    "), _vm._l(_vm.languages, function (language, index) {
    return _c('option', {
      key: index,
      attrs: {
        "data-tag": language.tag
      },
      domProps: {
        "value": language.id
      }
    }, [_vm._v(_vm._s(language.name))]);
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "custom-control custom-checkbox",
    attrs: {
      "id": "div_id_same_as_border_colour"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.same_as_border_colour,
      expression: "options.same_as_border_colour"
    }],
    staticClass: "checkboxinput custom-control-input",
    attrs: {
      "type": "checkbox",
      "name": "same_as_border_colour",
      "id": "id_same_as_border_colour"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.same_as_border_colour) ? _vm._i(_vm.options.same_as_border_colour, null) > -1 : _vm.options.same_as_border_colour
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.options.same_as_border_colour,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.options, "same_as_border_colour", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.options, "same_as_border_colour", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.options, "same_as_border_colour", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "id_same_as_border_colour"
    }
  }, [_vm._v("\n                                Text color same as border\n                            ")])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "text_colour_div"
    }
  }, [_vm._m(7), _vm._v(" "), _c('ul', {
    staticClass: "color_rgb"
  }, [_c('li', [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "div_id_text_colour"
    }
  }, [_c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.options.text_colour,
      expression: "options.text_colour",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "numberinput form-control",
    attrs: {
      "type": "number",
      "name": "text_colour",
      "min": "0",
      "max": "255",
      "required": "",
      "id": "id_text_colour",
      "disabled": _vm.options.same_as_border_colour
    },
    domProps: {
      "value": _vm.options.text_colour
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.$set(_vm.options, "text_colour", _vm._n($event.target.value));
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  })])])]), _vm._v(" "), _c('li', [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "text-colour-selected",
      "type": "text",
      "name": "color_b",
      "hidden": _vm.options.same_as_border_colour
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "div_id_stroke_weight"
    }
  }, [_vm._m(8), _vm._v(" "), _c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.options.stroke_weight,
      expression: "options.stroke_weight",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "numberinput form-control",
    attrs: {
      "type": "number",
      "name": "stroke_weight",
      "value": "3",
      "min": "1",
      "max": "50",
      "required": "",
      "id": "id_stroke_weight"
    },
    domProps: {
      "value": _vm.options.stroke_weight
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.$set(_vm.options, "stroke_weight", _vm._n($event.target.value));
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "custom-control custom-checkbox",
    attrs: {
      "id": "div_id_potrait"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.potrait,
      expression: "options.potrait"
    }],
    staticClass: "checkboxinput custom-control-input",
    attrs: {
      "type": "checkbox",
      "name": "potrait",
      "id": "id_potrait"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.potrait) ? _vm._i(_vm.options.potrait, null) > -1 : _vm.options.potrait
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.options.potrait,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.options, "potrait", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.options, "potrait", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.options, "potrait", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "id_potrait"
    }
  }, [_vm._v("\n                                Potrait\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "div_id_dpi"
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {}, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.dpi,
      expression: "options.dpi"
    }],
    staticClass: "select form-control",
    attrs: {
      "name": "dpi",
      "id": "id_dpi"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.options, "dpi", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "72"
    }
  }, [_vm._v("72")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "150"
    }
  }, [_vm._v("150")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "180"
    }
  }, [_vm._v("180")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "300",
      "disabled": !_vm.advancedFeatures
    }
  }, [_vm._v("300")])])])])])])])])]);
};
var __vue_staticRenderFns__$6 = [function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapseOne"
    }
  }, [_vm._v("\n                    Basic\n                ")])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', {
    staticClass: "requiredField",
    attrs: {
      "for": "id_colour"
    }
  }, [_vm._v("\n                            Outline"), _c('span', {
    staticClass: "asteriskField"
  }, [_vm._v("*")])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', {
    staticClass: "requiredField",
    attrs: {
      "for": "id_stroke_colour"
    }
  }, [_vm._v("Border Color"), _c('span', {
    staticClass: "asteriskField"
  }, [_vm._v("*")])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('li', [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "colour-selected",
      "type": "text",
      "name": "color_b"
    }
  })]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', {
    staticClass: "requiredField",
    attrs: {
      "for": "id_size"
    }
  }, [_vm._v("\n                            Size"), _c('span', {
    staticClass: "asteriskField"
  }, [_vm._v("*")])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('a', {
    staticClass: "collapsed card-link",
    attrs: {
      "data-toggle": "collapse",
      "href": "#collapseTwo"
    }
  }, [_vm._v("\n                    Advanced\n                ")])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', {
    staticClass: "requiredField",
    attrs: {
      "for": "id_language"
    }
  }, [_vm._v("\n                            Language"), _c('span', {
    staticClass: "asteriskField"
  }, [_vm._v("*")])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', {
    staticClass: "requiredField",
    attrs: {
      "for": "id_text_colour"
    }
  }, [_vm._v("\n                            Text Color\n                            "), _c('span', {
    staticClass: "asteriskField"
  }, [_vm._v("*")])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', {
    staticClass: "requiredField",
    attrs: {
      "for": "id_stroke_weight"
    }
  }, [_vm._v("\n                            Border thickness"), _c('span', {
    staticClass: "asteriskField"
  }, [_vm._v("*")])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', {
    staticClass: "requiredField",
    attrs: {
      "for": "id_dpi"
    }
  }, [_vm._v("\n                            Dpi"), _c('span', {
    staticClass: "asteriskField"
  }, [_vm._v("*")])]);
}];

/* style */
const __vue_inject_styles__$6 = undefined;
/* scoped */
const __vue_scope_id__$6 = "data-v-a2d55af6";
/* module identifier */
const __vue_module_identifier__$6 = undefined;
/* functional template */
const __vue_is_functional_template__$6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$8 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, undefined, undefined, undefined);
var PsOptions = __vue_component__$8;

var script$5 = {
  name: 'ps-colour',
  props: ['colour'],
  data() {
    return {};
  },
  computed: {
    style: function () {
      return {
        'background-color': this.colour
      };
    }
  }
};

/* script */
const __vue_script__$5 = script$5;

/* template */
var __vue_render__$5 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('li', [_c('input', {
    staticClass: "form-control",
    style: _vm.style,
    attrs: {
      "type": "text",
      "name": "color_b"
    }
  })]);
};
var __vue_staticRenderFns__$5 = [];

/* style */
const __vue_inject_styles__$5 = undefined;
/* scoped */
const __vue_scope_id__$5 = undefined;
/* module identifier */
const __vue_module_identifier__$5 = undefined;
/* functional template */
const __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$7 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);
var PsColour = __vue_component__$7;

var script$4 = {
  name: 'ps-options2-images',
  props: {
    languages: Array,
    options: Object,
    sizes: Array,
    colourOptions: Array,
    advancedFeatures: Boolean,
    effects: Array,
    dropshadowDirections: Array,
    showSizeOptions: {
      type: Boolean,
      default: true
    },
    showIsInteractive: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PsColour
  },
  data() {
    return {
      validEffectColour: true
    };
  },
  computed: {
    textColour: function () {
      const colour = this.options.text_colour;
      return `rgb(${colour}, ${colour}, ${colour})`;
    },
    strokeColour: function () {
      const colour = this.options.stroke_colour;
      return `rgb(${colour}, ${colour}, ${colour})`;
    },
    sameAsBorderColour: function () {
      return this.options.same_as_border_colour;
    },
    hasEffect: function () {
      return this.options.effect != 0;
    },
    effectIsDropshadow: function () {
      return this.options.effect == 1;
    },
    effectIsGlow: function () {
      return this.options.effect == 2;
    },
    effectColour: function () {
      if (this.validEffectColour) {
        const colour = this.options.effect_colour;
        if (this.effectIsDropshadow) {
          return `rgb(${colour}, ${colour}, ${colour})`;
        } else if (this.effectIsGlow) {
          return `#${colour}`;
        }
      }
    },
    isFullColour: function () {
      return this.options.colour == colourOptions.FullColour;
    }
  },
  watch: {
    strokeColour: function () {
      this.setStrokeColour();
    },
    textColour: function () {
      this.setTextColour();
    },
    sameAsBorderColour: function () {
      this.options.text_colour = this.options.stroke_colour;
      this.setTextColour();
    },
    "options.effect": function (val, oldVal) {
      if (val == 1) {
        // drop shadow
        this.options.effect_colour = 0; //black
      } else if (val == 2) {
        // glow
        this.options.effect_colour = "FFFFFF"; //white
      }
    },
    "options.effect_colour": {
      handler: function (val) {
        // default validEffectColour = true
        this.validEffectColour = true;
        if (!val && this.hasEffect) {
          this.validEffectColour = false;
        }
        if (this.effectIsDropshadow) {
          //if effectIsDropshadown number should be between 0 and 255
          if (parseInt(val) < 0 || parseInt(val) > 255) {
            this.validEffectColour = false;
          } else {
            this.validEffectColour = true;
          }
        } else if (this.effectIsGlow) {
          //if effectIsGlow string should be between 1 and 6 characters, 0 - F
          if (val.length > 6) {
            this.validEffectColour = false;
          } else {
            const regex = /^[0-9a-fA-F]{1,6}/i;
            const match = regex.exec(val);
            if (match && match[0] === val) {
              this.validEffectColour = true;
            } else {
              this.validEffectColour = false;
            }
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    setStrokeColour: function () {
      document.getElementById("colour-selected").style.setProperty("background-color", this.strokeColour);
    },
    setTextColour: function () {
      document.getElementById("text-colour-selected").style.setProperty("background-color", this.textColour);
    },
    blockLanguageChanged: function () {},
    sizeDisabled: function (id) {
      if (!this.advancedFeatures && id > 1) return true;
      return false;
    },
    onSizeChange: function () {
      this.$emit("size-changed");
    },
    onChangeStrokeColour: function () {
      this.$emit("change-stroke-colour", this.options.stroke_colour);
    }
  },
  mounted: function () {
    this.setStrokeColour();
    this.setTextColour();
  }
};

/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "div_id_colour"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {}, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.colour,
      expression: "options.colour"
    }],
    staticClass: "select form-control",
    attrs: {
      "name": "colour",
      "id": "id_colour"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.options, "colour", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.colourOptions, function (colourOption, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": colourOption.value
      }
    }, [_vm._v(_vm._s(colourOption.name) + "\n\t\t\t\t\t\t")]);
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "custom-control custom-checkbox",
    attrs: {
      "id": "div_high_contrast"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.high_contrast,
      expression: "options.high_contrast"
    }],
    staticClass: "checkboxinput custom-control-input",
    attrs: {
      "disabled": !_vm.isFullColour,
      "type": "checkbox",
      "name": "high_contrast",
      "id": "id_high_contrast"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.high_contrast) ? _vm._i(_vm.options.high_contrast, null) > -1 : _vm.options.high_contrast
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.options.high_contrast,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.options, "high_contrast", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.options, "high_contrast", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.options, "high_contrast", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "id_high_contrast"
    }
  }, [_vm._v("\n\t\t\t\t\tHigh contrast colours\n\t\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "div_id_language"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {}, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.language,
      expression: "options.language"
    }],
    staticClass: "select form-control",
    attrs: {
      "name": "language",
      "id": "id_language"
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.options, "language", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, function ($event) {
        return _vm.blockLanguageChanged();
      }]
    }
  }, [_vm._v("\n\t\t\t\t\t\t>\n\t\t\t\t\t\t"), _vm._l(_vm.languages, function (language, index) {
    return _c('option', {
      key: index,
      attrs: {
        "data-tag": language.tag
      },
      domProps: {
        "value": language.id
      }
    }, [_vm._v(_vm._s(language.name))]);
  })], 2)])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_vm._m(2), _vm._v(" "), _c('ul', {
    staticClass: "color_rgb"
  }, [_c('li', [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "div_id_stroke_colour"
    }
  }, [_c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.options.stroke_colour,
      expression: "options.stroke_colour",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "numberinput form-control",
    attrs: {
      "type": "number",
      "name": "stroke_colour",
      "min": "0",
      "max": "255",
      "required": "",
      "id": "id_stroke_colour"
    },
    domProps: {
      "value": _vm.options.stroke_colour
    },
    on: {
      "change": _vm.onChangeStrokeColour,
      "input": [function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.$set(_vm.options, "stroke_colour", _vm._n($event.target.value));
      }, function () {
        if (_vm.options.stroke_colour > 255) {
          _vm.options.stroke_colour = 255;
        }
        if (_vm.options.stroke_colour < 0) {
          _vm.options.stroke_colour = 0;
        }
      }],
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  })])])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "custom-control custom-checkbox",
    attrs: {
      "id": "div_id_same_as_border_colour"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.same_as_border_colour,
      expression: "options.same_as_border_colour"
    }],
    staticClass: "checkboxinput custom-control-input",
    attrs: {
      "type": "checkbox",
      "name": "same_as_border_colour",
      "id": "id_same_as_border_colour"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.same_as_border_colour) ? _vm._i(_vm.options.same_as_border_colour, null) > -1 : _vm.options.same_as_border_colour
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.options.same_as_border_colour,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.options, "same_as_border_colour", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.options, "same_as_border_colour", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.options, "same_as_border_colour", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "id_same_as_border_colour"
    }
  }, [_vm._v("\n\t\t\t\t\tText color same as border\n\t\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    attrs: {
      "id": "text_colour_div"
    }
  }, [_vm._m(4), _vm._v(" "), _c('ul', {
    staticClass: "color_rgb"
  }, [_c('li', [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "div_id_text_colour"
    }
  }, [_c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.options.text_colour,
      expression: "options.text_colour",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "numberinput form-control",
    attrs: {
      "type": "number",
      "name": "text_colour",
      "min": "0",
      "max": "255",
      "required": "",
      "id": "id_text_colour",
      "disabled": _vm.options.same_as_border_colour
    },
    domProps: {
      "value": _vm.options.text_colour
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.$set(_vm.options, "text_colour", _vm._n($event.target.value));
      }, function () {
        if (_vm.options.text_colour > 255) {
          _vm.options.text_colour = 255;
        }
        if (_vm.options.text_colour < 0) {
          _vm.options.text_colour = 0;
        }
      }],
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  })])])]), _vm._v(" "), _c('li', [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "text-colour-selected",
      "type": "text",
      "name": "color_b",
      "hidden": _vm.options.same_as_border_colour
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "div_id_stroke_weight"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.options.stroke_weight,
      expression: "options.stroke_weight",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "numberinput form-control",
    attrs: {
      "type": "number",
      "name": "stroke_weight",
      "value": "3",
      "min": "1",
      "max": "10",
      "required": "",
      "id": "id_stroke_weight"
    },
    domProps: {
      "value": _vm.options.stroke_weight
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.$set(_vm.options, "stroke_weight", _vm._n($event.target.value));
      }, function () {
        if (_vm.options.stroke_weight > 10) {
          _vm.options.stroke_weight = 10;
        }
        if (_vm.options.stroke_weight < 1) {
          _vm.options.stroke_weight = 1;
        }
      }],
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "custom-control custom-checkbox",
    attrs: {
      "id": "div_id_auto_hints"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.auto_hints,
      expression: "options.auto_hints"
    }],
    staticClass: "checkboxinput custom-control-input",
    attrs: {
      "type": "checkbox",
      "name": "auto_hints",
      "id": "id_auto_hints"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.auto_hints) ? _vm._i(_vm.options.auto_hints, null) > -1 : _vm.options.auto_hints
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.options.auto_hints,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.options, "auto_hints", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.options, "auto_hints", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.options, "auto_hints", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "id_auto_hints"
    }
  }, [_vm._v("\n\t\t\t\t\tAuto hints\n\t\t\t\t\t")])])]), _vm._v(" "), _vm.showIsInteractive ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "custom-control custom-checkbox",
    attrs: {
      "id": "div_id_iterative"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.iterative,
      expression: "options.iterative"
    }],
    staticClass: "checkboxinput custom-control-input",
    attrs: {
      "type": "checkbox",
      "name": "iterative",
      "id": "id_iterative"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.iterative) ? _vm._i(_vm.options.iterative, null) > -1 : _vm.options.iterative
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.options.iterative,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.options, "iterative", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.options, "iterative", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.options, "iterative", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "id_iterative"
    }
  }, [_vm._v("\n\t\t\t\t\tIs iterative?\n\t\t\t\t\t")])])]) : _vm._e()])]), _vm._v(" "), _vm.showSizeOptions ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "div_id_size"
    }
  }, [_vm._m(6), _vm._v(" "), _c('div', {}, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.size,
      expression: "options.size"
    }],
    staticClass: "select form-control",
    attrs: {
      "name": "size",
      "id": "id_size"
    },
    on: {
      "change": [function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.options, "size", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }, _vm.onSizeChange]
    }
  }, _vm._l(_vm.sizes, function (size, index) {
    return _c('option', {
      key: index,
      attrs: {
        "disabled": _vm.sizeDisabled(size.id)
      },
      domProps: {
        "value": size.id
      }
    }, [_vm._v(_vm._s(size.name))]);
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "div_id_dpi"
    }
  }, [_vm._m(7), _vm._v(" "), _c('div', {}, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.dpi,
      expression: "options.dpi"
    }],
    staticClass: "select form-control",
    attrs: {
      "name": "dpi",
      "id": "id_dpi"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.options, "dpi", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "72"
    }
  }, [_vm._v("72")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "150"
    }
  }, [_vm._v("150")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "180"
    }
  }, [_vm._v("180")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "300",
      "disabled": !_vm.advancedFeatures
    }
  }, [_vm._v("300")])])])])])]) : _vm._e(), _vm._v(" "), _vm.showSizeOptions ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "custom-control custom-checkbox",
    attrs: {
      "id": "div_id_potrait"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.potrait,
      expression: "options.potrait"
    }],
    staticClass: "checkboxinput custom-control-input",
    attrs: {
      "type": "checkbox",
      "name": "potrait",
      "id": "id_potrait"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.potrait) ? _vm._i(_vm.options.potrait, null) > -1 : _vm.options.potrait
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.options.potrait,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.options, "potrait", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.options, "potrait", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.options, "potrait", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "id_potrait"
    }
  }, [_vm._v("\n\t\t\t\t\tPotrait\n\t\t\t\t\t")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "div_id_effect"
    }
  }, [_vm._m(8), _vm._v(" "), _c('div', {}, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.effect,
      expression: "options.effect"
    }],
    staticClass: "select form-control",
    attrs: {
      "name": "effect",
      "id": "id_effect"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.options, "effect", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.effects, function (effect, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": effect.value
      }
    }, [_vm._v(_vm._s(effect.name) + "\n\t\t\t\t\t\t")]);
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "div_id_effect_size"
    }
  }, [_vm._m(9), _vm._v(" "), _c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.options.effect_size,
      expression: "options.effect_size",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "numberinput form-control",
    attrs: {
      "type": "number",
      "name": "effect_size",
      "min": "1",
      "max": "10",
      "required": "",
      "id": "id_effect_size",
      "disabled": !_vm.effectIsGlow && !_vm.effectIsDropshadow
    },
    domProps: {
      "value": _vm.options.effect_size
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.$set(_vm.options, "effect_size", _vm._n($event.target.value));
      }, function () {
        if (_vm.options.effect_size > 10) {
          _vm.options.effect_size = 10;
        }
        if (_vm.options.effect_size < 1) {
          _vm.options.effect_size = 1;
        }
      }],
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    attrs: {
      "id": "effect_colour_div"
    }
  }, [_vm._m(10), _vm._v(" "), _vm.effectIsDropshadow ? _c('div', {
    staticClass: "help"
  }, [_vm._v("\n\t\t\t\t\tDropshadows are grayscale, use a valid between 0 and 255. 0 is\n\t\t\t\t\tblack.\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), _vm.effectIsGlow ? _c('div', {
    staticClass: "help"
  }, [_vm._v("\n\t\t\t\t\tUse any valid HEX color code (without the #) e.g. FFFFFF for white.\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "color_rgb"
  }, [_c('li', [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "div_id_effect_colour"
    }
  }, [_c('div', {}, [!_vm.effectIsGlow ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.options.effect_colour,
      expression: "options.effect_colour",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "numberinput form-control",
    class: {
      invalid: !_vm.validEffectColour
    },
    attrs: {
      "type": "number",
      "name": "effect_colour",
      "min": "0",
      "max": "255",
      "required": "",
      "id": "id_effect_colour",
      "disabled": !_vm.effectIsGlow && !_vm.effectIsDropshadow
    },
    domProps: {
      "value": _vm.options.effect_colour
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.$set(_vm.options, "effect_colour", _vm._n($event.target.value));
      }, function () {
        if (_vm.options.effect_colour > 255) {
          _vm.options.effect_colour = 255;
        }
        if (_vm.options.effect_colour < 0) {
          _vm.options.effect_colour = 0;
        }
      }],
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.effectIsGlow ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.effect_colour,
      expression: "options.effect_colour"
    }],
    staticClass: "form-control",
    class: {
      invalid: !_vm.validEffectColour
    },
    attrs: {
      "name": "effect_colour",
      "required": "",
      "id": "id_effect_colour"
    },
    domProps: {
      "value": _vm.options.effect_colour
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.$set(_vm.options, "effect_colour", $event.target.value);
      }
    }
  }) : _vm._e()])])]), _vm._v(" "), _vm.hasEffect && _vm.validEffectColour ? _c('PsColour', {
    attrs: {
      "colour": _vm.effectColour
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "div_dropshadow_direction"
    }
  }, [_vm._m(11), _vm._v(" "), _c('div', {}, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.dropshadow_direction,
      expression: "options.dropshadow_direction"
    }],
    staticClass: "select form-control",
    attrs: {
      "name": "dropshadow_direction",
      "id": "id_dropshadow_direction",
      "disabled": !_vm.effectIsDropshadow
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.options, "dropshadow_direction", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.dropshadowDirections, function (dropshadowDirection, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": dropshadowDirection.value
      }
    }, [_vm._v(_vm._s(dropshadowDirection.name) + "\n\t\t\t\t\t\t")]);
  }), 0)])])])])]);
};
var __vue_staticRenderFns__$4 = [function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', {
    staticClass: "requiredField",
    attrs: {
      "for": "id_colour"
    }
  }, [_vm._v("\n\t\t\t\tColour"), _c('span', {
    staticClass: "asteriskField"
  }, [_vm._v("*")])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', {
    staticClass: "requiredField",
    attrs: {
      "for": "id_language"
    }
  }, [_vm._v("\n\t\t\t\tOutput language"), _c('span', {
    staticClass: "asteriskField"
  }, [_vm._v("*")])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', {
    staticClass: "requiredField",
    attrs: {
      "for": "id_stroke_colour"
    }
  }, [_vm._v("Border Color"), _c('span', {
    staticClass: "asteriskField"
  }, [_vm._v("*")])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('li', [_c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "colour-selected",
      "type": "text",
      "name": "color_b"
    }
  })]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', {
    staticClass: "requiredField",
    attrs: {
      "for": "id_text_colour"
    }
  }, [_vm._v("\n\t\t\t\tText Color\n\t\t\t\t"), _c('span', {
    staticClass: "asteriskField"
  }, [_vm._v("*")])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', {
    staticClass: "requiredField",
    attrs: {
      "for": "id_stroke_weight"
    }
  }, [_vm._v("\n\t\t\t\tBorder thickness"), _c('span', {
    staticClass: "asteriskField"
  }, [_vm._v("*")])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', {
    staticClass: "requiredField",
    attrs: {
      "for": "id_size"
    }
  }, [_vm._v("\n\t\t\t\tSize"), _c('span', {
    staticClass: "asteriskField"
  }, [_vm._v("*")])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', {
    staticClass: "requiredField",
    attrs: {
      "for": "id_dpi"
    }
  }, [_vm._v("\n\t\t\t\tDpi"), _c('span', {
    staticClass: "asteriskField"
  }, [_vm._v("*")])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', {
    staticClass: "requiredField",
    attrs: {
      "for": "id_effect"
    }
  }, [_vm._v("\n\t\t\t\tEffect"), _c('span', {
    staticClass: "asteriskField"
  }, [_vm._v("*")])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', {
    staticClass: "requiredField",
    attrs: {
      "for": "id_effect_size"
    }
  }, [_vm._v("\n\t\t\t\tEffect size"), _c('span', {
    staticClass: "asteriskField"
  }, [_vm._v("*")])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', {
    staticClass: "requiredField",
    attrs: {
      "for": "id_effect_colour"
    }
  }, [_vm._v("\n\t\t\t\tEffect Color\n\t\t\t\t"), _c('span', {
    staticClass: "asteriskField"
  }, [_vm._v("*")])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', {
    staticClass: "requiredField",
    attrs: {
      "for": "id_dropshadow_direction"
    }
  }, [_vm._v("\n\t\t\t\tDropshadow direction"), _c('span', {
    staticClass: "asteriskField"
  }, [_vm._v("*")])]);
}];

/* style */
const __vue_inject_styles__$4 = undefined;
/* scoped */
const __vue_scope_id__$4 = "data-v-a82ce642";
/* module identifier */
const __vue_module_identifier__$4 = undefined;
/* functional template */
const __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$6 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, undefined, undefined, undefined);
var PsOptions2Images = __vue_component__$6;

var script$3 = {
  name: "ps-options2",
  // props: [
  //     "languages",
  //     "options",
  //     "sizes",
  //     "colourOptions",
  //     "advancedFeatures",
  //     ],
  props: {
    languages: Array,
    options: Object,
    sizes: Array,
    colourOptions: Array,
    editorTextSizes: Array,
    indentUnits: Array,
    advancedFeatures: Boolean,
    effects: Array,
    dropshadowDirections: Array,
    showSizeOptions: {
      type: Boolean,
      default: true
    },
    showIsInteractive: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PsColour,
    PsOptions2Images
  },
  data() {
    return {
      validEffectColour: true
      //   showImageAndEditorOptions: true
    };
  },
  computed: {
    showImageAndEditorOptions: function () {
      return this.$root.showImageAndEditorOptions || false;
    },
    textColour: function () {
      const colour = this.options.text_colour;
      return `rgb(${colour}, ${colour}, ${colour})`;
    },
    strokeColour: function () {
      const colour = this.options.stroke_colour;
      return `rgb(${colour}, ${colour}, ${colour})`;
    },
    sameAsBorderColour: function () {
      return this.options.same_as_border_colour;
    },
    hasEffect: function () {
      return this.options.effect != 0;
    },
    effectIsDropshadow: function () {
      return this.options.effect == 1;
    },
    effectIsGlow: function () {
      return this.options.effect == 2;
    },
    effectColour: function () {
      if (this.validEffectColour) {
        const colour = this.options.effect_colour;
        if (this.effectIsDropshadow) {
          return `rgb(${colour}, ${colour}, ${colour})`;
        } else if (this.effectIsGlow) {
          return `#${colour}`;
        }
      }
    },
    isFullColour: function () {
      return this.options.colour == colourOptions.FullColour;
    }
  },
  watch: {
    strokeColour: function () {
      this.setStrokeColour();
    },
    textColour: function () {
      this.setTextColour();
    },
    sameAsBorderColour: function () {
      this.options.text_colour = this.options.stroke_colour;
      this.setTextColour();
    },
    "options.effect": function (val, oldVal) {
      if (val == 1) {
        // drop shadow
        this.options.effect_colour = 0; //black
      } else if (val == 2) {
        // glow
        this.options.effect_colour = "FFFFFF"; //white
      }
    },
    "options.effect_colour": {
      handler: function (val) {
        // default validEffectColour = true
        this.validEffectColour = true;
        if (!val && this.hasEffect) {
          this.validEffectColour = false;
        }
        if (this.effectIsDropshadow) {
          //if effectIsDropshadown number should be between 0 and 255
          if (parseInt(val) < 0 || parseInt(val) > 255) {
            this.validEffectColour = false;
          } else {
            this.validEffectColour = true;
          }
        } else if (this.effectIsGlow) {
          //if effectIsGlow string should be between 1 and 6 characters, 0 - F
          if (val.length > 6) {
            this.validEffectColour = false;
          } else {
            const regex = /^[0-9a-fA-F]{1,6}/i;
            const match = regex.exec(val);
            if (match && match[0] === val) {
              this.validEffectColour = true;
            } else {
              this.validEffectColour = false;
            }
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    setStrokeColour: function () {
      document.getElementById("colour-selected").style.setProperty("background-color", this.strokeColour);
    },
    setTextColour: function () {
      document.getElementById("text-colour-selected").style.setProperty("background-color", this.textColour);
    },
    blockLanguageChanged: function () {},
    sizeDisabled: function (id) {
      if (!this.advancedFeatures && id > 1) return true;
      return false;
    },
    onSizeChange: function () {
      this.$emit("size-changed");
    },
    onChangeStrokeColour: function () {
      this.$emit("change-stroke-colour", this.options.stroke_colour);
    }
  },
  mounted: function () {
    this.setStrokeColour();
    this.setTextColour();
  }
};

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "col-md-12 pl-0 pr-0"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "ml-4 custom-control custom-checkbox",
    attrs: {
      "id": "div_id_save_as_default"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.save_as_default,
      expression: "options.save_as_default"
    }],
    staticClass: "checkboxinput custom-control-input",
    attrs: {
      "type": "checkbox",
      "name": "save_as_default",
      "id": "id_save_as_default"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.save_as_default) ? _vm._i(_vm.options.save_as_default, null) > -1 : _vm.options.save_as_default
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.options.save_as_default,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.options, "save_as_default", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.options, "save_as_default", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.options, "save_as_default", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "id_save_as_default"
    }
  }, [_vm._v("\n                Save as defaults\n                ")])])]), _vm._v(" "), !_vm.showImageAndEditorOptions ? [_c('ps-options-2-images', {
    attrs: {
      "languages": _vm.languages,
      "options": _vm.options,
      "sizes": _vm.sizes,
      "colourOptions": _vm.colourOptions,
      "advancedFeatures": _vm.advancedFeatures,
      "showSizeOptions": _vm.showSizeOptions,
      "effects": _vm.effects,
      "dropshadowDirections": _vm.dropshadowDirections
    },
    on: {
      "change-stroke-colour": _vm.onChangeStrokeColour,
      "size-changed": _vm.onSizeChange
    }
  })] : [_c('div', {
    staticClass: "accordion",
    attrs: {
      "id": "accordionOptions"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "show",
    attrs: {
      "id": "collapseOne",
      "aria-labelledby": "headingOne",
      "data-parent": "#accordionExample"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('ps-options-2-images', {
    attrs: {
      "languages": _vm.languages,
      "options": _vm.options,
      "sizes": _vm.sizes,
      "colourOptions": _vm.colourOptions,
      "advancedFeatures": _vm.advancedFeatures,
      "showSizeOptions": _vm.showSizeOptions,
      "effects": _vm.effects,
      "dropshadowDirections": _vm.dropshadowDirections
    },
    on: {
      "change-stroke-colour": _vm.onChangeStrokeColour,
      "size-changed": _vm.onSizeChange
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "show",
    attrs: {
      "id": "collapseTwo",
      "aria-labelledby": "headingTwo",
      "data-parent": "#accordionExample"
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "custom-control custom-checkbox",
    attrs: {
      "id": "div_id_show_hints"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.enable_autocomplete,
      expression: "options.enable_autocomplete"
    }],
    staticClass: "checkboxinput custom-control-input",
    attrs: {
      "type": "checkbox",
      "name": "show_hints",
      "id": "showHints"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.enable_autocomplete) ? _vm._i(_vm.options.enable_autocomplete, null) > -1 : _vm.options.enable_autocomplete
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.options.enable_autocomplete,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.options, "enable_autocomplete", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.options, "enable_autocomplete", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.options, "enable_autocomplete", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "showHints"
    }
  }, [_vm._v("\n                                Enable autocompletion?\n                                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "custom-control custom-checkbox",
    attrs: {
      "id": "div_id_show_devices"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.include_device_extensions,
      expression: "options.include_device_extensions"
    }],
    staticClass: "checkboxinput custom-control-input",
    attrs: {
      "type": "checkbox",
      "name": "show_device_extensions",
      "id": "showDeviceExtensions"
    },
    domProps: {
      "checked": Array.isArray(_vm.options.include_device_extensions) ? _vm._i(_vm.options.include_device_extensions, null) > -1 : _vm.options.include_device_extensions
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.options.include_device_extensions,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.options, "include_device_extensions", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.options, "include_device_extensions", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.options, "include_device_extensions", $$c);
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "showDeviceExtensions"
    }
  }, [_vm._v("\n                                Show autocompletions for extensions requiring a device (Makey Makey, Micro:bit, EV3, Boost, WeDo and FA)?\n                                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "div_id_editor_textsize"
    }
  }, [_c('label', {
    staticClass: "requiredField",
    attrs: {
      "for": "id_editor_textsize"
    }
  }, [_vm._v("\n                                    Editor text size\n                                    ")]), _vm._v(" "), _c('div', {}, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.editor_text_size,
      expression: "options.editor_text_size"
    }],
    staticClass: "select form-control",
    attrs: {
      "name": "colour",
      "id": "id_editor_textsize"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.options, "editor_text_size", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.editorTextSizes, function (textSize, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": textSize.value
      }
    }, [_vm._v(_vm._s(textSize.name) + "\n                                            ")]);
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group",
    attrs: {
      "id": "div_id_indentunit"
    }
  }, [_c('label', {
    staticClass: "requiredField",
    attrs: {
      "for": "id_indentunit"
    }
  }, [_vm._v("\n                                    Indent Unit (in spaces)\n                                    ")]), _vm._v(" "), _c('div', {}, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.options.indent_unit,
      expression: "options.indent_unit"
    }],
    staticClass: "select form-control",
    attrs: {
      "name": "colour",
      "id": "id_indentunit"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.options, "indent_unit", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, _vm._l(_vm.indentUnits, function (indentUnit, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": indentUnit.value
      }
    }, [_vm._v(_vm._s(indentUnit.name) + "\n                                            ")]);
  }), 0)])])])])])])])])]], 2);
};
var __vue_staticRenderFns__$3 = [function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "card-header bg-secondary",
    attrs: {
      "id": "imageOptions"
    }
  }, [_c('h6', {
    staticClass: "mb-0 text-light"
  }, [_vm._v("\n                        Images\n                    ")])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "card-header bg-secondary",
    attrs: {
      "id": "editorOptions"
    }
  }, [_c('h6', {
    staticClass: "mb-0 text-light"
  }, [_vm._v("\n                        Editor\n                    ")])]);
}];

/* style */
const __vue_inject_styles__$3 = function (inject) {
  if (!inject) return;
  inject("data-v-04d1d218_0", {
    source: ".help[data-v-04d1d218]{font-size:11px}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__$3 = "data-v-04d1d218";
/* module identifier */
const __vue_module_identifier__$3 = undefined;
/* functional template */
const __vue_is_functional_template__$3 = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$5 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, createInjector, undefined, undefined);
var PsOptions2 = __vue_component__$5;

// Example of how this placeholder is used. Declare the component that it will placehold with a ref
// in a v-show div and then pass the ref to the linkto prop of the Placeholder
//
// <div v-show="false">
// 	<Editor
// 		ref="editor"
// 		:languages="languages"
// 		:options="options"
// 		:markdown="markdown"
// 		@changed="onChanged"
// 	/>
// </div>
//
// Put a place holder component anywhere you need an instance of the ref to appear
// <Placeholder :linkto="$refs.editor"/>
var script$2 = {
  name: 'ps-placeholder',
  props: ["linkto"],
  methods: {
    linkDom: function () {
      if (this.linkto && this.$el) {
        this.$el.parentElement.appendChild(this.linkto.$el);
      } else {
        this.linkDomNextClick();
      }
    },
    linkDomNextClick: function () {
      this.$nextTick(() => {
        if (!this.linkto) {
          // console.log('linkDomNextClick was called')
          this.$el.parentElement.appendChild(this.$parent.$refs.editor.$el);
        }
      });
    }
  },
  mounted() {
    this.linkDom();
  }
};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('span', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "dummy": _vm.linkDom()
    }
  });
};
var __vue_staticRenderFns__$2 = [];

/* style */
const __vue_inject_styles__$2 = undefined;
/* scoped */
const __vue_scope_id__$2 = "data-v-0eaf749e";
/* module identifier */
const __vue_module_identifier__$2 = undefined;
/* functional template */
const __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$4 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);
var PsPlaceholder = __vue_component__$4;

var script$1 = {
  name: 'ps-editor-options',
  props: ["languages", "options", "sizes", "colourOptions", "advancedFeatures", "showSizeOptions"],
  components: {
    PsEditor,
    PsOptions,
    PsOptions2,
    PsPlaceholder
  },
  data() {
    return {};
  },
  methods: {
    clearMarkdown: function () {
      this.$refs.editor.clearMarkdown();
    },
    onSizeChanged: function () {
      this.$emit('size-changed');
    },
    onChangeStrokeColour: function (value) {
      this.$emit('change-stroke-colour', value);
    },
    onEditorLanguageChanged: function () {
      this.$emit('editor-language-changed');
    }
  }
};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm.languages && _vm.options ? [_c('div', {
    staticClass: "col"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active show",
    attrs: {
      "id": "editor"
    }
  }, [_c('PsEditor', {
    ref: "editor",
    attrs: {
      "languages": _vm.languages,
      "options": _vm.options
    },
    on: {
      "editor-language-changed": _vm.onEditorLanguageChanged
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "options"
    }
  }, [_c('PsOptions2', {
    attrs: {
      "languages": _vm.languages,
      "options": _vm.options,
      "sizes": _vm.sizes,
      "colourOptions": _vm.colourOptions,
      "advancedFeatures": _vm.advancedFeatures,
      "showSizeOptions": _vm.showSizeOptions
    },
    on: {
      "size-changed": _vm.onSizeChanged,
      "change-stroke-colour": _vm.onChangeStrokeColour
    }
  })], 1)])])] : _vm._e()], 2)]);
};
var __vue_staticRenderFns__$1 = [function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_c('h5', {
    staticClass: "subheader"
  }, [_vm._v("Scripts and Options")])]);
}, function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "id": "lhs-header"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-toggle": "tab",
      "href": "#editor"
    }
  }, [_vm._v("Scripts")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-toggle": "tab",
      "href": "#options"
    }
  }, [_vm._v("Options")])])]);
}];

/* style */
const __vue_inject_styles__$1 = undefined;
/* scoped */
const __vue_scope_id__$1 = "data-v-474f64cb";
/* module identifier */
const __vue_module_identifier__$1 = undefined;
/* functional template */
const __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$2 = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);
var __vue_component__$3 = __vue_component__$2;

var saveSvgAsPng = createCommonjsModule(function (module, exports) {

(function () {
  var out$ = exports || typeof undefined != 'undefined'  || this || window;
  out$.default = out$;

  var xmlNs = 'http://www.w3.org/2000/xmlns/';
  var xhtmlNs = 'http://www.w3.org/1999/xhtml';
  var svgNs = 'http://www.w3.org/2000/svg';
  var doctype = '<?xml version="1.0" standalone="no"?><!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd" [<!ENTITY nbsp "&#160;">]>';
  var urlRegex = /url\(["']?(.+?)["']?\)/;
  var fontFormats = {
    woff2: 'font/woff2',
    woff: 'font/woff',
    otf: 'application/x-font-opentype',
    ttf: 'application/x-font-ttf',
    eot: 'application/vnd.ms-fontobject',
    sfnt: 'application/font-sfnt',
    svg: 'image/svg+xml'
  };

  var isElement = function isElement(obj) {
    return obj instanceof HTMLElement || obj instanceof SVGElement;
  };
  var requireDomNode = function requireDomNode(el) {
    if (!isElement(el)) throw new Error('an HTMLElement or SVGElement is required; got ' + el);
  };
  var requireDomNodePromise = function requireDomNodePromise(el) {
    return new Promise(function (resolve, reject) {
      if (isElement(el)) resolve(el);else reject(new Error('an HTMLElement or SVGElement is required; got ' + el));
    });
  };
  var isExternal = function isExternal(url) {
    return url && url.lastIndexOf('http', 0) === 0 && url.lastIndexOf(window.location.host) === -1;
  };

  var getFontMimeTypeFromUrl = function getFontMimeTypeFromUrl(fontUrl) {
    var formats = Object.keys(fontFormats).filter(function (extension) {
      return fontUrl.indexOf('.' + extension) > 0;
    }).map(function (extension) {
      return fontFormats[extension];
    });
    if (formats) return formats[0];
    console.error('Unknown font format for ' + fontUrl + '. Fonts may not be working correctly.');
    return 'application/octet-stream';
  };

  var arrayBufferToBase64 = function arrayBufferToBase64(buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    for (var i = 0; i < bytes.byteLength; i++) {
      binary += String.fromCharCode(bytes[i]);
    }return window.btoa(binary);
  };

  var getDimension = function getDimension(el, clone, dim) {
    var v = el.viewBox && el.viewBox.baseVal && el.viewBox.baseVal[dim] || clone.getAttribute(dim) !== null && !clone.getAttribute(dim).match(/%$/) && parseInt(clone.getAttribute(dim)) || el.getBoundingClientRect()[dim] || parseInt(clone.style[dim]) || parseInt(window.getComputedStyle(el).getPropertyValue(dim));
    return typeof v === 'undefined' || v === null || isNaN(parseFloat(v)) ? 0 : v;
  };

  var getDimensions = function getDimensions(el, clone, width, height) {
    if (el.tagName === 'svg') return {
      width: width || getDimension(el, clone, 'width'),
      height: height || getDimension(el, clone, 'height')
    };else if (el.getBBox) {
      var _el$getBBox = el.getBBox(),
          x = _el$getBBox.x,
          y = _el$getBBox.y,
          _width = _el$getBBox.width,
          _height = _el$getBBox.height;

      return {
        width: x + _width,
        height: y + _height
      };
    }
  };

  var reEncode = function reEncode(data) {
    return decodeURIComponent(encodeURIComponent(data).replace(/%([0-9A-F]{2})/g, function (match, p1) {
      var c = String.fromCharCode('0x' + p1);
      return c === '%' ? '%25' : c;
    }));
  };

  var uriToBlob = function uriToBlob(uri) {
    var byteString = window.atob(uri.split(',')[1]);
    var mimeString = uri.split(',')[0].split(':')[1].split(';')[0];
    var buffer = new ArrayBuffer(byteString.length);
    var intArray = new Uint8Array(buffer);
    for (var i = 0; i < byteString.length; i++) {
      intArray[i] = byteString.charCodeAt(i);
    }
    return new Blob([buffer], { type: mimeString });
  };

  var query = function query(el, selector) {
    if (!selector) return;
    try {
      return el.querySelector(selector) || el.parentNode && el.parentNode.querySelector(selector);
    } catch (err) {
      console.warn('Invalid CSS selector "' + selector + '"', err);
    }
  };

  var detectCssFont = function detectCssFont(rule, href) {
    // Match CSS font-face rules to external links.
    // @font-face {
    //   src: local('Abel'), url(https://fonts.gstatic.com/s/abel/v6/UzN-iejR1VoXU2Oc-7LsbvesZW2xOQ-xsNqO47m55DA.woff2);
    // }
    var match = rule.cssText.match(urlRegex);
    var url = match && match[1] || '';
    if (!url || url.match(/^data:/) || url === 'about:blank') return;
    var fullUrl = url.startsWith('../') ? href + '/../' + url : url.startsWith('./') ? href + '/.' + url : url;
    return {
      text: rule.cssText,
      format: getFontMimeTypeFromUrl(fullUrl),
      url: fullUrl
    };
  };

  var inlineImages = function inlineImages(el) {
    return Promise.all(Array.from(el.querySelectorAll('image')).map(function (image) {
      var href = image.getAttributeNS('http://www.w3.org/1999/xlink', 'href') || image.getAttribute('href');
      if (!href) return Promise.resolve(null);
      if (isExternal(href)) {
        href += (href.indexOf('?') === -1 ? '?' : '&') + 't=' + new Date().valueOf();
      }
      return new Promise(function (resolve, reject) {
        var canvas = document.createElement('canvas');
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.src = href;
        img.onerror = function () {
          return reject(new Error('Could not load ' + href));
        };
        img.onload = function () {
          canvas.width = img.width;
          canvas.height = img.height;
          canvas.getContext('2d').drawImage(img, 0, 0);
          image.setAttributeNS('http://www.w3.org/1999/xlink', 'href', canvas.toDataURL('image/png'));
          resolve(true);
        };
      });
    }));
  };

  var cachedFonts = {};
  var inlineFonts = function inlineFonts(fonts) {
    return Promise.all(fonts.map(function (font) {
      return new Promise(function (resolve, reject) {
        if (cachedFonts[font.url]) return resolve(cachedFonts[font.url]);

        var req = new XMLHttpRequest();
        req.addEventListener('load', function () {
          // TODO: it may also be worth it to wait until fonts are fully loaded before
          // attempting to rasterize them. (e.g. use https://developer.mozilla.org/en-US/docs/Web/API/FontFaceSet)
          var fontInBase64 = arrayBufferToBase64(req.response);
          var fontUri = font.text.replace(urlRegex, 'url("data:' + font.format + ';base64,' + fontInBase64 + '")') + '\n';
          cachedFonts[font.url] = fontUri;
          resolve(fontUri);
        });
        req.addEventListener('error', function (e) {
          console.warn('Failed to load font from: ' + font.url, e);
          cachedFonts[font.url] = null;
          resolve(null);
        });
        req.addEventListener('abort', function (e) {
          console.warn('Aborted loading font from: ' + font.url, e);
          resolve(null);
        });
        req.open('GET', font.url);
        req.responseType = 'arraybuffer';
        req.send();
      });
    })).then(function (fontCss) {
      return fontCss.filter(function (x) {
        return x;
      }).join('');
    });
  };

  var cachedRules = null;
  var styleSheetRules = function styleSheetRules() {
    if (cachedRules) return cachedRules;
    return cachedRules = Array.from(document.styleSheets).map(function (sheet) {
      try {
        return { rules: sheet.cssRules, href: sheet.href };
      } catch (e) {
        console.warn('Stylesheet could not be loaded: ' + sheet.href, e);
        return {};
      }
    });
  };

  var inlineCss = function inlineCss(el, options) {
    var _ref = options || {},
        selectorRemap = _ref.selectorRemap,
        modifyStyle = _ref.modifyStyle,
        modifyCss = _ref.modifyCss,
        fonts = _ref.fonts,
        excludeUnusedCss = _ref.excludeUnusedCss;

    var generateCss = modifyCss || function (selector, properties) {
      var sel = selectorRemap ? selectorRemap(selector) : selector;
      var props = modifyStyle ? modifyStyle(properties) : properties;
      return sel + '{' + props + '}\n';
    };
    var css = [];
    var detectFonts = typeof fonts === 'undefined';
    var fontList = fonts || [];
    styleSheetRules().forEach(function (_ref2) {
      var rules = _ref2.rules,
          href = _ref2.href;

      if (!rules) return;
      Array.from(rules).forEach(function (rule) {
        if (typeof rule.style != 'undefined') {
          if (query(el, rule.selectorText)) css.push(generateCss(rule.selectorText, rule.style.cssText));else if (detectFonts && rule.cssText.match(/^@font-face/)) {
            var font = detectCssFont(rule, href);
            if (font) fontList.push(font);
          } else if (!excludeUnusedCss) {
            css.push(rule.cssText);
          }
        }
      });
    });

    return inlineFonts(fontList).then(function (fontCss) {
      return css.join('\n') + fontCss;
    });
  };

  var downloadOptions = function downloadOptions() {
    if (!navigator.msSaveOrOpenBlob && !('download' in document.createElement('a'))) {
      return { popup: window.open() };
    }
  };

  out$.prepareSvg = function (el, options, done) {
    requireDomNode(el);

    var _ref3 = options || {},
        _ref3$left = _ref3.left,
        left = _ref3$left === undefined ? 0 : _ref3$left,
        _ref3$top = _ref3.top,
        top = _ref3$top === undefined ? 0 : _ref3$top,
        w = _ref3.width,
        h = _ref3.height,
        _ref3$scale = _ref3.scale,
        scale = _ref3$scale === undefined ? 1 : _ref3$scale,
        _ref3$responsive = _ref3.responsive,
        responsive = _ref3$responsive === undefined ? false : _ref3$responsive,
        _ref3$excludeCss = _ref3.excludeCss,
        excludeCss = _ref3$excludeCss === undefined ? false : _ref3$excludeCss;

    return inlineImages(el).then(function () {
      var clone = el.cloneNode(true);
      clone.style.backgroundColor = (options || {}).backgroundColor || el.style.backgroundColor;

      var _getDimensions = getDimensions(el, clone, w, h),
          width = _getDimensions.width,
          height = _getDimensions.height;

      if (el.tagName !== 'svg') {
        if (el.getBBox) {
          if (clone.getAttribute('transform') != null) {
            clone.setAttribute('transform', clone.getAttribute('transform').replace(/translate\(.*?\)/, ''));
          }
          var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          svg.appendChild(clone);
          clone = svg;
        } else {
          console.error('Attempted to render non-SVG element', el);
          return;
        }
      }

      clone.setAttribute('version', '1.1');
      clone.setAttribute('viewBox', [left, top, width, height].join(' '));
      if (!clone.getAttribute('xmlns')) clone.setAttributeNS(xmlNs, 'xmlns', svgNs);
      if (!clone.getAttribute('xmlns:xlink')) clone.setAttributeNS(xmlNs, 'xmlns:xlink', 'http://www.w3.org/1999/xlink');

      if (responsive) {
        clone.removeAttribute('width');
        clone.removeAttribute('height');
        clone.setAttribute('preserveAspectRatio', 'xMinYMin meet');
      } else {
        clone.setAttribute('width', width * scale);
        clone.setAttribute('height', height * scale);
      }

      Array.from(clone.querySelectorAll('foreignObject > *')).forEach(function (foreignObject) {
        foreignObject.setAttributeNS(xmlNs, 'xmlns', foreignObject.tagName === 'svg' ? svgNs : xhtmlNs);
      });

      if (excludeCss) {
        var outer = document.createElement('div');
        outer.appendChild(clone);
        var src = outer.innerHTML;
        if (typeof done === 'function') done(src, width, height);else return { src: src, width: width, height: height };
      } else {
        return inlineCss(el, options).then(function (css) {
          var style = document.createElement('style');
          style.setAttribute('type', 'text/css');
          style.innerHTML = '<![CDATA[\n' + css + '\n]]>';

          var defs = document.createElement('defs');
          defs.appendChild(style);
          clone.insertBefore(defs, clone.firstChild);

          var outer = document.createElement('div');
          outer.appendChild(clone);
          var src = outer.innerHTML.replace(/NS\d+:href/gi, 'xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href');

          if (typeof done === 'function') done(src, width, height);else return { src: src, width: width, height: height };
        });
      }
    });
  };

  out$.svgAsDataUri = function (el, options, done) {
    requireDomNode(el);
    return out$.prepareSvg(el, options).then(function (_ref4) {
      var src = _ref4.src,
          width = _ref4.width,
          height = _ref4.height;

      var svgXml = 'data:image/svg+xml;base64,' + window.btoa(reEncode(doctype + src));
      if (typeof done === 'function') {
        done(svgXml, width, height);
      }
      return svgXml;
    });
  };

  out$.svgAsPngUri = function (el, options, done) {
    requireDomNode(el);

    var _ref5 = options || {},
        _ref5$encoderType = _ref5.encoderType,
        encoderType = _ref5$encoderType === undefined ? 'image/png' : _ref5$encoderType,
        _ref5$encoderOptions = _ref5.encoderOptions,
        encoderOptions = _ref5$encoderOptions === undefined ? 0.8 : _ref5$encoderOptions,
        canvg = _ref5.canvg;

    var convertToPng = function convertToPng(_ref6) {
      var src = _ref6.src,
          width = _ref6.width,
          height = _ref6.height;

      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      var pixelRatio = window.devicePixelRatio || 1;

      canvas.width = width * pixelRatio;
      canvas.height = height * pixelRatio;
      canvas.style.width = canvas.width + 'px';
      canvas.style.height = canvas.height + 'px';
      context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);

      if (canvg) canvg(canvas, src);else context.drawImage(src, 0, 0);

      var png = void 0;
      try {
        png = canvas.toDataURL(encoderType, encoderOptions);
      } catch (e) {
        if (typeof SecurityError !== 'undefined' && e instanceof SecurityError || e.name === 'SecurityError') {
          console.error('Rendered SVG images cannot be downloaded in this browser.');
          return;
        } else throw e;
      }
      if (typeof done === 'function') done(png, canvas.width, canvas.height);
      return Promise.resolve(png);
    };

    if (canvg) return out$.prepareSvg(el, options).then(convertToPng);else return out$.svgAsDataUri(el, options).then(function (uri) {
      return new Promise(function (resolve, reject) {
        var image = new Image();
        image.onload = function () {
          return resolve(convertToPng({
            src: image,
            width: image.width,
            height: image.height
          }));
        };
        image.onerror = function () {
          reject('There was an error loading the data URI as an image on the following SVG\n' + window.atob(uri.slice(26)) + 'Open the following link to see browser\'s diagnosis\n' + uri);
        };
        image.src = uri;
      });
    });
  };

  out$.download = function (name, uri, options) {
    if (navigator.msSaveOrOpenBlob) navigator.msSaveOrOpenBlob(uriToBlob(uri), name);else {
      var saveLink = document.createElement('a');
      if ('download' in saveLink) {
        saveLink.download = name;
        saveLink.style.display = 'none';
        document.body.appendChild(saveLink);
        try {
          var blob = uriToBlob(uri);
          var url = URL.createObjectURL(blob);
          saveLink.href = url;
          saveLink.onclick = function () {
            return requestAnimationFrame(function () {
              return URL.revokeObjectURL(url);
            });
          };
        } catch (e) {
          console.error(e);
          console.warn('Error while getting object URL. Falling back to string URL.');
          saveLink.href = uri;
        }
        saveLink.click();
        document.body.removeChild(saveLink);
      } else if (options && options.popup) {
        options.popup.document.title = name;
        options.popup.location.replace(uri);
      }
    }
  };

  out$.saveSvg = function (el, name, options) {
    var downloadOpts = downloadOptions(); // don't inline, can't be async
    return requireDomNodePromise(el).then(function (el) {
      return out$.svgAsDataUri(el, options || {});
    }).then(function (uri) {
      return out$.download(name, uri, downloadOpts);
    });
  };

  out$.saveSvgAsPng = function (el, name, options) {
    var downloadOpts = downloadOptions(); // don't inline, can't be async
    return requireDomNodePromise(el).then(function (el) {
      return out$.svgAsPngUri(el, options || {});
    }).then(function (uri) {
      return out$.download(name, uri, downloadOpts);
    });
  };
})();
});

var script = {
  name: 'ps-preview',
  props: ["options", "sizes", "advancedFeatures"],
  components: {
    PsDrawingHeader,
    PsDrawing,
    PsDrawingHeaderMore
  },
  data() {
    return {
      workingTrees: [],
      filenames: [],
      visibleTabs: [],
      dropdownTabs: [],
      activeTab: 1,
      showMore: false,
      moreWidth: 80,
      context: document.createElement("canvas").getContext("2d"),
      fontSize: 14,
      fontFamily: "Poppings",
      fontWeight: 300
    };
  },
  inject: ['appConfig'],
  computed: {
    numTabs: function () {
      return this.workingTrees.length;
    },
    hasSetWidth: function () {
      const size = this.sizes.filter(size => size.id === this.options.size)[0];
      if (size.width !== null) {
        return true;
      }
      return false;
    }
  },
  watch: {
    numTabs: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          this.emitNumberDrawings();
        }
      },
      immediate: true
    }
  },
  methods: {
    redraw: function (data) {
      // console.log(`Editor data has changed`);          
      this.workingTrees = data.info.workingTrees;
      this.extractFilenames();
      this.determineTabVisibility();
      this.activeTab = this.determineActiveTab(data.lineNo);
    },
    extractFilenames: function () {
      this.filenames = [];
      for (let i = 0; i < this.workingTrees.length; i++) {
        const filename = this.getFilename(i, this.workingTrees[i]);
        this.filenames.push(filename);
      }
    },
    getFilename: function (index, workingTree) {
      let filename = `image_${index + 1}.png`;
      if ('filename' in workingTree.instructions) {
        filename = workingTree.instructions.filename;
      }
      return filename;
    },
    determineTabVisibility: function () {
      this.visibleTabs = [];
      this.dropdownTabs = [];
      this.showMore = false;
      if (this.$refs.tabs_container && this.filenames.length > 1) {
        const maxWidth = this.$refs.tabs_container.offsetWidth - this.moreWidth;
        this.dropdownTabs = [];
        this.showMore = false;
        let width = 0;
        for (let i = 0; i < this.filenames.length; i++) {
          const filename = this.filenames[i];
          const estimatedWidth = this.tabEstimatedWidth(filename);
          if (width + estimatedWidth < maxWidth) {
            width += estimatedWidth;
            this.$set(this.visibleTabs, this.visibleTabs.length, {
              tabNo: i + 1,
              filename: filename
            });
          } else {
            this.showMore = true;
            this.$set(this.dropdownTabs, this.dropdownTabs.length, {
              tabNo: i + 1,
              filename: filename
            });
          }
        }
      } else {
        for (let i = 0; i < this.filenames.length; i++) {
          const filename = this.filenames[i];
          this.$set(this.visibleTabs, this.visibleTabs.length, {
            tabNo: i + 1,
            filename: filename
          });
        }
      }
    },
    determineActiveTab: function (lineNo) {
      let tab = this.workingTrees.length; // Assume tab is last one
      for (let i = 0; i < this.workingTrees.length; i++) {
        const workingTree = this.workingTrees[i];
        const min = workingTree.script[0].original_lineno;
        const max = workingTree.script[workingTree.script.length - 1].original_lineno;
        if (lineNo >= min && lineNo <= max) {
          tab = i + 1;
        }
      }
      return tab;
    },
    getEncoderType: function (filename) {
      const parts = filename.split('.');
      const ext = parts[parts.length - 1];
      if (ext === 'jpg') {
        return 'image/jpeg';
      } else {
        return `image/${ext}`;
      }
    },
    vettedDPI: function (drawing) {
      if (!this.advancedFeatures && drawing.updatedOptions.dpi == 300) return 72;
      return drawing.updatedOptions.dpi;
    },
    vettedSize: function () {
      if (!this.advancedFeatured) return 1;
      return this.options.size;
    },
    addDrawing: function (drawing, filename, script) {
      // filename
      // options
      // script
      // image
      // scale_factor
      const svgElement = drawing.$refs.drawing;
      const scale = this.scale(this.vettedDPI(drawing), drawing);
      const sizeScale = this.sizeScale(drawing);
      const drawingDimensions = this.getDrawingDimensions(drawing);
      const options = {
        canvg: window.canvg,
        scale: scale,
        excludeUnusedCss: true,
        width: drawingDimensions.width / sizeScale,
        height: drawingDimensions.height / sizeScale,
        encoderType: this.getEncoderType(filename),
        encoderOptions: 1,
        fonts: []
      };
      // console.log(options)
      // console.log(sizeScale)
      if (options.encoderType === 'image/jpeg') {
        options.backgroundColor = '#FFFFFF';
      }
      return saveSvgAsPng.svgAsPngUri(svgElement, options).then(image => {
        return {
          filename: filename,
          script: script,
          image: image,
          scale_factor: scale,
          options: drawing.updatedOptions
        };
      });
    },
    getOriginalScript: function (script) {
      let lines = script.map(item => `${'  '.repeat(item.indentLevel)}${item.text}`);
      return lines.join('\n');
    },
    saveMultipleDrawings: function () {
      if (!this.workingTrees || this.workingTrees.length === 0) return;
      if (this.appConfig.clearErrorMessages) this.appConfig.clearErrorMessages();
      if (this.appConfig.loading) this.appConfig.loading(true);
      if (this.$refs.drawings) {
        let savedDrawings = [];
        for (let drawing of this.$refs.drawings) {
          const key = drawing.$vnode.key;
          const filename = this.filenames[key];
          const script = this.getOriginalScript(this.workingTrees[key].script);
          // console.log(`Script is: ${script}`)
          savedDrawings.push(this.addDrawing(drawing, filename, script));
        }
        Promise.all(savedDrawings).then(drawings => {
          // need to additional send the options (not the dpi as that is part of the options)
          // need to send the text of the script
          // need to send the filename of the image
          this.$emit('saving-drawings');
          this.appConfig.saveDrawings(drawings, this.options).then(result => {
            // a convert_id should be returned, redirect to success/<convert_id>/
            // console.log(`Successfully saved images with array`)
            if (this.appConfig.loading) this.appConfig.loading(false);
            const convertID = result.convertID;
            this.$emit('drawings-saved', convertID);
          }).catch(error => {
            // Need to display the error to the user
            // console.log('An error occurred in saving the array')
            if (this.appConfig.loading) this.appConfig.loading(false);
            if (this.appConfig.showErrorMessage) this.appConfig.showErrorMessage(error.message);
          });
        });
      }
    },
    scale: function (dpi, drawing) {
      // scaling is made up of two factors, scaling due to dpi
      // and scaling due to output size.
      let scale = dpi / 72 * this.sizeScale(drawing);
      if (drawing.workingTree.instructions.scale_factor) {
        scale = Number(drawing.workingTree.instructions.scale_factor);
      }
      return round(scale, 2);
    },
    sizeScale: function (drawing) {
      const dimensions = this.getDrawingDimensions(drawing);
      const widthScale = dimensions.width / drawing.width;
      const heightScale = dimensions.height / drawing.height;
      return Math.min(widthScale, heightScale);
    },
    tabEstimatedWidth: function (filename) {
      this.context.font = `${this.fontWeight} ${this.fontSize}pt ${this.fontFamily}`;
      return this.context.measureText(filename).width + 32; //padding left & right of 16
    },
    currentWidth: function () {
      let width = 0;
      if (this.$refs.tabs) {
        width = this.$refs.tabs.map(item => item.$el.offsetWidth).reduce((a, b) => a + b, 0);
      }
      // console.log(`Current width: ${width}`)
      return width;
    },
    getDimensions: function () {
      const size = this.sizes.filter(size => size.id === this.options.size)[0];
      let width = size.width,
        height = size.height;
      if (!this.options.potrait) {
        width = size.height;
        height = size.width;
      }
      return {
        width: width,
        height: height
      };
    },
    getDrawingDimensions: function (drawing) {
      let width = drawing.width;
      let height = drawing.height;
      if (this.hasSetWidth) {
        const dimensions = this.getDimensions();
        width = dimensions.width * 72; //this.vettedDPI()
        height = dimensions.height * 72; //this.vettedDPI()
      }
      return {
        width: width,
        height: height
      };
    },
    onTabClicked: function (tabNo) {
      this.activeTab = tabNo;
    },
    emitNumberDrawings: function () {
      const count = this.workingTrees ? this.workingTrees.length : 0;
      this.$emit('number-drawings-changed', count);
    }
  },
  mounted: function () {
    EventBus.$on(EVENT_REDRAWPREVIEW, data => {
      this.redraw(data);
    }), window.addEventListener('resize', this.determineTabVisibility);
    // this also needs to respond to EVENT_OPTIONSCHANGED
    // this also needs to respond to EVENT_WORKINGTREECHANGED, nees to do a diff and then edit teh 
    // working tree appropriately, which mean workingTree should defaul to []
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_c('ul', {
    ref: "tabs_container",
    staticClass: "nav nav-tabs",
    attrs: {
      "id": "drawing-header"
    }
  }, [_vm._l(_vm.visibleTabs, function (tab, index) {
    return _c('PsDrawingHeader', {
      key: index,
      ref: "tabs",
      refInFor: true,
      attrs: {
        "tab": tab,
        "activeTab": _vm.activeTab
      },
      on: {
        "tab-clicked": _vm.onTabClicked
      }
    });
  }), _vm._v(" "), _c('PsDrawingHeaderMore', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showMore,
      expression: "showMore"
    }],
    attrs: {
      "overflowTabs": _vm.dropdownTabs,
      "activeTab": _vm.activeTab
    },
    on: {
      "tab-clicked": _vm.onTabClicked
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-content drawing"
  }, _vm._l(_vm.workingTrees, function (workingTree, index) {
    return _c('PsDrawing', {
      key: index,
      ref: "drawings",
      refInFor: true,
      attrs: {
        "workingTree": workingTree,
        "tabNo": index + 1,
        "activeTab": _vm.activeTab,
        "options": _vm.options,
        "sizes": _vm.sizes
      }
    });
  }), 1)]);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = "data-v-176c9a19";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var __vue_component__$1 = __vue_component__;

/* eslint-disable import/prefer-default-export */

var components = /*#__PURE__*/Object.freeze({
    __proto__: null,
    PsContent: PsContent,
    PsContentText: PsContentText,
    PsContentCondition: PsContentCondition,
    PsContentDropdown: PsContentDropdown,
    PsContentFlag: PsContentFlag,
    PsContentTurnleft: PsContentTurnleft,
    PsContentMatrix: PsContentMatrix,
    PsContentMyblock: PsContentMyBlock,
    PsContentTurnright: PsContentTurnright,
    PsContentValue: PsContentValue,
    PsBlockBasic: PsBlockBasic,
    PsBlockDefine: PsBlockDefine,
    PsBlockEvent: PsBlockEvent,
    PsBlockIfthen: PsBlockIfthen,
    PsBlockRepeat: PsBlockRepeat,
    PsBlockSeparator: PsBlockSeparator,
    PsBlockSpace: PsBlockSpace,
    PsDrawing: PsDrawing,
    PsDrawingHeader: PsDrawingHeader,
    PsDrawingHeaderMore: PsDrawingHeaderMore,
    PsDrawingHeaderMoreDropdown: DrawingHeaderMoreDropDown,
    PsEditor: PsEditor,
    PsEditorOptions: __vue_component__$3,
    PsErrorLine: PsErrorLine,
    PsErrors: PsErrors,
    PsHint: PsHint,
    PsHintLine: PsHintLine,
    PsImportFile: PsImportFile,
    PsIncrementor: PsIncrementor,
    PsOptions: PsOptions,
    PsOptions2: PsOptions2,
    PsPlaceholder: PsPlaceholder,
    PsPreview: __vue_component__$1,
    PsEffect: PsEffect,
    PsColour: PsColour
});

// Import vue components

// install function executed by Vue.use()
const install = function installComponents(Vue) {
  Object.entries(components).forEach(([componentName, component]) => {
    Vue.component(componentName, component);
  });
};

// Auto-install when vue is found (eg. in browser via <script> tag)
let GlobalVue = null;
if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}
if (GlobalVue) {
  const plugin = {
    install
  };
  GlobalVue.use(plugin);
}

export { PsBlockBasic, PsBlockDefine, PsBlockEvent, PsBlockIfthen, PsBlockRepeat, PsBlockSeparator, PsBlockSpace, PsColour, PsContent, PsContentCondition, PsContentDropdown, PsContentFlag, PsContentMatrix, PsContentMyBlock as PsContentMyblock, PsContentText, PsContentTurnleft, PsContentTurnright, PsContentValue, PsDrawing, PsDrawingHeader, PsDrawingHeaderMore, DrawingHeaderMoreDropDown as PsDrawingHeaderMoreDropdown, PsEditor, __vue_component__$3 as PsEditorOptions, PsEffect, PsErrorLine, PsErrors, PsHint, PsHintLine, PsImportFile, PsIncrementor, PsOptions, PsOptions2, PsPlaceholder, __vue_component__$1 as PsPreview, install as default };
